/**
 * CAOS definitions in the form of a JS object
 */
export default {
    "mod_date": 1705094645,
    "commands": {
        "722": {
            "id": 722,
            "command": "_CD_ EJCT",
            "description": "Open the CD tray.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 35
        },
        "723": {
            "id": 723,
            "command": "_CD_ FRQH",
            "description": "Returns the average value for the highest frequencies detected in the CD player for the current tick.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 35
        },
        "724": {
            "id": 724,
            "command": "_CD_ FRQL",
            "description": "Returns the average value for the lowest frequencies detected in the CD player for the current tick.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 35
        },
        "725": {
            "id": 725,
            "command": "_CD_ FRQM",
            "description": "Returns the average value for the medium frequencies detected in the CD player for the current tick.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 35
        },
        "726": {
            "id": 726,
            "command": "_CD_ INIT",
            "description": "Let the game know that you wish to use the cd player. This will shut down all in game sounds and music as the mixer is needed to gauge the frequency spectrum.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 35
        },
        "727": {
            "id": 727,
            "command": "_CD_ PAWS",
            "parameters": [
                {
                    "index": 0,
                    "name": "onOff",
                    "type_id": 1
                }
            ],
            "description": "Pause the CD player if the parameter is greater than zero, to continue playing a previous paused track set the parameter to 1.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 35
        },
        "728": {
            "id": 728,
            "command": "_CD_ PLAY",
            "parameters": [
                {
                    "index": 0,
                    "name": "firstTrack",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "lastTrack",
                    "type_id": 1
                }
            ],
            "description": "Tell the CD Player to play the given track.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 35
        },
        "729": {
            "id": 729,
            "command": "_CD_ SHUT",
            "description": "Tell the game that you have finished with the cd player. This will reinstate the in game sounds and music.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 35
        },
        "730": {
            "id": 730,
            "command": "_CD_ STOP",
            "description": "Stop the cd player.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 35
        },
        "19": {
            "id": 19,
            "command": "_IT_",
            "description": "Object that [OWNR] creature was attending to when the macro was started.\nNote: Only [OWNR]\u2019s IT can be determined, not [TARG]\u2019s.",
            "return_type_id": 11,
            "rvalue": true,
            "requires_creature_ownr": true,
            "variants": 63,
            "command_group_id": 7
        },
        "36": {
            "id": 36,
            "command": "_P1_",
            "description": "First macro script parameters specified in command [MESG WRT+].",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 62,
            "command_group_id": 14
        },
        "37": {
            "id": 37,
            "command": "_P2_",
            "description": "Second macro script parameters specified in command [MESG WRT+]",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 62,
            "command_group_id": 14
        },
        "564": {
            "id": 564,
            "command": "_UP_",
            "description": "Returns the value of the UP constant.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "696": {
            "id": 696,
            "command": "ABBA",
            "description": "Returns the absolute base for the current agent/part. Returns -1 if an invalid part. The absolute base is the value passed into [NEW: SIMP] and so on, it is different from the [BASE].",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 18
        },
        "626": {
            "id": 626,
            "command": "ABSV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "#"
                }
            ],
            "description": "Set a variable to its absolute value, so if var is negative var = 0 - {var}, otherwise {var} is left alone.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "27": {
            "id": 27,
            "command": "ACCG",
            "description": "Sets/returns the objects Acceleration due to Gravity. This equates to density and air resistance in real-world physics. Value is in pixels per tick per tick.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "565": {
            "id": 565,
            "command": "ACCG",
            "parameters": [
                {
                    "index": 0,
                    "name": "acceleration",
                    "type_id": 2
                }
            ],
            "description": "Set acceleration due to gravity in pixels per tick squared.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "566": {
            "id": 566,
            "command": "ACCG",
            "description": "Returns target's acceleration due to gravity in pixels per tick squared.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "627": {
            "id": 627,
            "command": "ACOS",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                }
            ],
            "description": "Returns arccosine of {x} in degrees.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "62": {
            "id": 62,
            "command": "ACTV",
            "description": "Returns objects Active status. See reference section for values.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 124,
                "C1": 142
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 65
        },
        "523": {
            "id": 523,
            "command": "ADDB",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "backgroundFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 283,
                        "DS": 283,
                        "C3": 283,
                        "SM": 283
                    }
                }
            ],
            "description": "Add a new background to the given metaroom. Use [BKGD] to change the current displayed background.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "524": {
            "id": 524,
            "command": "ADDM",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "width",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "height",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "background",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 283,
                        "C3": 283,
                        "DS": 283,
                        "SM": 283
                    }
                }
            ],
            "description": "Creates a new metaroom with the given coordinates. Specifies the starting background file. Returns the id of the new metaroom.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "525": {
            "id": 525,
            "command": "ADDR",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "xLeft",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "xRight",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "yLeftCeiling",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "yRightCeiling",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "yLeftFloor",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "yRightFloor",
                    "type_id": 1
                }
            ],
            "description": "Creates a new room within a metaroom. Rooms have vertical left and right walls, but potentially sloped floors and ceilings. The coordinates specify the exact shape. Returns the id of the new room.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "628": {
            "id": 628,
            "command": "ADDS",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "4"
                },
                {
                    "index": 1,
                    "name": "append",
                    "type_id": 4
                }
            ],
            "description": "Concatenates two strings, so {var} = {var} + {append}.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "67": {
            "id": 67,
            "command": "ADDV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "sum",
                    "type_id": 1
                }
            ],
            "description": "{var} = {var} + {sum}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 12
        },
        "629": {
            "id": 629,
            "command": "ADDV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "#"
                },
                {
                    "index": 1,
                    "name": "sum",
                    "type_id": 16
                }
            ],
            "description": "Adds two integers or floats, so {var} = {var} + {sum}.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "711": {
            "id": 711,
            "command": "ADIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "verb",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "noun",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "qualifier",
                    "type_id": 2
                },
                {
                    "index": 3,
                    "name": "drive",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                }
            ],
            "description": "Add an instinct to the creature's brain queue. (The instinct is not processed immediately). Example: ADIN 3 4 0.5 7 encourages (by a factor of 0.5) the creature to do action 3 on category 4 when drive 7 is high.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 11
        },
        "830": {
            "id": 830,
            "command": "ADMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "dampingFactor",
                    "type_id": 2
                }
            ],
            "description": "Damp angular velocity by this much each tick. The value is from 0.0 to 1.0 where 0.0 means no damping, 1.0 maximum.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "831": {
            "id": 831,
            "command": "ADMP",
            "description": "Get current angular damping. The value is from 0.0 to 1.0 where 0.0 means no damping, 1.0 maximum.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "28": {
            "id": 28,
            "command": "AERO",
            "description": "Sets/returns the objects Aerodynamics. % of x and y velocity lost due to air resistance every tick.\n0% infinite movement!",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "567": {
            "id": 567,
            "command": "AERO",
            "parameters": [
                {
                    "index": 0,
                    "name": "aerodynamics",
                    "type_id": 1
                }
            ],
            "description": "Set aerodynamic factor as a percentage. The velocity is reduced by this factor each tick.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "568": {
            "id": 568,
            "command": "AERO",
            "description": "Returns aerodynamic factor as a percentage.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "425": {
            "id": 425,
            "command": "AGES",
            "parameters": [
                {
                    "index": 0,
                    "name": "times",
                    "type_id": 1
                }
            ],
            "description": "Forces a creature to age the given number of times. See also [CAGE].",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "479": {
            "id": 479,
            "command": "AGNT",
            "parameters": [
                {
                    "index": 0,
                    "name": "uniqueId",
                    "type_id": 1
                }
            ],
            "description": "Given a unique identifier, returns the corresponding agent. Returns [NULL] if the agent no longer exists. [UNID] extracts the unique id. NOTE: This should only be used for external programs to persistently refer to an agent during a session. Variables can use SETA to store agent r-values directly for internal use. Unique identifiers can change across saved sessions.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "224": {
            "id": 224,
            "command": "AIM:",
            "parameters": [
                {
                    "index": 0,
                    "name": "action",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 225,
                        "C1": 76
                    },
                    "description": "0=activate1, 1=Activate2, 2=deactive"
                }
            ],
            "description": "Set the target point on the [_IT_] object for subsequent [APPR] and [TOUC] commands.",
            "return_type_id": 8,
            "requires_creature_ownr": true,
            "variants": 3,
            "command_group_id": 1
        },
        "322": {
            "id": 322,
            "command": "ALPH",
            "parameters": [
                {
                    "index": 0,
                    "name": "onOff",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "alphaValue",
                    "type_id": 1
                }
            ],
            "description": "Tell the agent to draw the current sprite with alpha channeling (send 1 as first parameter) or normally (send 0 as first parameter). The second parameter is the intensity 0 being no blending and 255 being maximum blending. For a compound agent remember to set the [PART] number.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 18
        },
        "697": {
            "id": 697,
            "command": "ALPH",
            "parameters": [
                {
                    "index": 0,
                    "name": "alphaValue",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "yesOrNo",
                    "type_id": 1
                }
            ],
            "description": "The agent will be drawn alpha blended against the background by the given value - from 256 for invisible to 0 for completely solid. For compound agents set the [PART] to affect a particular part or to -1 to affect all parts. The second parameter switches alpha blending on (1) or off (0). Alpha graphics are drawn much slower, so use sparingly and turn it off completely rather than using an intensity value of 0 or 256. At the moment alpha channels only work on compressed, non-mirrored, non-zoomed sprites.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 18
        },
        "526": {
            "id": 526,
            "command": "ALTR",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "C3": 183,
                        "SM": 183
                    }
                },
                {
                    "index": 2,
                    "name": "caDelta",
                    "type_id": 2
                }
            ],
            "description": "Directly adjusts the level of a CA in a room. Specify an identifier of -1 to use the room of the midpoint of the target agent.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "73": {
            "id": 73,
            "command": "ANDV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "value",
                    "type_id": 1
                }
            ],
            "description": "{value1} = {value1} & {value2}",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 13
        },
        "832": {
            "id": 832,
            "command": "ANGL",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Gets the angle (as a fraction of a circle) from [TARG]'s position to the position specified.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "323": {
            "id": 323,
            "command": "ANIM",
            "parameters": [
                {
                    "index": 0,
                    "name": "poseList",
                    "type_id": 17
                }
            ],
            "description": "Specify a list of [POSE]s such as [1 2 3] to animate the current agent/part. Put 255 at the end to continually loop. The first number after the 255 is an index into the animation string where the looping restarts from - this defaults to 0 if not specified. e.g. [0 1 2 10 11 12 255 3] would loop just the 10, 11, 12 section.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 18
        },
        "101": {
            "id": 101,
            "command": "ANIM",
            "parameters": [
                {
                    "index": 0,
                    "name": "anim",
                    "type_id": 17,
                    "description": "Pose list such as [123456789R] or [001002003R] for creatures"
                }
            ],
            "description": "Start animation of [TARG] object or part, using the poses specified.\nAnimations ending in R will repeat indefinitely.\nNote: For objects the entries are single digit poses,\nfor creatures the entries are 3 digit poses.\nMax length of animation string in both cases is 32 digits",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 18
        },
        "324": {
            "id": 324,
            "command": "ANMS",
            "parameters": [
                {
                    "index": 0,
                    "name": "animString",
                    "type_id": 4
                }
            ],
            "description": "This is like [ANIM], only it reads the poses from a string such as \"3 4 5 255\". Use this when you need to dynamically construct animations. Use ANIM in general as it is quicker to execute, although they are the same speed once the animation is underway.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 18
        },
        "955": {
            "id": 955,
            "command": "APP: QUIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "appletId",
                    "type_id": 1,
                    "description": "The applet id that should be closed."
                }
            ],
            "description": "Close the applet with the given id",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "220": {
            "id": 220,
            "command": "APPR",
            "description": "Approach [_IT_]\nChose a walking gait according to chemo-receptors, then start walking towards [_IT_].\nContinue with next instruction when you are within reach",
            "return_type_id": 8,
            "requires_creature_ownr": true,
            "variants": 63,
            "command_group_id": 5
        },
        "480": {
            "id": 480,
            "command": "APRO",
            "parameters": [
                {
                    "index": 0,
                    "name": "searchText",
                    "type_id": 4
                }
            ],
            "description": "Lists all command names whose help contains the text.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "158": {
            "id": 158,
            "command": "ASEA",
            "description": "Advance Season. Move to the beginning of next season.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 22
        },
        "630": {
            "id": 630,
            "command": "ASIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                }
            ],
            "description": "Returns arcsine of {x} in degrees.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "210": {
            "id": 210,
            "command": "ASLP",
            "description": "Returns whether a creature is asleep. When asleep the eyes close and the creature becomes insensible to some stimuli. A change of action automatically wakes creature up again. 0=awake, 1=asleep",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 158,
                "C1": 158,
                "CV": 158,
                "DS": 158,
                "C3": 158,
                "SM": 158
            },
            "rvalue": true,
            "variants": 63,
            "command_group_id": 5
        },
        "211": {
            "id": 211,
            "command": "ASLP",
            "parameters": [
                {
                    "index": 0,
                    "name": "asleep",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 92,
                        "C1": 92,
                        "CV": 158,
                        "DS": 158,
                        "C3": 158,
                        "SM": 158
                    },
                    "description": "0=awake, 1=asleep"
                }
            ],
            "description": "Sets/returns whether a creature is asleep. When asleep the eyes close and the creature becomes insensible to some stimuli. A change of action automatically wakes creature up again.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 5
        },
        "631": {
            "id": 631,
            "command": "ATAN",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                }
            ],
            "description": "Returns arctangent of {x} in degrees.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "294": {
            "id": 294,
            "command": "ATTN",
            "description": "IT - object that [OWNR] creature is attending to. May be null and may change during script execution.\nNOTE: only [OWNR]'s IT can be determined, not [TARG]'s",
            "return_type_id": 11,
            "rvalue": true,
            "requires_creature_ownr": true,
            "variants": 3,
            "command_group_id": 5
        },
        "426": {
            "id": 426,
            "command": "ATTN",
            "description": "Returns the current focus of attention id of [TARG] creature",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "32": {
            "id": 32,
            "command": "ATTR",
            "description": "Sets/returns an objects Attributes",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 119,
                "C1": 68
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 65
        },
        "325": {
            "id": 325,
            "command": "ATTR",
            "parameters": [
                {
                    "index": 0,
                    "name": "attributes",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 107,
                        "DS": 117,
                        "C3": 117,
                        "SM": 117
                    }
                }
            ],
            "description": "Set attributes of target. Sum the values in the Attribute Flags table to get the attribute value to pass into this command.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 65
        },
        "996": {
            "id": 996,
            "command": "ATTR",
            "description": "Sets/returns an objects Attributes",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 107,
                "DS": 117,
                "C3": 117,
                "SM": 117
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 65
        },
        "632": {
            "id": 632,
            "command": "AVAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "index",
                    "type_id": 1
                }
            ],
            "description": "This is the OVxx variable of the agent passed in. It is equivalent to target agent, OVxx, but means that you don't need to target it first :) You can also use them to implement primitive arrays.",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "833": {
            "id": 833,
            "command": "AVEL",
            "parameters": [
                {
                    "index": 0,
                    "name": "amountInFractionOfWholeCircle",
                    "type_id": 2
                }
            ],
            "description": "Set angular velocity.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "834": {
            "id": 834,
            "command": "AVEL",
            "description": "Get current angular velocity.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "209": {
            "id": 209,
            "command": "BABY",
            "description": "Moniker of child genome if creature is pregnant.\nSet to 0 to finish pregnancy or a moniker to make pregnant.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 5
        },
        "774": {
            "id": 774,
            "command": "BANG",
            "description": "Causes a division by zero exception in the processor, to test the engine's error handling routines.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 10
        },
        "327": {
            "id": 327,
            "command": "BASE",
            "description": "Returns the BASE image for the current agent/part. Returns -1 if an invalid part.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 18
        },
        "106": {
            "id": 106,
            "command": "BASE",
            "parameters": [
                {
                    "index": 0,
                    "name": "index",
                    "type_id": 1
                }
            ],
            "description": "Specify the base image number for this object/part.\nCan be used to allow anims from a large table of images by moving base sprite number around table.\nThis is the only way to use [ANIM] on an object with more that 10 images in its image gallery\nbecause [ANIM] uses a single digit to specify poses.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 18
        },
        "315": {
            "id": 315,
            "command": "BBD: EDIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "n",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 231
                    }
                }
            ],
            "description": "Allow user to edit the current word (n=1) Prevent further editing and relinquish keyboard (n=0)",
            "return_type_id": 8,
            "variants": 1,
            "command_group_id": 4
        },
        "181": {
            "id": 181,
            "command": "BBD: EMIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "n",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 227,
                        "C1": 227
                    }
                }
            ],
            "description": "{emit} values:\n\\t{n} = 0 - Broadcast as read. ie. to creatures looking at the blackboard\n\\t{n} > 0 - Broadcast as Audible ie. to all creatures in earshot",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 4
        },
        "180": {
            "id": 180,
            "command": "BBD: SHOW",
            "parameters": [
                {
                    "index": 0,
                    "name": "show",
                    "type_id": 1
                }
            ],
            "description": "{show} value of:\n\\t0 = wipes text from blackboard\n\\t1 = draws current text string (ov00) onto part 0",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 4
        },
        "178": {
            "id": 178,
            "command": "BBD: VCB1",
            "parameters": [
                {
                    "index": 0,
                    "name": "wordListIndex",
                    "type_id": 1,
                    "description": "index in blackboard word list,"
                },
                {
                    "index": 1,
                    "name": "vocabListIndex",
                    "type_id": 1,
                    "description": "index in game vocabulary list."
                }
            ],
            "description": "Set BlackBoard Vocabulary word.\nThis is used to move a single word from the game word list into a specific blackboard objects word list.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 4
        },
        "177": {
            "id": 177,
            "command": "BBD: VOCB",
            "parameters": [
                {
                    "index": 0,
                    "name": "bbdStartPosition",
                    "type_id": 1,
                    "description": "starting position in blackboard word list"
                },
                {
                    "index": 1,
                    "name": "startPosition",
                    "type_id": 1,
                    "description": "stating position in game word list"
                },
                {
                    "index": 2,
                    "name": "count",
                    "type_id": 1,
                    "description": "number of words to copy"
                }
            ],
            "description": "Set Blackboard Vocabulary.\nThis is used to move words from the game word list into a specific blackboard objects word list.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 4
        },
        "179": {
            "id": 179,
            "command": "BBD: WORD",
            "parameters": [
                {
                    "index": 0,
                    "name": "index",
                    "type_id": 1,
                    "description": "word index in blackboard"
                },
                {
                    "index": 1,
                    "name": "conceptId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 187,
                        "C1": 184
                    },
                    "description": "the word concept id number"
                },
                {
                    "index": 2,
                    "name": "text",
                    "type_id": 9,
                    "description": "text to be used for the word"
                }
            ],
            "description": "Install a single named word into the blackboards word list.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 4
        },
        "184": {
            "id": 184,
            "command": "BBFD",
            "parameters": [
                {
                    "index": 0,
                    "name": "textPart",
                    "type_id": 1,
                    "description": "unique identifier for part"
                },
                {
                    "index": 1,
                    "name": "red",
                    "type_id": 1,
                    "min": 0,
                    "max": 255
                },
                {
                    "index": 2,
                    "name": "green",
                    "type_id": 1,
                    "min": 0,
                    "max": 255
                },
                {
                    "index": 3,
                    "name": "blue",
                    "type_id": 1,
                    "min": 0,
                    "max": 255
                }
            ],
            "description": "Specifies the target colour of the text in the given textpart. The bubble will then fade the text into this colour.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 6
        },
        "76": {
            "id": 76,
            "command": "BBLE",
            "parameters": [
                {
                    "index": 0,
                    "name": "text",
                    "type_id": 9
                },
                {
                    "index": 1,
                    "name": "duration",
                    "type_id": 1,
                    "description": "the number of ticks to display the bubble for"
                },
                {
                    "index": 2,
                    "name": "type",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 216
                    },
                    "description": "0=speech bubble, 1=think bubble"
                },
                {
                    "index": 3,
                    "name": "location",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 217
                    },
                    "description": "0=track owner, 1=centre in viewport"
                }
            ],
            "description": "Create a speech bubble object containing the given text for the specified number of ticks.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 6
        },
        "183": {
            "id": 183,
            "command": "BBT2",
            "parameters": [
                {
                    "index": 0,
                    "name": "textPart",
                    "type_id": 1,
                    "description": "unique identifier for part"
                },
                {
                    "index": 1,
                    "name": "string",
                    "type_id": 9,
                    "description": "string to be used"
                }
            ],
            "description": "Specify a text string to be used for the given textpart",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 6
        },
        "182": {
            "id": 182,
            "command": "BBTX",
            "parameters": [
                {
                    "index": 0,
                    "name": "textPart",
                    "type_id": 1,
                    "description": "unique identifier for part"
                },
                {
                    "index": 1,
                    "name": "stringNum",
                    "type_id": 1,
                    "description": "index in string table"
                }
            ],
            "description": "Associate a text string in the application resource table with the given text part.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 6
        },
        "33": {
            "id": 33,
            "command": "BHVR",
            "parameters": [
                {
                    "index": 0,
                    "name": "click",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 122
                    }
                },
                {
                    "index": 1,
                    "name": "touch",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 121,
                        "C1": 137
                    }
                }
            ],
            "description": "Sets/returns the reactions to clicks by mouse and activation requests by a creature. The values for click and touch are listed in the reference section",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 65
        },
        "328": {
            "id": 328,
            "command": "BHVR",
            "parameters": [
                {
                    "index": 0,
                    "name": "permissions",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 106,
                        "DS": 106,
                        "C3": 106,
                        "SM": 106
                    }
                }
            ],
            "description": "Sets the creature permissions for target. Sum the entries in the Creature Permissions table to get the value to use.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 65
        },
        "329": {
            "id": 329,
            "command": "BHVR",
            "description": "Returns the creature permissions for the target agent.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 106,
                "C3": 106,
                "DS": 106,
                "SM": 106
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 65
        },
        "527": {
            "id": 527,
            "command": "BKDS",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                }
            ],
            "description": "Returns a string containing all the background names for the specified metaroom in a comma separated list.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "385": {
            "id": 385,
            "command": "BKGD",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "background",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "transition",
                    "type_id": 1
                }
            ],
            "description": "Change the current background displayed for the selected camera (with SCAM). Transition is as for META. The background must have been specified with the ADDM or ADDB command first.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "386": {
            "id": 386,
            "command": "BKGD",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the background file currently shown by the given camera.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "977": {
            "id": 977,
            "command": "BLCK",
            "parameters": [
                {
                    "index": 0,
                    "name": "blockWidth",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "blockHeight",
                    "type_id": 1
                }
            ],
            "description": "Set the block width and height for the current agent and create the Animation strip to display the agent. This command is only for the direct display engine.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 66
        },
        "330": {
            "id": 330,
            "command": "BMPS",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4
                }
            ],
            "description": "Saves an image from the TARG agent's sprite file as a bitmap. The file will be saved using the specified name to the My Pictures folder.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 18
        },
        "427": {
            "id": 427,
            "command": "BODY",
            "parameters": [
                {
                    "index": 0,
                    "name": "setNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "layer",
                    "type_id": 1
                }
            ],
            "description": "Similar to WEAR, only puts the given set of clothes on every body part. This only works for the non tintable overlay file",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "428": {
            "id": 428,
            "command": "BODY",
            "parameters": [
                {
                    "index": 0,
                    "name": "bodyPart",
                    "type_id": 1
                }
            ],
            "description": "Return the set number of the outfit the norn is wearing on the outer most layer or -1 if it is not wearing anything",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "742": {
            "id": 742,
            "command": "BOOT",
            "parameters": [
                {
                    "index": 0,
                    "name": "subBootNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "folderNumberSum",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "clearWorld",
                    "type_id": 1
                }
            ],
            "description": "Loads in a list of numbered bootstrap folders contained within a folder called subboot. Bootstraps folders numbers are powers of 2, sum the folder numbers to load those folders. There is provision for more than one subboot folder, these should be uniquely numbered.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "429": {
            "id": 429,
            "command": "BORN",
            "description": "Signals the target creature as having been born - this sends a birth event, and sets the TAGE ticking.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "430": {
            "id": 430,
            "command": "BRED",
            "parameters": [
                {
                    "index": 0,
                    "name": "bodyPartIndex",
                    "type_id": 1
                }
            ],
            "description": "Returns the variant number for the appearance of the specified body part of the TARG creature",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 5
        },
        "387": {
            "id": 387,
            "command": "BRMI",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomBase",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "roomBase",
                    "type_id": 1
                }
            ],
            "description": "Sets the Map's Metaroom and Room index bases for adding new rooms/metarooms.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "712": {
            "id": 712,
            "command": "BRN: DMPB",
            "description": "Dumps the sizes of the binary data dumps for current lobes and tracts.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "713": {
            "id": 713,
            "command": "BRN: DMPD",
            "parameters": [
                {
                    "index": 0,
                    "name": "tractNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "dendriteNumber",
                    "type_id": 1
                }
            ],
            "description": "Dumps a dendrite as binary data.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "714": {
            "id": 714,
            "command": "BRN: DMPL",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobeNumber",
                    "type_id": 1
                }
            ],
            "description": "Dumps a lobe as binary data.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "715": {
            "id": 715,
            "command": "BRN: DMPN",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobeNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "neuronNumber",
                    "type_id": 1
                }
            ],
            "description": "Dumps a neuron as binary data.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "716": {
            "id": 716,
            "command": "BRN: DMPT",
            "parameters": [
                {
                    "index": 0,
                    "name": "tractNumber",
                    "type_id": 1
                }
            ],
            "description": "Dumps a tract as binary data.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "717": {
            "id": 717,
            "command": "BRN: SETD",
            "parameters": [
                {
                    "index": 0,
                    "name": "tractNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "dendriteNumber",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "weightNumber",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "newValue",
                    "type_id": 2
                }
            ],
            "description": "Sets a dendrite weight.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "718": {
            "id": 718,
            "command": "BRN: SETL",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobeNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "lineNumber",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "newValue",
                    "type_id": 2
                }
            ],
            "description": "Sets a lobe's SV rule float value.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "719": {
            "id": 719,
            "command": "BRN: SETN",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobeNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "neuronNumber",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "stateNumber",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "newValue",
                    "type_id": 2
                }
            ],
            "description": "Sets a neuron weight.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "720": {
            "id": 720,
            "command": "BRN: SETT",
            "parameters": [
                {
                    "index": 0,
                    "name": "tractNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "lineNumber",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "newValue",
                    "type_id": 2
                }
            ],
            "description": "Sets a tract's SV rule float value.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 11
        },
        "175": {
            "id": 175,
            "command": "BUMP",
            "description": "Returns a vehicle\u2019s collision data. This is a legacy command left in for completeness. To utilise this a vehicle must move use XVEC and YVEC (rather than VELX and VELY) and have ATTR set up to respond to boundaries.\nThe values returned are from a bit-field where:\n\\t1 = hit left\n\\t2 = hit right\n\\t4 = hit top\n\\t8 = hit bottom\nSo, for example: a value of 1 corresponds to having hit a wall to the left; a value of 4 corresponds to having hit a ceiling; a value of 5 corresponds to having hit a ceiling and a wall to the left (sum of ceiling=4, left=1)",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 185,
                "C1": 185
            },
            "rvalue": true,
            "variants": 3,
            "command_group_id": 3
        },
        "911": {
            "id": 911,
            "command": "BUZZ",
            "parameters": [
                {
                    "index": 0,
                    "name": "interval",
                    "type_id": 1
                }
            ],
            "description": "Sets the ideal interval in milliseconds between each tick. However fast the machine, it won't tick quicker than this, but it might tick slower. You can find the actual time taken with RACE. Changing this from the default value of 50 midgame will damage profiling and seasons. Things such as creature brains are designed for the default 50 millisecond update interval. Change this with caution!",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 22
        },
        "912": {
            "id": 912,
            "command": "BUZZ",
            "description": "Returns the ideal interval in milliseconds between each tick. You can find the actual interval with RACE.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 22
        },
        "431": {
            "id": 431,
            "command": "BVAR",
            "description": "Returns the variant number for target creature.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "432": {
            "id": 432,
            "command": "BYIT",
            "description": "Returns 1 if the creature is within reach of the IT agent, or 0 if it isn't.",
            "return_type_id": 1,
            "rvalue": true,
            "requires_creature_ownr": true,
            "variants": 60,
            "command_group_id": 5
        },
        "667": {
            "id": 667,
            "command": "CABB",
            "description": "Returns relative position of bottom side of cabin.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 3
        },
        "668": {
            "id": 668,
            "command": "CABL",
            "description": "Returns relative position of left side of cabin.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 3
        },
        "167": {
            "id": 167,
            "command": "CABN",
            "parameters": [
                {
                    "index": 0,
                    "name": "left",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "top",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "right",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "bottom",
                    "type_id": 1
                }
            ],
            "description": "Set the relative co-ordinates for a vehicle cabin, the place where creatures are held.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 3
        },
        "669": {
            "id": 669,
            "command": "CABP",
            "parameters": [
                {
                    "index": 0,
                    "name": "plane",
                    "type_id": 1
                }
            ],
            "description": "Set the plane that vehicle passengers are at. This is relative to the vehicle's plane.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "670": {
            "id": 670,
            "command": "CABP",
            "description": "Returns the plane that passengers of the vehicle are at.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 3
        },
        "671": {
            "id": 671,
            "command": "CABR",
            "description": "Returns relative position of right side of cabin.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 3
        },
        "672": {
            "id": 672,
            "command": "CABT",
            "description": "Returns relative position of topside of cabin.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 3
        },
        "673": {
            "id": 673,
            "command": "CABV",
            "parameters": [
                {
                    "index": 0,
                    "name": "cabinRoomId",
                    "type_id": 1
                }
            ],
            "description": "Sets the room number which things in the cabin think they are in. By default, the value is -1, and the room is the one underneath wherever the agent happens to be. Make sure you set this if the vehicle ever remotely leaves the room system. This command effects values returned from ROOM and GRID. It won't apply to some aspects of Creatures in the vehicle.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "674": {
            "id": 674,
            "command": "CABV",
            "description": "Returns the cabin room number.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 3
        },
        "675": {
            "id": 675,
            "command": "CABW",
            "parameters": [
                {
                    "index": 0,
                    "name": "cabinCapacity",
                    "type_id": 1
                }
            ],
            "description": "Set the capacity or width of the cabin. This will determine how many passengers the cabin can hold, each passenger will be on a separate plane within the cabin. Use CABP to set the plane of the first agent relative to the cabin. The default width is zero, this means that the cabin will accept any number of passengers and will place them all on the same plane.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "528": {
            "id": 528,
            "command": "CACL",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "SM": 183,
                        "C3": 183
                    }
                }
            ],
            "description": "This associates the classification specified with the CA specified. This allows the linking of CA's to classifiers within creatures' brains.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "236": {
            "id": 236,
            "command": "CAGE",
            "description": "Returns the creatures stage of life.\n0 \u2013 embryo\n1 \u2013 baby\n2 \u2013 child\n3 \u2013 adolescent\n4 \u2013 youth\n5 \u2013 adult\n6 \u2013 old\n7 \u2013 senile",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 159,
                "C1": 159,
                "CV": 159,
                "DS": 159,
                "C3": 159,
                "SM": 159
            },
            "rvalue": true,
            "variants": 63,
            "command_group_id": 5
        },
        "829": {
            "id": 829,
            "command": "CALC",
            "description": "Recalculates all the navigational CAs (warning: slow).",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 20
        },
        "743": {
            "id": 743,
            "command": "CALG",
            "parameters": [
                {
                    "index": 0,
                    "name": "categoryId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "categoryRepresentativeAlgorithmId",
                    "type_id": 1
                }
            ],
            "description": "Choose how a creature (TARG) decides which particular object in a category to look at. PICK_NEAREST_IN_X_DIRECTION=0, PICK_A_RANDOM_ONE=1, PICK_NEAREST_IN_CURRENT_ROOM=2, PICK_NEAREST_TO_GROUND=3, PICK_RANDOM_NEAREST_IN_X_DIRECTION=4.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "744": {
            "id": 744,
            "command": "CALG",
            "parameters": [
                {
                    "index": 0,
                    "name": "categoryId",
                    "type_id": 1
                }
            ],
            "description": "Find out which algorithm is currently being used for the creature TARG to decide which particular object in a category to look at.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 5
        },
        "698": {
            "id": 698,
            "command": "CALL",
            "parameters": [
                {
                    "index": 0,
                    "name": "eventNo",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 146,
                        "DS": 149,
                        "SM": 266
                    }
                },
                {
                    "index": 1,
                    "name": "param1",
                    "type_id": 13
                },
                {
                    "index": 2,
                    "name": "param2",
                    "type_id": 13
                }
            ],
            "description": "Calls a subroutine script on the owner with the specified event number. When that script finishes the current script is resumed. No variables are shared between the two scripts so any return values must go through OVs. The called script starts in the same INST state as the calling script, however, it may use SLOW or INST to override this initial state. In addition, when the script returns to the calling script, the INST state is reset to what it was before the CALL command, so CALL preserves INSTness in the calling script. So if the caller script is in an INST then the called script will inherit that, any change in the called script to cancel this (such as OVER, WAIT, SLOW etc) will only affect the called script... when execution returns to the caller script it will still be in whatever state it was in before.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 1
        },
        "301": {
            "id": 301,
            "command": "CAMN",
            "description": "Creature age in minutes",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 5
        },
        "590": {
            "id": 590,
            "command": "CAOS",
            "parameters": [
                {
                    "index": 0,
                    "name": "inline",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "stateTrans",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "p1",
                    "type_id": 13
                },
                {
                    "index": 3,
                    "name": "p2",
                    "type_id": 13
                },
                {
                    "index": 4,
                    "name": "commands",
                    "type_id": 4
                },
                {
                    "index": 5,
                    "name": "throws",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "catches",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "report",
                    "type_id": 6,
                    "variable_type_id": "4|1"
                }
            ],
            "description": "Executes the specified CAOS commands instantly. The local environment (_IT_ VAxx TARG OWNR etc.) will be promoted to the script's environment if inline is non-zero. If state_trans is non-zero, then FROM and OWNR are propagated, if zero, then the script is run orphaned. CAOS returns the output of the script. As you can put multiple scripts through in one call, the output is potentially concatenated. Note that all sets of scripts are executed in the same virtual machine if inline is non-zero, otherwise the virtual machine is reset before each script is passed. The params _p0_ and _p1_ are passed in as the parameters to the script, even when inline. You can execute \"outv 7 endm scrp 3 7 11 6 outv 3 endm outv 9\", which will make a script 3 7 11 6 and return \"79\".\nIf throws is non-zero then the system will throw exceptions, otherwise it will return \"***\" with report set to the exception sid in the CAOS catalogue TAG. If catches is non-zero then the system will catch any run errors encountered and return them in report, having set the return value to \"###\" first.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 14
        },
        "20": {
            "id": 20,
            "command": "CARR",
            "description": "Object that\u2019s carrying [OWNR].\nFor carrier of [TARG] see [TCAR]",
            "return_type_id": 11,
            "rvalue": true,
            "requires_ownr": 1,
            "variants": 3,
            "command_group_id": 7
        },
        "995": {
            "id": 995,
            "command": "CARR",
            "description": "Returns the the agent currently holding [TARG], or [NULL] if there is none.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "699": {
            "id": 699,
            "command": "CATA",
            "description": "Returns the target's category. This either depends on its classifier as described in CATI, or is its own individual override set with CATO.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 1
        },
        "331": {
            "id": 331,
            "command": "CATI",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Return the category id for the given classifier. The catalogue tag \"Agent Classifiers\" specifies these, and you can have more than 40. They are tested in order until the first match is found. 39 (or \"unclassified\") is always returned if none match.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "700": {
            "id": 700,
            "command": "CATO",
            "parameters": [
                {
                    "index": 0,
                    "name": "category",
                    "type_id": 1
                }
            ],
            "description": "Change the target's category to the one specified. The default is -1 which means the category is based on classifier and the catalogue as described in CATI. See also CATX and CATA.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 1
        },
        "332": {
            "id": 332,
            "command": "CATX",
            "parameters": [
                {
                    "index": 0,
                    "name": "categoryId",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the given category. For example, \"toy\" or \"bad bug\". The catalogue tag \"Agent Categories\" stores these. If the id is out of range, CATX returns an empty string.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "185": {
            "id": 185,
            "command": "CBRG",
            "description": "Call Button register.\nNotifies the last created lift of this call button\u2019s position.\nThis sets the floor level of the lift to be the room surface at this position.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 3
        },
        "186": {
            "id": 186,
            "command": "CBRX",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Call Button register extended.\nNotifies the last created lift of this call button and the specified position.\nThis sets the floor level of the lift to be the room surface at the specified position.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 3
        },
        "633": {
            "id": 633,
            "command": "CHAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 6,
                    "variable_type_id": "4"
                },
                {
                    "index": 1,
                    "name": "index",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "character",
                    "type_id": 1
                }
            ],
            "description": "Sets a character in a string. String indices begin at 1.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "634": {
            "id": 634,
            "command": "CHAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "index",
                    "type_id": 1
                }
            ],
            "description": "Returns a character from a string. String indices begin at 1.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "414": {
            "id": 414,
            "command": "CHAR",
            "description": "Returns the last character received by the currently selected character translator.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 29
        },
        "433": {
            "id": 433,
            "command": "CHEM",
            "parameters": [
                {
                    "index": 0,
                    "name": "chemical",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 233,
                        "C3": 140,
                        "DS": 140,
                        "SM": 140
                    }
                },
                {
                    "index": 1,
                    "name": "adjustment",
                    "type_id": 2,
                    "min": -1,
                    "max": 1
                }
            ],
            "description": "Adjusts chemical (0 to 255) by concentration -1.0 to +1.0 in the target creature's bloodstream.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "434": {
            "id": 434,
            "command": "CHEM",
            "parameters": [
                {
                    "index": 0,
                    "name": "chemical",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 233,
                        "C3": 140,
                        "DS": 140,
                        "SM": 140
                    }
                }
            ],
            "description": "Returns concentration (0.0 to 1.0) of chemical (1 to 255) in the target creature's bloodstream.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "207": {
            "id": 207,
            "command": "CHEM",
            "parameters": [
                {
                    "index": 0,
                    "name": "chemical",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                }
            ],
            "description": "Returns the concentration of a chemical in a creatures bloodstream or adds the amount given.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 5
        },
        "208": {
            "id": 208,
            "command": "CHEM",
            "parameters": [
                {
                    "index": 0,
                    "name": "chemical",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 1,
                    "name": "amount",
                    "type_id": 1
                }
            ],
            "description": "Adds the amount given.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "333": {
            "id": 333,
            "command": "CLAC",
            "description": "This returns the CLAC action of the TARG object. If the TARG is in CLIK mode, then the return value is -2. Otherwise it is the CLAC action.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 66
        },
        "510": {
            "id": 510,
            "command": "CLAC",
            "parameters": [
                {
                    "index": 0,
                    "name": "message",
                    "type_id": 1
                }
            ],
            "description": "Set the click action, which is the identifier of the message sent to the agent when it is clicked on, provided attribute Activateable is set. Default is activate 1. Use -1 to prevent it sending a message. Also overridden by CLIK. Remember that the early Message Numbers differ slightly from Script Numbers.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 28
        },
        "299": {
            "id": 299,
            "command": "CLAS",
            "description": "This sets the classifier of the current TARG. The classifier is its unique family/genus/species id. This number is calculated from the hexadecimal version of the long form classifier (see class calculator below)",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 65
        },
        "334": {
            "id": 334,
            "command": "CLIK",
            "parameters": [
                {
                    "index": 0,
                    "name": "whichValue",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 189,
                        "DS": 189,
                        "C3": 189,
                        "SM": 189
                    }
                }
            ],
            "description": "This returns the CLIK action of the TARG object. If the object is in CLAC mode, then it returns -2, else the return values are as follows:\n0 -> Current click action number (1,2,3)\n1 -> First CLIK action.\n2 -> Second CLIK action.\n3 -> Third CLIK action",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 66
        },
        "511": {
            "id": 511,
            "command": "CLIK",
            "parameters": [
                {
                    "index": 0,
                    "name": "message1",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "message2",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "message3",
                    "type_id": 1
                }
            ],
            "description": "Sets a chain of three message ids to cycle through as the agent is clicked on. Entries of -1 are ignored. Overridden by CLAC.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 28
        },
        "38": {
            "id": 38,
            "command": "CLS2",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Used when creating an object, this is how you assign it a unique classifier",
            "return_type_id": 6,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 65
        },
        "388": {
            "id": 388,
            "command": "CMRA",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "pan",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 285,
                        "DS": 285
                    }
                }
            ],
            "description": "Move current camera so top left corner of view is at world coordinate x y. Set pan 0 to jump straight to location, pan 1 to smoothly scroll there (unless in a different meta room).",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "389": {
            "id": 389,
            "command": "CMRP",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "pan",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 285,
                        "DS": 285
                    }
                }
            ],
            "description": "Centre current camera on world coordinate x y. Set pan 0 to jump straight to location, pan 1 to smoothly scroll there (unless in different meta room), and pan 2 to smoothly scroll only if the destination is already visible.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "390": {
            "id": 390,
            "command": "CMRT",
            "parameters": [
                {
                    "index": 0,
                    "name": "pan",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 285,
                        "DS": 285
                    }
                }
            ],
            "description": "Centre current camera on target. Set pan 0 to jump straight to location, pan 1 to smoothly scroll there (unless in different meta room), and pan 2 to smoothly scroll only if the destination is already visible.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "192": {
            "id": 192,
            "command": "CMRX",
            "description": "CaMeRa centre X co-ordinate.\nThe centre x co-ordinate of the camera in world co-ordinates.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 62,
            "command_group_id": 24
        },
        "193": {
            "id": 193,
            "command": "CMRY",
            "description": "CaMeRa centre Y co-ordinate.\nThe centre y co-ordinate of the camera in world co-ordinates.\nSYS: WPOS\nAttempt to position the game window,\nwith the top left corner being at (x,y) of the screen and the window having dimensions width and height.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 62,
            "command_group_id": 24
        },
        "481": {
            "id": 481,
            "command": "CODE",
            "description": "Returns event script number currently being run by target. Returns -1 if not running anything.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 147,
                "DS": 149,
                "C3": 146,
                "SM": 266
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "482": {
            "id": 482,
            "command": "CODF",
            "description": "Returns family of script currently being run by target. Returns -1 if not running anything.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "483": {
            "id": 483,
            "command": "CODG",
            "description": "Returns genus of script currently being run by target. Returns -1 if not running anything.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "484": {
            "id": 484,
            "command": "CODP",
            "description": "Returns the offset into the source code of the next instruction to be executed by the target. Use SORC to get the source code. Returns -1 if not running anything.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "485": {
            "id": 485,
            "command": "CODS",
            "description": "Returns species of script currently being run by target. Returns -1 if not running anything.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "701": {
            "id": 701,
            "command": "CORE",
            "parameters": [
                {
                    "index": 0,
                    "name": "topY",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "bottomY",
                    "type_id": 2
                },
                {
                    "index": 2,
                    "name": "leftX",
                    "type_id": 2
                },
                {
                    "index": 3,
                    "name": "rightX",
                    "type_id": 2
                }
            ],
            "description": "Sets the bounding box of the physical core of the object TARG. May be set to smaller (or larger) than the sprite's rectangle.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 1
        },
        "635": {
            "id": 635,
            "command": "COS_",
            "parameters": [
                {
                    "index": 0,
                    "name": "theta",
                    "type_id": 2
                }
            ],
            "description": "Returns cosine of theta. Theta should be in degrees.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 13
        },
        "435": {
            "id": 435,
            "command": "CREA",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                }
            ],
            "description": "Returns 1 if the agent is a creature, 0 if not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "215": {
            "id": 215,
            "command": "CREA",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 13,
                    "description": "Creature Moniker"
                }
            ],
            "description": "Returns the creature with the specified moniker",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 5
        },
        "611": {
            "id": 611,
            "command": "DATE",
            "description": "Returns the day within the current season, from 0 to GAME \"engine_LengthOfSeasonInDays\" - 1. See also HIST DATE.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "612": {
            "id": 612,
            "command": "DAYT",
            "description": "Returns the current day of the month",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "486": {
            "id": 486,
            "command": "DBG#",
            "parameters": [
                {
                    "index": 0,
                    "name": "variable",
                    "type_id": 1
                }
            ],
            "description": "Dumps debug information for the virtual machine of target. Whatever the type of the variable, a string is output.\nVariable can be:\n-1 : Whether in INST or not\n-2 : Whether in LOCK or not\n-3 : Current TARG of virtual machine\n-4 : OWNR - should be the same as our outer TARG\n-5 : FROM - who sent the message which is being run\n-6 : IT - if a Creature, where their attention was\n-7 : PART - part number being worked on for compound agents\n-8 : _P1_ - first parameter of message, if in a message\n-9 : _P2_ - second parameter of message, if in a message\n0 to 99 : Local variables VA00 to VA99",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "775": {
            "id": 775,
            "command": "DBG: ASRT",
            "parameters": [
                {
                    "index": 0,
                    "name": "condition",
                    "type_id": 15
                }
            ],
            "description": "Confirms that a condition is true. If it isn't, it displays a runtime error dialog.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "776": {
            "id": 776,
            "command": "DBG: CPRO",
            "description": "Clears agent profiling information. Measurements output with DBG: PROF start here.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "777": {
            "id": 777,
            "command": "DBG: FLSH",
            "description": "This flushes the system's input buffers - usually only useful if DBG: PAWSed.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "778": {
            "id": 778,
            "command": "DBG: HTML",
            "parameters": [
                {
                    "index": 0,
                    "name": "sortOrder",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 211,
                        "C3": 211,
                        "CV": 211,
                        "SM": 211
                    }
                }
            ],
            "description": "Sends CAOS documentation to the output stream. Sort order is 0 for alphabetical, 1 for categorical.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "779": {
            "id": 779,
            "command": "DBG: OUTS",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 4
                }
            ],
            "description": "Send a string to the debug log - use DBG: POLL to retrieve.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "780": {
            "id": 780,
            "command": "DBG: OUTV",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 16
                }
            ],
            "description": "Send a number to the debug log - use DBG: POLL to retrieve.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "781": {
            "id": 781,
            "command": "DBG: PAWS",
            "description": "This pauses everything in the game. No game driven ticks will occur until a DBG: PLAY command is issued, so this command is only useful for debugging. Use PAUS for pausing of specific agents, which you can use to implement a pause button.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "782": {
            "id": 782,
            "command": "DBG: PLAY",
            "description": "This command undoes a previously given DBG: PAWS and allows game time to flow as normal.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "783": {
            "id": 783,
            "command": "DBG: POLL",
            "description": "This takes all of the DBG: OUTV and DBG: OUTS output to date and writes it to the output stream.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "784": {
            "id": 784,
            "command": "DBG: PROF",
            "description": "Sends agent profile information to the output stream. This gives you data about the time the engine spends running the update and message handling code for each classifier. The data is measured from engine startup, or the point marked with DBG: CPRO. It's output in comma separated value (CSV) format, so you can load it into a spreadsheet (e.g. Gnumeric or Excel) for sorting and summing.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "785": {
            "id": 785,
            "command": "DBG: TACK",
            "parameters": [
                {
                    "index": 0,
                    "name": "follow",
                    "type_id": 11
                }
            ],
            "description": "Pauses the game when the given agent next executes a single line of CAOS code. This pause is mid-tick, and awaits incoming requests, or the pause key. Either another DBG: TACK or a DBG: PLAY command will make the engine carry on. Any other incoming requests will be processed as normal. However, the virtual machine of the tacking agent is effectively in mid-processing, so some CAOS commands may cause unpredictable results, and even crash the engine. In particular, you shouldn't KILL the tacking agent. You can see which agent is being tracked with TACK.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "786": {
            "id": 786,
            "command": "DBG: TOCK",
            "description": "This command forces a tick to occur. It is useful in external apps to drive the game according to a different clock instead of the game clock.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "787": {
            "id": 787,
            "command": "DBG: WTIK",
            "parameters": [
                {
                    "index": 0,
                    "name": "newWorldTick",
                    "type_id": 1
                }
            ],
            "description": "Changes the world tick WTIK to the given value. This should only be used for debugging, as it will potentially leave confusing information in the creature history, and change the time when delayed messages are processed. Its main use is to jump to different seasons and times of day.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "487": {
            "id": 487,
            "command": "DBGA",
            "parameters": [
                {
                    "index": 0,
                    "name": "variable",
                    "type_id": 1
                }
            ],
            "description": "Dumps debug information for target. Whatever the type of the variable, a string is output.\nVariable can be:\n0 to 99 : agent variables OV00 to OV99\n-1 : Counter for timer tick",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "272": {
            "id": 272,
            "command": "DBGM",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 9
                }
            ],
            "description": "Displays string as a trace message",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "271": {
            "id": 271,
            "command": "DBGV",
            "parameters": [
                {
                    "index": 0,
                    "name": "rvalue",
                    "type_id": 13
                }
            ],
            "description": "Sends the value of {rvalue}. Same as [DBUG] but doesn\u2019t force all commands to run in an [INST].",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "270": {
            "id": 270,
            "command": "DBUG",
            "parameters": [
                {
                    "index": 0,
                    "name": "rvalue",
                    "type_id": 13
                }
            ],
            "description": "All commands after this will run in an [INST], sends the value of {rvalue}.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "702": {
            "id": 702,
            "command": "DCOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "coreOn",
                    "type_id": 1
                }
            ],
            "description": "Debug command to show the physical core of the TARG agent graphically.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 1
        },
        "266": {
            "id": 266,
            "command": "DDE: CELL",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobe",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "cell",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "dentype",
                    "type_id": 1,
                    "min": 0,
                    "max": 1,
                    "description": "0 - type 0 dens, 1 - type 1 dens"
                }
            ],
            "description": "Get statistics about this neurone, in the following format: Output\nState\nNumber of dendrites of that type\nTotal susceptibility\nTotal short term weight\nTotal long term weight\nTotal strength\nThe dendrite values are totalled from all dendrites of the given dentype, for a numbered lobe and cell.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "954": {
            "id": 954,
            "command": "DDE: DEND",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobe",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "cell",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "denType",
                    "type_id": 1
                }
            ],
            "description": "Returns dendrite information for a lobe, cell and dend type.\nOutput is: NUM_DENDRITES|SRC_LOBE|{dentrite_data}*\nDendrite Data: XY{Strength}",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "267": {
            "id": 267,
            "command": "DDE: DIED",
            "description": "Update the number of norns that have died in the world",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "264": {
            "id": 264,
            "command": "DDE: GENE",
            "description": "Output the number of genes for the following 14 types: \nBrain Lobe\nChemical receptor\nChemical emitter\nChemical reaction\nChemical half life\nChemical starting concentration Organ\nCreature stimulus\nCreature genus\nCreature appearance\nCreature pose\nCreature gait\nCreature instinct\nCreature pigment",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "241": {
            "id": 241,
            "command": "DDE: GETB ALLR",
            "parameters": [
                {
                    "index": 0,
                    "name": "property",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 86
                    }
                }
            ],
            "description": "ALL Rooms property value. Returns a particular property for all rooms.\n0 = left, 1 = top, 2 = right, 3 = bottom, 4 = type, 5 = floor value, 6 = organic nutrient, 7 = inorganic nutrient,\n8 = temperature, 9 = pressure, 10 = wind x component, 11 = wind y component, 12 = light level, 13 = radiation, 14 = heat source, 15 = pressure source, 16 = light source, 17 = radiation source, 18 = visited flag.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "246": {
            "id": 246,
            "command": "DDE: GETB BIOC",
            "description": "Get biochemistry buffer. Returns a string of the target creatures chemical concentrations in the format \u201c123|33|0|...|\u201d. The string contains 256 values \u2013 as there is one entry for every chemical slot.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "257": {
            "id": 257,
            "command": "DDE: GETB CNAM",
            "description": "Write creatures name to buffer.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "258": {
            "id": 258,
            "command": "DDE: GETB CTIM",
            "description": "Get the amount of time the creature has been alive.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "256": {
            "id": 256,
            "command": "DDE: GETB DATA",
            "description": "Gets all creature data in the following format. Each entry is separated with \u2018|\u2019\nMoniker\nName\nMother's Moniker \nFather's Moniker\nBirth date - Format: HH:mm MMM DD YYYY\nBirth place\nOwner's Name\nOwner's Address\nOwner's Telephone Number\nOwner's Email\n\nExample:\n`47484238|Boseph|34646e63|346d6e63|12:50 Dec 28 2020|The birthplace|B. Summers|1630 Revello Drive, Sunnydale, CA 95037|555-8181|bsummers@email.com|`",
            "return_type_id": 8,
            "variants": 1,
            "command_group_id": 10
        },
        "990": {
            "id": 990,
            "command": "DDE: GETB DATA",
            "description": "Gets all creature data in the following format. Each entry is separated with \u2018|\u2019\nMoniker (Int)\nName\nMother's Moniker (Int)\nMother's Name\nFather's Moniker (Int)\nFather's Name\nBirth date - Format: HH:mm MMM DD YYY\nBirth place\nOwner Name\nWebsite\nNotes\nOwner's Email\nState of Creature \u2013 0=ok, 1=dead, 2=exported\nGender\nAge\nExample: \n1381517362|Sanchito|1853125733|Lupe|1853125733|Guillermo|08:23 Dec 29 2020|The birthplace|B. Summers|https://creatures.co.uk|Mi Sanchito ni\u00f1o es mi vida|bsummers@creatures.co.uk|0|1|0|",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "248": {
            "id": 248,
            "command": "DDE: GETB EMTR",
            "parameters": [
                {
                    "index": 0,
                    "name": "organ",
                    "type_id": 1,
                    "description": "organ number"
                }
            ],
            "description": "Get Emitter Buffer. Returns an integer specifying how many emitters the Targ creature\u2019s specified organ contains followed by the data for each emitter in the format \u201c1|2|33|\u201d. \nThe sequence of organ data is as follows:\n1. Locus organ identifier (byte)\n2. Locus tissue identifier (byte)\n3. Locus specifier (byte)\n4. Chemical emitted (byte)\n5. Emission threshold (byte)\n6. Emission rate (byte)\n7. Gain (byte)\n8. Effect flags (byte)\n9. Current value of source locus (byte).",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "245": {
            "id": 245,
            "command": "DDE: GETB LVOB",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Locate Visited Objects. Returns a list of X / Y positions for all the objects matching <f, g, s> that are in rooms that have been visited. After each objects details is an ampersand to allow later expansion if needed.\nReturns: X|Y|&|",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "259": {
            "id": 259,
            "command": "DDE: GETB MONK",
            "description": "Get the creatures moniker in the form \u2018464f4536\u2019 rather than \u20186EOF\u2019",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "244": {
            "id": 244,
            "command": "DDE: GETB NEWV",
            "description": "NEWly Visited rooms. Returns a list of room IDs for all rooms visited since the last query.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "247": {
            "id": 247,
            "command": "DDE: GETB ORGN",
            "description": "Get organ buffer. Returns an integer specifying how many organs the target creatures biochemistry contains followed by the data for each organ in the format \u201c1|2|4|55|\u201d. The sequence of organ data is as follows:\nClock Rate (byte)\nClock (byte)\nBioTick (unsigned integer)\nLifeForce (byte fraction of short term lifeforce) Initial LifeForce (float)\nShort Term LifeForce (float)\nLong Term LifeForce (float)\nLong Term Rate Of Repair (integer)\nLong Term Rate Of Repair Modifier (integer) Injury To Apply Next Activation (integer) EnergyCost (integer)\nDamage Due To ZeroEnergy (integer) Receptor Count (integer)\nEmitterCount (integer)\nReactionCount (integer).",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "260": {
            "id": 260,
            "command": "DDE: GETB OVVD",
            "description": "Get observation data. This returns the following information, with each field separated with a \u2018|\u2019 and each creature separated with a \u2018&\u2019:\nName\nMoniker\nSex \u2013 1=male, 2=female\nAge \u2013 in \u201chours:mins\u201d\nPregnancy \u2013 either \u201cN/A\u201d, \u201cNo\u201d or number\nLife Force \u2013 either number terminated in % or \u201cDead\u201d Medical \u2013 either \u201cHealthy\u201d, \u201cSick\u201d or \u201cDead\u201d\nRoom \u2013 number of room they are in\nXpos\nYpos",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "953": {
            "id": 953,
            "command": "DDE: GETB RCPR",
            "parameters": [
                {
                    "index": 0,
                    "name": "organ",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 249
                    },
                    "description": "Organ number"
                }
            ],
            "description": "Gets Receptor information for a given ORGAN.\nOutput Format: NUM_RECEPTORS|*RECEPTOR_INFORMATION*\nReceptor Information each receptor = ORGAN_ID|TISSUE_ID|LOCUS_ID|CHEMICAL|THRESHOLD|GAIN|EFFECT|DEST",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "249": {
            "id": 249,
            "command": "DDE: GETB RCTN",
            "parameters": [
                {
                    "index": 0,
                    "name": "organ",
                    "type_id": 1,
                    "description": "organ number"
                }
            ],
            "description": "Get Reaction Buffer. Returns an integer specifying how many reactions the Targ creature\u2019s specified organ contains followed by the data for each reaction in the format \u201c1|2|33|\u201d. The sequence of organ data is as follows:\nProportion of reactant 1 (byte) Chemical - reactant 1 (byte) Proportion of reactant 2 (byte) Chemical \u2013 reactant 2 (byte) Rate of decay (byte) Proportion of product 1 (byte) Chemical - product 1 (byte) Proportion of product 2 (byte) Chemical \u2013 product 2 (byte)",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "242": {
            "id": 242,
            "command": "DDE: GETB RPTY",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1
                }
            ],
            "description": "Returns properties of specified room# as a string. Results are in the following order:\nTemperature\nPressure\nWind X\nWind Y\nLight level Radiation\nOrganic Nutrients Inorganic Nutrients",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "243": {
            "id": 243,
            "command": "DDE: GETB RRCT",
            "description": "Room ReCTangles returns the ID, RECT structure and VISITED flag for every room.\nReturns: ID|top|left|bottom|right|VISITED(0=NO,1=YES)| Ampersand as room data separator |",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "957": {
            "id": 957,
            "command": "DDE: GETB SSFC",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomNumber",
                    "type_id": 1,
                    "description": "Room number to find points for"
                }
            ],
            "description": "Get SurFaCe points in a room.\nFormat: points_|x1|y1|x2|y2|...\nIf room number is invalid. Returns '0|'",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 21
        },
        "238": {
            "id": 238,
            "command": "DDE: GIDS FMLY",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                }
            ],
            "description": "Returns a list of all genuses that exist from within a certain family number.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "239": {
            "id": 239,
            "command": "DDE: GIDS GNUS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                }
            ],
            "description": "Returns a list of all species that exist from within a certain family and genus number",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "237": {
            "id": 237,
            "command": "DDE: GIDS ROOT",
            "description": "Returns a list of all the Family numbers that exist, separated with a space.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "240": {
            "id": 240,
            "command": "DDE: GIDS SPCS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Returns a list of all events that exist from within a certain family genus and species",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "269": {
            "id": 269,
            "command": "DDE: HATC",
            "description": "Update the number of hatchery norns in the world.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "268": {
            "id": 268,
            "command": "DDE: LIVE",
            "description": "Update the number of natural born norns in the world.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "253": {
            "id": 253,
            "command": "DDE: LNEU",
            "parameters": [
                {
                    "index": 0,
                    "name": "flags",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 222
                    },
                    "description": "0 = type 0 dens, 1 = type 2 dens"
                }
            ],
            "description": "Returns info about all firing cells in the brain. All numbers returned by this command are scaled to range from 0 to 63 then added to ascii \u20180\u2019 to keep them in printable range.\nEach firing neurone is returned in the following format: XYS[den0info][den1info]\nX and Y is the neurone position, and S is the neurone state.\nDen0info and Den1info are only sent depending on the flags field:\nflags:\n0 = output type 0 dens\n1 = output type 1 dens\nThe dendrite info format begins with a number indicating how many dendrites are feeding the cell, followed by a list of dendrites in the format:\nXYS\nWhere X,Y and S are the position and state of the source neuron.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "263": {
            "id": 263,
            "command": "DDE: LOBE",
            "description": "Output locations and information about brain lobes as a stream of bytes\nThe first number returned is the number of lobes followed by the following for each lobe\n- x_start\n- y_start\n- width\n- height\n- Separator(?) Seems to be 0x00 or 0x01",
            "return_type_id": 8,
            "variants": 1,
            "command_group_id": 10
        },
        "992": {
            "id": 992,
            "command": "DDE: LOBE",
            "description": "Output locations and information about brain lobes. The first number returned is the number of lobes, and then the information about them is returned in the following format, with the \u2018|\u2019 symbol separating fields:\n\\t-X position start\n\\t-Y position start\n\\t-Width\n\\t-Height\n\\t-Flags\n\\t-Number of Dendrites \n\\t-Dendrite type 0 source \n\\t-Dendrite type 0 minimum \n\\t-Dendrite type 0 maximum \n\\t-Dendrite type 1 source \n\\t-Dendrite type 1 minimum \n\\t-Dendrite type 1 maximum",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "252": {
            "id": 252,
            "command": "DDE: NACT",
            "description": "Neural activity. Returns pipe-delimited numbers. First number is the number of brain lobes, each lobe then has an entry of the format \u201c1|2|3\u201d , where the sequence is in the following order:\nNumber Of Cells Cell Flags\nFire Count Total Output Total State",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 10
        },
        "261": {
            "id": 261,
            "command": "DDE: NEGG",
            "description": "Update number of natural eggs in the world.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "262": {
            "id": 262,
            "command": "DDE: PANC",
            "description": "Pan camera to the creature.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "250": {
            "id": 250,
            "command": "DDE: PIC2",
            "parameters": [
                {
                    "index": 0,
                    "name": "width",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "height",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "filename",
                    "type_id": 9
                }
            ],
            "description": "PICture. Replaces macro PICT. This takes a snapshot of the currently selected creature of size width and height and saves it in the filename specified. The format of the file is S16. Note that the picture will be clipped by the top and bottom edges of the world and by the viewport. This will result in an image smaller than requested.\nReturns a string \u201c1\u201d if successful, \u201c0\u201d if not.",
            "return_type_id": 8,
            "return_values_list_ids": {
                "C2": 224
            },
            "variants": 2,
            "command_group_id": 10
        },
        "310": {
            "id": 310,
            "command": "DDE: PICT",
            "parameters": [
                {
                    "index": 0,
                    "name": "dimensions",
                    "type_id": 19,
                    "description": "Three chars literal with char 1 and 3 representing dimensions and char 2 a delimiter usually \"|\""
                }
            ],
            "description": "Takes a snapshot of the selected creature using the given dimensions. Dimensions are given as 3 chars. First and third char codes are width and height respectively. Second char is ignored. Picture is saved as an upside down SPR file without full headers.",
            "return_type_id": 8,
            "variants": 1,
            "command_group_id": 10
        },
        "309": {
            "id": 309,
            "command": "DDE: PUTB",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 9
                },
                {
                    "index": 1,
                    "name": "option",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 70
                    }
                }
            ],
            "description": "Write from string to location determined by option token\n#{dde: putb [CREATURE_NAME] cnam} sets the creatures name, but does not teach the creature its own name. For that use the extended #{dde: putb [...data...] data}.\n\nFor DDE: PUTB [string] DATA, expected the following fields, separated by a '|' character:\nMoniker (Int)\nName\nMother's Moniker (Int)\nMother's Name\nFather's Moniker (Int)\nFather's Name\nBirth date - Format: HH:mm MMM DD YYY\nBirth place\nOwner Name\nWebsite\nNotes\nOwner's Email\nState of Creature \u2013 0=ok, 1=dead, 2=exported\nGender\nAge\n\nUse: [DDE: GETB DATA] to get initial data\n\nExample\n#{dde: putb [1381517362|Sanchito|1853125733|Mother Dearest|1853125733|Pa'|08:23 Dec 29 2020|Jungle|Darien|https://www.darien.fake|My Sanchito, a cupcake for us all|darien@fake-email.com|0|1|0|]}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "989": {
            "id": 989,
            "command": "DDE: PUTB",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 9
                },
                {
                    "index": 1,
                    "name": "option",
                    "type_id": 3,
                    "values_list_ids": {
                        "C1": 70
                    }
                }
            ],
            "description": "Write from string to location determined by option token\n\n#{dde: putb [CREATURE_NAME] cnam} sets the creatures name, but does not teach the creature its own name, and does not immediately update UI. Best to use the extended#{dde: putb [...data...] data}.\n\nDDE: PUTB [string] DATA expects the following fields, separated by a '|' character:\nMoniker (Int)\nName\nMother's Moniker (Int)\nFather's Moniker (Int)\nBirth date (HH:mm MMM DD YYYY)\nBirth place\nOwner's Name\nOwner's Address\nOwner's Phone Number\nOwner's Email\n\nThe base information to use here can be aquired by using [DDE: GETB DATA]\n\nExample usage:\n#{dde: putb [47484238|Bo|34646e63|346d6e63|12:50 Dec 28 2020|The Island|Darien|2218 Thomas Pl. Someplace, CA 92335|555-8181|something@email.com|]}",
            "return_type_id": 8,
            "variants": 0,
            "command_group_id": 10
        },
        "255": {
            "id": 255,
            "command": "DDE: PUTS",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 9
                }
            ],
            "description": "Send a string to the output window.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "251": {
            "id": 251,
            "command": "DDE: PUTV",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 1
                }
            ],
            "description": "Display the value of {rvalue}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "308": {
            "id": 308,
            "command": "DDE: SCRP",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "event",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 150,
                        "C2": 120,
                        "CV": 147,
                        "C3": 146,
                        "DS": 149,
                        "SM": 266
                    }
                }
            ],
            "description": "fetch a script from the scriptorium and send it (used by script editor for reading out & editing existing scripts",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "265": {
            "id": 265,
            "command": "DDE: WORD",
            "parameters": [
                {
                    "index": 0,
                    "name": "index",
                    "type_id": 1
                }
            ],
            "description": "Read a word from the TARG blackboards word list. Sends the response of \u2018###|text|\u2019 where \u2018###\u2019 is the vocabulary slot for the idea represented by the blackboard picture whose index is index, and \u2018text\u2019 is the word it knows for it.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 10
        },
        "302": {
            "id": 302,
            "command": "DEAD",
            "description": "Creature is dead",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 182,
                "DS": 182,
                "C3": 182,
                "C1": 182,
                "C2": 182,
                "SM": 182
            },
            "rvalue": true,
            "variants": 63,
            "command_group_id": 5
        },
        "436": {
            "id": 436,
            "command": "DEAD",
            "description": "Makes the target creature die, triggering Die script and history events, closing its eyes, and stopping brain and biochemistry updates. Not to be confused with [KILL], which you will have to use later to remove the actual body.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "437": {
            "id": 437,
            "command": "DECN",
            "description": "Returns the current focus of decision id.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "917": {
            "id": 917,
            "command": "DELE",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 4
                }
            ],
            "description": "Deletes the specified EAME variable.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 12
        },
        "636": {
            "id": 636,
            "command": "DELG",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 4
                }
            ],
            "description": "Deletes the specified GAME variable.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "529": {
            "id": 529,
            "command": "DELM",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                }
            ],
            "description": "Deletes the specified metaroom from the map.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "144": {
            "id": 144,
            "command": "DELN",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1,
                    "description": "room ID."
                },
                {
                    "index": 1,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                }
            ],
            "description": "Delete Neighbour doors. Removes all neighbours for a room. Does not actually delete the rooms, just the relationship between room and the neighbours",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 20
        },
        "918": {
            "id": 918,
            "command": "DELN",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 13
                }
            ],
            "description": "Deletes the specified NAME variable on TARG.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 12
        },
        "143": {
            "id": 143,
            "command": "DELR",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                }
            ],
            "description": "Remove the room from the map.",
            "return_type_id": 8,
            "variants": 62,
            "command_group_id": 20
        },
        "680": {
            "id": 680,
            "command": "DELW",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldName",
                    "type_id": 4
                }
            ],
            "description": "Deletes the specified world directory.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "438": {
            "id": 438,
            "command": "DFTX",
            "description": "Returns X coordinate of creature's down foot.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "439": {
            "id": 439,
            "command": "DFTY",
            "description": "Returns Y coordinate of creature's down foot.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "440": {
            "id": 440,
            "command": "DIRN",
            "parameters": [
                {
                    "index": 0,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 96,
                        "DS": 96,
                        "C3": 96,
                        "SM": 96
                    }
                }
            ],
            "description": "Change creature to face a different direction. North 0, South 1, East 2, West 3.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "213": {
            "id": 213,
            "command": "DIRN",
            "description": "Returns the direction the creature is facing.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 96,
                "CV": 96,
                "DS": 96,
                "C3": 96,
                "SM": 96
            },
            "rvalue": true,
            "variants": 62,
            "command_group_id": 5
        },
        "335": {
            "id": 335,
            "command": "DISQ",
            "parameters": [
                {
                    "index": 0,
                    "name": "other",
                    "type_id": 11
                }
            ],
            "description": "Returns the square of the distance between the centre points of the target agent, and the other agent. It is quicker to compare this square against a squared constant directly, or if you need the actual distance use SQRT.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 13
        },
        "70": {
            "id": 70,
            "command": "DIVV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "div",
                    "type_id": 1
                }
            ],
            "description": "{value1} = {value1} / {value2}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 13
        },
        "637": {
            "id": 637,
            "command": "DIVV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "#"
                },
                {
                    "index": 1,
                    "name": "div",
                    "type_id": 16
                }
            ],
            "description": "Divides a variable by an integer or float, so var = var / div. Uses integer division if both numbers are integers, or floating point division otherwise.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 13
        },
        "530": {
            "id": 530,
            "command": "DMAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "debugMap",
                    "type_id": 1
                }
            ],
            "description": "Set to 1 to turn the debug map image on, 0 to turn it off. The debug map includes vehicle cabin lines.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "531": {
            "id": 531,
            "command": "DOCA",
            "parameters": [
                {
                    "index": 0,
                    "name": "noOfUpdates",
                    "type_id": 1
                }
            ],
            "description": "Updates all CAs the specified number of times.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "97": {
            "id": 97,
            "command": "DOIF",
            "parameters": [
                {
                    "index": 0,
                    "name": "condition",
                    "type_id": 15
                }
            ],
            "description": "Do next instructions if condition is true, else skip to after correct nested [ELSE] or [ENDI]",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "721": {
            "id": 721,
            "command": "DOIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "noOfInstinctsToProcess",
                    "type_id": 1
                }
            ],
            "description": "Make the creature TARG process N instincts.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 11
        },
        "229": {
            "id": 229,
            "command": "DONE",
            "description": "This voluntary or involuntary action has been completed.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 5
        },
        "532": {
            "id": 532,
            "command": "DOOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "room1Id",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "room2Id",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "permiability",
                    "type_id": 1
                }
            ],
            "description": "Sets the permiability of the door between two rooms. This is used for both CAs and physical motion. See also PERM.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "533": {
            "id": 533,
            "command": "DOOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "room1Id",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "room2Id",
                    "type_id": 1
                }
            ],
            "description": "Returns the door permeability between two rooms.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "145": {
            "id": 145,
            "command": "DOOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                },
                {
                    "index": 1,
                    "name": "room1Id",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "room2Id",
                    "type_id": 1
                }
            ],
            "description": "Gets/sets the door open value between the given rooms.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "534": {
            "id": 534,
            "command": "DOWN",
            "description": "Returns the value of the down constant.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "676": {
            "id": 676,
            "command": "DPAS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Drop all passengers matching classifier.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "169": {
            "id": 169,
            "command": "DPAS",
            "description": "Drop all passengers with gravity\nThis works the same way as specifying #{dps2 1}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 3
        },
        "168": {
            "id": 168,
            "command": "DPS2",
            "parameters": [
                {
                    "index": 0,
                    "name": "gravity",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 220
                    }
                }
            ],
            "description": "Drop Passengers 2. Causes any creatures carried by the vehicle to be \u2018dropped\u2019.\nGravity\n\\t0 - Gravity not activated on object\n\\tnon-zero - gravity is activated on object",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 3
        },
        "441": {
            "id": 441,
            "command": "DREA",
            "parameters": [
                {
                    "index": 0,
                    "name": "dream",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 157,
                        "C3": 157,
                        "DS": 157,
                        "SM": 157
                    }
                }
            ],
            "description": "Set to 1 to make the creature fall asleep and dream, 0 to stop the creature dreaming. When dreaming, a creature's instincts are processed. See also ASLP.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "442": {
            "id": 442,
            "command": "DREA",
            "description": "Returns 1 if the creature is asleep and dreaming, 0 otherwise.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 157,
                "DS": 157,
                "C3": 157,
                "SM": 157
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "231": {
            "id": 231,
            "command": "DREA",
            "parameters": [
                {
                    "index": 0,
                    "name": "max",
                    "type_id": 1
                }
            ],
            "description": "Start dreaming. This starts processing of any pending instincts instead of receiving sensory data from the environment. Normally this should only be done during deep sleep and during embryology.\nmax pending instincts will be processed and then dream state switches off automatically.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "443": {
            "id": 443,
            "command": "DRIV",
            "parameters": [
                {
                    "index": 0,
                    "name": "drive",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 1,
                    "name": "adjustment",
                    "type_id": 2
                }
            ],
            "description": "Adjusts the level of the given drive by the specified amount - can be positive or negative.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "444": {
            "id": 444,
            "command": "DRIV",
            "parameters": [
                {
                    "index": 0,
                    "name": "drive",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                }
            ],
            "description": "Returns the value (0.0 to 1.0) of the specified drive.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "205": {
            "id": 205,
            "command": "DRIV",
            "parameters": [
                {
                    "index": 0,
                    "name": "drive",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 78,
                        "C2": 134
                    },
                    "description": "drive number"
                }
            ],
            "description": "Returns the state of the creatures Drive number",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 134,
                "C1": 78
            },
            "rvalue": true,
            "variants": 3,
            "command_group_id": 5
        },
        "232": {
            "id": 232,
            "command": "DROP",
            "description": "Drop any objects you are carrying",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 1
        },
        "206": {
            "id": 206,
            "command": "DRV!",
            "description": "Returns the id of the highest drive for the target creature.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 134,
                "C1": 78,
                "CV": 234,
                "C3": 234,
                "DS": 234,
                "SM": 234
            },
            "rvalue": true,
            "variants": 63,
            "command_group_id": 5
        },
        "703": {
            "id": 703,
            "command": "DSEE",
            "parameters": [
                {
                    "index": 0,
                    "name": "canSeeOn",
                    "type_id": 1
                }
            ],
            "description": "Debug command to show all the agents which can be seen by any creature.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 1
        },
        "445": {
            "id": 445,
            "command": "DYED",
            "parameters": [
                {
                    "index": 0,
                    "name": "bodyId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "overlayFile",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "setNumber",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "layer",
                    "type_id": 1
                }
            ],
            "description": "Sets a layer of clothing on part of the creature. The overlay_file is the index of the overlay gallery. Currently there is also one tintable gallery available which is index 1. The set_number is the type of clothing to put on from the overlay file - think of it as an outfit number. layer 0 is the actual body of the creature, so unless you want to replace the body part itself use a higher layer. Higher layers are on top of lower ones. e.g. 0 for a face, 1 for measles spots, 2 for a fencing mask. See also BODY and NUDE.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 5
        },
        "919": {
            "id": 919,
            "command": "EAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 4
                }
            ],
            "description": "Very similar to GAME variables only they aren't saved or loaded with the world; they keep their value between worlds for one session of the engine. The E in EAME stands for for Engine. See the table of engine Eame Variables.",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "920": {
            "id": 920,
            "command": "EAMN",
            "parameters": [
                {
                    "index": 0,
                    "name": "previous",
                    "type_id": 4
                }
            ],
            "description": "Enumerates through EAME variable names, roughly as GAMN does through GAME variables. Start and end with an empty string.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "589": {
            "id": 589,
            "command": "ECON",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                }
            ],
            "description": "Starts an enumeration across all the agents in a connective system, where agent is any agent within the connective system.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "21": {
            "id": 21,
            "command": "EDIT",
            "description": "The contents of the edit buffer, set by using the [EDIT] command or shift clicking an object.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 1
        },
        "22": {
            "id": 22,
            "command": "EDIT",
            "description": "Adds TARG agent to hand",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 1
        },
        "161": {
            "id": 161,
            "command": "EGGL",
            "description": "Egg Limit. Returns the number of norns above which eggs should stop hatching",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "569": {
            "id": 569,
            "command": "ELAS",
            "parameters": [
                {
                    "index": 0,
                    "name": "elasticity",
                    "type_id": 1
                }
            ],
            "description": "Set the elasticity percentage. An agent with elasticity 100 will bounce perfectly, one with elasticity 0 won't bounce at all.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "570": {
            "id": 570,
            "command": "ELAS",
            "description": "Return the elasticity percentage.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "503": {
            "id": 503,
            "command": "ELIF",
            "parameters": [
                {
                    "index": 0,
                    "name": "condition",
                    "type_id": 15
                }
            ],
            "description": "ELseIF command to follow a DOIF. If the condition in a DOIF is false, each following ELIF command will be evaluated in turn. Only the first true condition will have its code block executed.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 15
        },
        "98": {
            "id": 98,
            "command": "ELSE",
            "description": "Hit an [ELSE] during normal processing (ie. previous [DOIF] was true), so jump from here to corresponding [ENDI], skipping any nested [DOIF]s en route",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "535": {
            "id": 535,
            "command": "EMID",
            "description": "Returns a string containing all the metaroom ids in the world separated by spaces.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "536": {
            "id": 536,
            "command": "EMIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "C3": 183,
                        "SM": 183
                    }
                },
                {
                    "index": 1,
                    "name": "amount",
                    "type_id": 2
                }
            ],
            "description": "Target now constantly emits an amount of a CA into the room it is in.\nAgents can only emit one CA at a time. Each call replaces the previous emitter",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "99": {
            "id": 99,
            "command": "ENDI",
            "description": "Marks end of a [DOIF] or [DOIF]/[ELSE] statement",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "78": {
            "id": 78,
            "command": "ENDM",
            "description": "Compulsory command at end of macro, placed there by Macro constructor Macro is terminated and maybe self-destructs only [STOP] (never [ENDM]) commands may be placed in the body of macro. [ENDM] is string terminator",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "86": {
            "id": 86,
            "command": "ENUM",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "[ENUM]...[NEXT]\nIterate through each object which conforms to the given classification,\nsetting [TARG] to point to each valid object in turn.\nFamily, Genus and/or Species can be zero to act as wildcards.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 16
        },
        "677": {
            "id": 677,
            "command": "EPAS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Enumerate over owner vehicle's passengers which match the given classifier. Similar to ENUM.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 16
        },
        "537": {
            "id": 537,
            "command": "ERID",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                }
            ],
            "description": "Returns a string containing all the room ids in the specified metaroom separated by spaces. Returns all rooms in the world if metaroom_id is -1.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "90": {
            "id": 90,
            "command": "ESCN",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "...[NSCN]\nEnumerate all specified scenery objects.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 16
        },
        "87": {
            "id": 87,
            "command": "ESEE",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "ESEE...[NEXT]\nEnumerate across all specified objects that can be seen by the [OWNR] object.\nNote: All commands between [ESEE] and [NEXT] run as [INST]. [TARG] is returned to [OWNR] (in event scripts) after enumeration.",
            "return_type_id": 8,
            "requires_ownr": 1,
            "variants": 62,
            "command_group_id": 16
        },
        "88": {
            "id": 88,
            "command": "ETCH",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "ETCH...[NEXT]\nEnumerate across all specified objects are touching the [OWNR] object.\nNote: All commands between [ESEE] and [NEXT] run as [INST]. [TARG] is returned to [OWNR] (in event scripts) after enumeration.",
            "return_type_id": 8,
            "requires_ownr": 1,
            "variants": 62,
            "command_group_id": 16
        },
        "613": {
            "id": 613,
            "command": "ETIK",
            "description": "Returns the number of ticks since the engine was loaded in.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "96": {
            "id": 96,
            "command": "EVER",
            "description": "Part of a [LOOP]-[EVER] statement. Repeat loop forever.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "277": {
            "id": 277,
            "command": "EVNT",
            "parameters": [
                {
                    "index": 0,
                    "name": "targ",
                    "type_id": 11
                }
            ],
            "description": "Adds an event label to the Event Bar, the three types possible are BIRTH, DEATH and EGG.\nTo get a death event call this macro with targ as OWNR in it\u2019s death script.\nTo get a birth event call this macro with targ as a new creature To get an egg event call this macro with targ as a newly created egg object.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "295": {
            "id": 295,
            "command": "EXEC",
            "description": "object who EXECuted the tool who owns this\nreturn (int)Exec; dde macro. NOTE: only valid for DDE\ntools who *know* that they were executed by an object",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 21
        },
        "950": {
            "id": 950,
            "command": "EXEC",
            "parameters": [
                {
                    "index": 0,
                    "name": "fsp",
                    "type_id": 9,
                    "description": "Executable name or absolute path."
                },
                {
                    "index": 1,
                    "name": "params",
                    "type_id": 9,
                    "description": "Parameters to pass to executable"
                }
            ],
            "description": "Execute a tool or other application.\nExample: exec [fsp.exe] [params] \nExample: exec [c:\\path\\fsp.exe] [params]\nIf fsp contains backslashes, it must be a full path, so execute GP program.\nIf no backslashes, assume it's a tool, so try both hard drive AND CD-ROM\n[params] are the command-line params for the program (or use [] if none)",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "446": {
            "id": 446,
            "command": "EXPR",
            "parameters": [
                {
                    "index": 0,
                    "name": "animatedExpressionIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 192
                    }
                },
                {
                    "index": 1,
                    "name": "ticks",
                    "type_id": 1
                }
            ],
            "description": "This sets the animated expression for a creatures, these are facial expressions requiring more than one frame and lasting a specified number of ticks, for example laughing or eating. Animated expression indexes are as follows: 0 - laugh 1 - cry 2 - eat",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 5
        },
        "447": {
            "id": 447,
            "command": "EXPR",
            "description": "Returns the current facial expression index for the creature. Expressions are as follows: EXPR_NORMAL = 0, EXPR_HAPPY =1, EXPR_SAD = 2, EXPR_ANGRY= 3, EXPR_SURPRISE = 4, EXPR_SLEEPY = 5, EXPR_VERY_SLEEPY = 6, EXPR_VERY_HAPPY = 7, EXPR_MISCHIEVOUS = 8, EXPR_SCARED = 9, EXPR_ILL = 10, EXPR_HUNGRY = 11",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "949": {
            "id": 949,
            "command": "F**K",
            "description": "Only relevant to male creatures:\nPass any waiting sperm to female (if IT is a female of same genus).\nFemale will conceive if she's in the right condition (fertile & receptive)",
            "return_type_id": 8,
            "variants": 1,
            "command_group_id": 5
        },
        "448": {
            "id": 448,
            "command": "FACE",
            "parameters": [
                {
                    "index": 0,
                    "name": "setNumber",
                    "type_id": 1
                }
            ],
            "description": "Sets a facial expression on target creature.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "449": {
            "id": 449,
            "command": "FACE",
            "description": "Returns the front facing pose for the current facial expression. See the FACE string rvalue.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "450": {
            "id": 450,
            "command": "FACE",
            "description": "Returns the name of the sprite file for the target creature's face. Currently automatically gives you the youngest age version of the gallery but soon will work in the following way: If you set the parameter to -1 you will get the name of the file the creature is currently using. Note that when the creature ages, this file name will change (the GALL command could be useful here). If you set the parameter to a particular age then the filename returned will be the gallery that best matches that age. Use the FACE integer rvalue to get the pose number for facing forwards.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "204": {
            "id": 204,
            "command": "FADE",
            "description": "Fade out any controlled sound currently playing with this [TARG].",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 25
        },
        "571": {
            "id": 571,
            "command": "FALL",
            "description": "Returns 1 if target is moving under the influence of gravity, or 0 if it is at rest.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C3": 286,
                "DS": 286
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "415": {
            "id": 415,
            "command": "FCUS",
            "description": "Set keyboard focus to the current PART of the targeted agent. The part should be a PAT: TEXT. If you TARG NULL first, then no part will have the focus.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "835": {
            "id": 835,
            "command": "FDMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "dampingFactor",
                    "type_id": 2
                }
            ],
            "description": "Damp forward velocity by this much each tick. The value is from 0.0 to 1.0 where 0.0 means no damping, 1.0 maximum.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "836": {
            "id": 836,
            "command": "FDMP",
            "description": "Get current forwards damping. The value is from 0.0 to 1.0 where 0.0 means no damping, 1.0 maximum.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "936": {
            "id": 936,
            "command": "FILE EXEC",
            "parameters": [
                {
                    "index": 0,
                    "name": "directory",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4
                }
            ],
            "description": "Launches an executable",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 30
        },
        "788": {
            "id": 788,
            "command": "FILE GLOB",
            "parameters": [
                {
                    "index": 0,
                    "name": "directory",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filespec",
                    "type_id": 4
                }
            ],
            "description": "This globs a journal directory (0 for world one, 1 for main one) for the filespec provided. As all this can do is list files, it does not worry about where you look relative to the journal directory in question. Use this with care.\nHaving globbed a directory, the listing is available on the input stream as a number, followed by the names of each file. To read - ise INOK, INNI and INNL. Once you have finished, remember to do a FILE ICLO to remove the glob output from the VM.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "789": {
            "id": 789,
            "command": "FILE ICLO",
            "description": "Disconnects anything which is attached to the input stream. If this is a file, then the file is closed.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "790": {
            "id": 790,
            "command": "FILE IOPE",
            "parameters": [
                {
                    "index": 0,
                    "name": "directory",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 295,
                        "DS": 295,
                        "SM": 295,
                        "CV": 295
                    }
                }
            ],
            "description": "Sets the file for the input stream of the current virtual machine - there is a virtual machine for each agent, so this is much the same as setting it for OWNR. Use INNL, INNI and INNF to get data from the stream, and INOK to check validity of the stream. The filename should include any file extension.\nYou should use FILE ICLO to close the file, although this happens automatically if you set a new file, if the virtual machine is destroyed, or if the engine exits.\nDirectory is 0 for the current world's journal directory, 1 for the main journal directory, or 2 for the GAME engine_other_world world's journal directory.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "791": {
            "id": 791,
            "command": "FILE JDEL",
            "parameters": [
                {
                    "index": 0,
                    "name": "directory",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 295,
                        "DS": 295,
                        "SM": 295,
                        "CV": 295
                    }
                }
            ],
            "description": "This deletes the file (filename) specified from the journal directory specified. If directory is zero, this is the current world's journal directory, otherwise it is the main journal directory. It deletes the file immediately, rather than marking it for the attic.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "792": {
            "id": 792,
            "command": "FILE OCLO",
            "description": "Disconnects anything which is attached to the output stream. If this is a file, then the file is closed.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "793": {
            "id": 793,
            "command": "FILE OFLU",
            "description": "Flush output stream. If it is attached to a disk file, this will force any data in the buffer to be written to disk.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "794": {
            "id": 794,
            "command": "FILE OOPE",
            "parameters": [
                {
                    "index": 0,
                    "name": "directory",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 212,
                        "C3": 212,
                        "CV": 212,
                        "SM": 212
                    }
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 295,
                        "DS": 295,
                        "SM": 295,
                        "CV": 295
                    }
                },
                {
                    "index": 2,
                    "name": "append",
                    "type_id": 1
                }
            ],
            "description": "Sets the file for the output stream of the current virtual machine - there is a virtual machine for each agent, so this is much the same as setting it for OWNR. Use OUTV and OUTS or various other commands to send text data to the stream. The filename should include any file extension.\nYou should use FILE OCLO to close the file, although this happens automatically if you set a new file, if the virtual machine is destroyed, or if the engine exits.\nDirectory is 0 for the current world's journal directory, 1 for the main journal directory, or 2 for the GAME engine_other_world world's journal directory. Set append to 1 to add to the end of the file, or 0 to replace any existing file.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "218": {
            "id": 218,
            "command": "FIRE",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "amount",
                    "type_id": 1,
                    "min": 0,
                    "max": 255
                }
            ],
            "description": "Fire the neurone whose position is at xy \u2013 amount is the signal strength (0-255)",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 11
        },
        "978": {
            "id": 978,
            "command": "FLIP",
            "parameters": [
                {
                    "index": 0,
                    "name": "onOrOff",
                    "type_id": 1
                }
            ],
            "description": "Tell the agent to draw the current sprite vertically flipped (send 1 as a parameter) or normally (send 0 as a parameter). This only works when using the direct display engine.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 18
        },
        "979": {
            "id": 979,
            "command": "FLIP",
            "description": "Is the current sprite for this agent vertically flipped (returns 1) or not (returns 0)",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 32,
            "command_group_id": 18
        },
        "152": {
            "id": 152,
            "command": "FLOR",
            "description": "Returns the y co-ordinate of the floor at the centre x position of [Targ].",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "572": {
            "id": 572,
            "command": "FLTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "screenX",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "screenY",
                    "type_id": 2
                }
            ],
            "description": "Move the top left corner of target to either the given screen coordinates, or the given coordinates relative to the agent it is FREL to. Useful for floating agents.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "336": {
            "id": 336,
            "command": "FLTX",
            "description": "This returns the X position of the TARG object's floating vector.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "337": {
            "id": 337,
            "command": "FLTY",
            "description": "This returns the Y position of the TARG object's floating vector.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "58": {
            "id": 58,
            "command": "FMLY",
            "description": "Returns the object\u2019s family",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 65
        },
        "451": {
            "id": 451,
            "command": "FORF",
            "parameters": [
                {
                    "index": 0,
                    "name": "creatureToLearnAbout",
                    "type_id": 11
                }
            ],
            "description": "Set the friends or foe lobe to learn from the creature.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "338": {
            "id": 338,
            "command": "FRAT",
            "parameters": [
                {
                    "index": 0,
                    "name": "framerate",
                    "type_id": 1
                }
            ],
            "description": "This command sets the frame rate on the TARG agent. If it is a compound agent, then the part affected can be set with the PART command. Valid rates are from 1 to 255. 1 is Normal rate, 2 is half speed etc...",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 1
        },
        "573": {
            "id": 573,
            "command": "FREL",
            "parameters": [
                {
                    "index": 0,
                    "name": "relative",
                    "type_id": 11
                }
            ],
            "description": "Sets an agent for target to float relative to. To make target actually float, you need to set attribute Floatable as well. Set FREL to NULL to make the target float relative to the main camera - this is the default. Use FLTO to set the relative position of the top left corner of the floating agent to the top left corner of the agent it is floating relative to.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "574": {
            "id": 574,
            "command": "FRIC",
            "parameters": [
                {
                    "index": 0,
                    "name": "friction",
                    "type_id": 1
                }
            ],
            "description": "Set physics friction percentage, normally from 0 to 100. Speed is lost by this amount when an agent slides along the floor.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "575": {
            "id": 575,
            "command": "FRIC",
            "description": "Return physics friction percentage.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "416": {
            "id": 416,
            "command": "FRMT",
            "parameters": [
                {
                    "index": 0,
                    "name": "leftMargin",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "topMargin",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "rightMargin",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "bottomMargin",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "lineSpacing",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "characterSpacing",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "justification",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 188,
                        "DS": 190,
                        "C3": 190,
                        "SM": 190
                    }
                }
            ],
            "description": "Use this command to alter the appearance of the current text part. The line and character spacing values are expressed in number of extra pixels to insert between characters. Values for justification are 0 - Left, 1 - Right, 2 - Center, 4 - Bottom, 8 - Middle (you may add mutually compatible numbers). The default format values are 8 8 8 8 0 0 0.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "16": {
            "id": 16,
            "command": "FROM",
            "description": "Object who caused event leading to execution of this script.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 7
        },
        "704": {
            "id": 704,
            "command": "FROM",
            "description": "If we're processing a message, this is the OWNR who sent the message. NULL if the message was sent from an injected script or an install script. If the message was sent over the network using NET: WRIT, then this contains the user id of the sender, as a string.",
            "return_type_id": 11,
            "rvalue": true,
            "lvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "391": {
            "id": 391,
            "command": "FRSH",
            "description": "Refreshes the main view port.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "47": {
            "id": 47,
            "command": "FRZN",
            "description": "Sets/returns whether an object is Frozen. Can be 1 or 0.\nWhen an object is frozen it no longer receives updates and, in the case of creatures, external stimuli.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 267
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 1
        },
        "638": {
            "id": 638,
            "command": "FTOI",
            "parameters": [
                {
                    "index": 0,
                    "name": "numberToConvert",
                    "type_id": 2
                }
            ],
            "description": "Converts a floating-point value into its integer equivalent.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "837": {
            "id": 837,
            "command": "FVEL",
            "parameters": [
                {
                    "index": 0,
                    "name": "amountInPixels",
                    "type_id": 2
                }
            ],
            "description": "Set forwards velocity.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "838": {
            "id": 838,
            "command": "FVEL",
            "description": "Get current forwards velocity.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "495": {
            "id": 495,
            "command": "FVWM",
            "parameters": [
                {
                    "index": 0,
                    "name": "name",
                    "type_id": 4
                }
            ],
            "description": "This returns a guaranteed-safe filename for use in world names, journal file names, etc.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 30
        },
        "339": {
            "id": 339,
            "command": "GAIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "gaitNumber",
                    "type_id": 1
                }
            ],
            "description": "Specifies the current gait for a creature. The gaits are genetically defined. It sets the gait of the creature agent stored in TARG.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 1
        },
        "340": {
            "id": 340,
            "command": "GALL",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 238,
                        "DS": 238,
                        "C3": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 1,
                    "name": "firstImage",
                    "type_id": 1
                }
            ],
            "description": "Changes the gallery (sprite file) used by an agent. This works for simple and compound agents (using the current PART). The current POSE is kept the same in both galleries.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 18
        },
        "705": {
            "id": 705,
            "command": "GALL",
            "description": "Returns the gallery (sprite file) used by an agent. This works for simple and compound agents (using the current PART).",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 18
        },
        "639": {
            "id": 639,
            "command": "GAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 281,
                        "DS": 281
                    }
                }
            ],
            "description": "A game variable is a global variable which can be referenced by name.\neg: SETV GAME \"pi\" 3.142\nGame variables are stored as part of the world and so will be saved out in the world file. If a script uses a non-existent game variable, that variable will be created automatically (with undefined contents). Agents, integers, floats and strings can be stored in game variables. Variable names are case sensitive.\nThere are some conventions for the variable names:\nengine_ for Creatures Engine\ncav_ for Creatures Adventures\nc3_ for Creatures 3\nIt's important to follow these, as 3rd party developers will just use whatever names they fancy. DELG deletes a game variable. See also the table of engine Game Variables.",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "940": {
            "id": 940,
            "command": "GAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "category",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "variable",
                    "type_id": 1
                }
            ],
            "description": "Game flow state. \nSets or queries game flow state.\nCategory: 0 = Applet custom condition,\nVariable: Applet slot number.\nCategory: 1 = Applet advanced option,\nVariable: Applet slot number. 5=Science Kit, 6=Neuroscience Kit.\nCategory: 2 = Game feature enable.\nVariable: 0 = Select Ettins/ Grendels, 1 = Infinite scroll",
            "return_type_id": 6,
            "return_values_list_ids": {
                "C2": 92
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "640": {
            "id": 640,
            "command": "GAMN",
            "parameters": [
                {
                    "index": 0,
                    "name": "previous",
                    "type_id": 4
                }
            ],
            "description": "Enumerates through game variable names. Pass in an empty string to find the first one, and then the previous one to find the next. Empty string is returned at the end.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "948": {
            "id": 948,
            "command": "GEND",
            "description": "Returns [OWNR] Creature's gender. Appears to return 1 on non-creature [OWNR] agents",
            "return_type_id": 1,
            "rvalue": true,
            "requires_creature_ownr": true,
            "variants": 3,
            "command_group_id": 5
        },
        "796": {
            "id": 796,
            "command": "GENE CLON",
            "parameters": [
                {
                    "index": 0,
                    "name": "destAgent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "destSlot",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "sourceAgent",
                    "type_id": 11
                },
                {
                    "index": 3,
                    "name": "sourceSlot",
                    "type_id": 1
                }
            ],
            "description": "Clones a genome, creating a new moniker and copying the genetics file.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 31
        },
        "797": {
            "id": 797,
            "command": "GENE CROS",
            "parameters": [
                {
                    "index": 0,
                    "name": "childAgent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "childSlot",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "mumAgent",
                    "type_id": 11
                },
                {
                    "index": 3,
                    "name": "mumSlot",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "dadAgent",
                    "type_id": 11
                },
                {
                    "index": 5,
                    "name": "dadSlot",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "mumChanceOfMutation",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "mumDegreeOfMutation",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "dadChanceOfMutation",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "dadDegreeOfMutation",
                    "type_id": 1
                }
            ],
            "description": "Crosses two genomes with mutation, and fills in a child genome slot. Mutation variables may be in the range of 0 to 255.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 31
        },
        "798": {
            "id": 798,
            "command": "GENE KILL",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "slot",
                    "type_id": 1
                }
            ],
            "description": "Clears a genome slot.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 31
        },
        "799": {
            "id": 799,
            "command": "GENE LOAD",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "slot",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "geneFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 296,
                        "DS": 296,
                        "SM": 296,
                        "CV": 296
                    }
                }
            ],
            "description": "Loads an engineered gene file into a slot. Slot 0 is a special slot used only for creatures, and contains the moniker they express. Only the NEW: CREA command fills it in. Other slot numbers are used in pregnant creatures, in eggs, or to temporarily store a genome before expressing it with NEW: CREA. You can use them as general purpose genome stores.\nThe gene file can have any name, and is loaded from the main genetics file. A new moniker is generated, and a copy of the gene file put in the world directory. You can use * and ? wildcards in the name, and a random matching file will be used.\nYou can also load monikered files from the world genetics directory with this command. If so, the file is copied and a new moniker generated. Wildcards are matched first in the main genetics directory, and only if none match is the world genetics directory searched.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 31
        },
        "800": {
            "id": 800,
            "command": "GENE MOVE",
            "parameters": [
                {
                    "index": 0,
                    "name": "destAgent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "destSlot",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "sourceAgent",
                    "type_id": 11
                },
                {
                    "index": 3,
                    "name": "sourceSlot",
                    "type_id": 1
                }
            ],
            "description": "Moves a genome from one slot to another.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 31
        },
        "903": {
            "id": 903,
            "command": "GIDS FMLY",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                }
            ],
            "description": "Output the genus numbers for which there are scripts in the scriptorium for the given family. List is space delimited.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "904": {
            "id": 904,
            "command": "GIDS GNUS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                }
            ],
            "description": "Output the species numbers for which there are scripts in the scriptorium for the given family and genus. List is space delimited.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "905": {
            "id": 905,
            "command": "GIDS ROOT",
            "description": "Output the family numbers for which there are scripts in the scriptorium. List is space delimited.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "906": {
            "id": 906,
            "command": "GIDS SPCS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Output the event numbers of scripts in the scriptorium for the given classifier. List is space delimited.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "538": {
            "id": 538,
            "command": "GMAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Returns the metaroom id at point x,y on the map. If the point is outside the room system, it returns -1.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "641": {
            "id": 641,
            "command": "GNAM",
            "description": "Returns the game name. For example \"Creatures 3\".",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "306": {
            "id": 306,
            "command": "GND#",
            "description": "Number of ground level data on map",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "307": {
            "id": 307,
            "command": "GNDW",
            "description": "Number of pixels per ground datum",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "59": {
            "id": 59,
            "command": "GNUS",
            "description": "Returns the object's genus",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 65
        },
        "504": {
            "id": 504,
            "command": "GOTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "destination",
                    "type_id": 3
                }
            ],
            "description": "Don't use this command. It jumps directly to a label defined by SUBR. This command is only here because it is used implicitly by DOIF blocks. This is a really dangerous command to use manually, because if you jump out of a block of code (eg a LOOP...EVER block), the stack frame will no longer be correct, and the script will most likely crash. Don't use it! See SUBR.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 15
        },
        "678": {
            "id": 678,
            "command": "GPAS",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "rectToUse",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 143,
                        "DS": 143,
                        "C3": 143,
                        "SM": 143
                    }
                }
            ],
            "description": "Collect all nearby agents matching the classifier as passengers.\n{rectToUse} = 0 : Nearby means touching bounding rectangle of agent\n{rectToUse} = 1 : Nearby means touching cabin rectangle",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "170": {
            "id": 170,
            "command": "GPAS",
            "description": "Get passengers. Loads any nearby creature into the vehicles cabin",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 3
        },
        "539": {
            "id": 539,
            "command": "GRAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Returns the room id at point x,y on the map. If the point is outside the room system, it returns -1.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "40": {
            "id": 40,
            "command": "GRAV",
            "description": "When an object is falling [GRAV] has a value of 1, set it to 1 to make it fall.\nGravity. 1 = on, 0 = off.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 181
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "540": {
            "id": 540,
            "command": "GRID",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "direction",
                    "type_id": 1
                }
            ],
            "description": "Returns the ID of a room adjacent to the agent in the given direction. A straight line is drawn from the centre of the agent until it hits a room. Directions are LEFT, RGHT, _UP_, or DOWN. A value of -1 is returned if no room can be found.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "154": {
            "id": 154,
            "command": "GRND",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                }
            ],
            "description": "Returns the ground level of the first surface room at x position in the world.\nGround, in this case, is just the bottom of the first surface room and doesn\u2019t take into account uneven floors or door values of adjoining rooms.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "417": {
            "id": 417,
            "command": "GRPL",
            "parameters": [
                {
                    "index": 0,
                    "name": "red",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "green",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "blue",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "minY",
                    "type_id": 2
                },
                {
                    "index": 4,
                    "name": "maxY",
                    "type_id": 2
                }
            ],
            "description": "Add a line to a graph (previously created with PAT: GRPH). The first line you add will be line 0.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "418": {
            "id": 418,
            "command": "GRPV",
            "parameters": [
                {
                    "index": 0,
                    "name": "lineIndex",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "value",
                    "type_id": 2
                }
            ],
            "description": "Add a value to a line on a graph. after you have added a value to each line on the graph, it will be updated by scrolling the current values to the left",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "80": {
            "id": 80,
            "command": "GSUB",
            "parameters": [
                {
                    "index": 0,
                    "name": "destination",
                    "type_id": 3,
                    "description": "four letter token"
                }
            ],
            "description": "GSUBs to given [SUBR] label. Often has to scan macro for subroutine start, but always remembers the address of the last subr visited, so most subrs will execute quickly in loops",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "506": {
            "id": 506,
            "command": "GTOS",
            "parameters": [
                {
                    "index": 0,
                    "name": "slot",
                    "type_id": 1
                }
            ],
            "description": "Returns the target's moniker in the given gene variable slot. This universally unique identifier is the name of a genetics file. Slot 0 is a creature's actual genome. Other slots are used in pregnant creatures, eggs and other places.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 31
        },
        "452": {
            "id": 452,
            "command": "HAIR",
            "parameters": [
                {
                    "index": 0,
                    "name": "stage",
                    "type_id": 1
                }
            ],
            "description": "Tidies or ruffles hair. Positive means tidy, negative untidy. There can be multiple stages of tidiness or untidiness; the more extreme the value the tidier or untidier.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "341": {
            "id": 341,
            "command": "HAND",
            "parameters": [
                {
                    "index": 0,
                    "name": "nameForTheHand",
                    "type_id": 4
                }
            ],
            "description": "Sets the name of the hand. Bt default this is 'hand'.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 1
        },
        "342": {
            "id": 342,
            "command": "HAND",
            "description": "This returns the name of the hand.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "162": {
            "id": 162,
            "command": "HATL",
            "description": "Hatchery limit. Returns the number of norns above which the hatchery should shut down.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "488": {
            "id": 488,
            "command": "HEAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "index",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 196,
                        "DS": 196,
                        "C3": 196,
                        "SM": 196
                    }
                }
            ],
            "description": "Returns heap and garbage collection information.\n0 - current allocated heap memory (development builds only)\n1 - total agents, including ones waiting to be garbage collected\n2 - similar, but just for creatures",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "343": {
            "id": 343,
            "command": "HEDX",
            "parameters": [
                {
                    "index": 0,
                    "name": "attachmentIndex",
                    "type_id": 1
                }
            ],
            "description": "This returns the X position of the TARG creature's specified attachment point in absolute (map) coordinates. Attachments go in this order: 0 - neck 1- mouth 2 - left ear 3- right ear 4 - hair (top of head)",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 1
        },
        "344": {
            "id": 344,
            "command": "HEDY",
            "parameters": [
                {
                    "index": 0,
                    "name": "attachmentIndex",
                    "type_id": 1
                }
            ],
            "description": "This returns the Y position of the TARG creature's specified attachment point in absolute (map) coordinates. Attachments go in this order: 0 - neck 1- mouth 2 - left ear 3- right ear 4 - hair (top of head)",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 1
        },
        "345": {
            "id": 345,
            "command": "HELD",
            "description": "Returns the item currently held by the target. For vehicles this returns a random carried agent if carrying more than one. Consider using EPAS instead.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "489": {
            "id": 489,
            "command": "HELP",
            "description": "Lists all command names to the output stream.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "35": {
            "id": 35,
            "command": "HGHT",
            "description": "Returns objects height",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 64
        },
        "453": {
            "id": 453,
            "command": "HHLD",
            "description": "Returns the creature currently holding hands with the pointer agent. NULL if no agent is holding hands.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "541": {
            "id": 541,
            "command": "HIRP",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "SM": 183,
                        "C3": 183
                    }
                },
                {
                    "index": 2,
                    "name": "directions",
                    "type_id": 1
                }
            ],
            "description": "Returns id of the room adjacent to this one with the highest concentration of the given CA. direction is 0 for left/right, 1 for any direction.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "801": {
            "id": 801,
            "command": "HIST CAGE",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the life stage of the creature when the given life event happened.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 159,
                "C3": 159,
                "CV": 159,
                "SM": 159
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "802": {
            "id": 802,
            "command": "HIST COUN",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the number of life events that there are for the given moniker. Returns 0 of there are no events, or the moniker doesn't exist.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "803": {
            "id": 803,
            "command": "HIST CROS",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the number of crossover points when the genome was made by splicing its parents genomes.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "913": {
            "id": 913,
            "command": "HIST DATE",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldTick",
                    "type_id": 1
                }
            ],
            "description": "Returns the day within the current season. This is the same as DATE. See also WTIK and HIST WTIK.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "804": {
            "id": 804,
            "command": "HIST EVNT",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventType",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "relatedMoniker1",
                    "type_id": 4
                },
                {
                    "index": 3,
                    "name": "relatedMoniker2",
                    "type_id": 4
                }
            ],
            "description": "Triggers a life event of the given type. Some events are triggered automatically by the engine, some events need triggering from CAOS, others are custom events that you can use for your own purposes. See HIST TYPE for details of the event numbers. All new events made call the Life Event script.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 32
        },
        "805": {
            "id": 805,
            "command": "HIST FIND",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventType",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "fromIndex",
                    "type_id": 1
                }
            ],
            "description": "Searches for a life event of a certain HIST TYPE for the given moniker. The search begins at the life event after the from index. Specify -1 to find the first event. Returns the event number, or -1 if there is no matching event.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "806": {
            "id": 806,
            "command": "HIST FINR",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventType",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "fromIndex",
                    "type_id": 1
                }
            ],
            "description": "Reverse searches for a life event of a certain HIST TYPE for the given moniker. The search begins at the life event before the from index. Specify -1 to find the last event. Returns the event number, or -1 if there is no matching event.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "807": {
            "id": 807,
            "command": "HIST FOTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "For the given life event, returns the filename of the associated photograph, or an empty string if there is no photo.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "808": {
            "id": 808,
            "command": "HIST FOTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "newValue",
                    "type_id": 4
                }
            ],
            "description": "For the given life event, sets the associated photograph. Use SNAP to take the photograph first.\nIf there was already a photograph for the event, then it is automatically marked for the attic as in LOFT, and overwritten with the new photo. Hence you can use an empty string to clear a photo. If HIST WIPE is used to clear the event, the photo is similarly stored in the attic.\nIt is considered an error to send a photograph that is in use (unless cloned with TINT) to the attic. If this happens, you will get a runtime error. You should either be confident that no agents are using the photo, or call LOFT first to test if they are.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 32
        },
        "809": {
            "id": 809,
            "command": "HIST GEND",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the sex that the creature with the given moniker has or had. 1 for male, 2 for female. If the creature hasn't been born yet, returns -1.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 162,
                "C3": 162,
                "CV": 162,
                "SM": 162
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "810": {
            "id": 810,
            "command": "HIST GNUS",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the genus of the moniker. This is 1 for Norn, 2 for Grendel, 3 for Ettin by convention.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 202,
                "C3": 202,
                "CV": 202,
                "SM": 202
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "937": {
            "id": 937,
            "command": "HIST MON1",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "For the given life event, returns the first associated moniker.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "938": {
            "id": 938,
            "command": "HIST MON2",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "For the given life event, returns the second associated moniker.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "811": {
            "id": 811,
            "command": "HIST MUTE",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the number of point mutations the genome received during crossover from its parents.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "812": {
            "id": 812,
            "command": "HIST NAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the name of the creature with the given moniker.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "813": {
            "id": 813,
            "command": "HIST NAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "newName",
                    "type_id": 4
                }
            ],
            "description": "Renames the creature with the given moniker.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 32
        },
        "814": {
            "id": 814,
            "command": "HIST NETU",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the network identifier of the user when the given life event happened.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 32
        },
        "815": {
            "id": 815,
            "command": "HIST NEXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the next moniker which has a history, or an empty string if we're at the end already. If the specified moniker is an empty string or doesn't have a history, then the first moniker with a history entry is returned, or an empty string if there isn't one.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "816": {
            "id": 816,
            "command": "HIST PREV",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the previous moniker which has a history. If the specified moniker is an empty string or doesn't have a history, then the last moniker with a history entry is returned, or an empty string if there isn't one.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "817": {
            "id": 817,
            "command": "HIST RTIM",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the real world time when the given life event happened. This is measured in seconds since midnight, 1 January 1970 in UTC. To display, use RTIF.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "914": {
            "id": 914,
            "command": "HIST SEAN",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldTick",
                    "type_id": 1
                }
            ],
            "description": "Returns the current season for a given world tick. This is the same as SEAN. See also WTIK and HIST WTIK.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 88,
                "C3": 88,
                "CV": 88,
                "SM": 88
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "818": {
            "id": 818,
            "command": "HIST TAGE",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the age in ticks of the creature when the given life event happened to it. If the creature was not in the world, wasn't born yet, or was fully dead, then -1 is returned. If the creature was dead, but its body still in the world, then its age on death is returned. See also TAGE.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "915": {
            "id": 915,
            "command": "HIST TIME",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldTick",
                    "type_id": 1
                }
            ],
            "description": "Returns the time of day for a given world tick. This is the same as TIME. See also WTIK and HIST WTIK.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "819": {
            "id": 819,
            "command": "HIST TYPE",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "For the given life event, returns its type.\nAll histories begin with one of the following four events. You can read the associated monikers with HIST MON1 and HIST MON2.\n0 Conceived - a natural start to life, associated monikers are the mother's and father's\n1 Spliced - created using GENE CROS to crossover the two associated monikers\n2 Engineered - from a human made genome with GENE LOAD, the first associated moniker is blank, and the second is the filename\n14 Cloned - such as when importing a creature that already exists in the world and reallocating the new moniker, when TWINing or GENE CLONing; associated moniker is who we were cloned from\nThe following events happen during a creature's life:\n3 Born - triggered by the BORN command, associated monikers are the parents.\n4 Aged - reached the next life stage, either naturally from the ageing loci or with AGES\n5 Exported - emigrated to another world\n6 Imported - immigrated back again\n7 Died - triggered naturally with the death trigger locus, or by the DEAD command\n8 Became pregnant - the first associated moniker is the child, and the second the father\n9 Impregnated - first associated moniker is the child, second the mother\n10 Child born - first moniker is the child, second the other parent\n15 Clone source - someone was cloned from you, first moniker is whom\n16 Warped out - exported through a worm hole with NET: EXPO\n17 Warped in - imported through a worm hole\nThese events aren't triggered by the engine, but reserved for CAOS to use with these numbers:\n11 Laid by mother\n12 Laid an egg\n13 Photographed\nOther numbers can also be used for custom life events. Start with numbers 100 and above, as events below that are reserved for the engine. You send your own events using HIST EVNT.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C3": 269,
                "CV": 269,
                "DS": 269,
                "SM": 269
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "820": {
            "id": 820,
            "command": "HIST UTXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "newValue",
                    "type_id": 4
                }
            ],
            "description": "For the given life event, sets the user text.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 32
        },
        "821": {
            "id": 821,
            "command": "HIST UTXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "For the given life event, returns the user text.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "822": {
            "id": 822,
            "command": "HIST VARI",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the variant that the creature with the given moniker has or had. If the creature hasn't been born yet, returns -1.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "823": {
            "id": 823,
            "command": "HIST WIPE",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Purge the creature history for the given moniker. Only applies if the genome isn't referenced by any slot, and the creature is fully dead or exported. Use OOWW to test this first.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 32
        },
        "824": {
            "id": 824,
            "command": "HIST WNAM",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the world the given life event happened in.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "825": {
            "id": 825,
            "command": "HIST WTIK",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the world tick when the life event happened, for the world that the event happened in.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "826": {
            "id": 826,
            "command": "HIST WUID",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "eventNo",
                    "type_id": 1
                }
            ],
            "description": "Returns the unique identifier of the world the given life event happened in.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "827": {
            "id": 827,
            "command": "HIST WVET",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns 1 if the Creature is a warp hole veteran, 0 otherwise. The creature is a veteran if they have ever been exported with NET: EXPO. They must have been the main exported creature - warping as an embryo doesn't make you a veteran.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 32
        },
        "916": {
            "id": 916,
            "command": "HIST YEAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldTick",
                    "type_id": 1
                }
            ],
            "description": "Returns the number of game years elapsed for a given world tick. This is the same as YEAR. See also WTIK and HIST WTIK.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "828": {
            "id": 828,
            "command": "HOTP",
            "description": "Returns the number of the compound part under the pointer. Returns -1 if no agent is under the pointer, and 0 if the agent is simple or a skeletal creature. Transparency of the parts is ignored, so each part is a rectangle. Transparency of the agent as a whole is, however, obeyed. Planes are also ignored, except later part numbers are treated as above earlier ones. See also HOTS to find the agent under the pointer.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 28
        },
        "512": {
            "id": 512,
            "command": "HOTS",
            "description": "Returns the agent nearest the screen under the hotspot of the pointer. For each agent, TRAN decides whether this allows for transparent pixels.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "279": {
            "id": 279,
            "command": "HOUR",
            "description": "Returns the number of game hours elapsed since game start.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 22
        },
        "132": {
            "id": 132,
            "command": "HSRC",
            "description": "Sets/returns the Heat source in room at targ",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "346": {
            "id": 346,
            "command": "IITT",
            "description": "Returns the target creature's current agent of attention. Compare _IT_.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "347": {
            "id": 347,
            "command": "IMGE",
            "parameters": [
                {
                    "index": 0,
                    "name": "fileName",
                    "type_id": 4
                }
            ],
            "description": "The agent will save its current sprite file to a file with the given name. The file is saved to the images folder within the local world directory.This doesn't work for creatures",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 18
        },
        "228": {
            "id": 228,
            "command": "IMPT",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 1,
                    "description": "value is the amount that gets used to nudge the current decision neurone and should be a low number."
                }
            ],
            "description": "Signify how important this (voluntary) action is. i.e. how unlikely it is that another action will override this one before it has finished.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 11
        },
        "513": {
            "id": 513,
            "command": "IMSK",
            "parameters": [
                {
                    "index": 0,
                    "name": "mask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 265,
                        "DS": 265,
                        "C3": 265,
                        "SM": 265
                    }
                }
            ],
            "description": "Set the input event mask. Indicates which types of global input events the agent is interested in, if any. For example, if the flag for \"key up\" events is set here, the agents \"key up\" script will be run every time a key is released.\nInput event bit flags are\n1 Raw Key Down\n2 Raw Key Up\n4 Raw Mouse Move\n8 Raw Mouse Down\n16 Raw Mouse Up\n32 Raw Mouse Wheel\n64 Raw Translated Char\nYou can find the script numbers executed by following the links above.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 28
        },
        "348": {
            "id": 348,
            "command": "IMSK",
            "description": "Returns the input event mask.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "217": {
            "id": 217,
            "command": "INJR",
            "parameters": [
                {
                    "index": 0,
                    "name": "organ",
                    "type_id": 1,
                    "description": "Organ is \u20131 for a randomly selected organ and 0 for the body organ"
                },
                {
                    "index": 1,
                    "name": "amount",
                    "type_id": 1
                }
            ],
            "description": "Reduce the life force of the specified organ.\nAmount is in the range of (0-255) and max damage is a 1/10 of the organs initial life force.",
            "return_type_id": 8,
            "variants": 62,
            "command_group_id": 5
        },
        "496": {
            "id": 496,
            "command": "INNF",
            "description": "Retrieves a float from the input stream, delimited by white space. Defaults to 0.0 if no valid data.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 30
        },
        "497": {
            "id": 497,
            "command": "INNI",
            "description": "Retrieves an integer from the input stream, delimited by white space. Defaults to 0 if no valid data.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 30
        },
        "498": {
            "id": 498,
            "command": "INNL",
            "description": "Retrieves a line of text from the input stream.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 30
        },
        "499": {
            "id": 499,
            "command": "INOK",
            "description": "Returns 1 if the input stream is good, or 0 if it is bad. A bad stream could be a non existent file, or the end of file reached. If the stream has never been opened at all, an error is displayed.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 180,
                "DS": 180,
                "C3": 180,
                "SM": 180
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 30
        },
        "212": {
            "id": 212,
            "command": "INS#",
            "description": "Returns the number of instincts the creature still has left to process. Instincts are processed in the egg and during sleep.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 62,
            "command_group_id": 5
        },
        "94": {
            "id": 94,
            "command": "INST",
            "description": "Make the rest of this macro execute in a single tick.\nThis is used to ensure the creation of an object (for example) is not interrupted during the scheduling of concurrent scripts",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 14
        },
        "128": {
            "id": 128,
            "command": "INTR",
            "description": "Sets/returns the Inorganic nutrients at [targ]",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "155": {
            "id": 155,
            "command": "ISAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomid",
                    "type_id": 1,
                    "description": "number of room to check"
                }
            ],
            "description": "Returns whether the given room number exists, returns 1 if true 0 if false.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 179
            },
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "290": {
            "id": 290,
            "command": "ISCR",
            "description": "Marks the following chunk of script as being for the installation of an object.\nThe presence of [SCRP], [RSCR] or [ENDM] is used to delimit the installation chunk",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "642": {
            "id": 642,
            "command": "ITOF",
            "parameters": [
                {
                    "index": 0,
                    "name": "numberToConvert",
                    "type_id": 1
                }
            ],
            "description": "Converts an integer value into its floating-point equivalent.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "907": {
            "id": 907,
            "command": "JECT",
            "parameters": [
                {
                    "index": 0,
                    "name": "cosFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 284,
                        "DS": 284,
                        "SM": 284,
                        "CV": 284
                    }
                },
                {
                    "index": 1,
                    "name": "flags",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 198,
                        "C3": 198,
                        "SM": 198
                    }
                }
            ],
            "description": "Injects a COS file from the bootstrap directory. The file is searched for (case insensitively) in all bootstrap subdirectories. You must specify the file extension (it doesn't have to be .cos). Flags is a combination of what you want to inject:\n1 - Remove script\n2 - Event scripts\n4 - Install script\nThe scripts (if present) are injected in that order. So, setting flags to 7 will fully uninstall and reinstall the cos file. Error messages and output are written to the current output stream.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 14
        },
        "514": {
            "id": 514,
            "command": "KEYD",
            "parameters": [
                {
                    "index": 0,
                    "name": "keycode",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 272,
                        "C3": 272,
                        "DS": 272,
                        "SM": 272
                    }
                }
            ],
            "description": "Returns 1 if the specified key is currently pressed down, 0 if not.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 178,
                "DS": 178,
                "C3": 178,
                "SM": 178
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "42": {
            "id": 42,
            "command": "KILL",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11,
                    "description": "agent to delete"
                }
            ],
            "description": "Delete the object specified.\n@example: #{kill edit} deletes the object in the [EDIT] buffer\n@example: #{kill ownr} kills the owner of the script\n@example: #{kill targ} kills the current [TARG] object.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 1
        },
        "165": {
            "id": 165,
            "command": "KMSG",
            "parameters": [
                {
                    "index": 0,
                    "name": "knob",
                    "type_id": 1,
                    "description": "refers to the KNOB functions already set up"
                },
                {
                    "index": 1,
                    "name": "flag",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 91
                    },
                    "description": "flag used to describe the usage of the knob"
                },
                {
                    "index": 2,
                    "name": "message",
                    "type_id": 1,
                    "min": 0,
                    "max": 65535,
                    "description": "message/event to be sent when this knob is activated."
                }
            ],
            "description": "Knob Message. Set the object message associated with the knob.\nThis allows messages other that act1,act2 and deac to be sent \u2013 and also allows the usage to be altered (e.g. creature only)\nflags:\n\\t1=Only creature can use this knob\n\\t2=Only pointer can use this knob\n\\t3=Both creature and pointer can use this knob message",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 66
        },
        "164": {
            "id": 164,
            "command": "KNOB",
            "parameters": [
                {
                    "index": 0,
                    "name": "function",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 90
                    },
                    "description": "specifies the event and usage"
                },
                {
                    "index": 1,
                    "name": "hotspot",
                    "type_id": 1,
                    "min": 0,
                    "max": 5,
                    "description": "refers to the hot spot number defined with the SPOT command."
                }
            ],
            "description": "Attach compound objects\u2019 hotspot to a particular function.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 66
        },
        "172": {
            "id": 172,
            "command": "LACB",
            "description": "Align Lift cabin with room floor.\nIf this value is set to non- zero the lift will stop at a position where the bottom of its cabin is aligned with the room floor.\nThe default behaviour is to align the bottom of the lift with the floor.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 268
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 3
        },
        "292": {
            "id": 292,
            "command": "LANG",
            "description": "\nPrimary LANGuage of Windows desktop. Values are (in hexadecimal) as follows:\nNeutral = 0x00\nChinese = 0x04\nCzech = 0x05\nDanish = 0x06\nDutch = 0x13\nEnglish = 0x09\nFinnish = 0x0b\nFrench = 0x0c\nGerman = 0x07\nGreek = 0x08\nHungarian = 0x0e\nIcelandic = 0x0F\nItalian = 0x10\nJapanese = 0x11\nKorean = 0x12\nNorwegian = 0x14\nPolish = 0x15\nPortuguese = 0x16\nRussian = 0x19\nSerbo Croatian = 0x1a\nSlovak = 0x1b\nSpanish = 0x0a\nSwedish = 0x1d\nTurkish = 0x1F",
            "return_type_id": 18,
            "return_values_list_ids": {
                "C2": 85
            },
            "rvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "681": {
            "id": 681,
            "command": "LANG",
            "description": "Returns preferred language id eg fr - french german - de.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 21
        },
        "254": {
            "id": 254,
            "command": "LCUS",
            "parameters": [
                {
                    "index": 0,
                    "name": "type",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 223
                    },
                    "min": 0,
                    "max": 1,
                    "description": "0=receptor loci 1=emmiter loci"
                },
                {
                    "index": 1,
                    "name": "organ",
                    "type_id": 1,
                    "description": "Note: organ field does not refer to the organs defined in the"
                },
                {
                    "index": 2,
                    "name": "tissue",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "locusid",
                    "type_id": 1
                }
            ],
            "description": "Allows interrogation of creature loci values.\ntype - 0=receptor loci 1=emitter loci\nDetails of the other values are listed in the reference section. Note: organ field does not refer to the organs defined in the genome.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 5
        },
        "542": {
            "id": 542,
            "command": "LEFT",
            "description": "Returns the value of the left constant.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "454": {
            "id": 454,
            "command": "LIKE",
            "parameters": [
                {
                    "index": 0,
                    "name": "creatureStateOpinionAbout",
                    "type_id": 11
                }
            ],
            "description": "State a personal opinion about a creature.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "57": {
            "id": 57,
            "command": "LIMB",
            "description": "Returns object\u2019s Limit to the Bottom as absolute value of rooms boundary\nNote: Room boundaries are not the same as walls, rooms can join but still allow full passage between them.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "745": {
            "id": 745,
            "command": "LIMB",
            "parameters": [
                {
                    "index": 0,
                    "name": "bodyPart",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "gender",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "age",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "variant",
                    "type_id": 1
                }
            ],
            "description": "Returns the filename for the specified part of a creature. If the exact part isn't present, a 'nearby' file which is on the disk is returned.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 5
        },
        "54": {
            "id": 54,
            "command": "LIML",
            "description": "Returns object\u2019s Limit to the Left as absolute value of rooms boundary\nNote: Room boundaries are not the same as walls, rooms can join but still allow full passage between them.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "55": {
            "id": 55,
            "command": "LIMR",
            "description": "Returns object\u2019s Limit to the Right as absolute value of rooms boundary\nNote: Room boundaries are not the same as walls, rooms can join but still allow full passage between them.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "56": {
            "id": 56,
            "command": "LIMT",
            "description": "Returns object\u2019s Limit to the Top as absolute value of rooms boundary\nNote: Room boundaries are not the same as walls, rooms can join but still allow full passage between them.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "392": {
            "id": 392,
            "command": "LINE",
            "parameters": [
                {
                    "index": 0,
                    "name": "x1",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y1",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "x2",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "y2",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "r",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "g",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "b",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "stippleOn",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "stippleOff",
                    "type_id": 1
                }
            ],
            "description": "Adds a line to target's drawing list. The line goes between the start and end points (world coordinates) in the specified colour. Set stipple_on and stipple_off to 0 to draw a solid line, or to the number of pixels to alternate for a stippled line. To clear all the lines for an agent, call LINE with the start and end points the same.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "543": {
            "id": 543,
            "command": "LINK",
            "parameters": [
                {
                    "index": 0,
                    "name": "room1",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "room2",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "permiability",
                    "type_id": 1
                }
            ],
            "description": "Sets the permiability of the link between the rooms specified, creating the link if none exists before. Set to 0 to close (destroy) the link. This is used for CAs. See also DOOR.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "544": {
            "id": 544,
            "command": "LINK",
            "parameters": [
                {
                    "index": 0,
                    "name": "room1",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "room2",
                    "type_id": 1
                }
            ],
            "description": "Returns the permiability of the link between the rooms specified or 0 if no link exists.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "125": {
            "id": 125,
            "command": "LITE",
            "description": "Sets/returns the room light level at [targ]",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "942": {
            "id": 942,
            "command": "LNG+",
            "description": "Sub Language of Windows desktop. Values are in hexadecimal",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "682": {
            "id": 682,
            "command": "LOAD",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldName",
                    "type_id": 4
                }
            ],
            "description": "Loads the specified world at the start of the next tick. See also QUIT for important information about using INST.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "455": {
            "id": 455,
            "command": "LOCI",
            "parameters": [
                {
                    "index": 0,
                    "name": "type",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 248,
                        "DS": 248
                    }
                },
                {
                    "index": 1,
                    "name": "organ",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 279,
                        "CV": 279,
                        "DS": 279
                    }
                },
                {
                    "index": 2,
                    "name": "tissue",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 299,
                        "C3": 299,
                        "CV": 299
                    }
                },
                {
                    "index": 3,
                    "name": "id",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 280,
                        "C3": 280,
                        "DS": 280,
                        "SM": 280
                    }
                },
                {
                    "index": 4,
                    "name": "newValue",
                    "type_id": 2
                }
            ],
            "description": "Sets a biochemical locus value. See Receptor Locus Numbers and Emitter Locus Numbers",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "456": {
            "id": 456,
            "command": "LOCI",
            "parameters": [
                {
                    "index": 0,
                    "name": "type",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 248,
                        "DS": 248
                    }
                },
                {
                    "index": 1,
                    "name": "organ",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 279
                    }
                },
                {
                    "index": 2,
                    "name": "tissue",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 299,
                        "C3": 299,
                        "DS": 299
                    }
                },
                {
                    "index": 3,
                    "name": "id",
                    "type_id": 1,
                    "values_list_ids": {
                        "SM": 280,
                        "C3": 280,
                        "DS": 280,
                        "CV": 280
                    }
                }
            ],
            "description": "Reads a biochemical locus value.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "275": {
            "id": 275,
            "command": "LOCK",
            "description": "Prevents the execution of other event scripts taking place on this object and hence interrupting this script.\nNote that this will result in lost events and messages. Any script that contains a LOCK should also contain an UNLK. This will not prevent the execution of a SCRIPTEXCEPTION macro script however.",
            "return_type_id": 8,
            "variants": 62,
            "command_group_id": 14
        },
        "393": {
            "id": 393,
            "command": "LOFT",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 4
                }
            ],
            "description": "Declares that you have finished with a photograph image file taken by SNAP. If the file is in use in a gallery, this function fails and returns 1. Otherwise it returns 0. The file will be marked for the attic, and moved there later.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "84": {
            "id": 84,
            "command": "LOOP",
            "description": "Top of LOOP...[UNTL] statment or LOOP...[EVER]\nLOOPs may be nested, but MUST NOT be jumped out of",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "545": {
            "id": 545,
            "command": "LORP",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "SM": 183,
                        "C3": 183
                    }
                },
                {
                    "index": 2,
                    "name": "directions",
                    "type_id": 1
                }
            ],
            "description": "Returns id of the room adjacent to this one with the lowest concentration of the given CA. direction is 0 for left/right, 1 for any direction.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "921": {
            "id": 921,
            "command": "LOWA",
            "parameters": [
                {
                    "index": 0,
                    "name": "anyOld",
                    "type_id": 4
                }
            ],
            "description": "Converts the given string into all lower case letters.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "134": {
            "id": 134,
            "command": "LSRC",
            "description": "Sets/returns the Light source in room at targ.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "230": {
            "id": 230,
            "command": "LTCY",
            "parameters": [
                {
                    "index": 0,
                    "name": "action",
                    "type_id": 1,
                    "description": "involuntary action"
                },
                {
                    "index": 1,
                    "name": "min",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "max",
                    "type_id": 1
                }
            ],
            "description": "Set the latency for the creatures given involuntary action (only relevant to involuntary actions). Prevent this action from repeating for an amount of time defined by min max. Delay is a random amount of ticks between min*4 and max*4.\naction\tint\nmin\tint\nmax\tint",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 5
        },
        "922": {
            "id": 922,
            "command": "MAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 13
                }
            ],
            "description": "Machine variable version of NAME. Accesses the same variables, only via OWNR rather than TARG. This is the same difference as between MVxx and OVxx.",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "requires_ownr": 2,
            "variants": 56,
            "command_group_id": 12
        },
        "490": {
            "id": 490,
            "command": "MANN",
            "parameters": [
                {
                    "index": 0,
                    "name": "command",
                    "type_id": 4
                }
            ],
            "description": "Outputs help on the given command to the output stream.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "546": {
            "id": 546,
            "command": "MAPD",
            "parameters": [
                {
                    "index": 0,
                    "name": "width",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "height",
                    "type_id": 1
                }
            ],
            "description": "Sets the dimensions of the map. These are the maximum world coordinates. Metarooms are rectangles within this area.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "547": {
            "id": 547,
            "command": "MAPH",
            "description": "Returns the total height of the map.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "548": {
            "id": 548,
            "command": "MAPK",
            "description": "Resets the map to be empty.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "549": {
            "id": 549,
            "command": "MAPW",
            "description": "Returns the total width of the map.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "233": {
            "id": 233,
            "command": "MATE",
            "description": "Only relevant to male creatures \u2013 pass on waiting sperm to _IT_ (if _IT_ is female and the same genus). Female will conceive if she is in the right condition \u2013 fertile and receptive.",
            "return_type_id": 8,
            "requires_creature_ownr": true,
            "variants": 63,
            "command_group_id": 5
        },
        "594": {
            "id": 594,
            "command": "MCLR",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Clear the music for the metaroom at the given location.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "110": {
            "id": 110,
            "command": "MCRT",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Move object to absolute location and redraw,\nthis is different from [MVTO] in that the object has it\u2019s limits removed before moving.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 64
        },
        "491": {
            "id": 491,
            "command": "MEMX",
            "description": "Sends information about the memory allocated to the output stream. In order, these are the Memory Load (unknown), Total Physical (size in bytes of physical memory), Available Physical (free physical space), Total Page File (maximum possible size of page file), Available Page File (size in bytes of space available in paging file), Total Virtual (size of user mode portion of the virtual address space of the engine), Available Virtual (size of unreserved and uncommitted memory in the user mode portion of the virtual address space of the engine).",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 10
        },
        "112": {
            "id": 112,
            "command": "MESG SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "message",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 80
                    }
                }
            ],
            "description": "Shout message to all creatures that can hear the object",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 1
        },
        "113": {
            "id": 113,
            "command": "MESG SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "message",
                    "type_id": 1
                }
            ],
            "description": "Send message to all creatures that can see the object",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 1
        },
        "114": {
            "id": 114,
            "command": "MESG TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "message",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 80
                    }
                }
            ],
            "description": "Send message to all creatures that are touching the object",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 1
        },
        "321": {
            "id": 321,
            "command": "MESG WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "messageId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 80,
                        "C2": 123,
                        "DS": 115,
                        "C3": 115,
                        "SM": 115,
                        "CV": 115
                    }
                }
            ],
            "description": "Write/Send message to a specific object. Object is a pointer to an object ([TARG], [OWNR], [FROM] or [NORN])",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 1
        },
        "115": {
            "id": 115,
            "command": "MESG WRT+",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "messageId",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 115,
                        "C3": 115,
                        "SM": 115,
                        "CV": 115
                    },
                    "min": 256,
                    "max": 65535
                },
                {
                    "index": 2,
                    "name": "param1",
                    "type_id": 13,
                    "description": "passed to event script as _P1_"
                },
                {
                    "index": 3,
                    "name": "param2",
                    "type_id": 13,
                    "description": "passed to event script as _P2_"
                },
                {
                    "index": 4,
                    "name": "delay",
                    "type_id": 1
                }
            ],
            "description": "Write message {message} with parameters {p1} and {p2} to object; to be handled in {delay} clock ticks. If {delay} = 0 the message will be handled immediately. {message} must be in the range 256..65535. (Messages 0..12 are currently used for ACTIVATE1 etc. events).\nThe message that is sent will trigger event m on the targ object.",
            "return_type_id": 8,
            "variants": 62,
            "command_group_id": 1
        },
        "394": {
            "id": 394,
            "command": "META",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "cameraX",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "cameraY",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "transition",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 191,
                        "DS": 191,
                        "C3": 191,
                        "SM": 191
                    }
                }
            ],
            "description": "Change the current camera (set with SCAM) to a new meta room. Moves the top left coordinate of the camera to the given coordinates.\nTransition can be:\n0 - no transition effect\n1 - flip horizontally\n2 - burst",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "395": {
            "id": 395,
            "command": "META",
            "description": "Returns the metaroom id that the current camera is looking at.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "595": {
            "id": 595,
            "command": "MIDI",
            "parameters": [
                {
                    "index": 0,
                    "name": "midiFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 297,
                        "DS": 297,
                        "SM": 297,
                        "CV": 297
                    }
                }
            ],
            "description": "Plays a MIDI file. Set to an empty string to stop the MIDI player.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "746": {
            "id": 746,
            "command": "MIND",
            "parameters": [
                {
                    "index": 0,
                    "name": "state",
                    "type_id": 1
                }
            ],
            "description": "Enable (1) or disable (0) the creature's brain (unlike ZOMB# in that the brain actually stops processing and it's output is frozen onto the one noun and verb).",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "747": {
            "id": 747,
            "command": "MIND",
            "description": "Returns whether the creature TARG's brain is being processed or not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 5
        },
        "280": {
            "id": 280,
            "command": "MINS",
            "description": "Returns the number of game minutes elapsed since game start.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 22
        },
        "349": {
            "id": 349,
            "command": "MIRA",
            "parameters": [
                {
                    "index": 0,
                    "name": "onOff",
                    "type_id": 1
                }
            ],
            "description": "Tell the agent to draw the current sprite mirrored (send 1 as a parameter) or normally (send 0 as a parameter)",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 18
        },
        "350": {
            "id": 350,
            "command": "MIRA",
            "description": "Is the current sprite for this agent mirrored (returns 1) or not (returns 0)",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 177,
                "DS": 177,
                "C3": 177,
                "SM": 177
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 18
        },
        "396": {
            "id": 396,
            "command": "MIRR",
            "parameters": [
                {
                    "index": 0,
                    "name": "sceneOnOff",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "agentsOnOff",
                    "type_id": 1
                }
            ],
            "description": "Tell the agent to draw the whole scene mirrored (send 1 as a parameter) or normally (send 0 as a parameter), the second parameter mirrors just the agents.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 24
        },
        "550": {
            "id": 550,
            "command": "MLOC",
            "parameters": [
                {
                    "index": 0,
                    "name": "metaroomId",
                    "type_id": 1
                }
            ],
            "description": "Returns the location of the specified metaroom as a string formatted as follows: x y width height.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "596": {
            "id": 596,
            "command": "MMSC",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "trackName",
                    "type_id": 4
                }
            ],
            "description": "Associates a music track with the meta room at the specified coordinates.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "597": {
            "id": 597,
            "command": "MMSC",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the music track played at the metaroom in the given location.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 25
        },
        "923": {
            "id": 923,
            "command": "MODU",
            "description": "Returns a string listed the loaded modules, and the display engine type. You can use SINS to parse this for particular values.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 21
        },
        "71": {
            "id": 71,
            "command": "MODV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "mod",
                    "type_id": 1
                }
            ],
            "description": "{value1} = {value1} % {value2}",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 13
        },
        "214": {
            "id": 214,
            "command": "MONK",
            "description": "Returns the moniker of the creature",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 5
        },
        "614": {
            "id": 614,
            "command": "MONT",
            "description": "Returns the month of the year",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "515": {
            "id": 515,
            "command": "MOPX",
            "description": "Returns x position of mouse in world coordinates.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "516": {
            "id": 516,
            "command": "MOPY",
            "description": "Returns y position of mouse in world coordinates.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "748": {
            "id": 748,
            "command": "MOTR",
            "parameters": [
                {
                    "index": 0,
                    "name": "state",
                    "type_id": 1
                }
            ],
            "description": "Enable (1) or disable (0) the creature's motor faculty, i.e. whether it sets the IT object and fires off scripts.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "749": {
            "id": 749,
            "command": "MOTR",
            "description": "Returns whether the creature TARG's motor faculty is being processed or not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 5
        },
        "517": {
            "id": 517,
            "command": "MOUS",
            "parameters": [
                {
                    "index": 0,
                    "name": "behaviour",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 251,
                        "DS": 251,
                        "C3": 251,
                        "SM": 251
                    }
                }
            ],
            "description": "Defines the behaviour of the mouse button for the default pointer behaviour - see PURE.\n0 is normal\n1 means the right button does what the left button does\n2 means the left button does what the right button does",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 28
        },
        "61": {
            "id": 61,
            "command": "MOVS",
            "description": "Gets/Returns the Movement Status of an object. See reference section for values.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 125,
                "C1": 67
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 8
        },
        "576": {
            "id": 576,
            "command": "MOVS",
            "description": "Returns the movement status of the target.\n0 Autonomous\n1 Mouse driven\n2 Floating\n3 In vehicle\n4 Carried",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 128,
                "DS": 128,
                "C3": 128,
                "SM": 128
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "518": {
            "id": 518,
            "command": "MOVX",
            "description": "Returns horizontal mouse velocity.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "519": {
            "id": 519,
            "command": "MOVY",
            "description": "Returns vertical mouse velocity.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "351": {
            "id": 351,
            "command": "MOWS",
            "description": "Returns whether the lawn was cut last Sunday or not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "615": {
            "id": 615,
            "command": "MSEC",
            "description": "Returns a time stamp measured in milliseconds. It is not specified when the time is measured from; the stamp is only guaranteed to be consistent during one session.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "352": {
            "id": 352,
            "command": "MTHX",
            "description": "This returns the X position of the TARG creature's mouth attachment point in absolute (map) coordinates.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "353": {
            "id": 353,
            "command": "MTHY",
            "description": "This returns the Y position of the TARG creature's mouth attachment point in absolute (map) coordinates.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "507": {
            "id": 507,
            "command": "MTOA",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the agent which references the given moniker. The moniker could be stored in any of the gene slots for that agent, including the special slot 0 for a creature. If the moniker is not currently used in the game, then returns NULL. This command can be slow - use MTOC if possible.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 31
        },
        "508": {
            "id": 508,
            "command": "MTOC",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the creature with the given moniker. If there is no agent alive with that moniker, then returns NULL. See also MTOA.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 31
        },
        "69": {
            "id": 69,
            "command": "MULV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "values_list_ids": {
                        "C2": 126,
                        "C1": 77
                    },
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "mul",
                    "type_id": 1
                }
            ],
            "description": "{value1} = {value1} * {value2}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 13
        },
        "643": {
            "id": 643,
            "command": "MULV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "#"
                },
                {
                    "index": 1,
                    "name": "mul",
                    "type_id": 16
                }
            ],
            "description": "Multiplies a variable by an integer or float, so var = var * mul.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 13
        },
        "197": {
            "id": 197,
            "command": "MUSC",
            "parameters": [
                {
                    "index": 0,
                    "name": "property",
                    "type_id": 1
                }
            ],
            "description": "\\t0=volume (0-255)\n\\t1=mood (0-255)\n\\t2=threat (0-255)\n\\t3=Automatically update music",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 25
        },
        "598": {
            "id": 598,
            "command": "MUTE",
            "parameters": [
                {
                    "index": 0,
                    "name": "andMask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 213,
                        "DS": 213,
                        "C3": 213,
                        "SM": 213
                    }
                },
                {
                    "index": 1,
                    "name": "eorMask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 213,
                        "DS": 213,
                        "C3": 213,
                        "SM": 213
                    }
                }
            ],
            "description": "This returns (and potentially sets) the mute values for the sound managers in the game. Sensible settings for the parameters are as follows:\nandMask\teorMask\treturns\n0\t3\t3 - Mutes both sound and music\n3\t0\t0 for no mute\n1 for sound muted\n2 for music muted\n3 for both muted\nSets nothing\n1\t2\tReturns 2 for music muted, or 3 for both muted\nOnly sets mute on music, leaves sound alone",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 213,
                "DS": 213,
                "C3": 213,
                "SM": 213
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 25
        },
        "577": {
            "id": 577,
            "command": "MVBY",
            "parameters": [
                {
                    "index": 0,
                    "name": "deltaX",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "deltaY",
                    "type_id": 2
                }
            ],
            "description": "Move the target agent by relative distances, which can be negative or positive.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "111": {
            "id": 111,
            "command": "MVBY",
            "parameters": [
                {
                    "index": 0,
                    "name": "deltaX",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "deltaY",
                    "type_id": 1
                }
            ],
            "description": "Move object by relative amount and redraw.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 8
        },
        "457": {
            "id": 457,
            "command": "MVFT",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Move creature's down foot to position x,y. Use this instead of MVTO for creatures.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "578": {
            "id": 578,
            "command": "MVSF",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Move the target agent into a safe map location somewhere in the vicinity of x, y. Only works on autonomous agents - see MOVS. Works like a safe MVFT for creatures.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "579": {
            "id": 579,
            "command": "MVTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Move the top left corner of the target agent to the given world coordinates. Use MVFT instead to move creatures.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "109": {
            "id": 109,
            "command": "MVTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Move object to absolute location and redraw\nNote: Should not be used on a creature that has had its limit set.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 8
        },
        "644": {
            "id": 644,
            "command": "MVxx",
            "description": "MV00 to MV99 are variables specific to an agent. They are read from [OWNR], the owner agent of the current script. These are the exact same variables as [OVxx], except read from [OWNR] not [TARG]. If [OWNR] and [TARG] are the same, then OV23 is MV23, for example.\n@range(0 to 99)",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 12
        },
        "924": {
            "id": 924,
            "command": "NAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "variableName",
                    "type_id": 13
                }
            ],
            "description": "This is a named variable, similar to a GAME variable, only local to the target agent. See also MAME. The \"name\" of the variable is not limited to strings, but can be anything stored in a variable. i.e. integer, float, string, even an agent.",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "925": {
            "id": 925,
            "command": "NAMN",
            "parameters": [
                {
                    "index": 0,
                    "name": "previous",
                    "type_id": 6,
                    "variable_type_id": "4"
                }
            ],
            "description": "Enumerates through NAME variable names, roughly as GAMN does through GAME variables. Start and end with an empty string.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 12
        },
        "354": {
            "id": 354,
            "command": "NCLS",
            "parameters": [
                {
                    "index": 0,
                    "name": "previous",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Finds the next agent in the agent list which also matches the given classifier. If the previous agent doesn't exist or doesn't match the classifier then the first agent matching it is returned. If none match the classifier, then NULL is returned.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "72": {
            "id": 72,
            "command": "NEGV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                }
            ],
            "description": "{value1} = -{value1}",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 13
        },
        "63": {
            "id": 63,
            "command": "NEID",
            "description": "Returns an objects Neural ID \u2013 i.e. which attention lobe neurone corresponds to this object",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 11
        },
        "850": {
            "id": 850,
            "command": "NET: ERRA",
            "description": "Returns an error code from the last command. Currently NET: LINE is the only command to set it.\nError codes are:\n0 - Unknown\n1 - Connection OK\n2 - Connection failed, you or the server are offline\n3 - Connection failed, invalid user name/password\n4 - Connection failed, you are already logged in elsewhere\n5 - Connection failed, too many users for server\n6 - Connection failed, internal error\n7 - Connection failed, new client version required.\nTry [NET: RAWE] for more detailed diagnostic codes.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 176,
                "SM": 176
            },
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "851": {
            "id": 851,
            "command": "NET: EXPO",
            "parameters": [
                {
                    "index": 0,
                    "name": "chunkType",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "destUserId",
                    "type_id": 4
                }
            ],
            "description": "Transwarp the target creature to the given user. The Creature is exported to the warp out directory; this command is very similar to PRAY EXPO. Return value is one of the following:\n0 for success\n1 if the creature, or if pregnant any of its offspring, are already on disk in some form. This case won't happen much, if you use a special chunk name like WARP.\n2 if the user hasn't been online in this world yet / since the user name changed, so we don't know who they are.\nWhen receiving a creature, use NET: FROM to find out who sent it.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 175,
                "SM": 175
            },
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "852": {
            "id": 852,
            "command": "NET: FROM",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                }
            ],
            "description": "The user who sent the PRAY file which contains the specified resource. If the resource did not arrive as a message over the network via NET: MAKE or NET: EXPO, then this returns an empty string. The user returned by this command is guaranteed in a way that looking at the content of the PRAY file would not be. For example, the \"Last Network User\" attribute in an exported Creature made with NET: EXPO could be faked.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "853": {
            "id": 853,
            "command": "NET: HEAD",
            "description": "Dump debugging information about who is NET: HEARing on what channels.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "854": {
            "id": 854,
            "command": "NET: HEAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "channel",
                    "type_id": 4
                }
            ],
            "description": "The target agent will now accept CAOS messages over the network on the specified channel, and execute their script as appropriate. Use NET: WRIT to send the message.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "855": {
            "id": 855,
            "command": "NET: HOST",
            "description": "Returns the hostname, port, id and friendly name on that host that we are currently connected to, or empty string if offline. The fields are space separated, although the last field (friendly name) may contain spaces.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "856": {
            "id": 856,
            "command": "NET: LINE",
            "parameters": [
                {
                    "index": 0,
                    "name": "state",
                    "type_id": 1
                }
            ],
            "description": "Goes on or offline, connecting or disconnecting from the Babel server. Set to 1 to connect, 0 to disconnect. A NET: USER must be set first. NET: ERRA is set to any error code. While the connection is being made, this command can block for several ticks. This command never runs in an INST.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "857": {
            "id": 857,
            "command": "NET: LINE",
            "description": "Returns 1 if you are connected to the Babel server, or 0 if you aren't.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 174,
                "SM": 174
            },
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "885": {
            "id": 885,
            "command": "NET: MAKE",
            "parameters": [
                {
                    "index": 0,
                    "name": "whichJournalSpot",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 206
                    }
                },
                {
                    "index": 1,
                    "name": "journalName",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "user",
                    "type_id": 4
                },
                {
                    "index": 3,
                    "name": "reportDestination",
                    "type_id": 6,
                    "variable_type_id": "4"
                }
            ],
            "description": "Like PRAY MAKE, only sends the made pray file to the specified user. This will arrive in their inbox, where it can be read with normal PRAY commands and deleted with PRAY KILL.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "858": {
            "id": 858,
            "command": "NET: PASS",
            "description": "Returns the currently set username, as selected with PASS.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "859": {
            "id": 859,
            "command": "NET: PASS",
            "parameters": [
                {
                    "index": 0,
                    "name": "nickName",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "password",
                    "type_id": 4
                }
            ],
            "description": "Set nickname and password - do this before connecting with NET: LINE. If you set GAME \"engine_netbabel_save_passwords\" to 1 then the password for each nickname is saved in user.cfg, so you can specify an empty string for the password after the first time. The nickname is saved with the serialised world, so is cleared when you start a new world. You can use NET: PASS to retrieve the user later.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "860": {
            "id": 860,
            "command": "NET: RAWE",
            "description": "Returns an internal error code from Babel. Only use this for display and diagnostic purpose, use NET: ERRA for documented error codes which you can rely on.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "861": {
            "id": 861,
            "command": "NET: RUSO",
            "parameters": [
                {
                    "index": 0,
                    "name": "storeResult",
                    "type_id": 6,
                    "variable_type_id": "4"
                }
            ],
            "description": "Returns (into store_result) a random user who is currently online. Returns an empty string if you're offline, or if you aren't using the Docking Station Babel server module. Since you're online, it can return yourself (especially if you're the only person online!). The user is also only likely to be online - they could have gone offline since the server replied to you.\nThis is a command rather than an integer r-value because it is blocking. This means that it might take several ticks before the server returns the result. In this sense it is similar to a command like OVER, so it does not run in an INST. You should use LOCK if you don't want your script interrupting.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "862": {
            "id": 862,
            "command": "NET: STAT",
            "parameters": [
                {
                    "index": 0,
                    "name": "timeOnline",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "usersOnline",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 2,
                    "name": "bytesReceived",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 3,
                    "name": "bytesSent",
                    "type_id": 6,
                    "variable_type_id": "1"
                }
            ],
            "description": "Returns statistics for the current Babel connection, or -1 if offline. This command can block (doesn't execute in an INST). The statistics are:\ntime_online - Time online in milliseconds\nusers_online - Number of users currently connected to the server\nbytes_received - Bytes received by the client\nbytes_sent - Bytes sent from the client",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "863": {
            "id": 863,
            "command": "NET: ULIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "userId",
                    "type_id": 4
                }
            ],
            "description": "Returns 1 if the specified user is online, or 0 if they are offline. This is slow (i.e. has to call the server) unless the user is in the whose wanted register of any agent. Use NET: WHON to add a user to the register.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 173,
                "SM": 173
            },
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "864": {
            "id": 864,
            "command": "NET: UNIK",
            "parameters": [
                {
                    "index": 0,
                    "name": "userId",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "storeResult",
                    "type_id": 6,
                    "variable_type_id": "4"
                }
            ],
            "description": "Returns the specified user's screen or nick name. Returns empty string if offline, or no such user. This command can take many ticks to execute while the server is quizzed, like NET: RUSO.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "865": {
            "id": 865,
            "command": "NET: USER",
            "description": "Returns the user's numeric Babel id, or an empty string if they have never logged in with this world since they last changed user name.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "866": {
            "id": 866,
            "command": "NET: WHAT",
            "description": "For debugging only. Returns a string describing what the upload/query network thread is currently doing. For example, it may be fetching a random online user, or uploading some creature history. Returns an empty string if it is doing nothing.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 16,
            "command_group_id": 36
        },
        "867": {
            "id": 867,
            "command": "NET: WHOD",
            "description": "Dump debugging information about the whose wanted register.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "868": {
            "id": 868,
            "command": "NET: WHOF",
            "parameters": [
                {
                    "index": 0,
                    "name": "user",
                    "type_id": 4
                }
            ],
            "description": "Removes a user from the whose wanted list for the target agent. See NET: WHON.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "869": {
            "id": 869,
            "command": "NET: WHON",
            "parameters": [
                {
                    "index": 0,
                    "name": "user",
                    "type_id": 4
                }
            ],
            "description": "Add a user to the whose wanted register for the target agent. Scripts User Online and User Offline are now called on this agent when that user goes on or offline, or indeed when the local user goes offline. Use NET: WHOF to remove them from the register. This command is blocking, it can take several ticks to return.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "870": {
            "id": 870,
            "command": "NET: WHOZ",
            "description": "Zap the target agent's whose wanted register, removing all entries.",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "871": {
            "id": 871,
            "command": "NET: WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "userId",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "channel",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "messageId",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "param1",
                    "type_id": 13
                },
                {
                    "index": 4,
                    "name": "param2",
                    "type_id": 13
                }
            ],
            "description": "Send a message to a remote machine, as specified by the user identifier. All agents which are NET: HEARing on the given channel will receive the message, and run the appropriate script. If the specified user is offline, then the message is discarded. The FROM variable of the receiving script contains the user id of the sender, as a string. See also MESG WRIT.\nPorts",
            "return_type_id": 8,
            "variants": 16,
            "command_group_id": 36
        },
        "13": {
            "id": 13,
            "command": "NEW: BBTX",
            "parameters": [
                {
                    "index": 0,
                    "name": "textPart",
                    "type_id": 1,
                    "min": 0,
                    "max": 9,
                    "description": "a unique identifier for the part"
                },
                {
                    "index": 1,
                    "name": "relx",
                    "type_id": 1,
                    "description": "x position of text part relative to compound bubble"
                },
                {
                    "index": 2,
                    "name": "rely",
                    "type_id": 1,
                    "description": "y position of text part relative to compound bubble"
                },
                {
                    "index": 3,
                    "name": "width",
                    "type_id": 1,
                    "description": "width of the text."
                }
            ],
            "description": "Create a new text part for the current compound bubble object.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 6
        },
        "8": {
            "id": 8,
            "command": "NEW: BKBD",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                },
                {
                    "index": 3,
                    "name": "backgroundColor",
                    "type_id": 1,
                    "description": "color number to use for plotting text"
                },
                {
                    "index": 4,
                    "name": "chalkColor",
                    "type_id": 1,
                    "description": "color number to use for plotting text"
                },
                {
                    "index": 5,
                    "name": "aliasColour",
                    "type_id": 1,
                    "description": "color number to use for plotting text."
                },
                {
                    "index": 6,
                    "name": "textX",
                    "type_id": 1,
                    "description": "the x-coordinate to place the text plot area relative to part 0"
                },
                {
                    "index": 7,
                    "name": "textY",
                    "type_id": 1,
                    "description": "the y-coordinate to place the text plot area relative to part 0"
                }
            ],
            "description": "Create a blackboard object \u2013 blackboard objects are the only ones that can use the [BBD:] commands designed to teach words and concepts.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 4
        },
        "3": {
            "id": 3,
            "command": "NEW: CBTN",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                },
                {
                    "index": 3,
                    "name": "plane",
                    "type_id": 1,
                    "description": "plane for this object between the range of 0=back, 9000=front"
                }
            ],
            "description": "Create a call button object.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 3
        },
        "12": {
            "id": 12,
            "command": "NEW: CBUB",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                },
                {
                    "index": 3,
                    "name": "stringId",
                    "type_id": 13,
                    "description": "string id in in-game string table"
                }
            ],
            "description": "Create a new Compound bubble object, this is a specialisation of a compound object that has text boxes capable of displaying text from the in-game string table \u2013 specified by stringID.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 6
        },
        "4": {
            "id": 4,
            "command": "NEW: COMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                },
                {
                    "index": 3,
                    "name": "clone",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 92
                    }
                }
            ],
            "description": "Create a Compound Object. By default it has no parts, these must be set up after creation \u2013 Compound Objects need at least one part.\nCompound Objects are different from Simple Objects in that they can not be picked up \u2013 even if ATTR is set to allow it.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 67
        },
        "731": {
            "id": 731,
            "command": "NEW: COMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 4,
                    "name": "imageCount",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "plane",
                    "type_id": 1
                }
            ],
            "description": "Create a new compound agent. The sprite file is for the first part, which is made automatically. Similarly, image_count and first_image are for that first part. The plane is the absolute plane of part 1 - the planes of other parts are relative to the first part.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 67
        },
        "750": {
            "id": 750,
            "command": "NEW: CRAG",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "geneAgent",
                    "type_id": 11
                },
                {
                    "index": 2,
                    "name": "geneSlot",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "sex",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "variant",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 6,
                    "name": "imageCount",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 7,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "plane",
                    "type_id": 1
                }
            ],
            "description": "Makes a non-skeletal creature. The first five arguments are the same as NEW: CREA. The last four, starting from the sprite file, are exactly as in NEW: COMP.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "10": {
            "id": 10,
            "command": "NEW: CREA",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 1,
                    "description": "the moniker to use to locate the child\u2019s genome. **Should already exist**. Must be int. Use [TOKN] to get int from moniker"
                },
                {
                    "index": 1,
                    "name": "sex",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 71,
                        "C1": 71
                    },
                    "description": "1 if male, 2 if female and 0 for random"
                }
            ],
            "description": "Create a new-born creature.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "751": {
            "id": 751,
            "command": "NEW: CREA",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "geneAgent",
                    "type_id": 11
                },
                {
                    "index": 2,
                    "name": "geneSlot",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "sex",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 71,
                        "C3": 71,
                        "CV": 71,
                        "SM": 71
                    }
                },
                {
                    "index": 4,
                    "name": "variant",
                    "type_id": 1
                }
            ],
            "description": "Makes a creature using the genome from the given gene slot in another agent. You'll want to use GENE CROS or GENE LOAD to fill that slot in first. The gene slot is cleared, as control of that genome is moved to the special slot 0 of the new creature, where it is expressed. Sex is 1 for male, 2 for female or 0 for random. The variant can also be 0 for a random value between 1 and 8. See also NEWC.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "11": {
            "id": 11,
            "command": "NEW: GENE",
            "parameters": [
                {
                    "index": 0,
                    "name": "mum",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 296,
                        "C2": 296
                    },
                    "description": "int moniker for mother"
                },
                {
                    "index": 1,
                    "name": "dad",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 296,
                        "C2": 296
                    },
                    "description": "int monikor for father."
                },
                {
                    "index": 2,
                    "name": "child",
                    "type_id": 6,
                    "description": "variable to store the new Moniker",
                    "variable_type_id": "1"
                }
            ],
            "description": "Creates a new genome file from mum\u2019s and dad\u2019s (or just mum if dad=0) genomes, and stores the new genome's moniker in the variable child.\nUse [TOKN] to convert text moniker to int\n@example: #{NEW: GENE TOKN ADAM TOKN EVE_ OV00}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "7": {
            "id": 7,
            "command": "NEW: LIFT",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                }
            ],
            "description": "Create a lift object \u2013 lift objects work in conjunction with call buttons to move between floors.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 3
        },
        "5": {
            "id": 5,
            "command": "NEW: PART",
            "parameters": [
                {
                    "index": 0,
                    "name": "part",
                    "type_id": 1,
                    "description": "part number (0-9)"
                },
                {
                    "index": 1,
                    "name": "relx",
                    "type_id": 1,
                    "description": "x-position of the part relative to part 0"
                },
                {
                    "index": 2,
                    "name": "rely",
                    "type_id": 1,
                    "description": "y-position of the part relative to part 0"
                },
                {
                    "index": 3,
                    "name": "imageOffset",
                    "type_id": 1,
                    "description": "the base sprite for this part relative to the first sprite"
                },
                {
                    "index": 4,
                    "name": "plane",
                    "type_id": 1,
                    "description": "plane for this object between the range of 0=back, 9000=front"
                }
            ],
            "description": "Add apart to the current Compound Object. Should be used immediately after creating a Compound Object to add one or more parts to it.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 67
        },
        "187": {
            "id": 187,
            "command": "NEW: RAIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240
                    },
                    "description": "the sprite file to use for the cloud itself"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "the total number of images to be used for this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "the number of the first image belonging to this object"
                },
                {
                    "index": 3,
                    "name": "plane",
                    "type_id": 1,
                    "description": "the image plane to plot the object at."
                },
                {
                    "index": 4,
                    "name": "clone",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 92
                    },
                    "description": "create a cloned image gallery yes/no"
                }
            ],
            "description": "Creates a new rain cloud object, these are like Simple Objects but have a weather effect underneath.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 23
        },
        "1": {
            "id": 1,
            "command": "NEW: SCEN",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "totalInSprite",
                    "type_id": 1,
                    "description": "total number of images in the sprite file"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                },
                {
                    "index": 3,
                    "name": "plane",
                    "type_id": 1,
                    "description": "plane for this object between the range of 0=back, 9000=front"
                }
            ],
            "description": "Creates a scenery object \u2013 scenery objects do not need to have a unique classifier.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 67
        },
        "2": {
            "id": 2,
            "command": "NEW: SIMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                },
                {
                    "index": 3,
                    "name": "plane",
                    "type_id": 1,
                    "description": "plane for this object between the range of 0=back, 9000=front"
                },
                {
                    "index": 4,
                    "name": "clone",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 92
                    },
                    "description": "0 means that all identical objects can use the same image gallery.  1 creates a whole new image gallery for this object, normally only required if that particular object\u2019s image is going to be modified."
                }
            ],
            "description": "Creates a Simple Object. By default Simple Objects have no attributes or behavior defined, these must be set up after creation.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 67
        },
        "706": {
            "id": 706,
            "command": "NEW: SIMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 4,
                    "name": "imageCount",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "plane",
                    "type_id": 1
                }
            ],
            "description": "Create a new simple agent, using the specified sprite file. The agent will have image_count sprites available, starting at first_image in the file. The plane is the screen depth to show the agent at - the higher the number, the nearer the camera.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 67
        },
        "6": {
            "id": 6,
            "command": "NEW: VHCL",
            "parameters": [
                {
                    "index": 0,
                    "name": "spriteFile",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240,
                        "C1": 236
                    },
                    "description": "4 letter token representing the sprite filename"
                },
                {
                    "index": 1,
                    "name": "numImages",
                    "type_id": 1,
                    "description": "number of images belonging to this object"
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1,
                    "description": "offset of first image associated with this object"
                }
            ],
            "description": "Create a vehicle object.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 3
        },
        "930": {
            "id": 930,
            "command": "NEW: VHCL",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 4,
                    "name": "imageCount",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "plane",
                    "type_id": 1
                }
            ],
            "description": "Create a new vehicle. Parameters are the same as NEW: COMP.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "458": {
            "id": 458,
            "command": "NEWC",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "geneAgent",
                    "type_id": 11
                },
                {
                    "index": 2,
                    "name": "geneSlot",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "sex",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "variant",
                    "type_id": 1
                }
            ],
            "description": "This version of NEW: CREA executes over a series of ticks, helping to prevent the pause caused by the creation of a creature with the NEW: CREA command. However, it cannot be used in install scripts (e.g. the bootstrap) and so NEW: CREA should be used for that.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "89": {
            "id": 89,
            "command": "NEXT",
            "description": "part of [ENUM]...[NEXT]",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 18
        },
        "355": {
            "id": 355,
            "command": "NOHH",
            "description": "Tell the creature to immediately stop holding hands with the pointer. Useful when you are about to teleport a norn, it prevents the pointer from continuously changing his position back to where it was.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "459": {
            "id": 459,
            "command": "NORN",
            "parameters": [
                {
                    "index": 0,
                    "name": "creature",
                    "type_id": 11
                }
            ],
            "description": "Chooses the active creature. Script 120 is executed on that creature, to inform them that they've been selected.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "460": {
            "id": 460,
            "command": "NORN",
            "description": "Returns the creature currently selected by the user.",
            "return_type_id": 11,
            "rvalue": true,
            "lvalue": true,
            "variants": 63,
            "command_group_id": 5
        },
        "926": {
            "id": 926,
            "command": "NOTV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                }
            ],
            "description": "Perform a bitwise NOT on an integer variable.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 13
        },
        "419": {
            "id": 419,
            "command": "NPGS",
            "description": "Returns the number of available pages for current text part.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 29
        },
        "91": {
            "id": 91,
            "command": "NSCN",
            "description": "Ends [ESCN] enum loop",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 18
        },
        "461": {
            "id": 461,
            "command": "NUDE",
            "description": "Removes all clothes from a creature. Any changed layer 0 will revert to drawing the body part again. See WEAR.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "356": {
            "id": 356,
            "command": "NULL",
            "description": "Returns a null agent pointer.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "683": {
            "id": 683,
            "command": "NWLD",
            "description": "Returns the number of world directories.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 21
        },
        "150": {
            "id": 150,
            "command": "OBDT",
            "parameters": [
                {
                    "index": 0,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                }
            ],
            "description": "Returns the distance to any obstacle in the given direction regardless of SIZE, floor value or door values.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "24": {
            "id": 24,
            "command": "OBJP",
            "description": "Specific pointer to store ID of an object for later retrieval.\nLegacy command from Creatures 1. Can now use normal variables instead.",
            "return_type_id": 11,
            "rvalue": true,
            "lvalue": true,
            "requires_ownr": 1,
            "variants": 3,
            "command_group_id": 7
        },
        "580": {
            "id": 580,
            "command": "OBST",
            "parameters": [
                {
                    "index": 0,
                    "name": "direction",
                    "type_id": 1
                }
            ],
            "description": "Returns the distance from the agent to the nearest wall that it might collide with in the given direction. Directions are LEFT, RGHT, _UP_, or DOWN. If the distance to the collision is greater than RNGE then a very large number is returned.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "149": {
            "id": 149,
            "command": "OBST",
            "parameters": [
                {
                    "index": 0,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                }
            ],
            "description": "Searches the room from the centre point of TARG for a floor or room door that presents an obstacle to the agent assuming it is moving in the given direction.\nThe value returned is the distance to this obstacle.\nThis macro command takes into consideration the SIZE of the agent, the floor value of the room and appropriate door values.\nIf no obstacle is presented to the agent then a very large number is returned.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "151": {
            "id": 151,
            "command": "OBSV",
            "parameters": [
                {
                    "index": 0,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                }
            ],
            "description": "Obstacle Value. Returns the value of the door for the first obstacle in the given direction.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "944": {
            "id": 944,
            "command": "OBVx",
            "description": "OBV0 to OBV2 are variables specific to an agent. They are read from [TARG] (the target agent)\n@range(0 to 2)",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 12
        },
        "127": {
            "id": 127,
            "command": "ONTR",
            "description": "Sets/returns the room's organic nutrients at [targ]",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "357": {
            "id": 357,
            "command": "ONTV",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "checkAllCameras",
                    "type_id": 1
                }
            ],
            "description": "Checks if the given agent, or any of its parts, is on screen and returns 1 if it is or 0 if it is not. Set to 0 to check if the agent is on the main camera. Set to 1 to check if the agent is on the main camera or any remote cameras",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 1
        },
        "509": {
            "id": 509,
            "command": "OOWW",
            "parameters": [
                {
                    "index": 0,
                    "name": "moniker",
                    "type_id": 4
                }
            ],
            "description": "Returns the status of the moniker.\n0 - never existed, or history purged\n1 - genome referenced by a slot, for example an egg\n2 - creature made with NEW: CREA\n3 - creature properly BORN\n4 - out of world, exported\n5 - dead, body still exists\n6 - dead, body KILLed\n7 - unreferenced genome",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 172,
                "DS": 172,
                "C3": 172,
                "SM": 172
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 32
        },
        "752": {
            "id": 752,
            "command": "ORDR SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "speech",
                    "type_id": 4
                }
            ],
            "description": "Sends a spoken command from target to all creatures that can hear it.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "753": {
            "id": 753,
            "command": "ORDR SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "speech",
                    "type_id": 4
                }
            ],
            "description": "Sends a spoken command from target to all creatures that can see it.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "754": {
            "id": 754,
            "command": "ORDR TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "speech",
                    "type_id": 4
                }
            ],
            "description": "Sends a spoken command from target to all creatures that are touching it.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "755": {
            "id": 755,
            "command": "ORDR WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "creature",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "speech",
                    "type_id": 4
                }
            ],
            "description": "Sends a spoken command from target to the specified creature.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "462": {
            "id": 462,
            "command": "ORGF",
            "parameters": [
                {
                    "index": 0,
                    "name": "organNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "data",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 193,
                        "DS": 193,
                        "C3": 193,
                        "SM": 193
                    }
                }
            ],
            "description": "Returns floating point data about the specified organ. The organ number is from 0 to ORGN - 1. The data parameter specifies what information is returned:\n0 - Clock rate in updates per tick (as locus)\n1 - Short term life force as a proportion of initial (as locus)\n2 - Factor to modulate rate of repair (as locus)\n3 - Injury to apply (as locus)\n4 - Initial life force, a million is the largest initial value\n5 - Short term life force, temporary damage\n6 - Long term life force, permanent damage\n7 - Long term rate damage during repair\n8 - Energy cost to run this organ, calculated from the number of receptors, emitters and reactions\n9 - Damage done to the organ if no energy is available",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "463": {
            "id": 463,
            "command": "ORGI",
            "parameters": [
                {
                    "index": 0,
                    "name": "organNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "data",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 195,
                        "DS": 195,
                        "C3": 195,
                        "SM": 195
                    }
                }
            ],
            "description": "Returns integer data about the specified organ. The organ number is from 0 to ORGN - 1. The data parameter specifies what information is returned:\n0 - receptor count\n1 - emitter count\n2 - reaction count.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "216": {
            "id": 216,
            "command": "ORGN",
            "description": "Returns the number of organs in the creature",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 62,
            "command_group_id": 5
        },
        "316": {
            "id": 316,
            "command": "ORRV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "value",
                    "type_id": 1
                }
            ],
            "description": "sets the {var} to the {var} bit-wise or with {value}\n{var} = {var} | {value}",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 13
        },
        "980": {
            "id": 980,
            "command": "OUTL",
            "parameters": [
                {
                    "index": 0,
                    "name": "onOrOff",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "red",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "green",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "blue",
                    "type_id": 1
                }
            ],
            "description": "Detect and outline the edges of an agent with a specified colour.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 18
        },
        "500": {
            "id": 500,
            "command": "OUTS",
            "parameters": [
                {
                    "index": 0,
                    "name": "text",
                    "type_id": 4
                }
            ],
            "description": "Sends a string to the output stream. When running a script, the stream is null and this command does nothing. For an externally injected command, the data from the stream is returned to the calling process. For the CAOS command, the text is returned as a string. You can use FILE OOPE to set the stream to a journal file.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "501": {
            "id": 501,
            "command": "OUTV",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 16
                }
            ],
            "description": "Similar to OUTS only outputs a float or integer as a decimal string.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "502": {
            "id": 502,
            "command": "OUTX",
            "parameters": [
                {
                    "index": 0,
                    "name": "text",
                    "type_id": 4
                }
            ],
            "description": "This sends the string text to the output stream. However it first transforms any escapes into quoted escapes, and it also quotes the entire string for you.\ne.g.:\noutx \"Moooose\\n\"\nWould produce:\n\"Moooose\\n\"\non the output stream instead of:\nMoooose",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 30
        },
        "102": {
            "id": 102,
            "command": "OVER",
            "description": "Wait until [TARG] objects animation is over.\nNote: [ANIM]s ending in R will never end, hence causing a lock out",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 18
        },
        "645": {
            "id": 645,
            "command": "OVxx",
            "description": "OV00 to OV99 are variables specific to an agent. They are read from [TARG], the target agent. You can also access these same variables via [OWNR] using [MVxx].\n@range(0 to 99)",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 62,
            "command_group_id": 12
        },
        "293": {
            "id": 293,
            "command": "OWNR",
            "description": "default object (owner of script, or pet if [DDE])",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 7
        },
        "616": {
            "id": 616,
            "command": "PACE",
            "description": "Returns the tick rate satisfaction factor.\nFactor 1 - ticks are taking the time we would expect them to, which is 0.05 secs.\nFactor more than 1 - the engine is running too slowly.\nFactor less than 1 - the engine is leaving spare processing time.\nThis is averaged over the last 10 ticks.\nAgents can look at this to adjust the resources they use according to current spare processing time. For example, if you have a random snowflake generator in winter, you could increase the chance of generation if PACE is low, and decrease the chance if PACE is high. When you do this remember that computers will be arbitrarily faster in the future, so you should place an extra upper limit on the number of snowflakes to stop them filling the whole screen.\nNote that PACE only measures the time the engine takes for tick processing, not for handling requests from external applications, or adding Windows events to its internal queue. Because of this, you should aim for a value which is a bit less than 1.\nCompare RACE.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "420": {
            "id": 420,
            "command": "PAGE",
            "parameters": [
                {
                    "index": 0,
                    "name": "page",
                    "type_id": 1
                }
            ],
            "description": "Sets current page for text part. The page number should be equal or greater than zero and less than the number returned by NPGS. Use PAT: TEXT or PAT: FIXD to make a text part, and PART to set the current part.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "421": {
            "id": 421,
            "command": "PAGE",
            "description": "Returns the current page for current text part. See the PAGE command for more information.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 29
        },
        "166": {
            "id": 166,
            "command": "PART",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1,
                    "description": "part number"
                }
            ],
            "description": "Sets the working part number. Future command such as POSE and ANIM, amongst others, act on that part of a compound agent.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 1
        },
        "732": {
            "id": 732,
            "command": "PART",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                }
            ],
            "description": "Returns 1 if the given part number exists on the TARG agent and 0 if it does not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 29
        },
        "733": {
            "id": 733,
            "command": "PAT: BUTT",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "imageCount",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 6,
                    "name": "relPlane",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "animHover",
                    "type_id": 17
                },
                {
                    "index": 8,
                    "name": "messageId",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "option",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 290,
                        "CV": 290,
                        "DS": 290,
                        "SM": 290
                    }
                }
            ],
            "description": "Create a button on a compound agent. anim_hover is an animation, as in the ANIM command, to use when the mouse is over the button - when the mouse is moved off, it returns to any previous animation that was going. message_id is sent when the button is clicked. option is 0 for the mouse to hit anywhere in the bounding box, 1 to hit only non-transparent pixels.\n_P1_ of the message is set to the part number of the buttons allowing you to overload your messages by button group and then switch on input value in the script.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "933": {
            "id": 933,
            "command": "PAT: CHAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                }
            ],
            "description": "Creates a part that will receive keyboard input and translate key codes.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 29
        },
        "734": {
            "id": 734,
            "command": "PAT: CMRA",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "overlaySprite",
                    "type_id": 4,
                    "values_list_ids": {
                        "SM": 238,
                        "DS": 238,
                        "C3": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 2,
                    "name": "baseImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relx",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "rely",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relativePlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "viewWidth",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "viewHeight",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "cameraWidth",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "cameraHeight",
                    "type_id": 1
                }
            ],
            "description": "Create a camera with possible overlay sprite whose name may be blank. Use SCAM to change the camera's view.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "986": {
            "id": 986,
            "command": "PAT: DULL",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relPlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "numberOfImages",
                    "type_id": 1
                }
            ],
            "description": "Create a dull part for a compound agent. A dull part does nothing except show an image from the given sprite file. You should number part ids starting at 1, as part 0 is automatically made when the agent is made. The dull part's position is relative to part 0, as is its plane. Use PART to select it before you change POSE or ANIM, or use various other commands.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 29
        },
        "735": {
            "id": 735,
            "command": "PAT: DULL",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relPlane",
                    "type_id": 1
                }
            ],
            "description": "Create a dull part for a compound agent. A dull part does nothing except show an image from the given sprite file. You should number part ids starting at 1, as part 0 is automatically made when the agent is made. The dull part's position is relative to part 0, as is its plane. Use PART to select it before you change POSE or ANIM, or use various other commands.",
            "return_type_id": 8,
            "variants": 28,
            "command_group_id": 29
        },
        "987": {
            "id": 987,
            "command": "PAT: FIXD",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relPlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "fontSprite",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 7,
                    "name": "fontWidth",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "fontHeight",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "red",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "blue",
                    "type_id": 1
                },
                {
                    "index": 11,
                    "name": "green",
                    "type_id": 1
                },
                {
                    "index": 12,
                    "name": "bold",
                    "type_id": 1
                }
            ],
            "description": "Create a fixed text part. The text is wrapped on top of the supplied gallery image. new-line characters may be used. Use PTXT to set the text.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 29
        },
        "736": {
            "id": 736,
            "command": "PAT: FIXD",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relPlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "fontSprite",
                    "type_id": 4,
                    "values_list_ids": {
                        "SM": 238,
                        "DS": 238,
                        "C3": 238,
                        "CV": 238
                    }
                }
            ],
            "description": "Create a fixed text part. The text is wrapped on top of the supplied gallery image. new-line characters may be used. Use PTXT to set the text.",
            "return_type_id": 8,
            "variants": 28,
            "command_group_id": 29
        },
        "737": {
            "id": 737,
            "command": "PAT: GRPH",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "overlaySprite",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 2,
                    "name": "baseImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relx",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "rely",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relativePlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "numValues",
                    "type_id": 1
                }
            ],
            "description": "Creates a graph part on a compound agent. Use GRPL to add a line to the graph and GRPV to add a value to a graph line.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "738": {
            "id": 738,
            "command": "PAT: KILL",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                }
            ],
            "description": "Destroys the specified part of a compound agent. You can't destroy part 0.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "739": {
            "id": 739,
            "command": "PAT: MOVE",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 2,
                    "name": "relY",
                    "type_id": 16
                }
            ],
            "description": "Moves a compound part to the new relative position specified.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 29
        },
        "988": {
            "id": 988,
            "command": "PAT: TEXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relPlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "messageId",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "fontSprite",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238,
                        "CV": 238
                    }
                },
                {
                    "index": 8,
                    "name": "fontWidth",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "fontHeight",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "red",
                    "type_id": 1
                },
                {
                    "index": 11,
                    "name": "blue",
                    "type_id": 1
                },
                {
                    "index": 12,
                    "name": "green",
                    "type_id": 1
                },
                {
                    "index": 13,
                    "name": "bold",
                    "type_id": 1
                }
            ],
            "description": "Creates a text entry part. Gains the focus when you click on it, or with the FCUS command. Sends the message_id when tab or return are pressed - a good place to use PTXT to get the text out, and to set the focus elsewhere.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 29
        },
        "740": {
            "id": 740,
            "command": "PAT: TEXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "partId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "spriteFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "DS": 238,
                        "C3": 238,
                        "CV": 238,
                        "SM": 238
                    }
                },
                {
                    "index": 2,
                    "name": "firstImage",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "relX",
                    "type_id": 16
                },
                {
                    "index": 4,
                    "name": "relY",
                    "type_id": 16
                },
                {
                    "index": 5,
                    "name": "relPlane",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "messageId",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "fontSprite",
                    "type_id": 4,
                    "values_list_ids": {
                        "C3": 238,
                        "DS": 238,
                        "SM": 238
                    }
                }
            ],
            "description": "Creates a text entry part. Gains the focus when you click on it, or with the FCUS command. Sends the message_id when return is pressed - a good place to use PTXT to get the text out, and to set the focus elsewhere. Set message_id to 0 to not call any script, or to -1 to not send any message and instead insert a carriage return.",
            "return_type_id": 8,
            "variants": 28,
            "command_group_id": 29
        },
        "274": {
            "id": 274,
            "command": "PAUS",
            "description": "PAUSe game. 0=normal, 1=pause\nNote that Creatures already calls a dispatch method for each applet currently running when the game pauses.\nGAME\t<<value>>\nGAME flow state. Sets or queries game flow state. Category: 0 = Applet custom condition,\nVariable: Applet slot number.\nCategory: 1 = Applet advanced option,\nVariable: Applet slot number. 5 for Science Kit, 6 for Neuroscience Kit.\nCategory: 2 = Game feature enable.\nVariable: 0 = Select Ettins/ Grendels, 1 = Infinite scroll",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 161,
                "SM": 161
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "358": {
            "id": 358,
            "command": "PAUS",
            "parameters": [
                {
                    "index": 0,
                    "name": "paused",
                    "type_id": 1
                }
            ],
            "description": "Stops the target agent from running - it'll freeze completely, scripts and physics. Set to 1 to pause, 0 to run. You might want to use WPAU with this to implement a pause game option.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 1
        },
        "359": {
            "id": 359,
            "command": "PAUS",
            "description": "Returns 1 if the target agent is paused, or 0 otherwise.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 161,
                "DS": 161,
                "C3": 161,
                "SM": 161
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "492": {
            "id": 492,
            "command": "PAWS",
            "description": "Returns 1 for debug pawsed, 0 for playing. See DBG: PAWS.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 171,
                "DS": 171,
                "C3": 171,
                "SM": 171
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "360": {
            "id": 360,
            "command": "PCLS",
            "parameters": [
                {
                    "index": 0,
                    "name": "next",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Same as NCLS, only cycles the other way.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 7
        },
        "551": {
            "id": 551,
            "command": "PERM",
            "parameters": [
                {
                    "index": 0,
                    "name": "permiability",
                    "type_id": 1
                }
            ],
            "description": "Value from 1 to 100. Sets which room boundaries the agent can pass through. The smaller the PERM the more it can go through. DOOR sets the corresponding room boundary permiability. Also used for ESEE, to decide what it can see through.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "552": {
            "id": 552,
            "command": "PERM",
            "description": "Returns the target's map permiability.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "202": {
            "id": 202,
            "command": "PLDS",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 235,
                        "C1": 235
                    },
                    "description": "4 letter filename token"
                }
            ],
            "description": "Preload the named sound into the sound cache if TARG is visible or just off screen.\nfilename\tvalue",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "756": {
            "id": 756,
            "command": "PLMD",
            "parameters": [
                {
                    "index": 0,
                    "name": "tractIndex",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4
                }
            ],
            "description": "Dumps out all the dendrite learned information of the specified tract to a file (will be changed to sync with Palm).",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "757": {
            "id": 757,
            "command": "PLMU",
            "parameters": [
                {
                    "index": 0,
                    "name": "tractIndex",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "filename",
                    "type_id": 4
                }
            ],
            "description": "Configures the dendrites in the specified tract with the data in the file (will be changed to sync with Palm).",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "361": {
            "id": 361,
            "command": "PLNE",
            "parameters": [
                {
                    "index": 0,
                    "name": "plane",
                    "type_id": 1
                }
            ],
            "description": "Sets the target agent's principal drawing plane. The higher the value, the nearer the camera. For compound agents, the principal plane is the one for the automatically made first part. The plane of other parts is relative to this one.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 64
        },
        "362": {
            "id": 362,
            "command": "PLNE",
            "description": "Returns the screen depth plane of the principal part.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "18": {
            "id": 18,
            "command": "PNTR",
            "description": "The hand/pointer object.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 7
        },
        "741": {
            "id": 741,
            "command": "PNXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "previousPart",
                    "type_id": 1
                }
            ],
            "description": "Returns the next compound PART on an agent. Start by calling it with -1 to get the first part, and it finishes by returning -1 when it reaches the end.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 29
        },
        "223": {
            "id": 223,
            "command": "POIN",
            "description": "Point to [_IT_]. As for [TOUC] but creature reaches out to object with head facing the camera.",
            "return_type_id": 8,
            "requires_creature_ownr": true,
            "variants": 3,
            "command_group_id": 1
        },
        "52": {
            "id": 52,
            "command": "POSB",
            "description": "Returns the object\u2019s Position \u2013 Bottom edge of object",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "363": {
            "id": 363,
            "command": "POSB",
            "description": "Returns bottom position of target's bounding box.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "103": {
            "id": 103,
            "command": "POSE",
            "description": "Returns the objects (or parts) pose \u2013 i.e. which image number it is currently using",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 18
        },
        "104": {
            "id": 104,
            "command": "POSE",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                }
            ],
            "description": "Sets the object (or parts) pose = i.e. which image number it is currently using",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 18
        },
        "50": {
            "id": 50,
            "command": "POSL",
            "description": "Returns the object\u2019s Position \u2013 Left edge of object",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "364": {
            "id": 364,
            "command": "POSL",
            "description": "Returns left position of target's bounding box.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "51": {
            "id": 51,
            "command": "POSR",
            "description": "Returns the object\u2019s Position \u2013 Right edge of object",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "365": {
            "id": 365,
            "command": "POSR",
            "description": "Returns right position of target's bounding box.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "53": {
            "id": 53,
            "command": "POST",
            "description": "Returns the object\u2019s Position \u2013 Top edge of object",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 64
        },
        "366": {
            "id": 366,
            "command": "POST",
            "description": "Returns top position of target's bounding box.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "48": {
            "id": 48,
            "command": "POSX",
            "description": "Returns the X co-ordinate of the centre point of object Targ.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 64
        },
        "367": {
            "id": 367,
            "command": "POSX",
            "description": "Returns X position of centre of target.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "49": {
            "id": 49,
            "command": "POSY",
            "description": "Returns the Y co-ordinate of the centre point of object Targ.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 64
        },
        "368": {
            "id": 368,
            "command": "POSY",
            "description": "Returns Y position of centre of target.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "886": {
            "id": 886,
            "command": "PRAY AGTI",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "integerTag",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "defaultValue",
                    "type_id": 1
                }
            ],
            "description": "This returns the value of the integer tag associated with the named resource. If the resource does not contain such a tag, then the default value specified is returned. This call pairs with PRAY AGTS.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "887": {
            "id": 887,
            "command": "PRAY AGTS",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "stringTag",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "defaultValue",
                    "type_id": 4
                }
            ],
            "description": "This returns the value of the string tag associated with the named resource. If the resource does not contain such a tag, then the default value specified is returned. This call pairs with PRAY AGTI.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "888": {
            "id": 888,
            "command": "PRAY BACK",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceType",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "lastKnown",
                    "type_id": 4
                }
            ],
            "description": "Like PRAY PREV, only doesn't loop at the end. If you go beyond the first entry then it returns an empty string.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 38
        },
        "889": {
            "id": 889,
            "command": "PRAY COUN",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceType",
                    "type_id": 4
                }
            ],
            "description": "This returns the number of resource chunks which are tagged with the resource type passed in. Resource types are four characters only. Anything over that length will be silently truncated.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "890": {
            "id": 890,
            "command": "PRAY DEPS",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "doInstall",
                    "type_id": 1
                }
            ],
            "description": "This performs a scan of the specified resource, and checks out the dependency data. The primary use for this would be in the preparation for injection of agents. If you pass zero in the do_install parameter, then the dependencies are only checked. If do_install is non-zero, then they are installed also. The return values are as follows:\n0 = Success\n-1 = Agent Type not found\n-2 = Dependency Count not found\n-3 to -(2 + count) is the dependency string missing\n-(3+count) to -(2+2*count) is the dependency type missing\n2*count to 3*count is the category ID for that dependency being invalid\n1 to count is the dependency failing",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "891": {
            "id": 891,
            "command": "PRAY EXPO",
            "parameters": [
                {
                    "index": 0,
                    "name": "chunkType",
                    "type_id": 4
                }
            ],
            "description": "This function exports the target creature. If the creature is exported successfully then it has been removed from the world. Returns value is one of the following:\n0 for success\n1 if the creature, or if pregnant any of its offspring, are already on disk in some form.\nThe chunk type should be used to find the creature again to import it. In Creatures 3, most exported creatures have a chunk type EXPC, and the starter family uses SFAM.\nFor new games, you should not use SFAM, as its data would get confused with that of an EXPC with the same moniker. This is for backwards compatibility with Creatures 3's use of SFAM, which works because the CAOS code guarantees different monikers.\nFor other chunk names, creatures exported with a different type are kept entirely separately, and will not get confused with each other. The chunk type is added to the end of the moniker to form the chunk name.\nThe exported creature has some fields associated with it, that can be read by PRAY AGTI or PRAY AGTS before importing:\n\"Exported At World Time\" integer\n\"Creature Age In Ticks\" integer\n\"Exported At Real Time\" integer\n\"Creature Life Stage\" integer\n\"Exported From World Name\" string\n\"Exported From World UID\" string\n\"Native Network User\" string\n\"Last Network User\" (could be faked, NET: FROM is safer) string\n\"Creature Name\" string\n\"Gender\" integer\n\"Genus\" integer\n\"Variant\" integer\n\"Head Gallery\" string (this is calculated on the sending computer, so the file may be missing on the receiving one - try LIMB instead)\n\"Pregnancy Status\" integer\nIn addition you can add custom fields by setting NAME variables on the Creature before export. Any strings or integers whose name begin \"Pray Extra \" are added as entries to the export file.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "892": {
            "id": 892,
            "command": "PRAY FILE",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "resourceType",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "doInstall",
                    "type_id": 1
                }
            ],
            "description": "This performs the \"installation\" of one file from the resource files. The resource_type is defined in the agent resource guide. If do_install is zero, the command simply checks if the file install should succeed. Return value is 0 for success, 1 for error.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 204,
                "C3": 204,
                "CV": 204,
                "SM": 204
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "893": {
            "id": 893,
            "command": "PRAY FORE",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceType",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "lastKnown",
                    "type_id": 4
                }
            ],
            "description": "Like PRAY NEXT, only doesn't loop at the end. If you go beyond the last entry then it returns an empty string.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 38
        },
        "894": {
            "id": 894,
            "command": "PRAY GARB",
            "parameters": [
                {
                    "index": 0,
                    "name": "force",
                    "type_id": 1
                }
            ],
            "description": "This command clears the manager's cached resource data. Execute this after a lot of resource accesses (E.g. installing an agent) to clean up the memory used during the process. If you don't do this, excess memory can be held for a while, If the parameter is zero (the most usual) then the manager will only forget resources which are not in use at the moment. If force is non-zero, then the manager will forget all the previously loaded resources. As the resources currently in use go out of scope, they are automatically garbage collected.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 38
        },
        "895": {
            "id": 895,
            "command": "PRAY IMPO",
            "parameters": [
                {
                    "index": 0,
                    "name": "monikerChunk",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "actuallyDoIt",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "keepFile",
                    "type_id": 1
                }
            ],
            "description": "This function imports the creature with the requested moniker and chunk type. Returns one of the following codes:\n0 - success\n1 - couldn't reconcile histories so creature was cloned\n2 - moniker not found in PRAY system\n3 - unused error code\n4 - internal / file format error\nSet actually_do_it to 1 to try and perform the import, or 0 to perform a query giving just the return value. You can use the query to test if the creature is available, and if the creature would have to be cloned upon importing, and warn the user. The new creature is TARGetted after import. If you set keep file to 1, then the exported file won't be deleted (moved to the porch). The creature will appear in the same place that it was exported, but as with NEW: CREA, it will be in limbo, and won't function until moved to a valid place.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 194,
                "C3": 194,
                "CV": 194,
                "SM": 194
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "896": {
            "id": 896,
            "command": "PRAY INJT",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "doInstall",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "reportVar",
                    "type_id": 6,
                    "variable_type_id": "4|1"
                }
            ],
            "description": "This command injects an agent. The agent must be in the chunk named. If do_install is zero, the command simply checks for the presence of the required scripts and dependencies. If non-zero, it attempts to inject the agent. The report var is a string variable, and is set to the name of the offending script if the injection/check fails.\nReturn is 0 for success, -1 for \"Script not found\" and if injecting, -2 for \"Injection failed\".\nReturn value -3 indicates that a dependency evaluation failed, and in this case, the report var is the return code from PRAY DEPS",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 205,
                "C3": 205,
                "CV": 205,
                "SM": 205
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "897": {
            "id": 897,
            "command": "PRAY KILL",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                }
            ],
            "description": "Deletes the resource file which contains the specified chunk. This is permanent and irreversible. Returns 1 if there was such a chunk and file, or 0 if there wasn't.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 38
        },
        "898": {
            "id": 898,
            "command": "PRAY MAKE",
            "parameters": [
                {
                    "index": 0,
                    "name": "whichJournalSpot",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 206,
                        "C3": 206,
                        "CV": 206,
                        "SM": 206
                    }
                },
                {
                    "index": 1,
                    "name": "journalName",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "whichPraySpot",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 208,
                        "DS": 208
                    }
                },
                {
                    "index": 3,
                    "name": "prayName",
                    "type_id": 4
                },
                {
                    "index": 4,
                    "name": "reportDestination",
                    "type_id": 6,
                    "variable_type_id": "4"
                }
            ],
            "description": "Please see the documentation accompanying the praybuilder on CDN\nSuffice it to say: return value is zero for success, otherwise non-zero, and report is set to the praybuilder output for you\nAlso, the which_journal_spot is zero for world journal, 1 for global journal. Also the which_pray_spot is zero for \"My Agents\" and 1 for \"My Creatures\"",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "899": {
            "id": 899,
            "command": "PRAY NEXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceType",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "lastKnown",
                    "type_id": 4
                }
            ],
            "description": "This returns the name of the resource chunk directly after the named one, given that they are of the same type. It loops when it reaches the end. If the named resource cannot be found in the list of resources of the type specified, then the last resource of that type is returned. This call pairs with PRAY PREV. Compare PRAY FORE.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "900": {
            "id": 900,
            "command": "PRAY PREV",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceType",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "lastKnown",
                    "type_id": 4
                }
            ],
            "description": "This returns the name of the resource chunk directly before the named one, given that they are of the same type. It loops when it reaches the end. If the named resource cannot be found in the list of resources of the type specified, then the first resource of that type is returned. This call pairs with PRAY NEXT. Compare PRAY BACK.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "901": {
            "id": 901,
            "command": "PRAY REFR",
            "description": "This command refreshes the engine's view of the Resource directory. Execute this if you have reason to believe that the files in the directory may have changed. It only detects changes if there is a new file or a deleted file - if a file has only changed it won't notice. This is awkward during development, you can use PRAY KILL to kill the old file before copying the new one over. PRAY REFR forces a PRAY GARB to happen automatically.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 38
        },
        "932": {
            "id": 932,
            "command": "PRAY SIZE",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                }
            ],
            "description": "The return value for this is the size of the chunk. This can be used to determine chunk information for decisions on time criteria. E.g. a large compressed chunk will take a short while to decompress.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 38
        },
        "902": {
            "id": 902,
            "command": "PRAY TEST",
            "parameters": [
                {
                    "index": 0,
                    "name": "resourceName",
                    "type_id": 4
                }
            ],
            "description": "This checks for the existence of a chunk, returning zero if it is not found, and a value from 1-3 indicating the cost to load if it is.\nReturn values are currently defined as:\n0 - Chunk not available at this time\n1 - Chunk Available, Cached and ready for use\n2 - Chunk available, on disk uncompressed and fine for loading\n3 - Chunk available, on disk compressed and ready for loading.\nThus the return value could be thought of as the cost of loading, where 1 is no cost, and 3 is high cost.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 197,
                "C3": 197,
                "CV": 197,
                "SM": 197
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 38
        },
        "129": {
            "id": 129,
            "command": "PRES",
            "description": "Sets/returns the Pressure in room at object.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "105": {
            "id": 105,
            "command": "PRLD",
            "parameters": [
                {
                    "index": 0,
                    "name": "anim",
                    "type_id": 17,
                    "description": "ie. [1234]"
                }
            ],
            "description": "Pre-load image cache with these poses for smoother animation later\nNote: Not applicable on a creature",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 18
        },
        "397": {
            "id": 397,
            "command": "PRNT",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                }
            ],
            "description": "Prints an image from the TARG agent's sprite file. The pose is taken to be from the current base image.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 24
        },
        "553": {
            "id": 553,
            "command": "PROP",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "C3": 183,
                        "SM": 183
                    }
                },
                {
                    "index": 2,
                    "name": "caValue",
                    "type_id": 2
                }
            ],
            "description": "Sets the level of a CA (cellular automata) in a particular room. There are 16 CAs, and their meaning depends on the game. The level is between 0 and 1.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "554": {
            "id": 554,
            "command": "PROP",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "C3": 183,
                        "SM": 183
                    }
                }
            ],
            "description": "Returns the value of a CA in a room.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "872": {
            "id": 872,
            "command": "PRT: BANG",
            "parameters": [
                {
                    "index": 0,
                    "name": "bangStrength",
                    "type_id": 1
                }
            ],
            "description": "Breaks connections randomly with other machines (as if the machine had been 'banged'. Use a bang_strength of 100 to disconnect all ports, 50 to disconnect about half etc.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "873": {
            "id": 873,
            "command": "PRT: FRMA",
            "parameters": [
                {
                    "index": 0,
                    "name": "inputPort",
                    "type_id": 1
                }
            ],
            "description": "Returns the agent from which the input port is fed. Returns NULLHANDLE if that port does not exist, or is not connected.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 33
        },
        "874": {
            "id": 874,
            "command": "PRT: FROM",
            "parameters": [
                {
                    "index": 0,
                    "name": "inputPort",
                    "type_id": 1
                }
            ],
            "description": "Returns the output port index on the source agent, feeding that input port on the TARG agent.\nReturn values are -ve for error.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 33
        },
        "875": {
            "id": 875,
            "command": "PRT: INEW",
            "parameters": [
                {
                    "index": 0,
                    "name": "id",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "name",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "description",
                    "type_id": 4
                },
                {
                    "index": 3,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "messageNum",
                    "type_id": 1
                }
            ],
            "description": "Create a new input port on target. You should number input port ids starting at 0. The message_num is the message that will be sent to the agent when a signal comes in through the input port. _P1_ of that message will contain the data value of the signal. The position of the port, relative to the agent, is given by x, y.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "876": {
            "id": 876,
            "command": "PRT: ITOT",
            "description": "Returns the number of input ports, assuming they are indexed sequentially.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 33
        },
        "877": {
            "id": 877,
            "command": "PRT: IZAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "id",
                    "type_id": 1
                }
            ],
            "description": "Remove the specified input port.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "878": {
            "id": 878,
            "command": "PRT: JOIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "sourceAgent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "outputId",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "destAgent",
                    "type_id": 11
                },
                {
                    "index": 3,
                    "name": "inputId",
                    "type_id": 1
                }
            ],
            "description": "Connect an output port on the source agent to an input port on the destination. An input may only be connected to one output at at time, but an output may feed any number of inputs.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "879": {
            "id": 879,
            "command": "PRT: KRAK",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "inOrOut",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "portIndex",
                    "type_id": 1
                }
            ],
            "description": "Breaks a specific connection on a machine. If in_or_out is zero, it is an input port whose connection is broken, if it is an output port, then all inputs are disconnected.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "880": {
            "id": 880,
            "command": "PRT: NAME",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "inOrOut",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "portIndex",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the indexed port (input port if in_or_out is zero, output port if non-zero) on the specified agent. Returns \"\" in error.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 33
        },
        "881": {
            "id": 881,
            "command": "PRT: ONEW",
            "parameters": [
                {
                    "index": 0,
                    "name": "id",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "name",
                    "type_id": 4
                },
                {
                    "index": 2,
                    "name": "description",
                    "type_id": 4
                },
                {
                    "index": 3,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Create a new output port on target. You should number input port ids starting at 0. The port's relative position is given by x, y.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "882": {
            "id": 882,
            "command": "PRT: OTOT",
            "description": "Returns the number of output ports, assuming they are indexed sequentially.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 33
        },
        "883": {
            "id": 883,
            "command": "PRT: OZAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "id",
                    "type_id": 1
                }
            ],
            "description": "Remove the specified output port.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "884": {
            "id": 884,
            "command": "PRT: SEND",
            "parameters": [
                {
                    "index": 0,
                    "name": "id",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "data",
                    "type_id": 13
                }
            ],
            "description": "Send a signal from the specified output port to all connected inputs. The data can be any integer.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 33
        },
        "133": {
            "id": 133,
            "command": "PSRC",
            "description": "Sets/returns the Pressure source in room at targ",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "931": {
            "id": 931,
            "command": "PSWD",
            "parameters": [
                {
                    "index": 0,
                    "name": "password",
                    "type_id": 4
                }
            ],
            "description": "Sets the password for the next world loaded. The world must be loaded (and saved) before it is actually set.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 21
        },
        "684": {
            "id": 684,
            "command": "PSWD",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldName",
                    "type_id": 4
                }
            ],
            "description": "Sets the password of the current world.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 21
        },
        "685": {
            "id": 685,
            "command": "PSWD",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldIndex",
                    "type_id": 1
                }
            ],
            "description": "Returns the password for the specified world. If the world is not password protected the return value will be an empty string.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 21
        },
        "422": {
            "id": 422,
            "command": "PTXT",
            "parameters": [
                {
                    "index": 0,
                    "name": "text",
                    "type_id": 4
                }
            ],
            "description": "Set string of current text part. Use PAT: TEXT or PAT: FIXD to make a text part, and PART to set the current part.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 29
        },
        "423": {
            "id": 423,
            "command": "PTXT",
            "description": "Returns the string of the current text part. See the PTXT command for more information.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 29
        },
        "26": {
            "id": 26,
            "command": "PUHL",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1,
                    "description": "corresponding object pose"
                },
                {
                    "index": 1,
                    "name": "x",
                    "type_id": 1,
                    "description": "relative x-cordinate"
                },
                {
                    "index": 2,
                    "name": "y",
                    "type_id": 1,
                    "description": "relative y-cordinate"
                }
            ],
            "description": "Pick Up handle. The virtual 'handle', i.e. the point by which an object is carried. Simple Objects only.",
            "return_type_id": 6,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 66
        },
        "369": {
            "id": 369,
            "command": "PUHL",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Set the relative x and y coordinate of the handle that target is picked up by, for the given pose. This pose is measured from the absolute base specified in the NEW: command, rather than the relative base specified by the BASE command. Pose -1 sets the same point for all poses.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 66
        },
        "370": {
            "id": 370,
            "command": "PUHL",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "xOrY",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 210,
                        "DS": 210,
                        "C3": 210,
                        "SM": 210
                    }
                }
            ],
            "description": "Returns the x or y coordinate of the handle that target is picked up by for the given pose. x_or_y is 1 for x, 2 for y.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 66
        },
        "25": {
            "id": 25,
            "command": "PUPT",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1,
                    "description": "corresponding object pose"
                },
                {
                    "index": 1,
                    "name": "x",
                    "type_id": 1,
                    "description": "relative x-cordinate"
                },
                {
                    "index": 2,
                    "name": "y",
                    "type_id": 1,
                    "description": "relative y-cordinate"
                }
            ],
            "description": "Pick Up point. This is the location of the virtual 'hand' an object uses to hold another. Simple Objects only",
            "return_type_id": 6,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 66
        },
        "371": {
            "id": 371,
            "command": "PUPT",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Set the relative x and y coordinate of the place where target picks agents up, for the given pose. This pose is measured from the absolute base specified in the NEW: command, rather than the relative base specified by the BASE command. Pose -1 sets the same point for all poses. For vehicles use the CABN command.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 66
        },
        "372": {
            "id": 372,
            "command": "PUPT",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "xOrY",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 210,
                        "DS": 210,
                        "C3": 210,
                        "SM": 210
                    }
                }
            ],
            "description": "Returns the x or y coordinate of the place where target picks agents up for the given pose. x_or_y is 1 for x, 2 for y.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 66
        },
        "520": {
            "id": 520,
            "command": "PURE",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 1
                }
            ],
            "description": "Enables or disables the default clicking and moving behaviour of the pointer. This default behaviour is to implement CLAC and CLIK, and to operate ports. Set to 1 to enable, 0 to disable. When disabled, use IMSK to hook mouse events.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 28
        },
        "521": {
            "id": 521,
            "command": "PURE",
            "description": "Returns whether default pointer behaviour is disabled or enabled. 1 if enabled, 0 if disabled.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 170,
                "DS": 170,
                "C3": 170,
                "SM": 170
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 28
        },
        "686": {
            "id": 686,
            "command": "QUIT",
            "description": "Quits the engine at the start of the next tick, without saving any changes. Call SAVE first to make it save the current world. If doing a sequence like \"SAVE QUIT\" or \"SAVE LOAD menu\", do it in an INST section. Otherwise it will sometimes save between the two instructions, meaning it quits (or loads menu) immediately upon reloading.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "617": {
            "id": 617,
            "command": "RACE",
            "description": "Returns the time in milliseconds which the last tick took overall. This differs from PACE in that on fast machines it will have a minimum of 50 milliseconds. It accounts for all the time in the tick, including event handling and window processing.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "126": {
            "id": 126,
            "command": "RADN",
            "description": "Sets/returns the room's radiation at [targ]",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "188": {
            "id": 188,
            "command": "RAIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "property",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 94
                    }
                }
            ],
            "description": "Get value of a property of the weather effect of a [RAIN] object.\nProperties:\n\\t0=x position, relative to object\n\\t1=y position, relative to object\n\\t2=width\n\\t3=height\n\\t4=angle of effect (updated by wind)\n\\t5=speed\tnumber of pixels moved per update\n\\t6=mode\t(0=stopped, 1=running, 2=start!, 3=stop!)\n\\t7=rain image number (0-11)",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 23
        },
        "189": {
            "id": 189,
            "command": "RAIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "property",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 94
                    }
                },
                {
                    "index": 1,
                    "name": "value",
                    "type_id": 1
                }
            ],
            "description": "Set a property of the weather effect of a [RAIN] object.\nProperties:\n\\t0=x position, relative to object\n\\t1=y position, relative to object\n\\t2=width\n\\t3=height\n\\t4=angle of effect (updated by wind)\n\\t5=speed\tnumber of pixels moved per update\n\\t6=mode\t(0=stopped, 1=running, 2=start!, 3=stop!)\n\\t7=rain image number (0-11)",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 23
        },
        "646": {
            "id": 646,
            "command": "RAND",
            "parameters": [
                {
                    "index": 0,
                    "name": "value1",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "value2",
                    "type_id": 1
                }
            ],
            "description": "Returns a random integer between value1 and value2 inclusive of both values. You can use negative values, and have them either way round.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "555": {
            "id": 555,
            "command": "RATE",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomType",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 278,
                        "C3": 278,
                        "DS": 278
                    }
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "C3": 183,
                        "SM": 183
                    }
                },
                {
                    "index": 2,
                    "name": "gain",
                    "type_id": 2
                },
                {
                    "index": 3,
                    "name": "loss",
                    "type_id": 2
                },
                {
                    "index": 4,
                    "name": "diffusion",
                    "type_id": 2
                }
            ],
            "description": "Sets various rates for a CA (cellular automata) in a particular type of room. The values can be from 0 to 1. Gain is the susceptibility to absorb from agents in the room, and loss is the amount lost to the atmosphere. The diffusion is the amount it spreads to adjacent rooms.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "556": {
            "id": 556,
            "command": "RATE",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomType",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 278,
                        "C3": 278,
                        "DS": 278
                    }
                },
                {
                    "index": 1,
                    "name": "caIndex",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 244,
                        "DS": 183,
                        "C3": 183,
                        "SM": 183
                    }
                }
            ],
            "description": "Returns a string containing gain, loss and diffusion rates for that combination of room type and CA.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "908": {
            "id": 908,
            "command": "RCLR",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Clear the music for the room at the given location.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "196": {
            "id": 196,
            "command": "RCLR",
            "description": "Room CleaR music. Resets the music track of all rooms to \u201cno change\u201d.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 25
        },
        "647": {
            "id": 647,
            "command": "READ",
            "parameters": [
                {
                    "index": 0,
                    "name": "catalogueTag",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "offset",
                    "type_id": 1
                }
            ],
            "description": "Returns a string from the catalogue. This is used for localisation. offset 0 is the first string after the TAG command in the catalogue file. See also REAN and WILD.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 34
        },
        "648": {
            "id": 648,
            "command": "REAF",
            "description": "Refreshes the catalogue from files on disk, from the main catalogue directory and the world catalogue directory. These are normally read in at startup, when a new world is read in, or when the PRAY resources system installs a catalogue file. Use while developing CAOS programs to refresh the catalogue as you add entries.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 34
        },
        "649": {
            "id": 649,
            "command": "REAN",
            "parameters": [
                {
                    "index": 0,
                    "name": "catalogueTag",
                    "type_id": 4
                }
            ],
            "description": "Returns the number of entries in the catalogue for the given tag. For the same tag, you can READ values from 0 to one less than REAN returns.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 34
        },
        "650": {
            "id": 650,
            "command": "REAQ",
            "parameters": [
                {
                    "index": 0,
                    "name": "catalogueTag",
                    "type_id": 4
                }
            ],
            "description": "Returns 1 if the catalogue tag is present, 0 if not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 34
        },
        "43": {
            "id": 43,
            "command": "RELX",
            "description": "Returns the relative x-position of object [Targ] from the script [OWNR] object.",
            "return_type_id": 1,
            "rvalue": true,
            "requires_ownr": 1,
            "variants": 2,
            "command_group_id": 8
        },
        "581": {
            "id": 581,
            "command": "RELX",
            "parameters": [
                {
                    "index": 0,
                    "name": "first",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "second",
                    "type_id": 11
                }
            ],
            "description": "Returns the relative X distance of the centre point of the second agent from the centre point of the first.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "44": {
            "id": 44,
            "command": "RELY",
            "description": "Returns the relative y-position of object [Targ] from the script [OWNR] object.",
            "return_type_id": 1,
            "rvalue": true,
            "requires_ownr": 1,
            "variants": 2,
            "command_group_id": 8
        },
        "582": {
            "id": 582,
            "command": "RELY",
            "parameters": [
                {
                    "index": 0,
                    "name": "first",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "second",
                    "type_id": 11
                }
            ],
            "description": "Returns the relative Y distance of the centre point of the second agent from the centre point of the first.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "83": {
            "id": 83,
            "command": "REPE",
            "description": "End [REPS] loop",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "82": {
            "id": 82,
            "command": "REPS",
            "parameters": [
                {
                    "index": 0,
                    "name": "count",
                    "type_id": 1,
                    "description": "repetitions"
                }
            ],
            "description": "Repeat the following code # times, up to next [REPE] (# >= 1)\nNOTE: [REPS]/[REPE] may be nested, but loops must NOT be jumped out of",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "29": {
            "id": 29,
            "command": "REST",
            "description": "Sets/returns the objects Restitution. % of y velocity lost after collision. I.e. Bounciness.\n0% infinite bounce!",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "81": {
            "id": 81,
            "command": "RETN",
            "description": "returns from a [GSUB]",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "687": {
            "id": 687,
            "command": "RGAM",
            "description": "Refresh all settings that are always read from game variables at start up e.g. the length of a day. This allows you to change such setting on the fly.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "557": {
            "id": 557,
            "command": "RGHT",
            "description": "Returns the value of the right constant.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "558": {
            "id": 558,
            "command": "RLOC",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                }
            ],
            "description": "Returns the location of the specified room as a string formatted as follows: xLeft xRight yLeftCeiling yRightCeiling yLeftFloor yRightFloor.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "278": {
            "id": 278,
            "command": "RMEV",
            "parameters": [
                {
                    "index": 0,
                    "name": "targ",
                    "type_id": 11,
                    "values_list_ids": {
                        "C2": 83
                    }
                }
            ],
            "description": "Removes an event label from the event bar. The value for targ works the same as EVNT.\nSCOR\tint>>\nReturns chronicle information concerning a particular game item. The values for item are:\n0 \u2013 Generation 1 eggs used\n1 \u2013 Number of natural eggs laid\n2 \u2013 Number of deaths\n3 \u2013 Number of creatures imported\n4 \u2013 Number of creatures exported\n5 \u2013 Number of creatures alive",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "138": {
            "id": 138,
            "command": "RMN#",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "edge",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    }
                }
            ],
            "description": "Room Neighbour count.\nNumber of neighbours a room has on a given edge.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "139": {
            "id": 139,
            "command": "RMND",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1,
                    "description": "room number."
                },
                {
                    "index": 1,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                },
                {
                    "index": 2,
                    "name": "door",
                    "type_id": 1,
                    "description": "number of door required. E.g. 1 for 1st, 2 for 2nd, etc."
                }
            ],
            "description": "Room Neighbour door Door-open value.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "136": {
            "id": 136,
            "command": "RMNO",
            "description": "Room Number. Return the room number of the current room of Targ.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "140": {
            "id": 140,
            "command": "RMNR",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1,
                    "description": "room number."
                },
                {
                    "index": 1,
                    "name": "direction",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 87
                    },
                    "description": "0 = left, 1 = right, 2 = up, 3 = down."
                },
                {
                    "index": 2,
                    "name": "neighbour",
                    "type_id": 1,
                    "description": "number of door required. E.g. 1 for 1st, 2 for 2nd, etc."
                }
            ],
            "description": "Room door destination room id",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "153": {
            "id": 153,
            "command": "RMS#",
            "description": "Returns the number of rooms defined in the world.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "599": {
            "id": 599,
            "command": "RMSC",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "trackName",
                    "type_id": 4
                }
            ],
            "description": "Associates a music track with the room at the specified coordinates. This overrides any track specified for the metaroom that the room is in.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "600": {
            "id": 600,
            "command": "RMSC",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the music track played at the room in the given location.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 25
        },
        "195": {
            "id": 195,
            "command": "RMSC",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "trackName",
                    "type_id": 9,
                    "description": "file name, [] (Empty string) = no change in track, [Silence] = play no track."
                }
            ],
            "description": "Room MuSiC. Specify music track associated with the room at this x y co-ordinate.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 25
        },
        "941": {
            "id": 941,
            "command": "RNDR",
            "description": "Renderer image format. Returns 0 if image format is 555 and 1 if it is 565.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 154
            },
            "rvalue": true,
            "variants": 2,
            "command_group_id": 18
        },
        "74": {
            "id": 74,
            "command": "RNDV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "min",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "max",
                    "type_id": 1
                }
            ],
            "description": "Set a variable to a random number between {min} and {max}.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 12
        },
        "31": {
            "id": 31,
            "command": "RNGE",
            "description": "Sets/returns the range an object can see.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 64
        },
        "373": {
            "id": 373,
            "command": "RNGE",
            "parameters": [
                {
                    "index": 0,
                    "name": "distance",
                    "type_id": 2
                }
            ],
            "description": "Sets the distance that the target can see and hear, and the distance used to test for potential collisions. See also ESEE, OBST.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 64
        },
        "374": {
            "id": 374,
            "command": "RNGE",
            "description": "Returns the target's range. See ESEE, OBST.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 64
        },
        "559": {
            "id": 559,
            "command": "ROOM",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                }
            ],
            "description": "Returns the id of the room containing the midpoint of the specified agent.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "305": {
            "id": 305,
            "command": "ROOM",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomNumber",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "edge",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 69
                    }
                }
            ],
            "description": "return world l,t,r,b or Type of given room where \"edge\" = 0=l 1=r 2=t 3=b\nor \"edge\" = 4 returns room Type (INDOORS...) Returns 0 if no such room",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 1,
            "command_group_id": 20
        },
        "318": {
            "id": 318,
            "command": "ROOM",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomNumber",
                    "type_id": 1,
                    "description": "Room# is the room to set up (may be a new room)"
                },
                {
                    "index": 1,
                    "name": "left",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "top",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "right",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "bottom",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 218
                    }
                },
                {
                    "index": 5,
                    "name": "roomType",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 72
                    }
                }
            ],
            "description": "Set up a room on map. LEFT, TOP, RIGHT, BOTTOM are the room rectangle in world coords \nRoom Type is 0=INDOORS 1=SURFACE 2=UNDERSEA",
            "return_type_id": 8,
            "variants": 1,
            "command_group_id": 20
        },
        "141": {
            "id": 141,
            "command": "ROOM",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1,
                    "description": "room ID"
                },
                {
                    "index": 1,
                    "name": "property",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 86
                    },
                    "description": "property of room"
                }
            ],
            "description": "[ROOM] property values\nProperties:\n\\t0 = left,\n\\t1 = top\n\\t2 = right\n\\t3 = bottom\n\\t4 = type\n\\t5 = floor value\n\\t6 = organic nutrient\n\\t7 = inorganic nutrient,\n\\t8 = temperature\n\\t9 = pressure\n\\t10 = wind x component\n\\t11 = wind y component\n\\t12 = light level\n\\t13 = radiation\n\\t14 = heat source\n\\t15 = pressure source\n\\t16 = light source\n\\t17 = radiation source\n\\t18 = visited flag\n\\t19 = drop status",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "142": {
            "id": 142,
            "command": "ROOM",
            "parameters": [
                {
                    "index": 0,
                    "name": "room",
                    "type_id": 1,
                    "description": "roomID"
                },
                {
                    "index": 1,
                    "name": "left",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "top",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "right",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "down",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "type",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "floorValue",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "organicNutrients",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "inorganicNutrients",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "temperature",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "pressure",
                    "type_id": 1
                },
                {
                    "index": 11,
                    "name": "lightLevel",
                    "type_id": 1
                },
                {
                    "index": 12,
                    "name": "radiation",
                    "type_id": 1
                },
                {
                    "index": 13,
                    "name": "heatSource",
                    "type_id": 1
                },
                {
                    "index": 14,
                    "name": "pressureSource",
                    "type_id": 1
                },
                {
                    "index": 15,
                    "name": "lightSource",
                    "type_id": 1
                },
                {
                    "index": 16,
                    "name": "radiationSource",
                    "type_id": 1
                },
                {
                    "index": 17,
                    "name": "dropStatus",
                    "type_id": 1
                }
            ],
            "description": "Room Property values",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 20
        },
        "981": {
            "id": 981,
            "command": "ROTA",
            "parameters": [
                {
                    "index": 0,
                    "name": "angle",
                    "type_id": 1
                }
            ],
            "description": "DirectDraw version does not work will try to find another way. Tell the agent to draw the current sprite rotated clockwise by the given angle a value between 0 and 360. This only works when using the direct display engine.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 18
        },
        "982": {
            "id": 982,
            "command": "ROTA",
            "description": "By what angle is the current sprite for this agent rotated returns angle between 0 and 360.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 32,
            "command_group_id": 18
        },
        "839": {
            "id": 839,
            "command": "ROTN",
            "parameters": [
                {
                    "index": 0,
                    "name": "noOfSpritesForEachRotation",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "noOfRotations",
                    "type_id": 2
                }
            ],
            "description": "For automatic change of sprite when the agent rotates the engine assumes that the sprite file is stored with all the sprites for one rotation together starting with pointing north.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "679": {
            "id": 679,
            "command": "RPAS",
            "parameters": [
                {
                    "index": 0,
                    "name": "vehicle",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "passenger",
                    "type_id": 11
                }
            ],
            "description": "Specified vehicle drops the specified passenger.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 3
        },
        "291": {
            "id": 291,
            "command": "RSCR",
            "description": "Marks the following chunk of scripts as being for the removal of an object.\nThe presence of [SCRP], [ISCR] or [ENDM] is used to delimit the removal chunk",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "464": {
            "id": 464,
            "command": "RSET",
            "description": "This clothes the TARG creature with the last stored clothing set - see STRE command.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 5
        },
        "135": {
            "id": 135,
            "command": "RSRC",
            "description": "Sets/returns the Radiation source in room at targ.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "92": {
            "id": 92,
            "command": "RTAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Randomly selects a member from the given classification and sets it as [TARG]. Null if no members exist",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 7
        },
        "618": {
            "id": 618,
            "command": "RTIF",
            "parameters": [
                {
                    "index": 0,
                    "name": "realTime",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "format",
                    "type_id": 4
                }
            ],
            "description": "Takes a real world time, as returned by RTIM or HIST RTIM and converts it to a localised string for display. The format string is made up of any text, with the following special codes:\n%a - Abbreviated weekday name\n%A - Full weekday name\n%b - Abbreviated month name\n%B - Full month name\n%c - Date and time representation appropriate for locale\n%d - Day of month as decimal number (01 - 31)\n%H - Hour in 24-hour format (00 - 23)\n%I - Hour in 12-hour format (01 - 12)\n%j - Day of year as decimal number (001 - 366)\n%m - Month as decimal number (01 - 12)\n%M - Minute as decimal number (00 - 59)\n%p - Current locale\u2019s AM/PM indicator for 12-hour clock\n%S - Second as decimal number (00 - 59)\n%U - Week of year as decimal number, with Sunday as first day of week (00 - 53)\n%w - Weekday as decimal number (0 - 6; Sunday is 0)\n%W - Week of year as decimal number, with Monday as first day of week (00 - 53)\n%x - Date representation for current locale\n%X - Time representation for current locale\n%y - Year without century, as decimal number (00 - 99)\n%Y - Year with century, as decimal number\n%z, %Z - Time-zone name or abbreviation; no characters if time zone is unknown\n%% - Percent sign\nThe # flag may prefix any formatting code, having the following meanings:\n%#a, %#A, %#b, %#B, %#p, %#X, %#z, %#Z, %#% # flag is ignored.\n%#c Long date and time representation, appropriate for current locale. For example: Tuesday, March 14, 1995, 12:41:29.\n%#x Long date representation, appropriate to current locale. For example: Tuesday, March 14, 1995.\n%#d, %#H, %#I, %#j, %#m, %#M, %#S, %#U, %#w, %#W, %#y, %#Y Remove leading zeros (if any).\nYou probably want to READ any formatted string you use from a catalogue file.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "619": {
            "id": 619,
            "command": "RTIM",
            "description": "Returns the current real world time. This is measured in seconds since midnight, 1 January 1970 in UTC. To display, use RTIF.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "560": {
            "id": 560,
            "command": "RTYP",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "roomType",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 278,
                        "DS": 278
                    }
                }
            ],
            "description": "Sets the type of a room. The meaning of the types depends on the game. RATE also uses the room type.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 20
        },
        "561": {
            "id": 561,
            "command": "RTYP",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                }
            ],
            "description": "Returns the type of a room, or -1 if not a valid room id.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C3": 278,
                "DS": 278
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "137": {
            "id": 137,
            "command": "RTYP",
            "description": "Room Type. Sets/returns the type of the room at the centre point of Targ.\nReturns:\n\\t(-1) - Invalid.\n\\t0 - Under the Albian surface.\n\\t1 - On the Albian surface.\n\\t2 - In the sea.\n\\t3 - In the sky.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 218
            },
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "688": {
            "id": 688,
            "command": "SAVE",
            "description": "Saves the current world at the start of the next tick. See also QUIT for important information about using INST.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "225": {
            "id": 225,
            "command": "SAY#",
            "parameters": [
                {
                    "index": 0,
                    "name": "number",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 187
                    },
                    "description": "word number"
                }
            ],
            "description": "Speak word number in a speech bubble, and send that word as a signal message to creatures in earshot",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "226": {
            "id": 226,
            "command": "SAY$",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 9,
                    "description": "text to speak"
                }
            ],
            "description": "Speak the given string in a speech bubble \u2013 no signal sent",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "227": {
            "id": 227,
            "command": "SAYN",
            "description": "Speak your most pressing need",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 5
        },
        "398": {
            "id": 398,
            "command": "SCAM",
            "parameters": [
                {
                    "index": 0,
                    "name": "compoundAgent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "partNumber",
                    "type_id": 1
                }
            ],
            "description": "Sets the current camera to be used in subsequent camera macro commands. This uses the given TARG and the given PART number. If you set this to NULL then the Main Camera will be used. This is the default setting",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "375": {
            "id": 375,
            "command": "SCLE",
            "parameters": [
                {
                    "index": 0,
                    "name": "pose",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "scaleBy",
                    "type_id": 2
                }
            ],
            "description": "Scales an image from the TARG agent's sprite file by the given percentage. The scale factor always refers to the original size of the image. If the pose number is -1 then the whole sprite file will be cloned and scaled. Note that this takes up lots of memory.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 18
        },
        "983": {
            "id": 983,
            "command": "SCLE",
            "parameters": [
                {
                    "index": 0,
                    "name": "scaleBy",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "yesOrNo",
                    "type_id": 1
                }
            ],
            "description": "Scales an image from the TARG agent's sprite file by the given percentage. The scale factor always refers to the original size of the image. The second parameter turns scaling on or off. For the direct display engine scaling is done on the fly. Otherwise the whole sprite file will be cloned and scaled, note that this takes up lots of memory.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 18
        },
        "620": {
            "id": 620,
            "command": "SCOL",
            "parameters": [
                {
                    "index": 0,
                    "name": "andMask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 199,
                        "DS": 199,
                        "C3": 199,
                        "SM": 199
                    }
                },
                {
                    "index": 1,
                    "name": "eorMask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 199,
                        "DS": 199,
                        "C3": 199,
                        "SM": 199
                    }
                },
                {
                    "index": 2,
                    "name": "upSpeeds",
                    "type_id": 10
                },
                {
                    "index": 3,
                    "name": "downSpeeds",
                    "type_id": 10
                }
            ],
            "description": "Set an AND and an EOR mask, to control the following scrolling functions:\n1 - Screen edge nudgy scrolling\n2 - Keyboard scrolling\n4 - Middle mouse button screen dragging\n8 - Mouse wheel screen scrolling\nThe byte strings is used for nudgy and keyboard scrolling. The defaults are [1 2 4 8 16 32 64] and [0 1 2 4 8 16 32]. They represent the number of pixels scrolled each consecutive tick, as the scrolling gets slower and faster.\nIf you use [] for a byte string, then the string won't be changed at all.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "300": {
            "id": 300,
            "command": "SCOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "item",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 277
                    }
                }
            ],
            "description": "Returns game score statistics for a particular game item.\nValues as inferred by a player are:\n1 - Natural Eggs Laid\n2 - Deaths\n3 - Living Norns\n4 - Game Score",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 1,
            "command_group_id": 21
        },
        "939": {
            "id": 939,
            "command": "SCOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "item",
                    "type_id": 1
                }
            ],
            "description": "Returns chronicle information concerning a particular game item. The values for item are:\n0 \u2013 Generation 1 eggs used\n1 \u2013 Number of natural eggs laid\n2 \u2013 Number of deaths\n3 \u2013 Number of creatures imported \n4 \u2013 Number of creatures exported\n5 \u2013 Number of creatures alive",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 21
        },
        "399": {
            "id": 399,
            "command": "SCRL",
            "parameters": [
                {
                    "index": 0,
                    "name": "toggleOnOff",
                    "type_id": 1
                }
            ],
            "description": "This turns off all scrolling capabilities these are the automatic scrolling with the mouse and cursor keys.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 24
        },
        "945": {
            "id": 945,
            "command": "SCRP",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "event",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 150,
                        "C2": 120,
                        "CV": 147,
                        "C3": 146,
                        "DS": 149,
                        "SM": 266
                    }
                }
            ],
            "description": "Indicates that the rest of this macro is to be installed into the scriptorium, making it available as a new/replacement event script for a given type of object.\nfamily genus species \u2013 indicate the owner of this script, if values of 0 are used for any of these then the script will be installed as a default script for a wide range of objects. i.e. if species is 0 then the script will apply to all who share the same family and genus. event \u2013 indicates the event that will invoke this script, see the reference section for a list of event numbers.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 14
        },
        "273": {
            "id": 273,
            "command": "SCRX",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "event",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 150,
                        "C2": 120,
                        "CV": 147,
                        "C3": 146,
                        "DS": 149,
                        "SM": 266
                    }
                }
            ],
            "description": "Removes the script matching this description from the scriptorium.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 14
        },
        "840": {
            "id": 840,
            "command": "SDMP",
            "parameters": [
                {
                    "index": 0,
                    "name": "dampingFactor",
                    "type_id": 2
                }
            ],
            "description": "Damp sideways velocity by this much each tick. The value is from 0.0 to 1.0 where 0.0 means no damping, 1.0 maximum.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "841": {
            "id": 841,
            "command": "SDMP",
            "description": "Get current sideways damping. The value is from 0.0 to 1.0 where 0.0 means no damping, 1.0 maximum.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "156": {
            "id": 156,
            "command": "SEAN",
            "description": "Returns the season Number: 0..3. (Spring, Summer, Autumn, Winter)\n\\t0=Spring\n\\t1=SUmmer\n\\t2=Autumn\n\\t3=Winter",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 88,
                "CV": 88,
                "DS": 88,
                "C3": 88,
                "SM": 88
            },
            "rvalue": true,
            "variants": 62,
            "command_group_id": 22
        },
        "157": {
            "id": 157,
            "command": "SEAV",
            "description": "Season Value: 0..19. Returns the position within the season.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 22
        },
        "376": {
            "id": 376,
            "command": "SEEE",
            "parameters": [
                {
                    "index": 0,
                    "name": "first",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "second",
                    "type_id": 11
                }
            ],
            "description": "Returns 1 if the first agent can see the second, or 0 if it can't. See ESEE.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 169,
                "DS": 169,
                "C3": 169,
                "SM": 169
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "758": {
            "id": 758,
            "command": "SEEN",
            "parameters": [
                {
                    "index": 0,
                    "name": "category",
                    "type_id": 1
                }
            ],
            "description": "Returns the agent which the creature TARG has currently in mind for the category specified.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 5
        },
        "651": {
            "id": 651,
            "command": "SETA",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "11"
                },
                {
                    "index": 1,
                    "name": "agent",
                    "type_id": 11
                }
            ],
            "description": "Stores a reference to an agent in a variable.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "652": {
            "id": 652,
            "command": "SETS",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "4"
                },
                {
                    "index": 1,
                    "name": "string",
                    "type_id": 4
                }
            ],
            "description": "Sets a variable to a string value.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "75": {
            "id": 75,
            "command": "SETV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "value",
                    "type_id": 13
                }
            ],
            "description": "Set a variable to have the value {value}.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 12
        },
        "653": {
            "id": 653,
            "command": "SETV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "#"
                },
                {
                    "index": 1,
                    "name": "value",
                    "type_id": 16
                }
            ],
            "description": "Stores an integer or float in a variable.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 12
        },
        "601": {
            "id": 601,
            "command": "SEZZ",
            "parameters": [
                {
                    "index": 0,
                    "name": "text",
                    "type_id": 4
                }
            ],
            "description": "Makes the TARG agent speak the specified text with voice as set by VOIS or VOIC. If TARG is a creature then it will be spoken properly (speech bubble et al).",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "984": {
            "id": 984,
            "command": "SHAD",
            "parameters": [
                {
                    "index": 0,
                    "name": "shadowValue",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "xOffset",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "yOffset",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "yesOrNo",
                    "type_id": 1
                }
            ],
            "description": "A shadow will be drawn offset from the agent by the given x y co-ordinates. The intensity of the shadow depends on the shadow_intensity value. This only works when using the direct display engine. The second parameter switches the shadow on or off.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 18
        },
        "377": {
            "id": 377,
            "command": "SHOW",
            "parameters": [
                {
                    "index": 0,
                    "name": "visibility",
                    "type_id": 1
                }
            ],
            "description": "Set the parameter to 0 to hide the agent and to 1 to show the agent on camera. This removes or adds the agent to the main camera and any remote cameras. A non-shown agent can still be visible to creatures, and can still be clicked on or picked up. It just doesn't appear on the cameras.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 1
        },
        "378": {
            "id": 378,
            "command": "SHOW",
            "description": "Returns true if the TARG is currently on visible, false otherwise.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 1
        },
        "654": {
            "id": 654,
            "command": "SIN_",
            "parameters": [
                {
                    "index": 0,
                    "name": "theta",
                    "type_id": 2
                }
            ],
            "description": "Returns sine of theta. Theta should be in degrees.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "927": {
            "id": 927,
            "command": "SINS",
            "parameters": [
                {
                    "index": 0,
                    "name": "main",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "indexToSearchFrom",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "search",
                    "type_id": 4
                }
            ],
            "description": "Looks for the search string as an exact substring of the main string (string in string). Starts searching at the given index into the main string - to find the first occurence, set this to 1. String indices begin at 1. Returns the index of the position of the substring, if found, or -1 otherwise. The search is case sensitive - use UPPA and LOWA to convert all strings first, for a case insensitive search.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "30": {
            "id": 30,
            "command": "SIZE",
            "description": "Sets/returns the minimum door value through which an object will pass. Door values are set up using a Room Editor.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 64
        },
        "66": {
            "id": 66,
            "command": "SLIM",
            "description": "Set the limits of the target object.\nThis is needed when an object is first put into the world (or after a MCRT command) because it appears in a state where it\u2019s boundary limits are not defined.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 64
        },
        "95": {
            "id": 95,
            "command": "SLOW",
            "description": "Negates previous [INST] command, returns control flow to normal execution.",
            "return_type_id": 8,
            "variants": 62,
            "command_group_id": 14
        },
        "400": {
            "id": 400,
            "command": "SNAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "xCentre",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "yCentre",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "width",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "height",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "zoomFactor",
                    "type_id": 1
                }
            ],
            "description": "This takes a photograph of the world at a particular place. The zoom parameter should be <= 100. 100 means at original size, 50 means half size etc. It makes a new image file in the world images directory - you can use it to make agents and parts as with any image file. Call SNAX first to check your filename isn't already in use in any images directory. When you have finished with the file, call LOFT.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "401": {
            "id": 401,
            "command": "SNAX",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 4
                }
            ],
            "description": "Returns 1 if the specified image file exists, or 0 if it doesn't. Use with SNAP to find a unique filename to use.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 168,
                "DS": 168,
                "C3": 168,
                "SM": 168
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "602": {
            "id": 602,
            "command": "SNDC",
            "parameters": [
                {
                    "index": 0,
                    "name": "soundFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 235,
                        "DS": 235,
                        "C3": 235,
                        "SM": 235
                    }
                }
            ],
            "description": "Plays a controlled sound effect emitted from the target. Updates volume and panning as the agent moves.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "200": {
            "id": 200,
            "command": "SNDC",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 235,
                        "C1": 235
                    }
                }
            ],
            "description": "Play controlled sound effect if TARG is visible on screen. A controlled sound will follow TARG around as it moves, for the duration of the effect.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "603": {
            "id": 603,
            "command": "SNDE",
            "parameters": [
                {
                    "index": 0,
                    "name": "soundFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 235,
                        "DS": 235,
                        "C3": 235,
                        "SM": 235
                    }
                }
            ],
            "description": "Play a sound effect audible as if emitted from target's current location.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "198": {
            "id": 198,
            "command": "SNDE",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 235,
                        "C1": 235
                    }
                }
            ],
            "description": "Play sound effect if TARG is visible on screen.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "319": {
            "id": 319,
            "command": "SNDF",
            "parameters": [
                {
                    "index": 0,
                    "name": "function",
                    "type_id": 3,
                    "values_list_ids": {
                        "C1": 73
                    }
                }
            ],
            "description": "Set the sound status",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "604": {
            "id": 604,
            "command": "SNDL",
            "parameters": [
                {
                    "index": 0,
                    "name": "soundFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 235,
                        "DS": 235,
                        "C3": 235,
                        "SM": 235
                    }
                }
            ],
            "description": "Play a sound effect as in SNDC, only the sound is looped.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "201": {
            "id": 201,
            "command": "SNDL",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 235,
                        "C1": 235
                    }
                }
            ],
            "description": "Start a controlled sound loop if TARG is visible on screen",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "605": {
            "id": 605,
            "command": "SNDQ",
            "parameters": [
                {
                    "index": 0,
                    "name": "soundFile",
                    "type_id": 4,
                    "values_list_ids": {
                        "CV": 235,
                        "DS": 235,
                        "C3": 235,
                        "SM": 235
                    }
                },
                {
                    "index": 1,
                    "name": "delay",
                    "type_id": 1
                }
            ],
            "description": "As SNDE, only with a delay before playing.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "199": {
            "id": 199,
            "command": "SNDQ",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 235,
                        "C1": 235
                    }
                },
                {
                    "index": 1,
                    "name": "delay",
                    "type_id": 1
                }
            ],
            "description": "Play sound effect after a short delay if [TARG] is visible on screen.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "296": {
            "id": 296,
            "command": "SNDS",
            "description": "sound status\nBit 0 = Sound on/off\nBit 1 = Sound mode (foreground only\\continuous)",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 25
        },
        "320": {
            "id": 320,
            "command": "SNDV",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 9,
                    "values_list_ids": {
                        "C1": 235,
                        "C2": 235
                    },
                    "description": "filename WITHOUT.WAV suffix"
                }
            ],
            "description": "Play sound if [TARG] object is visible on screen \nChange volume according to distance from screen\nNow replaced by [SNDE] (sound effect) which doesn't require surrounding brackets (ie. []'s)",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 25
        },
        "234": {
            "id": 234,
            "command": "SNEZ",
            "description": "Creature sneezes \u2013 this will infect any nearby creatures or environment with any live bacteria it has in it.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "591": {
            "id": 591,
            "command": "SORC",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "event",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 150,
                        "C2": 120,
                        "CV": 147,
                        "C3": 146,
                        "DS": 149,
                        "SM": 266
                    }
                }
            ],
            "description": "Returns the source code for the specified script. Use the GIDS commands to find available scripts.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 14
        },
        "592": {
            "id": 592,
            "command": "SORQ",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "event",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 150,
                        "C2": 120,
                        "CV": 147,
                        "C3": 146,
                        "DS": 149,
                        "SM": 266
                    }
                }
            ],
            "description": "Returns 1 if the script is in the scriptorium, or if there is a general event script for the entire genus, or family. Returns 0 if there is no matching script.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 14
        },
        "759": {
            "id": 759,
            "command": "SOUL",
            "parameters": [
                {
                    "index": 0,
                    "name": "facultyId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 282,
                        "DS": 282,
                        "SM": 282
                    }
                },
                {
                    "index": 1,
                    "name": "on",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 181,
                        "DS": 181,
                        "SM": 181
                    }
                }
            ],
            "description": "Enable (1) or disable (0) the update on the creature's faculty as given by type id as follows: Sensory Faculty (0), Brain (1), Motor Faculty (2), Linguistic Faculty (3), Biochemistry (4), Reproductive Faculty (5), Expressive Faculty (6), Music Faculty (7), Life Faculty (8)",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "760": {
            "id": 760,
            "command": "SOUL",
            "parameters": [
                {
                    "index": 0,
                    "name": "facultyId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 282,
                        "DS": 282,
                        "SM": 282
                    }
                }
            ],
            "description": "Returns whether the creature faculty of the type specified is being processed or not.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C3": 181,
                "DS": 181,
                "SM": 181
            },
            "rvalue": true,
            "variants": 56,
            "command_group_id": 5
        },
        "171": {
            "id": 171,
            "command": "SPAS",
            "parameters": [
                {
                    "index": 0,
                    "name": "vehicle",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "newPassenger",
                    "type_id": 11
                }
            ],
            "description": "Loads a named {creature} into the named {vehicle}",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 3
        },
        "60": {
            "id": 60,
            "command": "SPCS",
            "description": "Returns the object\u2019s species",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 65
        },
        "842": {
            "id": 842,
            "command": "SPIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "amountInFractionOfWholeCircle",
                    "type_id": 2
                }
            ],
            "description": "Rotate to a particular facing.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "843": {
            "id": 843,
            "command": "SPIN",
            "description": "Get current facing angle.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "465": {
            "id": 465,
            "command": "SPNL",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobeMoniker",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "neuronId",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "value",
                    "type_id": 2
                }
            ],
            "description": "This sets the input of the neuron in the lobe specified to be the value given.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "163": {
            "id": 163,
            "command": "SPOT",
            "parameters": [
                {
                    "index": 0,
                    "name": "spot",
                    "type_id": 1,
                    "min": 0,
                    "max": 5,
                    "description": "a number to identify this particular spot"
                },
                {
                    "index": 1,
                    "name": "left",
                    "type_id": 1,
                    "description": "left of hotspot relative to part 0 of the object."
                },
                {
                    "index": 2,
                    "name": "top",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "right",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "bottom",
                    "type_id": 1
                }
            ],
            "description": "Set up a compound object hotspot for users/creatures to click on. These commands (along with [KNOB]) allows different parts of an object to produce different events when clicked on.\nspot# = (0-5) a number to identify this particular spot\nleft/top/right/bottom = Co-ordinates of hotspot relative to part 0 of the object.\nNOTE: Set {left} {top} {right} {bottom} to \u20131 \u20131 \u20131 \u20131 to remove/blank a hotspot\n\\t@example: #{spot 0 -1 -1 -1 -1} - will remove hot spot 0",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 66
        },
        "655": {
            "id": 655,
            "command": "SQRT",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 2
                }
            ],
            "description": "Calculates a square root.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 13
        },
        "956": {
            "id": 956,
            "command": "SSFC",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "numberOfPoints",
                    "type_id": 1,
                    "description": "The number of floor points that are planned to be set"
                }
            ],
            "description": "Set SurFaCe points in a room.\nSecond parameter is the number of points to set, and controls how many arguments this command takes.\nEvery floor point requires 2 arguments, the X and Y\nExample: #{ dde: getb ssfc 0 1 2 2 }  Gives us a room with one floor point at (2,2)\nExample: #{ dde: getb ssfc 0 2 1 1 3 2} Gives us a room with two floor points [ (1,1),(3,2) ]",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 21
        },
        "93": {
            "id": 93,
            "command": "STAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Pick a random object that can be seen by [OWNR] object matching the given family genus species",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 62,
            "command_group_id": 7
        },
        "761": {
            "id": 761,
            "command": "STEP",
            "parameters": [
                {
                    "index": 0,
                    "name": "facultyId",
                    "type_id": 1
                }
            ],
            "description": "Does one update of the specified faculty (for faculty id see SOUL#).",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 5
        },
        "947": {
            "id": 947,
            "command": "STIM FROM",
            "parameters": [
                {
                    "index": 0,
                    "name": "significance",
                    "type_id": 1,
                    "description": "amount to nudge significance neurone by"
                },
                {
                    "index": 1,
                    "name": "input",
                    "type_id": 1,
                    "description": "sensory lobe neurone# (or 255 if none)"
                },
                {
                    "index": 2,
                    "name": "intensity",
                    "type_id": 1,
                    "description": "Amount to nudge input neurone by"
                },
                {
                    "index": 3,
                    "name": "features",
                    "type_id": 1,
                    "description": "bit record of features"
                },
                {
                    "index": 4,
                    "name": "chem1",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79
                    }
                },
                {
                    "index": 5,
                    "name": "amount1",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "chem2",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79
                    }
                },
                {
                    "index": 7,
                    "name": "amount2",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "chem3",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79
                    }
                },
                {
                    "index": 9,
                    "name": "amount3",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "chem4",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79
                    }
                },
                {
                    "index": 11,
                    "name": "amount4",
                    "type_id": 1
                }
            ],
            "description": "Undocumented command. Send a stimulus to [FROM] agent.  Theoretically similar to #{ STIM WRIT FROM }#\nsignificance \u2013 amount to nudge the Source lobe neurone by, this decides the significance of the object. input \u2013 which neurone in the General Sense lobe to fire (or 255 for none)\nList 4 chemicals to emit and the amounts. If less than 4 chemicals are required then the remaining values should be set to 0",
            "return_type_id": 8,
            "requires_ownr": 1,
            "variants": 1,
            "command_group_id": 5
        },
        "120": {
            "id": 120,
            "command": "STIM SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "significance",
                    "type_id": 1,
                    "description": "Amount to nudge the source lobe neurone by. This decides the significance of the object"
                },
                {
                    "index": 1,
                    "name": "input",
                    "type_id": 1,
                    "description": "Which neuron in the General Sense Lobe to fire"
                },
                {
                    "index": 2,
                    "name": "intensity",
                    "type_id": 1,
                    "description": "the amount to nudge the General Sense neurone selected as input"
                },
                {
                    "index": 3,
                    "name": "features",
                    "type_id": 1,
                    "description": "<< do not use non-zero values \u2013 not implemented >>"
                },
                {
                    "index": 4,
                    "name": "chem1",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 5,
                    "name": "amount1",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "chem2",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 7,
                    "name": "amount2",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "chem3",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 9,
                    "name": "amount3",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "chem4",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 11,
                    "name": "amount4",
                    "type_id": 1
                }
            ],
            "description": "Shout the list of stimulus_items to all within earshot\nsignificance \u2013 amount to nudge the Source lobe neurone by, this decides the significance of the object. input \u2013 which neurone in the General Sense lobe to fire (or 255 for none)\nList 4 chemicals to emit and the amounts. If less than 4 chemicals are required then the remaining values should be set to 0",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 3,
            "command_group_id": 5
        },
        "762": {
            "id": 762,
            "command": "STIM SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 113,
                        "C3": 113,
                        "CV": 113,
                        "SM": 113
                    }
                },
                {
                    "index": 1,
                    "name": "strength",
                    "type_id": 2
                }
            ],
            "description": "Shout a stimulus to all creatures who can hear [OWNR].\nThe strength is a multiplier for the stimulus. Set to 1 for a default stimulation, 2 for a stronger stimulation and so on. It is important you use this, rather than send several stims, as it affects learning. Set strength to 0 to prevent learning altogether, and send a strength 1 chemical change. See the table of Stimulus Numbers.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "121": {
            "id": 121,
            "command": "STIM SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "significance",
                    "type_id": 1,
                    "description": "Amount to nudge the source lobe neurone by. This decides the significance of the object"
                },
                {
                    "index": 1,
                    "name": "input",
                    "type_id": 1,
                    "description": "Which neuron in the General Sense Lobe to fire"
                },
                {
                    "index": 2,
                    "name": "intensity",
                    "type_id": 1,
                    "description": "the amount to nudge the General Sense neurone selected as input"
                },
                {
                    "index": 3,
                    "name": "features",
                    "type_id": 1,
                    "description": "<< do not use non-zero values \u2013 not implemented >>"
                },
                {
                    "index": 4,
                    "name": "chem1",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 5,
                    "name": "amount1",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "chem2",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 7,
                    "name": "amount2",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "chem3",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 9,
                    "name": "amount3",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "chem4",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 11,
                    "name": "amount4",
                    "type_id": 1
                }
            ],
            "description": "Send a stimulus to all creatures who can see [OWNR].\nsignificance \u2013 amount to nudge the Source lobe neurone by, this decides the significance of the object. input \u2013 which neurone in the General Sense lobe to fire (or 255 for none)\nList 4 chemicals to emit and the amounts. If less than 4 chemicals are required then the remaining values should be set to 0",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 3,
            "command_group_id": 5
        },
        "763": {
            "id": 763,
            "command": "STIM SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 113,
                        "C3": 113,
                        "CV": 113,
                        "SM": 113
                    }
                },
                {
                    "index": 1,
                    "name": "strength",
                    "type_id": 2
                }
            ],
            "description": "Send a stimulus to all creatures who can see [OWNR].",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "122": {
            "id": 122,
            "command": "STIM TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "significance",
                    "type_id": 1,
                    "description": "amount to nudge significance neurone by"
                },
                {
                    "index": 1,
                    "name": "input",
                    "type_id": 1,
                    "description": "sensory lobe neurone# (or 255 if none)"
                },
                {
                    "index": 2,
                    "name": "intensity",
                    "type_id": 1,
                    "description": "the amount to nudge the General Sense neurone selected as input"
                },
                {
                    "index": 3,
                    "name": "features",
                    "type_id": 1,
                    "description": "<< do not use non-zero values \u2013 not implemented >>"
                },
                {
                    "index": 4,
                    "name": "chem1",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 5,
                    "name": "amount1",
                    "type_id": 1
                },
                {
                    "index": 6,
                    "name": "chem2",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 7,
                    "name": "amount2",
                    "type_id": 1
                },
                {
                    "index": 8,
                    "name": "chem3",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 9,
                    "name": "amount3",
                    "type_id": 1
                },
                {
                    "index": 10,
                    "name": "chem4",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 11,
                    "name": "amount4",
                    "type_id": 1
                }
            ],
            "description": "Send a stimulus to all creatures who are touching [OWNR].\nsignificance \u2013 amount to nudge the Source lobe neurone by, this decides the significance of the object. input \u2013 which neurone in the General Sense lobe to fire (or 255 for none)\nList 4 chemicals to emit and the amounts. If less than 4 chemicals are required then the remaining values should be set to 0",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 3,
            "command_group_id": 5
        },
        "764": {
            "id": 764,
            "command": "STIM TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "DS": 113,
                        "C3": 113,
                        "CV": 113,
                        "SM": 113
                    }
                },
                {
                    "index": 1,
                    "name": "strength",
                    "type_id": 2
                }
            ],
            "description": "Send a stimulus to all creatures who are touching [OWNR].",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "123": {
            "id": 123,
            "command": "STIM WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "significance",
                    "type_id": 1,
                    "description": "amount to nudge significance neurone by"
                },
                {
                    "index": 2,
                    "name": "input",
                    "type_id": 1,
                    "description": "sensory lobe neurone# (or 255 if none)"
                },
                {
                    "index": 3,
                    "name": "intensity",
                    "type_id": 1,
                    "description": "the amount to nudge the General Sense neurone selected as input"
                },
                {
                    "index": 4,
                    "name": "features",
                    "type_id": 1,
                    "description": "<< do not use non-zero values \u2013 not implemented >>"
                },
                {
                    "index": 5,
                    "name": "chem1",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 6,
                    "name": "amount1",
                    "type_id": 1
                },
                {
                    "index": 7,
                    "name": "chem2",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 8,
                    "name": "amount2",
                    "type_id": 1
                },
                {
                    "index": 9,
                    "name": "chem3",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 10,
                    "name": "amount3",
                    "type_id": 1
                },
                {
                    "index": 11,
                    "name": "chem4",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 79,
                        "C2": 135
                    }
                },
                {
                    "index": 12,
                    "name": "amount4",
                    "type_id": 1
                }
            ],
            "description": "Send stimulus to a specific creature.\nSignificance \u2013 amount to nudge the Source lobe neurone by, this decides the significance of the object. \nInput \u2013 which neurone in the General Sense lobe to fire (or 255 for none)\nList 4 chemicals to emit and the amounts.\nIf less than 4 chemicals are required then the remaining values should be set to 0",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "765": {
            "id": 765,
            "command": "STIM WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "creature",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 113,
                        "C3": 113,
                        "DS": 113,
                        "SM": 113
                    }
                },
                {
                    "index": 2,
                    "name": "strength",
                    "type_id": 2
                }
            ],
            "description": "Send stimulus to a specific creature. Can be used from an install script, but the stimulus will be from NULL, so the creature will react but not learn.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "116": {
            "id": 116,
            "command": "STM# SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 126,
                        "C1": 77
                    }
                }
            ],
            "description": "Shout {stimulus} to all creatures within earshot of [OWNR] object",
            "return_type_id": 8,
            "requires_ownr": 1,
            "variants": 3,
            "command_group_id": 5
        },
        "117": {
            "id": 117,
            "command": "STM# SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 126,
                        "C1": 77
                    }
                }
            ],
            "description": "Send {stimulus} to all creatures that can see [OWNR] object",
            "return_type_id": 8,
            "requires_ownr": 1,
            "variants": 3,
            "command_group_id": 5
        },
        "118": {
            "id": 118,
            "command": "STM# TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "stimulus",
                    "type_id": 1
                }
            ],
            "description": "Send {stimulus} to all creatures that are touching [OWNR] object",
            "return_type_id": 8,
            "requires_ownr": 1,
            "variants": 3,
            "command_group_id": 5
        },
        "119": {
            "id": 119,
            "command": "STM# WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "stimulus",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 126,
                        "C1": 77
                    }
                }
            ],
            "description": "Send {stimulus} to the specified {object}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "656": {
            "id": 656,
            "command": "STOF",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 4
                }
            ],
            "description": "Converts a string in decimal to a floating point number. Characters in the string after an initial number are quietly ignored. If there is no obvious number then zero is returned.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "657": {
            "id": 657,
            "command": "STOI",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 4
                }
            ],
            "description": "Converts a string in decimal to an integer. Characters in the string after an initial number are quietly ignored. If there is no obvious number then zero is returned.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "77": {
            "id": 77,
            "command": "STOP",
            "description": "Stop execution (eg. following error, or before subroutine definitions start)",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 14
        },
        "203": {
            "id": 203,
            "command": "STPC",
            "description": "Stop any controlled sounds currently playing with this [TARG].",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 25
        },
        "593": {
            "id": 593,
            "command": "STPT",
            "description": "Stops any currently running script in the target agent. See also STOP.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 14
        },
        "985": {
            "id": 985,
            "command": "STRC",
            "parameters": [
                {
                    "index": 0,
                    "name": "stretchedWidth",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "stretchedHeight",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "yesOrNo",
                    "type_id": 1
                }
            ],
            "description": "The agent will be drawn stretched widthways, given the new stretched width. This only works when using the direct display engine. The second parameter switches stretching on or off.",
            "return_type_id": 8,
            "variants": 32,
            "command_group_id": 18
        },
        "466": {
            "id": 466,
            "command": "STRE",
            "description": "This stores the current clothing set for the TARG creature. If the creature is not wearing clothes this will be recorded.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 5
        },
        "606": {
            "id": 606,
            "command": "STRK",
            "parameters": [
                {
                    "index": 0,
                    "name": "latency",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "track",
                    "type_id": 4
                }
            ],
            "description": "This triggers the music track specified. The track will play for at least latency seconds before being overridden by room or metaroom music.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "658": {
            "id": 658,
            "command": "STRL",
            "parameters": [
                {
                    "index": 0,
                    "name": "string",
                    "type_id": 4
                }
            ],
            "description": "Returns the length of a string.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "79": {
            "id": 79,
            "command": "SUBR",
            "parameters": [
                {
                    "index": 0,
                    "name": "label",
                    "type_id": 3,
                    "description": "four letter token"
                }
            ],
            "description": "Identifies a Subroutine. 'label' is a 4-char unique label name [GSUB] takes us to point AFTER [SUBR] labl, so only reach here through normal code flow.\nTherefore, treat [SUBR] the same as [STOP] ([STOP] is therefore not needed before the start of any subroutines).",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "505": {
            "id": 505,
            "command": "SUBR",
            "parameters": [
                {
                    "index": 0,
                    "name": "label",
                    "type_id": 3,
                    "description": "Label is case sensitive, and should start with a letter"
                }
            ],
            "description": "Defines the start of a subroutine. Specify a label after the SUBR command - the label is case sensitive, and should start with a letter. If this instruction is hit during normal program flow, it works as a STOP instruction. See GSUB and RETN.",
            "return_type_id": 8,
            "variants": 0,
            "command_group_id": 15
        },
        "659": {
            "id": 659,
            "command": "SUBS",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 4
                },
                {
                    "index": 1,
                    "name": "start",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "count",
                    "type_id": 1
                }
            ],
            "description": "Slices up a string, returning the substring starting at position start, with length count. String indices begin at 1.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "68": {
            "id": 68,
            "command": "SUBV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "1"
                },
                {
                    "index": 1,
                    "name": "sub",
                    "type_id": 1
                }
            ],
            "description": "{value1} = {value1} - {value2}",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 13
        },
        "660": {
            "id": 660,
            "command": "SUBV",
            "parameters": [
                {
                    "index": 0,
                    "name": "var",
                    "type_id": 6,
                    "variable_type_id": "#"
                },
                {
                    "index": 1,
                    "name": "sub",
                    "type_id": 16
                }
            ],
            "description": "Subtracts an integer or float from a variable, so var = var - sub.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 13
        },
        "844": {
            "id": 844,
            "command": "SVEL",
            "parameters": [
                {
                    "index": 0,
                    "name": "amountInPixels",
                    "type_id": 2
                }
            ],
            "description": "Set sideways velocity.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "845": {
            "id": 845,
            "command": "SVEL",
            "description": "Get current sideways velocity.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "467": {
            "id": 467,
            "command": "SWAP",
            "parameters": [
                {
                    "index": 0,
                    "name": "variant",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "bodyPartId",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "commitChanges",
                    "type_id": 1
                }
            ],
            "description": "Swap the specified part of the body with the equivalent body part of the given variant.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 5
        },
        "766": {
            "id": 766,
            "command": "SWAY SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "drive1",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 1,
                    "name": "adjust1",
                    "type_id": 2
                },
                {
                    "index": 2,
                    "name": "drive2",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 3,
                    "name": "adjust2",
                    "type_id": 2
                },
                {
                    "index": 4,
                    "name": "drive3",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 5,
                    "name": "adjust3",
                    "type_id": 2
                },
                {
                    "index": 6,
                    "name": "drive4",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 7,
                    "name": "adjust4",
                    "type_id": 2
                }
            ],
            "description": "Stimulate all creatures that can hear OWNR to adjust four drives by the given amounts.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "767": {
            "id": 767,
            "command": "SWAY SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "drive1",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 1,
                    "name": "adjust1",
                    "type_id": 2
                },
                {
                    "index": 2,
                    "name": "drive2",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 3,
                    "name": "adjust2",
                    "type_id": 2
                },
                {
                    "index": 4,
                    "name": "drive3",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 5,
                    "name": "adjust3",
                    "type_id": 2
                },
                {
                    "index": 6,
                    "name": "drive4",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 7,
                    "name": "adjust4",
                    "type_id": 2
                }
            ],
            "description": "Stimulate all creatures that can see OWNR to adjust four drives by the given amounts.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "768": {
            "id": 768,
            "command": "SWAY TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "drive1",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 1,
                    "name": "adjust1",
                    "type_id": 2
                },
                {
                    "index": 2,
                    "name": "drive2",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 3,
                    "name": "adjust2",
                    "type_id": 2
                },
                {
                    "index": 4,
                    "name": "drive3",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 5,
                    "name": "adjust3",
                    "type_id": 2
                },
                {
                    "index": 6,
                    "name": "drive4",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 7,
                    "name": "adjust4",
                    "type_id": 2
                }
            ],
            "description": "Stimulate all creatures that are touching OWNR to adjust four drives by the given amounts.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "769": {
            "id": 769,
            "command": "SWAY WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "creature",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "drive1",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 2,
                    "name": "adjust1",
                    "type_id": 2
                },
                {
                    "index": 3,
                    "name": "drive2",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 4,
                    "name": "adjust2",
                    "type_id": 2
                },
                {
                    "index": 5,
                    "name": "drive3",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 6,
                    "name": "adjust3",
                    "type_id": 2
                },
                {
                    "index": 7,
                    "name": "drive4",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 234,
                        "C3": 234,
                        "DS": 234,
                        "SM": 234
                    }
                },
                {
                    "index": 8,
                    "name": "adjust4",
                    "type_id": 2
                }
            ],
            "description": "Stimulate a specific creature to adjust four drives by the given amounts.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "285": {
            "id": 285,
            "command": "SYS: ABRT",
            "description": "Abandons changes to world and closes the game window",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "313": {
            "id": 313,
            "command": "SYS: CAMT",
            "description": "moves camera to point at current [TARG]",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 24
        },
        "311": {
            "id": 311,
            "command": "SYS: CMND",
            "parameters": [
                {
                    "index": 0,
                    "name": "id",
                    "type_id": 1,
                    "values_list_ids": {
                        "C1": 245,
                        "C2": 246
                    }
                }
            ],
            "description": "Issue an ID_XXX command message to the application. This allows macros to activate ANY menu command. Note that command will get executed LATER - fn doesn't wait before returning!\nid#\tint\tthe decimal ID_XXX value - look these up in the resource file & list them for users",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "191": {
            "id": 191,
            "command": "SYS: CMRA",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Position camera with this co-ordinate as the top-left",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 24
        },
        "190": {
            "id": 190,
            "command": "SYS: CMRP",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "CaMeRa Pan. Similar to the macro [SYS: CMRA]\nMoves the camera to the specified x and y position.\nIf that location is within the window view then the camera smooth scrolls to this position, otherwise the camera jumps to that location.\nThis command does not effect the users choice of scrolling mode.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 24
        },
        "287": {
            "id": 287,
            "command": "SYS: CONV",
            "parameters": [
                {
                    "index": 0,
                    "name": "fileSpec",
                    "type_id": 3,
                    "values_list_ids": {
                        "C2": 240
                    },
                    "description": "A four letter sprite identifier"
                },
                {
                    "index": 1,
                    "name": "showProgress",
                    "type_id": 1,
                    "values_list_ids": {
                        "C2": 221
                    },
                    "description": "0 = no progress dialog is displayed. 1 = a progress dialog is displayed."
                }
            ],
            "description": "CONVert sprite file. Command converts a given sprite file (located in the images directory) to the current system image format. If the file is already in the correct format it is not modified.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 21
        },
        "282": {
            "id": 282,
            "command": "SYS: DMAP",
            "description": "Draw map.\n1 -> draw room box, floor and vehicle cabins over backdrop. 0 -> do not draw room data.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 21
        },
        "281": {
            "id": 281,
            "command": "SYS: EDIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "left",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "top",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "right",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "bottom",
                    "type_id": 1
                }
            ],
            "description": "Draw a rectangle on the game window with the corners given by the co-ordinates left top right bottom.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "314": {
            "id": 314,
            "command": "SYS: GRND",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1,
                    "description": "y"
                }
            ],
            "description": "set ground level at position x (worldx/GROUNDW) (see [GND#] and [GNDW] macros for establishing useful constants)",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "284": {
            "id": 284,
            "command": "SYS: QUIT",
            "description": "Saves the world and closes the game window",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "312": {
            "id": 312,
            "command": "SYS: WPOS",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "width",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "height",
                    "type_id": 1
                }
            ],
            "description": "attempt to position vivarium frame window to this size (in pixels)\nActual size will be limited to maximum view size or size of screen, if necessary",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "286": {
            "id": 286,
            "command": "SYS: WRLD",
            "parameters": [
                {
                    "index": 0,
                    "name": "filename",
                    "type_id": 9
                }
            ],
            "description": "Saves the current world and opens the named one",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "283": {
            "id": 283,
            "command": "SYS: WTOP",
            "description": "Set the world window to be the foreground window.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "493": {
            "id": 493,
            "command": "TACK",
            "description": "Returns the agent currently being DBG: TACKed.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "468": {
            "id": 468,
            "command": "TAGE",
            "description": "Returns the age in ticks since the target creature was BORN. Ticking stops when the creature dies - see DEAD.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "661": {
            "id": 661,
            "command": "TAN_",
            "parameters": [
                {
                    "index": 0,
                    "name": "theta",
                    "type_id": 2
                }
            ],
            "description": "Returns tangent of theta. Theta should be in degrees. Watch out for those nasty discontinuities at 90 and 270.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 13
        },
        "14": {
            "id": 14,
            "command": "TARG",
            "description": "the current object of script focus.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 7
        },
        "15": {
            "id": 15,
            "command": "TARG",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                }
            ],
            "description": "Sets the current object of script focus.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 7
        },
        "23": {
            "id": 23,
            "command": "TCAR",
            "description": "Returns carrier of [TARG].\nFor carrier of [OWNR] see [CARR]",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 7
        },
        "993": {
            "id": 993,
            "command": "TCAR",
            "description": "Returns carrier of [TARG].\nFor carrier of [OWNR] see [CARR]",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 0,
            "command_group_id": 7
        },
        "994": {
            "id": 994,
            "command": "TCAR",
            "description": "Returns carrier of [TARG].\nFor carrier of [OWNR] see [CARR]",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 0,
            "command_group_id": 7
        },
        "707": {
            "id": 707,
            "command": "TCOR",
            "parameters": [
                {
                    "index": 0,
                    "name": "topY",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "bottomY",
                    "type_id": 2
                },
                {
                    "index": 2,
                    "name": "leftX",
                    "type_id": 2
                },
                {
                    "index": 3,
                    "name": "rightX",
                    "type_id": 2
                }
            ],
            "description": "Tests setting the bounding box of the physical core of the object TARG. May be set to smaller (or larger) than the sprite's rectangle. Returns 1 if OK to set (using CORE), 0 if not.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 64
        },
        "148": {
            "id": 148,
            "command": "TECO",
            "description": "Toggle Ecosystem on and off.\nSwitches the room system update mechanism on or off.\nDefault: on.",
            "return_type_id": 8,
            "variants": 2,
            "command_group_id": 21
        },
        "176": {
            "id": 176,
            "command": "TELE",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Teleport the vehicles occupants to the location x y and move the camera too.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 3
        },
        "304": {
            "id": 304,
            "command": "TEMP",
            "description": "Air temperature near [TARG] object\nrange (-3 to +3)",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 1,
            "command_group_id": 20
        },
        "124": {
            "id": 124,
            "command": "TEMP",
            "description": "Sets/returns the room temperature at [targ]",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "194": {
            "id": 194,
            "command": "THRT",
            "description": "Sets/returns the THReaT, how dangerous an object is to a creature.\nThis attribute is used only for the in-game music system. 255 = high threat; 0 = no threat.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 65
        },
        "45": {
            "id": 45,
            "command": "TICK",
            "description": "Gets ticks left in current timer.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 62,
            "command_group_id": 1
        },
        "46": {
            "id": 46,
            "command": "TICK",
            "parameters": [
                {
                    "index": 0,
                    "name": "tickRate",
                    "type_id": 1,
                    "description": "tick rate"
                }
            ],
            "description": "Sets the object timer script tick rate. Set TICK to 0 to stop the timer script executing.",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 1
        },
        "621": {
            "id": 621,
            "command": "TIME",
            "description": "Returns the time of day. This can be\n0 - dawn\n1 - morning\n2 - afternoon\n3 - evening\n4 - night\nThe GAME variable engine_LengthOfDayInMinutes sets the day length. See also HIST TIME.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 89,
                "DS": 89,
                "C3": 89,
                "SM": 89
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "708": {
            "id": 708,
            "command": "TINO",
            "parameters": [
                {
                    "index": 0,
                    "name": "redTint",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "greenTint",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "blueTint",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "rotation",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "swap",
                    "type_id": 1
                }
            ],
            "description": "Like TINT but only tints the current frame. The other frames are no longer available in the gallery, it becomes a one frame sprite file. Original display engine only.",
            "return_type_id": 8,
            "variants": 24,
            "command_group_id": 18
        },
        "379": {
            "id": 379,
            "command": "TINT",
            "parameters": [
                {
                    "index": 0,
                    "name": "redTint",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "greenTint",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "blueTint",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "rotation",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "swap",
                    "type_id": 1
                }
            ],
            "description": "This tints the TARG agent with the r,g,b tint and applies the colour rotation and swap as per pigment bleed genes. Specify the PART first for compound agents. The tinted agent or part now uses a cloned gallery, which means it takes up more memory, and the save world files are larger. However it also no longer needs the sprite file. Also, tinting resets camera shy and other properties of the gallery.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 18
        },
        "709": {
            "id": 709,
            "command": "TINT",
            "parameters": [
                {
                    "index": 0,
                    "name": "attribute",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 214,
                        "C3": 214,
                        "DS": 214,
                        "SM": 214
                    }
                }
            ],
            "description": "Returns a tint value for an agent - currently it works only on Skeletal Creatures. Attribute can be:\n1 - Red\n2 - Green\n3 - Blue\n4 - Rotation\n5 - Swap",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 18
        },
        "159": {
            "id": 159,
            "command": "TMOD",
            "description": "Time Of Day: 0..4.\n\\t0=Dawn\n\\t1=Morning\n\\t2=Afternoon\n\\t3=Evening\n\\t4=Night",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 89,
                "SM": 89
            },
            "rvalue": true,
            "variants": 2,
            "command_group_id": 22
        },
        "583": {
            "id": 583,
            "command": "TMVB",
            "parameters": [
                {
                    "index": 0,
                    "name": "deltaX",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "deltaY",
                    "type_id": 2
                }
            ],
            "description": "Similar to TMVT only tests a MVBY.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 167,
                "DS": 167,
                "C3": 167,
                "SM": 167
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "584": {
            "id": 584,
            "command": "TMVF",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Test if a creature could move it's down foot to position x,y.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 167,
                "DS": 167,
                "C3": 167,
                "SM": 167
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "585": {
            "id": 585,
            "command": "TMVT",
            "parameters": [
                {
                    "index": 0,
                    "name": "x",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "y",
                    "type_id": 2
                }
            ],
            "description": "Test if target can move to the given location and still lie validly within the room system. Returns 1 if it can, 0 if it can't.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 167,
                "DS": 167,
                "C3": 167,
                "SM": 167
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "469": {
            "id": 469,
            "command": "TNTC",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldTintIndex",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "bodyPartId",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "commitChanges",
                    "type_id": 1
                }
            ],
            "description": "Tint the specified part of the body with the given world tint. Use WTNT to create the world tint.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 5
        },
        "402": {
            "id": 402,
            "command": "TNTO",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldTint",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "bodyPartIndex",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "setNumber",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "fileIndex",
                    "type_id": 1
                }
            ],
            "description": "This tints the given set of clothing (overlay) for the TARG norn. The file index cannot be zero since that set of clothing is not tintable.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 24
        },
        "689": {
            "id": 689,
            "command": "TNTW",
            "parameters": [
                {
                    "index": 0,
                    "name": "index",
                    "type_id": 1
                }
            ],
            "description": "This tints the TARG agent with the global tint manager at index. Specify the PART first for compound agents. See also TINT.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "9": {
            "id": 9,
            "command": "TOKN",
            "parameters": [
                {
                    "index": 0,
                    "name": "token",
                    "type_id": 3
                }
            ],
            "description": "Convert 4 characters into an integer. Generally only used for the following commands to reference a string moniker, rather than the integer they require.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 5
        },
        "317": {
            "id": 317,
            "command": "TOOL",
            "parameters": [
                {
                    "index": 0,
                    "name": "fsp",
                    "type_id": 9
                },
                {
                    "index": 1,
                    "name": "menuText",
                    "type_id": 9
                },
                {
                    "index": 2,
                    "name": "helpText",
                    "type_id": 9
                },
                {
                    "index": 3,
                    "name": "glyph",
                    "type_id": 1
                }
            ],
            "description": "Issued by a DDE tool app to register itself with the toolbar",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "562": {
            "id": 562,
            "command": "TORX",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                }
            ],
            "description": "Returns relative X position of the centre of the given room from target's top left corner.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "563": {
            "id": 563,
            "command": "TORY",
            "parameters": [
                {
                    "index": 0,
                    "name": "roomId",
                    "type_id": 1
                }
            ],
            "description": "Returns relative Y position of the centre of the given room from target's top left corner.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 20
        },
        "64": {
            "id": 64,
            "command": "TOTL",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Returns the number of objects in the world who fit this specifier",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 1
        },
        "65": {
            "id": 65,
            "command": "TOUC",
            "parameters": [
                {
                    "index": 0,
                    "name": "first",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "second",
                    "type_id": 11
                }
            ],
            "description": "Returns 1 if these two objects are in contact.\n@example: #{doif touc targ ownr gt 0} - DOIF [TARG] and [OWNR] are touching",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 253,
                "C1": 253,
                "CV": 253,
                "DS": 253,
                "C3": 253,
                "SM": 253
            },
            "rvalue": true,
            "variants": 63,
            "command_group_id": 1
        },
        "222": {
            "id": 222,
            "command": "TOUC",
            "description": "Reach out and touch [_IT_], normally preceded with an [APPR] macro.\nContinue with next instruction when you have successfully touched [_IT_].\nIf total failure (object gone away) then present action schema is suppressed.",
            "return_type_id": 8,
            "requires_creature_ownr": true,
            "variants": 63,
            "command_group_id": 5
        },
        "522": {
            "id": 522,
            "command": "TRAN",
            "parameters": [
                {
                    "index": 0,
                    "name": "transparency",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 203,
                        "DS": 203,
                        "C3": 203,
                        "SM": 203
                    }
                },
                {
                    "index": 1,
                    "name": "partNo",
                    "type_id": 1
                }
            ],
            "description": "Sets pixel transparency awareness. 1 for pixel perfect, so transparent parts of the agent can't be clicked. 0 to allow anywhere on the agent rectangle to be clicked. See also the option parameter on PAT: BUTT which overrides this.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 28
        },
        "380": {
            "id": 380,
            "command": "TRAN",
            "parameters": [
                {
                    "index": 0,
                    "name": "xPos",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "yPos",
                    "type_id": 1
                }
            ],
            "description": "Returns true if the given x y position coincides with a non transparent pixel on the TARG agent. This does not work for creatures.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 18
        },
        "424": {
            "id": 424,
            "command": "TRAN",
            "parameters": [
                {
                    "index": 0,
                    "name": "keyCode",
                    "type_id": 1
                }
            ],
            "description": "The currently selected character code translator will translates the given key code to a character.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 29
        },
        "403": {
            "id": 403,
            "command": "TRCK",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "x%",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "y%",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "style",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 258,
                        "DS": 258,
                        "C3": 258,
                        "SM": 258
                    }
                },
                {
                    "index": 4,
                    "name": "transition",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 191,
                        "DS": 191,
                        "C3": 191,
                        "SM": 191
                    }
                }
            ],
            "description": "Camera follows the given agent. Set to NULL to stop tracking. x% and y% are percentages (0-100) of the screen size. They describe a rectangle centred on the screen which the target stays within.\nStyle 0 is brittle - if you move the camera so the target is out of the rectangle, then the tracking is broken.\nStyle 1 is flexible - you can move the camera away from the target. If you move it back, then tracking resumes.\nStyle 2 is hard - you can't move the camera so the target is out of the rectangle.\nThe transition is the sort of fade to use if the tracking causes a change in meta room. The values are the same as for the transition in the META command.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "404": {
            "id": 404,
            "command": "TRCK",
            "description": "Returns the agent being tracked by the camera, if any.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "219": {
            "id": 219,
            "command": "TRIG",
            "parameters": [
                {
                    "index": 0,
                    "name": "lobe",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "cell",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "amount",
                    "type_id": 1,
                    "min": 0,
                    "max": 255
                }
            ],
            "description": "Fire the neurone that is at the lobe and cell numbers specified \u2013 amount is the signal strength (0-255)",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 5
        },
        "381": {
            "id": 381,
            "command": "TTAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                }
            ],
            "description": "Randomly chooses an agent which matches the given classifier and is touching the owner of the script. It then sets TARG to that agent. See ETCH.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 7
        },
        "382": {
            "id": 382,
            "command": "TWIN",
            "parameters": [
                {
                    "index": 0,
                    "name": "original",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "agentNull",
                    "type_id": 1
                }
            ],
            "description": "Clones an agent, and returns the replica. If agent_null is set to 1 the agents that this agent points to (in OVxx, or VAxx in its running script) are set to NULL in the clone. If agent_null is 0, then the clone points to the same agents as the original. When using agent_null 1, you might want to call STPT first so variables being used mid-script aren't cleared under the agent's nose.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "662": {
            "id": 662,
            "command": "TYPE",
            "parameters": [
                {
                    "index": 0,
                    "name": "something",
                    "type_id": 13
                }
            ],
            "description": "Determines the type of a variable. The type is one of the following:\n0 - integer\n1 - floating-point\n2 - string\n3 - simple agent\n4 - pointer agent\n5 - compound agent\n6 - vehicle\n7 - creature\nERROR codes for agents:\n-1 - NULL agent handle\n-2 - Unknown agent - you should never get this",
            "return_type_id": 1,
            "return_values_list_ids": {
                "DS": 153,
                "SM": 153,
                "CV": 153,
                "C3": 153
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "710": {
            "id": 710,
            "command": "UCLN",
            "description": "Make sure that an agent isn't cloned anymore, this releases the memory taken up by TINTing it. Agents are usually cloned for purposes such as tinting. Don't forget to set the relevant PART number for compound agents.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 1
        },
        "928": {
            "id": 928,
            "command": "UFOS",
            "description": "This returns the equivalent of \"uname -a\" on compatible systems, or a description of your operating system on others. This is a descriptive string and should not be taken as fixed format, or parsable.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "470": {
            "id": 470,
            "command": "UFTX",
            "description": "Returns X coordinate of creature's up foot.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "471": {
            "id": 471,
            "command": "UFTY",
            "description": "Returns Y coordinate of creature's up foot.",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "472": {
            "id": 472,
            "command": "UNCS",
            "parameters": [
                {
                    "index": 0,
                    "name": "unconscious",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 166,
                        "DS": 166,
                        "C3": 166,
                        "SM": 166
                    }
                }
            ],
            "description": "Make the creature conscious or unconscious. 0 for conscious, 1 for unconscious.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "473": {
            "id": 473,
            "command": "UNCS",
            "description": "Returns 1 if the creature is unconscious, 0 otherwise.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 166,
                "C2": 166,
                "C3": 166,
                "DS": 166,
                "SM": 166
            },
            "rvalue": true,
            "variants": 62,
            "command_group_id": 5
        },
        "39": {
            "id": 39,
            "command": "UNID",
            "description": "Unique Identifier.\nA UNID of zero is invalid and indicates that the object does not exist.\nNote: This command has been left in for completeness, because using [TARG] will produce the same results.",
            "return_type_id": 11,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 10
        },
        "494": {
            "id": 494,
            "command": "UNID",
            "description": "Returns unique identifier for target agent. AGNT goes the opposite way. NOTE: This should only be used for external programs to persistently refer to an agent. Variables can use SETA to store agent r-values directly for internal use.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 10
        },
        "276": {
            "id": 276,
            "command": "UNLK",
            "description": "Enables the execution of other event scripts on this object. This should be paired with command LOCK.",
            "return_type_id": 8,
            "variants": 62,
            "command_group_id": 14
        },
        "85": {
            "id": 85,
            "command": "UNTL",
            "parameters": [
                {
                    "index": 0,
                    "name": "condition",
                    "type_id": 15
                }
            ],
            "description": "Part of a LOOP-UNTL statement. Repeat loop unless condition is true.\nValid relations are:\nEQ \u2013 Equal\nNE \u2013 Not equal\nGT \u2013 Greater than\nLT \u2013 Less than\nGE \u2013 Greater than or equal to \nLE \u2013 Less than or equal to \nBT \u2013 Bit-wise AND function \nBF \u2013 Bit-wise NAND function",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 15
        },
        "929": {
            "id": 929,
            "command": "UPPA",
            "parameters": [
                {
                    "index": 0,
                    "name": "anyOld",
                    "type_id": 4
                }
            ],
            "description": "Converts the given string into all upper case letters.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 12
        },
        "770": {
            "id": 770,
            "command": "URGE SHOU",
            "parameters": [
                {
                    "index": 0,
                    "name": "nounStim",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "verbId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 292,
                        "DS": 292
                    }
                },
                {
                    "index": 2,
                    "name": "verbStim",
                    "type_id": 2
                }
            ],
            "description": "Urge all creatures who can hear OWNR to perform the verb_id action on OWNR. Stimuli can range from -1 to 1, ranging from discourage to encourage.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "771": {
            "id": 771,
            "command": "URGE SIGN",
            "parameters": [
                {
                    "index": 0,
                    "name": "nounStim",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "verbId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 292,
                        "DS": 292
                    }
                },
                {
                    "index": 2,
                    "name": "verbStim",
                    "type_id": 2
                }
            ],
            "description": "Urge all creatures who can see OWNR to perform an action on OWNR.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "772": {
            "id": 772,
            "command": "URGE TACT",
            "parameters": [
                {
                    "index": 0,
                    "name": "nounStim",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "verbId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 292,
                        "DS": 292
                    }
                },
                {
                    "index": 2,
                    "name": "verbStim",
                    "type_id": 2
                }
            ],
            "description": "Urge all creatures who are touching OWNR to perform an action on OWNR.",
            "return_type_id": 8,
            "requires_ownr": 2,
            "variants": 60,
            "command_group_id": 5
        },
        "773": {
            "id": 773,
            "command": "URGE WRIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "creature",
                    "type_id": 11
                },
                {
                    "index": 1,
                    "name": "nounId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 291,
                        "DS": 291
                    }
                },
                {
                    "index": 2,
                    "name": "nounStim",
                    "type_id": 2
                },
                {
                    "index": 3,
                    "name": "verbId",
                    "type_id": 1,
                    "values_list_ids": {
                        "C3": 292,
                        "DS": 292
                    }
                },
                {
                    "index": 4,
                    "name": "verbStim",
                    "type_id": 2
                }
            ],
            "description": "Urge a specific creature to perform a specific action on a specific noun. A stimulus greater than 1 will force the Creature to perform an action, or to set its attention (mind control!). Use an id -1 and stim greater than 1 to un-force it.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "846": {
            "id": 846,
            "command": "VARC",
            "parameters": [
                {
                    "index": 0,
                    "name": "viewArcSize",
                    "type_id": 2
                }
            ],
            "description": "[not implemented yet]",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 8
        },
        "847": {
            "id": 847,
            "command": "VARC",
            "description": "[not implemented yet]",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "943": {
            "id": 943,
            "command": "VARx",
            "description": "VAR0 to VAR9 are local variables, whose values are lost when the current script ends.\n@range(0 to 9)",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 12
        },
        "663": {
            "id": 663,
            "command": "VAxx",
            "description": "VA00 to VA99 are local variables, whose values are lost when the current script ends.\n@range(0 to 99)",
            "return_type_id": 6,
            "rvalue": true,
            "lvalue": true,
            "variants": 62,
            "command_group_id": 12
        },
        "848": {
            "id": 848,
            "command": "VECX",
            "parameters": [
                {
                    "index": 0,
                    "name": "angle",
                    "type_id": 2
                }
            ],
            "description": "Returns a normalised vector for the given angle (X coordinate).",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "849": {
            "id": 849,
            "command": "VECY",
            "parameters": [
                {
                    "index": 0,
                    "name": "angle",
                    "type_id": 2
                }
            ],
            "description": "Returns a normalised vector for the given angle (Y coordinate).",
            "return_type_id": 2,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 8
        },
        "586": {
            "id": 586,
            "command": "VELO",
            "parameters": [
                {
                    "index": 0,
                    "name": "xVelocity",
                    "type_id": 2
                },
                {
                    "index": 1,
                    "name": "yVelocity",
                    "type_id": 2
                }
            ],
            "description": "Set velocity, measured in pixels per tick.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 8
        },
        "587": {
            "id": 587,
            "command": "VELX",
            "description": "Horizontal velocity in pixels per tick - floating point.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "107": {
            "id": 107,
            "command": "VELX",
            "description": "Sets/returns the object's velocity in X direction.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "588": {
            "id": 588,
            "command": "VELY",
            "description": "Vertical velocity in pixels per tick - floating point.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 60,
            "command_group_id": 8
        },
        "108": {
            "id": 108,
            "command": "VELY",
            "description": "Sets/returns the object's velocity in Y direction.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 2,
            "command_group_id": 8
        },
        "383": {
            "id": 383,
            "command": "VISI",
            "parameters": [
                {
                    "index": 0,
                    "name": "checkAllCameras",
                    "type_id": 1
                }
            ],
            "description": "Checks if the agent, or any of its parts, is on screen and returns 1 if it is or 0 if it is not. Set to 0 to check if the agent is on the main camera. Set to 1 to check if the agent is on the main camera or any remote cameras",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 1
        },
        "664": {
            "id": 664,
            "command": "VMJR",
            "description": "Returns the major version number of the engine.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "665": {
            "id": 665,
            "command": "VMNR",
            "description": "Returns the minor version number of the engine.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "474": {
            "id": 474,
            "command": "VOCB",
            "description": "Learn all vocabulary instantly.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "607": {
            "id": 607,
            "command": "VOIC",
            "parameters": [
                {
                    "index": 0,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "gender",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "age",
                    "type_id": 1
                }
            ],
            "description": "This sets the TARG agent's voice to the specified creature voice, using standard cascade techniques to select the nearest match. On failure, \"DefaultVoice\" will be reloaded. Use SEZZ to actually say something.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "608": {
            "id": 608,
            "command": "VOIS",
            "parameters": [
                {
                    "index": 0,
                    "name": "voiceName",
                    "type_id": 4
                }
            ],
            "description": "Sets the TARG agent's voice to the specified value. The voice name must be valid in the catalogue. If it fails, then \"DefaultVoice\" will be reloaded. Use SEZZ to actually say something.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 25
        },
        "609": {
            "id": 609,
            "command": "VOIS",
            "description": "This returns the voice name for the TARG agent. (Unless it has been serialised in :( In which case it returns \"Lozenged\" if the agent had a voice before the save, or \"\" as normal if the agent can't speak.)",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 25
        },
        "610": {
            "id": 610,
            "command": "VOLM",
            "parameters": [
                {
                    "index": 0,
                    "name": "volume",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "whichModule",
                    "type_id": 1
                }
            ],
            "description": "Set overall the volume of the MIDI and the sound effects. Send 0 as the second parameter to affect just the MIDI, 1 to affect just the sound effects and anything else to affect both modules.",
            "return_type_id": 8,
            "variants": 4,
            "command_group_id": 25
        },
        "909": {
            "id": 909,
            "command": "VOLM",
            "parameters": [
                {
                    "index": 0,
                    "name": "channel",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "volume",
                    "type_id": 1
                }
            ],
            "description": "Set overall the volume of the sound effects (channel 0), the MIDI (channel 1) or the generated music (channel 2). Values range from -10000 (silent) to 0 (loudest).",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 25
        },
        "910": {
            "id": 910,
            "command": "VOLM",
            "parameters": [
                {
                    "index": 0,
                    "name": "channel",
                    "type_id": 1
                }
            ],
            "description": "Returns the overall the volume of the sound effects (channel 0), the MIDI (channel 1) or the generated music (channel 2). Values range from -10000 (silent) to 0 (loudest). Currently not supported for MIDI.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 56,
            "command_group_id": 25
        },
        "288": {
            "id": 288,
            "command": "VRSN",
            "description": "Return the Creatures Build ID",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 21
        },
        "289": {
            "id": 289,
            "command": "VRSN",
            "parameters": [
                {
                    "index": 0,
                    "name": "version",
                    "type_id": 1
                }
            ],
            "description": "Only run this script if the Creatures Build ID is equivalent or higher than number.",
            "return_type_id": 8,
            "variants": 3,
            "command_group_id": 21
        },
        "666": {
            "id": 666,
            "command": "VTOS",
            "parameters": [
                {
                    "index": 0,
                    "name": "value",
                    "type_id": 16
                }
            ],
            "description": "Converts an integer or float into a string in decimal.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 12
        },
        "100": {
            "id": 100,
            "command": "WAIT",
            "parameters": [
                {
                    "index": 0,
                    "name": "ticks",
                    "type_id": 1
                }
            ],
            "description": "Wait for the specified number of game ticks before continuing with next instruction. A tick is roughly 1/10 sec",
            "return_type_id": 8,
            "variants": 63,
            "command_group_id": 14
        },
        "221": {
            "id": 221,
            "command": "WALK",
            "description": "Walk indefinitely. Chose a walking gait according to chemo-receptors, then start walking.\nIf extraspective you\u2019ll continuously walk towards [_IT_], but the command is primarily for introspective walking.",
            "return_type_id": 8,
            "requires_creature_ownr": true,
            "variants": 63,
            "command_group_id": 5
        },
        "41": {
            "id": 41,
            "command": "WALL",
            "description": "WALL last collided with. 0 = left, 1 = right, 2 = up, 3 = down, 4 = unknown.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 164,
                "CV": 165,
                "DS": 165,
                "C3": 165,
                "SM": 165
            },
            "rvalue": true,
            "variants": 62,
            "command_group_id": 8
        },
        "405": {
            "id": 405,
            "command": "WDOW",
            "description": "Toggle full screen mode.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        },
        "406": {
            "id": 406,
            "command": "WDOW",
            "description": "Returns 1 if in full screen mode, or 0 if in windowed mode.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 163,
                "DS": 163,
                "C3": 163,
                "SM": 163
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "34": {
            "id": 34,
            "command": "WDTH",
            "description": "Returns objects width",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 63,
            "command_group_id": 64
        },
        "475": {
            "id": 475,
            "command": "WEAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "bodyId",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "setNumber",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "layer",
                    "type_id": 1
                }
            ],
            "description": "Sets a layer of clothing on part of the creature. The set_number is the type of clothing to put on from the overlay file - think of it as an outfit number. layer 0 is the actual body of the creature, so unless you want to replace the body part itself use a higher layer. Higher layers are on top of lower ones. e.g. 0 for a face, 1 for measles spots, 2 for a fencing mask. See also BODY and NUDE.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "476": {
            "id": 476,
            "command": "WEAR",
            "parameters": [
                {
                    "index": 0,
                    "name": "bodyPart",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "layer",
                    "type_id": 1
                }
            ],
            "description": "Return the set number of the outfit the norn is wearing on the specified layer or -1 if it is not wearing anything",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 4,
            "command_group_id": 5
        },
        "795": {
            "id": 795,
            "command": "WEBB",
            "parameters": [
                {
                    "index": 0,
                    "name": "httpUrl",
                    "type_id": 4
                }
            ],
            "description": "Launches an external URL in the user's browser. The game engine adds http:// at the beginning to prevent malicious launching of programs, so you just need to specify the domain name and path.",
            "return_type_id": 8,
            "variants": 56,
            "command_group_id": 30
        },
        "384": {
            "id": 384,
            "command": "WILD",
            "parameters": [
                {
                    "index": 0,
                    "name": "family",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "genus",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "species",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "tagStub",
                    "type_id": 4
                },
                {
                    "index": 4,
                    "name": "offset",
                    "type_id": 1
                }
            ],
            "description": "Searches for a catalogue tag based on the given classifier, and returns the string at the given offset. See also READ. As an example, with a tag_stub of \"Agent Help\" and a classifier 3 7 11 it would first look for the tag \"Agent Help 3 7 11\". If that wasn't present, it would go through the wildcards, eventually trying \"Agent Help 0 0 0\", and throwing an error if even that isn't there.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 34
        },
        "303": {
            "id": 303,
            "command": "WIND",
            "description": "Wind speed/direction near [TARG] object\nAlways returns 1\nShould have had Range (-3 to +3)",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "298": {
            "id": 298,
            "command": "WINH",
            "description": "Max allowed view window height (WORLD coords)",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "297": {
            "id": 297,
            "command": "WINW",
            "description": "Max allowed view window width (WORLD coords)",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 20
        },
        "147": {
            "id": 147,
            "command": "WLDH",
            "description": "World Height, in pixels.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "146": {
            "id": 146,
            "command": "WLDW",
            "description": "World Width, in pixels.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "690": {
            "id": 690,
            "command": "WNAM",
            "description": "Returns the name of the currently loaded world.",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 21
        },
        "407": {
            "id": 407,
            "command": "WNDB",
            "description": "Returns world coordinates of bottom of current camera window.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "408": {
            "id": 408,
            "command": "WNDH",
            "description": "Returns height of current camera window.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "409": {
            "id": 409,
            "command": "WNDL",
            "description": "Returns world coordinates of left of current camera window.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "410": {
            "id": 410,
            "command": "WNDR",
            "description": "Returns world coordinates of right of current camera window.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "411": {
            "id": 411,
            "command": "WNDT",
            "description": "Returns world coordinates of top of current camera window.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "412": {
            "id": 412,
            "command": "WNDW",
            "description": "Returns width of current camera window.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 24
        },
        "130": {
            "id": 130,
            "command": "WNDX",
            "description": "Sets/returns the wind X component at [TARG]",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "131": {
            "id": 131,
            "command": "WNDY",
            "description": "Sets/returns the wind Y component at [TARG]",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 2,
            "command_group_id": 20
        },
        "691": {
            "id": 691,
            "command": "WNTI",
            "parameters": [
                {
                    "index": 0,
                    "name": "world",
                    "type_id": 4
                }
            ],
            "description": "This returns the index of the world. If you pass in a world name which is not within the system, -1 is returned.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 21
        },
        "622": {
            "id": 622,
            "command": "WOLF",
            "parameters": [
                {
                    "index": 0,
                    "name": "kangaMask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 201,
                        "DS": 201,
                        "C3": 201,
                        "SM": 201
                    }
                },
                {
                    "index": 1,
                    "name": "eeyoreMask",
                    "type_id": 1,
                    "values_list_ids": {
                        "CV": 201,
                        "DS": 201,
                        "C3": 201,
                        "SM": 201
                    }
                }
            ],
            "description": "Provides various functions to distort space-time and otherwise help with wolfing runs. Set an AND and an EOR mask, to control the following bits:\n1 - Display rendering. Turning it off speeds the game up.\n2 - Fastest ticks. The game usually runs at a maximum of 20 frames per second. If this is set, it instead runs as fast as it can.\n4 - Refresh display at end of tick. If set, then the display is updated at the end of the tick, and the flag is cleared.\n8 - Autokill. If set, agents which generate run errors are automatically killed, as the command line option.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "623": {
            "id": 623,
            "command": "WPAU",
            "parameters": [
                {
                    "index": 0,
                    "name": "paused",
                    "type_id": 1
                }
            ],
            "description": "Stops world ticks from running. Days, seasons and years won't change and any delayed messages are paused, as are CAs and some sound effects. Set to 1 to pause, 0 to run. Use along with PAUS.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 22
        },
        "624": {
            "id": 624,
            "command": "WPAU",
            "description": "Returns 1 if world ticks are paused, or 0 otherwise.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 161,
                "DS": 161,
                "C3": 161,
                "SM": 161
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "692": {
            "id": 692,
            "command": "WRLD",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldName",
                    "type_id": 4
                }
            ],
            "description": "Creates a new world directory for the specified world.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "693": {
            "id": 693,
            "command": "WRLD",
            "parameters": [
                {
                    "index": 0,
                    "name": "worldIndex",
                    "type_id": 1
                }
            ],
            "description": "Returns the name of the world specified by world_index which must be in the range 0 to (NWLD-1).",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 21
        },
        "625": {
            "id": 625,
            "command": "WTIK",
            "description": "Returns the number of ticks since the world was first made. For debugging purposes only you can change this value with DBG: WTIK.",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 22
        },
        "694": {
            "id": 694,
            "command": "WTNT",
            "parameters": [
                {
                    "index": 0,
                    "name": "index",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "redTint",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "greenTint",
                    "type_id": 1
                },
                {
                    "index": 3,
                    "name": "blueTint",
                    "type_id": 1
                },
                {
                    "index": 4,
                    "name": "rotation",
                    "type_id": 1
                },
                {
                    "index": 5,
                    "name": "swap",
                    "type_id": 1
                }
            ],
            "description": "This sets up the world (global) tint table. The index is the number associated with the tint table - (keep it small please) and the r,g,b is the tint level. Rotation and Swap work as for pigment bleed genes.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 21
        },
        "695": {
            "id": 695,
            "command": "WUID",
            "description": "Returns the unique identifier of the currently loaded world.\n",
            "return_type_id": 4,
            "rvalue": true,
            "variants": 60,
            "command_group_id": 21
        },
        "946": {
            "id": 946,
            "command": "XIST",
            "parameters": [
                {
                    "index": 0,
                    "name": "agent",
                    "type_id": 11
                }
            ],
            "description": "Returns 1 if specified agent exists, or 0 otherwise (ie, if it is null).",
            "return_type_id": 1,
            "return_values_list_ids": {
                "C2": 232
            },
            "rvalue": true,
            "variants": 2,
            "command_group_id": 1
        },
        "173": {
            "id": 173,
            "command": "XVEC",
            "description": "Sets/returns the vehicles x-movement vector in 1/256th of a pixel.\nThis command is a legacy from Creatures 1 \u2013 [VELX] will work just as good.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 8
        },
        "160": {
            "id": 160,
            "command": "YEAR",
            "description": "Returns the current year in Albia. Starting with 0000 AD (first chronicled year After Disaster)",
            "return_type_id": 1,
            "rvalue": true,
            "variants": 62,
            "command_group_id": 22
        },
        "174": {
            "id": 174,
            "command": "YVEC",
            "description": "Sets/returns the vehicles y-movement vector in 1/256th of a pixel.\nThis command is a legacy from Creatures 1 \u2013 [VELY] will work just as good.",
            "return_type_id": 1,
            "rvalue": true,
            "lvalue": true,
            "variants": 3,
            "command_group_id": 8
        },
        "477": {
            "id": 477,
            "command": "ZOMB",
            "parameters": [
                {
                    "index": 0,
                    "name": "zombie",
                    "type_id": 1
                }
            ],
            "description": "Make or undo the creature's zombification factor. 1 makes creatures zombies: in a zombie state creatures won't process any decision scripts but they will respond to ANIMs and POSEs. 0 umzombifies.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 5
        },
        "478": {
            "id": 478,
            "command": "ZOMB",
            "description": "Returns 1 if the creature is zombified (has its brain to motor link severed), 0 otherwise.",
            "return_type_id": 1,
            "return_values_list_ids": {
                "CV": 160,
                "DS": 160,
                "C3": 160,
                "SM": 160
            },
            "rvalue": true,
            "variants": 60,
            "command_group_id": 5
        },
        "413": {
            "id": 413,
            "command": "ZOOM",
            "parameters": [
                {
                    "index": 0,
                    "name": "pixels",
                    "type_id": 1
                },
                {
                    "index": 1,
                    "name": "x",
                    "type_id": 1
                },
                {
                    "index": 2,
                    "name": "y",
                    "type_id": 1
                }
            ],
            "description": "Zoom in on the specified position by a negative amount of pixels or out by positive amount of pixels. If you send -1 as the x and y coordinates then the camera zooms in on the existing view port centre. This only applies to remote cameras.",
            "return_type_id": 8,
            "variants": 60,
            "command_group_id": 24
        }
    },
    "command_groups": {
        "19": "AgentAnimation",
        "65": "AgentAttributes",
        "64": "AgentBounds",
        "67": "AgentConstructors",
        "66": "AgentInteractions",
        "1": "Agents",
        "18": "AgentSprites",
        "7": "AgentVars",
        "4": "Blackboard",
        "11": "Brain",
        "6": "Bubbles",
        "24": "Camera",
        "9": "Caos",
        "34": "Catalogue",
        "35": "CD Player",
        "29": "CompoundAgents",
        "5": "Creatures",
        "10": "Debug",
        "17": "Enumeration",
        "16": "Enums",
        "30": "Files",
        "15": "Flow",
        "31": "Genetics",
        "32": "History",
        "28": "Input",
        "20": "Map",
        "13": "Math",
        "8": "Motion",
        "36": "Net",
        "33": "Ports",
        "38": "Pray",
        "23": "Rain",
        "37": "Resources",
        "14": "Scripts",
        "25": "Sounds",
        "22": "Time",
        "12": "Variables",
        "3": "Vehicles",
        "21": "World"
    },
    "variable_types": {
        "1": "integer",
        "2": "float",
        "3": "token",
        "4": "string",
        "6": "variable",
        "8": "command",
        "9": "[string]",
        "10": "[byte_string]",
        "11": "agent",
        "13": "any",
        "15": "condition",
        "16": "decimal",
        "17": "[anim]",
        "18": "hexadecimal",
        "19": "pict_dimension"
    },
    "variant_map": {
        "C1": {
            "code": "C1",
            "name": "Creatures 1",
            "vars": {
                "VARx": 9,
                "VAxx": null,
                "OBVx": 2,
                "OVxx": null,
                "MVxx": null
            },
            "values_lists_ids": [
                236,
                92,
                71,
                296,
                137,
                77,
                80,
                79,
                184,
                227,
                235,
                78,
                76,
                150,
                69,
                245,
                231,
                72,
                73,
                277,
                70,
                68,
                67,
                142,
                253,
                185,
                158,
                159,
                182,
                228
            ]
        },
        "C2": {
            "code": "C2",
            "name": "Creatures 2",
            "vars": {
                "VARx": 9,
                "VAxx": 99,
                "OBVx": 9,
                "OVxx": 99,
                "MVxx": null
            },
            "values_lists_ids": [
                240,
                71,
                296,
                122,
                121,
                126,
                216,
                217,
                135,
                87,
                86,
                90,
                91,
                220,
                187,
                227,
                92,
                94,
                235,
                134,
                225,
                222,
                223,
                120,
                83,
                221,
                70,
                246,
                218,
                123,
                249,
                119,
                181,
                164,
                267,
                125,
                124,
                253,
                179,
                88,
                89,
                268,
                185,
                158,
                96,
                159,
                224,
                161,
                85,
                182,
                166,
                154,
                232,
                230
            ]
        },
        "CV": {
            "code": "CV",
            "name": "Creatures Village",
            "vars": {
                "VARx": null,
                "VAxx": 99,
                "OBVx": null,
                "OVxx": 99,
                "MVxx": 99
            },
            "values_lists_ids": [
                115,
                158,
                147,
                107,
                106,
                189,
                238,
                210,
                191,
                258,
                188,
                233,
                96,
                157,
                234,
                192,
                279,
                299,
                280,
                193,
                195,
                166,
                196,
                265,
                272,
                251,
                203,
                283,
                244,
                278,
                297,
                213,
                235,
                199,
                201,
                143,
                214,
                290,
                71,
                113,
                211,
                295,
                212,
                296,
                206,
                284,
                165,
                253,
                88,
                159,
                182,
                177,
                161,
                169,
                168,
                163,
                160,
                171,
                180,
                172,
                178,
                170,
                128,
                167,
                89,
                153,
                162,
                202,
                269,
                204,
                194,
                205,
                197,
                273,
                274,
                275,
                276
            ]
        },
        "C3": {
            "code": "C3",
            "name": "Creatures 3",
            "vars": {
                "VARx": null,
                "VAxx": 99,
                "OBVx": null,
                "OVxx": 99,
                "MVxx": 99
            },
            "values_lists_ids": [
                115,
                158,
                146,
                117,
                106,
                189,
                238,
                210,
                285,
                191,
                258,
                190,
                140,
                96,
                157,
                234,
                248,
                279,
                299,
                280,
                193,
                195,
                166,
                196,
                265,
                272,
                251,
                203,
                283,
                183,
                278,
                297,
                213,
                235,
                199,
                201,
                281,
                143,
                214,
                290,
                71,
                282,
                181,
                113,
                292,
                291,
                211,
                295,
                212,
                296,
                206,
                208,
                284,
                198,
                165,
                253,
                88,
                159,
                182,
                177,
                161,
                169,
                168,
                163,
                160,
                171,
                180,
                172,
                178,
                170,
                286,
                128,
                167,
                89,
                153,
                162,
                202,
                269,
                204,
                194,
                205,
                197,
                273,
                274,
                275,
                276,
                229
            ]
        },
        "DS": {
            "code": "DS",
            "name": "Docking Station",
            "vars": {
                "VARx": null,
                "VAxx": 99,
                "OBVx": null,
                "OVxx": 99,
                "MVxx": 99
            },
            "values_lists_ids": [
                115,
                158,
                149,
                117,
                106,
                189,
                238,
                210,
                285,
                191,
                258,
                190,
                140,
                96,
                157,
                234,
                248,
                279,
                299,
                280,
                193,
                195,
                166,
                196,
                265,
                272,
                251,
                203,
                283,
                183,
                278,
                297,
                213,
                235,
                199,
                201,
                281,
                143,
                214,
                290,
                71,
                282,
                181,
                113,
                292,
                291,
                211,
                295,
                212,
                296,
                206,
                208,
                284,
                198,
                165,
                253,
                88,
                159,
                182,
                177,
                161,
                169,
                168,
                163,
                160,
                171,
                180,
                172,
                178,
                170,
                286,
                128,
                167,
                89,
                153,
                162,
                202,
                269,
                176,
                175,
                174,
                173,
                204,
                194,
                205,
                197,
                273,
                274,
                275,
                276,
                229
            ]
        },
        "SM": {
            "code": "SM",
            "name": "SeaMonkeys",
            "vars": {
                "VARx": null,
                "VAxx": 99,
                "OBVx": null,
                "OVxx": 99,
                "MVxx": 99
            },
            "values_lists_ids": [
                115,
                158,
                266,
                117,
                106,
                189,
                238,
                210,
                191,
                258,
                190,
                140,
                96,
                157,
                234,
                280,
                193,
                195,
                166,
                196,
                265,
                272,
                251,
                203,
                283,
                183,
                297,
                213,
                235,
                199,
                201,
                143,
                214,
                290,
                71,
                282,
                181,
                113,
                211,
                295,
                212,
                296,
                206,
                284,
                198,
                165,
                253,
                88,
                89,
                159,
                161,
                182,
                177,
                169,
                168,
                163,
                160,
                171,
                180,
                172,
                178,
                170,
                128,
                167,
                153,
                162,
                202,
                269,
                176,
                175,
                174,
                173,
                204,
                194,
                205,
                197,
                273,
                274,
                275,
                276
            ]
        }
    },
    "variant_masks": [
        [
            1,
            "C1"
        ],
        [
            2,
            "C2"
        ],
        [
            4,
            "CV"
        ],
        [
            8,
            "C3"
        ],
        [
            16,
            "DS"
        ],
        [
            32,
            "SM"
        ]
    ],
    "values_lists": {
        "list_273": {
            "id": 273,
            "variant": "AL",
            "name": "_P1_",
            "description": "Name for _P1_ in various event script contexts",
            "arguments": [
                {
                    "id": 7294,
                    "argument_list_id": 273,
                    "value": "6",
                    "name": "X-Velocity",
                    "description": "X collision velocity"
                },
                {
                    "id": 7295,
                    "argument_list_id": 273,
                    "value": "73",
                    "name": "Key pressed@KeyCodes",
                    "description": "Keycode of key down event"
                },
                {
                    "id": 7296,
                    "argument_list_id": 273,
                    "value": "74",
                    "name": "Key released@KeyCodes",
                    "description": "Keycode of key up event"
                },
                {
                    "id": 7297,
                    "argument_list_id": 273,
                    "value": "75",
                    "name": "Mouse-X",
                    "description": "New Mouse X position"
                },
                {
                    "id": 7298,
                    "argument_list_id": 273,
                    "value": "76",
                    "name": "Mouse button down@MouseButton",
                    "description": "Mouse button pressed. Values are @{1: Left, 2: Right, 4: Middle}"
                },
                {
                    "id": 7299,
                    "argument_list_id": 273,
                    "value": "77",
                    "name": "Mouse button up@MouseButton",
                    "description": "Mouse button releaased. Values are @{1: Left, 2: Right, 4: Middle}"
                },
                {
                    "id": 7300,
                    "argument_list_id": 273,
                    "value": "78",
                    "name": "Mouse wheel delta",
                    "description": "Delta value of mouse wheel in 120 units per 'click'"
                },
                {
                    "id": 7301,
                    "argument_list_id": 273,
                    "value": "79",
                    "name": "Translated key code",
                    "description": "The keycode of a translated character. (ie. Japanese keyboard can translate roman characters to japansese characters"
                },
                {
                    "id": 7302,
                    "argument_list_id": 273,
                    "value": "117",
                    "name": "Pointer action@PointerAction",
                    "description": "Says what action clicking on a creature would perform. Values are @{0: No Action (Pointer not above creature), 1: Slap, 2: Tickle}"
                },
                {
                    "id": 7303,
                    "argument_list_id": 273,
                    "value": "120",
                    "name": "Selected creature",
                    "description": "The newly selected creature"
                },
                {
                    "id": 7320,
                    "argument_list_id": 273,
                    "value": "126",
                    "name": "Texts spoken"
                },
                {
                    "id": 7304,
                    "argument_list_id": 273,
                    "value": "127",
                    "name": "Event moniker",
                    "description": "The moniker for this new event"
                },
                {
                    "id": 7305,
                    "argument_list_id": 273,
                    "value": "137",
                    "name": "Connected user ID",
                    "description": "The user id for the player that has just come online"
                },
                {
                    "id": 7306,
                    "argument_list_id": 273,
                    "value": "138",
                    "name": "Disconnected user ID",
                    "description": "The user id for the player that has just gone offline"
                },
                {
                    "id": 7307,
                    "argument_list_id": 273,
                    "value": "150",
                    "name": "TargetX",
                    "description": "X position of approach command's IT object"
                },
                {
                    "id": 7308,
                    "argument_list_id": 273,
                    "value": "152",
                    "name": "TargetRoomX",
                    "description": "X position of room center with the highest (or lowest if retreating) concentration of target IT smell, when there is no IT object"
                },
                {
                    "id": 7309,
                    "argument_list_id": 273,
                    "value": "153",
                    "name": "TargetLinkX",
                    "description": "X position of link center with the highest (or lowest if retreating) concentration of target IT smell, when there is no IT object"
                },
                {
                    "id": 7310,
                    "argument_list_id": 273,
                    "value": "154",
                    "name": "RoomX",
                    "description": "X position of room when creature is in room with highest (or lowest if retreating) concentration of IT smell, when there is no IT object"
                },
                {
                    "id": 7311,
                    "argument_list_id": 273,
                    "value": "160",
                    "name": "Next age@Age",
                    "description": "Next life stage of creature for event"
                }
            ],
            "variants": 60
        },
        "list_274": {
            "id": 274,
            "variant": "AL",
            "name": "_P2_",
            "description": "Name for _P2_ in various event script contexts",
            "arguments": [
                {
                    "id": 7312,
                    "argument_list_id": 274,
                    "value": "6",
                    "name": "Y-Velocity",
                    "description": "Y collision velocity"
                },
                {
                    "id": 7313,
                    "argument_list_id": 274,
                    "value": "75",
                    "name": "Mouse-Y",
                    "description": "New Mouse Y position"
                },
                {
                    "id": 7314,
                    "argument_list_id": 274,
                    "value": "120",
                    "name": "Previously selected creature",
                    "description": "The previously selected creature"
                },
                {
                    "id": 7321,
                    "argument_list_id": 274,
                    "value": "126",
                    "name": "Speaking creature"
                },
                {
                    "id": 7315,
                    "argument_list_id": 274,
                    "value": "127",
                    "name": "Event index",
                    "description": "An index into the events for that moniker."
                },
                {
                    "id": 7316,
                    "argument_list_id": 274,
                    "value": "150",
                    "name": "TargetY",
                    "description": "Y position of approach command's IT object"
                },
                {
                    "id": 7317,
                    "argument_list_id": 274,
                    "value": "152",
                    "name": "TargetRoomY",
                    "description": "Y position of room center with the highest (or lowest if retreating) concentration of target IT smell, when there is no IT object"
                },
                {
                    "id": 7318,
                    "argument_list_id": 274,
                    "value": "153",
                    "name": "TargetLinkY",
                    "description": "Y position of link center with the highest (or lowest if retreating) concentration of target IT smell, when there is no IT object"
                },
                {
                    "id": 7319,
                    "argument_list_id": 274,
                    "value": "154",
                    "name": "RoomY",
                    "description": "Y position of room when creature is in room with highest (or lowest if retreating) concentration of IT smell, when there is no IT object"
                }
            ],
            "variants": 60
        },
        "list_76": {
            "id": 76,
            "variant": "C1",
            "name": "Action",
            "base_values_list_id": 10,
            "arguments": [
                {
                    "id": 967,
                    "argument_list_id": 76,
                    "value": "0",
                    "name": "Activate 1"
                },
                {
                    "id": 968,
                    "argument_list_id": 76,
                    "value": "1",
                    "name": "Activate 2"
                },
                {
                    "id": 969,
                    "argument_list_id": 76,
                    "value": "2",
                    "name": "Deactivate"
                }
            ],
            "variants": 1
        },
        "list_124": {
            "id": 124,
            "variant": "C2",
            "name": "ActiveStatus",
            "extension_type": "bool:gt",
            "base_values_list_id": 35,
            "arguments": [
                {
                    "id": 2592,
                    "argument_list_id": 124,
                    "value": "0",
                    "name": "Inactive"
                },
                {
                    "id": 2593,
                    "argument_list_id": 124,
                    "value": "1",
                    "name": "Activate 1"
                },
                {
                    "id": 2594,
                    "argument_list_id": 124,
                    "value": "2",
                    "name": "Activate 2"
                },
                {
                    "id": 2595,
                    "argument_list_id": 124,
                    "value": "3",
                    "name": "Hit"
                },
                {
                    "id": 2596,
                    "argument_list_id": 124,
                    "value": "4",
                    "name": "Eat"
                }
            ],
            "variants": 2
        },
        "list_142": {
            "id": 142,
            "variant": "C1",
            "name": "ActiveStatus",
            "extension_type": "bool:gt",
            "base_values_list_id": 35,
            "arguments": [
                {
                    "id": 3345,
                    "argument_list_id": 142,
                    "value": "0",
                    "name": "Inactive"
                },
                {
                    "id": 3346,
                    "argument_list_id": 142,
                    "value": "1",
                    "name": "Active 1"
                },
                {
                    "id": 3347,
                    "argument_list_id": 142,
                    "value": "2",
                    "name": "Active 2"
                }
            ],
            "variants": 1
        },
        "list_159": {
            "id": 159,
            "variant": "AL",
            "name": "Age",
            "base_values_list_id": 45,
            "arguments": [
                {
                    "id": 3692,
                    "argument_list_id": 159,
                    "value": "0",
                    "name": "Embryo"
                },
                {
                    "id": 3693,
                    "argument_list_id": 159,
                    "value": "1",
                    "name": "Baby"
                },
                {
                    "id": 3694,
                    "argument_list_id": 159,
                    "value": "2",
                    "name": "Child"
                },
                {
                    "id": 3695,
                    "argument_list_id": 159,
                    "value": "3",
                    "name": "Adolescent"
                },
                {
                    "id": 3696,
                    "argument_list_id": 159,
                    "value": "4",
                    "name": "Youth"
                },
                {
                    "id": 3699,
                    "argument_list_id": 159,
                    "value": "5",
                    "name": "Adult"
                },
                {
                    "id": 3697,
                    "argument_list_id": 159,
                    "value": "6",
                    "name": "Old"
                },
                {
                    "id": 3698,
                    "argument_list_id": 159,
                    "value": "7",
                    "name": "Senile"
                }
            ],
            "variants": 63
        },
        "list_225": {
            "id": 225,
            "variant": "AL",
            "name": "AimAction",
            "base_values_list_id": 102,
            "arguments": [
                {
                    "id": 4371,
                    "argument_list_id": 225,
                    "value": "0",
                    "name": "Activate1"
                },
                {
                    "id": 4372,
                    "argument_list_id": 225,
                    "value": "1",
                    "name": "Activate2"
                },
                {
                    "id": 4373,
                    "argument_list_id": 225,
                    "value": "2",
                    "name": "Deactivate"
                }
            ],
            "variants": 2
        },
        "list_268": {
            "id": 268,
            "variant": "AL",
            "name": "AlignLiftCabin",
            "extension_type": "bool",
            "arguments": [
                {
                    "id": 6697,
                    "argument_list_id": 268,
                    "value": "0",
                    "name": "Do Not Align Lift Cabin",
                    "description": "Do not force alignment of lift cabin and floor"
                },
                {
                    "id": 6698,
                    "argument_list_id": 268,
                    "value": ">0",
                    "name": "Align Lift Cabin",
                    "description": "Align lift cabin with floor (default)"
                }
            ],
            "variants": 2
        },
        "list_68": {
            "id": 68,
            "variant": "C1",
            "name": "Attributes",
            "extension_type": "BitFlags",
            "base_values_list_id": 2,
            "arguments": [
                {
                    "id": 929,
                    "argument_list_id": 68,
                    "value": "1",
                    "name": "Carryable",
                    "description": "Creature can pick up object"
                },
                {
                    "id": 930,
                    "argument_list_id": 68,
                    "value": "2",
                    "name": "Mouseable",
                    "description": "Mouse can pick up object"
                },
                {
                    "id": 931,
                    "argument_list_id": 68,
                    "value": "4",
                    "name": "Activatable",
                    "description": "Can be activated with mouse"
                },
                {
                    "id": 932,
                    "argument_list_id": 68,
                    "value": "8",
                    "name": "Container",
                    "description": "Carries other objects (vehicles only)"
                },
                {
                    "id": 933,
                    "argument_list_id": 68,
                    "value": "16",
                    "name": "Invisible",
                    "description": "Creatures can't see it"
                },
                {
                    "id": 934,
                    "argument_list_id": 68,
                    "value": "32",
                    "name": "Floatable",
                    "description": "Normally floating on screen"
                },
                {
                    "id": 935,
                    "argument_list_id": 68,
                    "value": "64",
                    "name": "Wallbound",
                    "description": "Limits movement to current room"
                },
                {
                    "id": 936,
                    "argument_list_id": 68,
                    "value": "128",
                    "name": "Ground Bound",
                    "description": "Movement only limited by ground"
                }
            ],
            "variants": 1
        },
        "list_107": {
            "id": 107,
            "variant": "CV",
            "name": "Attributes",
            "extension_type": "BitFlags",
            "base_values_list_id": 2,
            "arguments": [
                {
                    "id": 1652,
                    "argument_list_id": 107,
                    "value": "1",
                    "name": "Carryable",
                    "description": "Can be picked up by things other than creatures, vehicles and the pointer."
                },
                {
                    "id": 1653,
                    "argument_list_id": 107,
                    "value": "2",
                    "name": "Mouseable",
                    "description": "Can be picked up by the mouse."
                },
                {
                    "id": 1654,
                    "argument_list_id": 107,
                    "value": "4",
                    "name": "Activateable",
                    "description": "Can be activated using the mouse - otherwise CLAC and CLIK style events don't get sent when you click on the agent."
                },
                {
                    "id": 1655,
                    "argument_list_id": 107,
                    "value": "8",
                    "name": "Greedy Cabin",
                    "description": "When set on a vehicle, it will automatically pick up things dropped in its cabin."
                },
                {
                    "id": 1656,
                    "argument_list_id": 107,
                    "value": "16",
                    "name": "Invisible",
                    "description": "Creatures don't see you - applies to ESEE and STAR on creatures, as well as internal creature code."
                },
                {
                    "id": 1657,
                    "argument_list_id": 107,
                    "value": "32",
                    "name": "Floatable",
                    "description": "Agent floats relative to the screen. Move it with FLTO. If you call FREL, the agent will float relative to another agent instead of the screen."
                },
                {
                    "id": 1658,
                    "argument_list_id": 107,
                    "value": "64",
                    "name": "Suffer Collisions",
                    "description": "Will collide with room boundaries, according to its PERM."
                },
                {
                    "id": 1659,
                    "argument_list_id": 107,
                    "value": "128",
                    "name": "Suffer Physics",
                    "description": "Agent falls with proper physics, including gravity, air resistance and friction. Otherwise, it simply moves with velocity."
                },
                {
                    "id": 1660,
                    "argument_list_id": 107,
                    "value": "256",
                    "name": "Camera Shy",
                    "description": "Agent can't be seen on a remote camera (PAT: CMRA) or photograph (SNAP). For vehicles, the contents is shy as well."
                },
                {
                    "id": 1661,
                    "argument_list_id": 107,
                    "value": "512",
                    "name": "Open Air Cabin",
                    "description": "When set on a vehicle, it allows creatures to see and activate its passengers. The default behaviour is that they can't."
                },
                {
                    "id": 1662,
                    "argument_list_id": 107,
                    "value": "1024",
                    "name": "Swallow Mouse Clicks",
                    "description": "When set on an agent, it will receive mouse clicks as if activatable but will not fire off a message."
                },
                {
                    "id": 1663,
                    "argument_list_id": 107,
                    "value": "2048",
                    "name": "No Activate1 Pointer Animation",
                    "description": "When set on an agent, the mouse pointer will not fire its default activate1 animation allowing you to create your own."
                },
                {
                    "id": 1664,
                    "argument_list_id": 107,
                    "value": "4096",
                    "name": "No Walking Inside Cabin",
                    "description": "When set on a vehicle, the passenger norn will not walk inside the cabin."
                }
            ],
            "variants": 4
        },
        "list_117": {
            "id": 117,
            "variant": "DS",
            "name": "Attributes",
            "extension_type": "BitFlags",
            "base_values_list_id": 2,
            "arguments": [
                {
                    "id": 2097,
                    "argument_list_id": 117,
                    "value": "1",
                    "name": "Carryable",
                    "description": "Can be picked up by things other than creatures, vehicles and the pointer."
                },
                {
                    "id": 2098,
                    "argument_list_id": 117,
                    "value": "2",
                    "name": "Mouseable",
                    "description": "Can be picked up by the mouse."
                },
                {
                    "id": 2099,
                    "argument_list_id": 117,
                    "value": "4",
                    "name": "Activateable",
                    "description": "Can be activated using the mouse - otherwise [CLAC] and [CLIK] style events don't get sent when you click on the agent."
                },
                {
                    "id": 2100,
                    "argument_list_id": 117,
                    "value": "8",
                    "name": "Greedy Cabin",
                    "description": "When set on a vehicle, it will automatically pick up things dropped in its cabin."
                },
                {
                    "id": 2101,
                    "argument_list_id": 117,
                    "value": "16",
                    "name": "Invisible",
                    "description": "Creatures don't see you - applies to [ESEE] and [STAR] on creatures, as well as internal creature code."
                },
                {
                    "id": 2102,
                    "argument_list_id": 117,
                    "value": "32",
                    "name": "Floatable",
                    "description": "Agent floats relative to the screen. Move it with FLTO. If you call [FREL], the agent will float relative to another agent instead of the screen."
                },
                {
                    "id": 2103,
                    "argument_list_id": 117,
                    "value": "64",
                    "name": "Suffer Collisions",
                    "description": "Will collide with room boundaries, according to its [PERM]."
                },
                {
                    "id": 2104,
                    "argument_list_id": 117,
                    "value": "128",
                    "name": "Suffer Physics",
                    "description": "Agent falls with proper physics, including gravity, air resistance and friction. Otherwise, it simply moves with velocity."
                },
                {
                    "id": 2105,
                    "argument_list_id": 117,
                    "value": "256",
                    "name": "Camera Shy",
                    "description": "Agent can't be seen on a remote camera ([PAT: CMRA]) or photograph ([SNAP]). For vehicles, the contents is shy as well."
                },
                {
                    "id": 2106,
                    "argument_list_id": 117,
                    "value": "512",
                    "name": "Open Air Cabin",
                    "description": "When set on a vehicle, it allows creatures to see and activate its passengers. The default behaviour is that they can't."
                },
                {
                    "id": 2107,
                    "argument_list_id": 117,
                    "value": "1024",
                    "name": "Rotatable",
                    "description": "When set on an agent the various rotation commands ([SPIN], [ROTN], [AVEL] etc.) can be used."
                },
                {
                    "id": 2108,
                    "argument_list_id": 117,
                    "value": "2048",
                    "name": "Presence",
                    "description": "An agent with this attribute set has a circular physical presence in the world and receives Impact script callbacks."
                }
            ],
            "variants": 56
        },
        "list_119": {
            "id": 119,
            "variant": "C2",
            "name": "Attributes",
            "extension_type": "BitFlags",
            "base_values_list_id": 2,
            "arguments": [
                {
                    "id": 2109,
                    "argument_list_id": 119,
                    "value": "1",
                    "name": "Carryable",
                    "description": "Creature or another object can pick up object"
                },
                {
                    "id": 2111,
                    "argument_list_id": 119,
                    "value": "2",
                    "name": "Mouseable",
                    "description": "Mouse can pick up object"
                },
                {
                    "id": 2112,
                    "argument_list_id": 119,
                    "value": "4",
                    "name": "Activatable",
                    "description": "Mouse can activate object"
                },
                {
                    "id": 2113,
                    "argument_list_id": 119,
                    "value": "8",
                    "name": "Container",
                    "description": "Can carry other objects (vehicles only)"
                },
                {
                    "id": 2114,
                    "argument_list_id": 119,
                    "value": "16",
                    "name": "Invisible",
                    "description": "Creatures can not see it"
                },
                {
                    "id": 2115,
                    "argument_list_id": 119,
                    "value": "32",
                    "name": "Floatable",
                    "description": "Maintains it\u2019s position relative to window, not world"
                },
                {
                    "id": 2116,
                    "argument_list_id": 119,
                    "value": "64",
                    "name": "Has Boundaries",
                    "description": "Responds to collision events and size"
                },
                {
                    "id": 2117,
                    "argument_list_id": 119,
                    "value": "128",
                    "name": "Suffers Gravity",
                    "description": "Falls due to gravity"
                }
            ],
            "variants": 2
        },
        "list_231": {
            "id": 231,
            "variant": "AL",
            "name": "BBDEdit",
            "base_values_list_id": 106,
            "arguments": [
                {
                    "id": 4599,
                    "argument_list_id": 231,
                    "value": "0",
                    "name": "End Edit"
                },
                {
                    "id": 4600,
                    "argument_list_id": 231,
                    "value": "1",
                    "name": "Start Edit"
                }
            ],
            "variants": 1
        },
        "list_217": {
            "id": 217,
            "variant": "C2",
            "name": "BbleLocation",
            "base_values_list_id": 96,
            "arguments": [
                {
                    "id": 4349,
                    "argument_list_id": 217,
                    "value": "0",
                    "name": "Track Owner"
                },
                {
                    "id": 4350,
                    "argument_list_id": 217,
                    "value": "1",
                    "name": "Center In Viewport"
                }
            ],
            "variants": 2
        },
        "list_216": {
            "id": 216,
            "variant": "C2",
            "name": "BbleType",
            "base_values_list_id": 95,
            "arguments": [
                {
                    "id": 4347,
                    "argument_list_id": 216,
                    "value": "0",
                    "name": "Speech Bubble"
                },
                {
                    "id": 4348,
                    "argument_list_id": 216,
                    "value": "1",
                    "name": "Think Bubble"
                }
            ],
            "variants": 2
        },
        "list_106": {
            "id": 106,
            "variant": "AL",
            "name": "Behavior",
            "extension_type": "BitFlags",
            "base_values_list_id": 31,
            "arguments": [
                {
                    "id": 1646,
                    "argument_list_id": 106,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "Creature can activate 1 this agent."
                },
                {
                    "id": 1647,
                    "argument_list_id": 106,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "Creature can activate 2 this agent."
                },
                {
                    "id": 1648,
                    "argument_list_id": 106,
                    "value": "4",
                    "name": "Deactivate",
                    "description": "Creature can deactivate this agent."
                },
                {
                    "id": 1649,
                    "argument_list_id": 106,
                    "value": "8",
                    "name": "Hit",
                    "description": "Creature can hit this agent."
                },
                {
                    "id": 1650,
                    "argument_list_id": 106,
                    "value": "16",
                    "name": "Eat",
                    "description": "Creature can eat this agent."
                },
                {
                    "id": 1651,
                    "argument_list_id": 106,
                    "value": "32",
                    "name": "Pick Up",
                    "description": "Creature can pick up this agent."
                }
            ],
            "variants": 60
        },
        "list_122": {
            "id": 122,
            "variant": "C2",
            "name": "BehaviorClick",
            "base_values_list_id": 34,
            "arguments": [
                {
                    "id": 2579,
                    "argument_list_id": 122,
                    "value": "0",
                    "name": "No Clicks",
                    "description": "Clicks have not effect"
                },
                {
                    "id": 2580,
                    "argument_list_id": 122,
                    "value": "1",
                    "name": "MonoStable",
                    "description": "Clicks activate, further clicks have no effect until object is inactive again"
                },
                {
                    "id": 2581,
                    "argument_list_id": 122,
                    "value": "3",
                    "name": "Toggle",
                    "description": "First click activates, second deactivates"
                },
                {
                    "id": 2582,
                    "argument_list_id": 122,
                    "value": "4",
                    "name": "Cycle",
                    "description": "First click activate 1, second activate 2, third deactivate"
                }
            ],
            "variants": 2
        },
        "list_121": {
            "id": 121,
            "variant": "C2",
            "name": "BehaviorTouch",
            "extension_type": "BitFlags",
            "base_values_list_id": 33,
            "arguments": [
                {
                    "id": 2573,
                    "argument_list_id": 121,
                    "value": "0",
                    "name": "No Action",
                    "description": "Creature can take no actions"
                },
                {
                    "id": 2574,
                    "argument_list_id": 121,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "Creature can activate 1"
                },
                {
                    "id": 2575,
                    "argument_list_id": 121,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "Creature can activate 2"
                },
                {
                    "id": 2576,
                    "argument_list_id": 121,
                    "value": "4",
                    "name": "Deactivate",
                    "description": "Creature can deactivate"
                },
                {
                    "id": 2577,
                    "argument_list_id": 121,
                    "value": "8",
                    "name": "Can Hit",
                    "description": "Creature can hit"
                },
                {
                    "id": 2578,
                    "argument_list_id": 121,
                    "value": "64",
                    "name": "Can Eat",
                    "description": "Creature can eat"
                }
            ],
            "variants": 2
        },
        "list_137": {
            "id": 137,
            "variant": "C1",
            "name": "BehaviorTouch",
            "base_values_list_id": 33,
            "arguments": [
                {
                    "id": 2829,
                    "argument_list_id": 137,
                    "value": "0",
                    "name": "No Action",
                    "description": "Creature can take no actions"
                },
                {
                    "id": 2830,
                    "argument_list_id": 137,
                    "value": "1",
                    "name": "Activate 1"
                },
                {
                    "id": 2831,
                    "argument_list_id": 137,
                    "value": "2",
                    "name": "Activate 2"
                },
                {
                    "id": 2832,
                    "argument_list_id": 137,
                    "value": "3",
                    "name": "Activate 1 & 2"
                },
                {
                    "id": 2833,
                    "argument_list_id": 137,
                    "value": "4",
                    "name": "Deactivate"
                },
                {
                    "id": 2834,
                    "argument_list_id": 137,
                    "value": "5",
                    "name": "Activate 1 & Deactivate"
                },
                {
                    "id": 2835,
                    "argument_list_id": 137,
                    "value": "6",
                    "name": "Activate 2 & Deactivate"
                },
                {
                    "id": 2836,
                    "argument_list_id": 137,
                    "value": "7",
                    "name": "Activate 1,2,Deactivate"
                }
            ],
            "variants": 1
        },
        "list_184": {
            "id": 184,
            "variant": "C1",
            "name": "BlackBoardWords",
            "description": "Word identifiers for blackboard words",
            "base_values_list_id": 68,
            "arguments": [
                {
                    "id": 4108,
                    "argument_list_id": 184,
                    "value": "0",
                    "name": "Stay (just look)"
                },
                {
                    "id": 4109,
                    "argument_list_id": 184,
                    "value": "1",
                    "name": "Push"
                },
                {
                    "id": 4110,
                    "argument_list_id": 184,
                    "value": "2",
                    "name": "Pull"
                },
                {
                    "id": 4111,
                    "argument_list_id": 184,
                    "value": "3",
                    "name": "Stop"
                },
                {
                    "id": 4112,
                    "argument_list_id": 184,
                    "value": "4",
                    "name": "Come"
                },
                {
                    "id": 4113,
                    "argument_list_id": 184,
                    "value": "5",
                    "name": "Run"
                },
                {
                    "id": 4114,
                    "argument_list_id": 184,
                    "value": "6",
                    "name": "Get"
                },
                {
                    "id": 4115,
                    "argument_list_id": 184,
                    "value": "7",
                    "name": "Drop"
                },
                {
                    "id": 4116,
                    "argument_list_id": 184,
                    "value": "8",
                    "name": "Think (say need)"
                },
                {
                    "id": 4117,
                    "argument_list_id": 184,
                    "value": "9",
                    "name": "Sleep"
                },
                {
                    "id": 4118,
                    "argument_list_id": 184,
                    "value": "10",
                    "name": "Left"
                },
                {
                    "id": 4119,
                    "argument_list_id": 184,
                    "value": "11",
                    "name": "Right"
                },
                {
                    "id": 4120,
                    "argument_list_id": 184,
                    "value": "16",
                    "name": "<Creature's Name>"
                },
                {
                    "id": 4121,
                    "argument_list_id": 184,
                    "value": "17",
                    "name": "<hand name>",
                    "description": "Classifier: 2 1 x"
                },
                {
                    "id": 4122,
                    "argument_list_id": 184,
                    "value": "18",
                    "name": "Call(lift call button)",
                    "description": "Classifier 2 2 x"
                },
                {
                    "id": 4123,
                    "argument_list_id": 184,
                    "value": "19",
                    "name": "Water",
                    "description": "Classifier: 2 3 x"
                },
                {
                    "id": 4124,
                    "argument_list_id": 184,
                    "value": "20",
                    "name": "Plant (or herb)",
                    "description": "Class: 2 4 x"
                },
                {
                    "id": 4125,
                    "argument_list_id": 184,
                    "value": "21",
                    "name": "Egg",
                    "description": "Class: 2 5 x"
                },
                {
                    "id": 4126,
                    "argument_list_id": 184,
                    "value": "22",
                    "name": "Food",
                    "description": "Class: 2 6 x"
                },
                {
                    "id": 4127,
                    "argument_list_id": 184,
                    "value": "23",
                    "name": "Drink",
                    "description": "Class: 2 7 x"
                },
                {
                    "id": 4128,
                    "argument_list_id": 184,
                    "value": "24",
                    "name": "Vendor",
                    "description": "Class: 2 8 x"
                },
                {
                    "id": 4129,
                    "argument_list_id": 184,
                    "value": "25",
                    "name": "Music",
                    "description": "Class: 2 9 x"
                },
                {
                    "id": 4130,
                    "argument_list_id": 184,
                    "value": "26",
                    "name": "Animal",
                    "description": "Class: 2 10 x"
                },
                {
                    "id": 4131,
                    "argument_list_id": 184,
                    "value": "27",
                    "name": "Fire",
                    "description": "Class: 2 11 x"
                },
                {
                    "id": 4132,
                    "argument_list_id": 184,
                    "value": "28",
                    "name": "Shower/clock",
                    "description": "Class: 2 12 x"
                },
                {
                    "id": 4133,
                    "argument_list_id": 184,
                    "value": "29",
                    "name": "Toy",
                    "description": "Class: 2 13 x"
                },
                {
                    "id": 4134,
                    "argument_list_id": 184,
                    "value": "30",
                    "name": "Big Toy",
                    "description": "Class: 2 14 x"
                },
                {
                    "id": 4135,
                    "argument_list_id": 184,
                    "value": "31",
                    "name": "Weed",
                    "description": "Class: 2 15 x"
                },
                {
                    "id": 4136,
                    "argument_list_id": 184,
                    "value": "42",
                    "name": "Mover",
                    "description": "Class: 3 1 x"
                },
                {
                    "id": 4137,
                    "argument_list_id": 184,
                    "value": "43",
                    "name": "Lift",
                    "description": "Class: 3 2 x"
                },
                {
                    "id": 4138,
                    "argument_list_id": 184,
                    "value": "44",
                    "name": "Computer",
                    "description": "Class: 3 3 x"
                },
                {
                    "id": 4139,
                    "argument_list_id": 184,
                    "value": "45",
                    "name": "Fun (projector)",
                    "description": "Class: 3 4 x"
                },
                {
                    "id": 4140,
                    "argument_list_id": 184,
                    "value": "46",
                    "name": "Bang (cannon)",
                    "description": "Class: 3 5 x"
                },
                {
                    "id": 4141,
                    "argument_list_id": 184,
                    "value": "52",
                    "name": "Norn",
                    "description": "Class: 4 1 x"
                },
                {
                    "id": 4142,
                    "argument_list_id": 184,
                    "value": "53",
                    "name": "Grendel",
                    "description": "Class: 4 2 x"
                },
                {
                    "id": 4143,
                    "argument_list_id": 184,
                    "value": "56",
                    "name": "Hurt"
                },
                {
                    "id": 4144,
                    "argument_list_id": 184,
                    "value": "57",
                    "name": "Sad"
                },
                {
                    "id": 4145,
                    "argument_list_id": 184,
                    "value": "58",
                    "name": "Hungry"
                },
                {
                    "id": 4146,
                    "argument_list_id": 184,
                    "value": "59",
                    "name": "Cold"
                },
                {
                    "id": 4147,
                    "argument_list_id": 184,
                    "value": "60",
                    "name": "Hot"
                },
                {
                    "id": 4148,
                    "argument_list_id": 184,
                    "value": "61",
                    "name": "Tired"
                },
                {
                    "id": 4149,
                    "argument_list_id": 184,
                    "value": "62",
                    "name": "Sleepy"
                },
                {
                    "id": 4150,
                    "argument_list_id": 184,
                    "value": "63",
                    "name": "Lonely"
                },
                {
                    "id": 4151,
                    "argument_list_id": 184,
                    "value": "64",
                    "name": "Cramped"
                },
                {
                    "id": 4152,
                    "argument_list_id": 184,
                    "value": "65",
                    "name": "Afraid"
                },
                {
                    "id": 4153,
                    "argument_list_id": 184,
                    "value": "66",
                    "name": "Bored"
                },
                {
                    "id": 4154,
                    "argument_list_id": 184,
                    "value": "67",
                    "name": "Angry"
                },
                {
                    "id": 4155,
                    "argument_list_id": 184,
                    "value": "68",
                    "name": "Amorous"
                },
                {
                    "id": 4156,
                    "argument_list_id": 184,
                    "value": "72",
                    "name": "Yes",
                    "description": "Reward creature"
                },
                {
                    "id": 4157,
                    "argument_list_id": 184,
                    "value": "73",
                    "name": "No",
                    "description": "Punish creature"
                },
                {
                    "id": 4158,
                    "argument_list_id": 184,
                    "value": "74",
                    "name": "Look",
                    "description": "Helps focus attention on hand or whatever hand is holding or pointing at."
                },
                {
                    "id": 4159,
                    "argument_list_id": 184,
                    "value": "75",
                    "name": "What",
                    "description": "Say whatever action and/or object creature is thinking about."
                }
            ],
            "variants": 1
        },
        "list_187": {
            "id": 187,
            "variant": "C2",
            "name": "BlackBoardWords",
            "description": "Word identifiers for blackboard words",
            "base_values_list_id": 68,
            "arguments": [
                {
                    "id": 4168,
                    "argument_list_id": 187,
                    "value": "0",
                    "name": "Stay"
                },
                {
                    "id": 4169,
                    "argument_list_id": 187,
                    "value": "1",
                    "name": "Push"
                },
                {
                    "id": 4170,
                    "argument_list_id": 187,
                    "value": "2",
                    "name": "Pull"
                },
                {
                    "id": 4171,
                    "argument_list_id": 187,
                    "value": "3",
                    "name": "Stop"
                },
                {
                    "id": 4172,
                    "argument_list_id": 187,
                    "value": "4",
                    "name": "Come"
                },
                {
                    "id": 4173,
                    "argument_list_id": 187,
                    "value": "5",
                    "name": "Run"
                },
                {
                    "id": 4174,
                    "argument_list_id": 187,
                    "value": "6",
                    "name": "Get"
                },
                {
                    "id": 4175,
                    "argument_list_id": 187,
                    "value": "7",
                    "name": "Drop"
                },
                {
                    "id": 4176,
                    "argument_list_id": 187,
                    "value": "8",
                    "name": "Why"
                },
                {
                    "id": 4177,
                    "argument_list_id": 187,
                    "value": "9",
                    "name": "Rest"
                },
                {
                    "id": 4178,
                    "argument_list_id": 187,
                    "value": "10",
                    "name": "Left"
                },
                {
                    "id": 4179,
                    "argument_list_id": 187,
                    "value": "11",
                    "name": "Right"
                },
                {
                    "id": 4180,
                    "argument_list_id": 187,
                    "value": "12",
                    "name": "Eat"
                },
                {
                    "id": 4181,
                    "argument_list_id": 187,
                    "value": "13",
                    "name": "Hit"
                },
                {
                    "id": 4182,
                    "argument_list_id": 187,
                    "value": "14",
                    "name": "<Empty Slot?>"
                },
                {
                    "id": 4183,
                    "argument_list_id": 187,
                    "value": "15",
                    "name": "<Empty Slot?>"
                },
                {
                    "id": 4184,
                    "argument_list_id": 187,
                    "value": "16",
                    "name": "<Creature's Name>"
                },
                {
                    "id": 4185,
                    "argument_list_id": 187,
                    "value": "17",
                    "name": "<Hand>"
                },
                {
                    "id": 4186,
                    "argument_list_id": 187,
                    "value": "18",
                    "name": "Button"
                },
                {
                    "id": 4187,
                    "argument_list_id": 187,
                    "value": "19",
                    "name": "Nature"
                },
                {
                    "id": 4188,
                    "argument_list_id": 187,
                    "value": "20",
                    "name": "Plant"
                },
                {
                    "id": 4189,
                    "argument_list_id": 187,
                    "value": "21",
                    "name": "Egg"
                },
                {
                    "id": 4190,
                    "argument_list_id": 187,
                    "value": "22",
                    "name": "Food",
                    "description": "Classifier: 2 6 x"
                },
                {
                    "id": 4191,
                    "argument_list_id": 187,
                    "value": "23",
                    "name": "Drink",
                    "description": "Classifier: 2 7 x"
                },
                {
                    "id": 4192,
                    "argument_list_id": 187,
                    "value": "24",
                    "name": "Dispenser",
                    "description": "Classifier: 2 8 x"
                },
                {
                    "id": 4193,
                    "argument_list_id": 187,
                    "value": "25",
                    "name": "Implement",
                    "description": "Classifier: 2 9 x"
                },
                {
                    "id": 4194,
                    "argument_list_id": 187,
                    "value": "26",
                    "name": "Cliff Edge",
                    "description": "Classifier: 2 10 x"
                },
                {
                    "id": 4195,
                    "argument_list_id": 187,
                    "value": "27",
                    "name": "Detritus",
                    "description": "Classifier: 2 11 x"
                },
                {
                    "id": 4196,
                    "argument_list_id": 187,
                    "value": "28",
                    "name": "Medicine",
                    "description": "Classifier: 2 12 x"
                },
                {
                    "id": 4197,
                    "argument_list_id": 187,
                    "value": "29",
                    "name": "Toy",
                    "description": "Classifier: 2 13 x"
                },
                {
                    "id": 4198,
                    "argument_list_id": 187,
                    "value": "30",
                    "name": "Weather",
                    "description": "Classifier: 2 14 x"
                },
                {
                    "id": 4199,
                    "argument_list_id": 187,
                    "value": "31",
                    "name": "Badplant",
                    "description": "Classifier: 2 15 x"
                },
                {
                    "id": 4200,
                    "argument_list_id": 187,
                    "value": "32",
                    "name": "Nest",
                    "description": "Classifier: 2 16 x"
                },
                {
                    "id": 4201,
                    "argument_list_id": 187,
                    "value": "33",
                    "name": "Badbug",
                    "description": "Classifier: 2 17 x"
                },
                {
                    "id": 4202,
                    "argument_list_id": 187,
                    "value": "34",
                    "name": "Bug",
                    "description": "Classifier: 2 18 x"
                },
                {
                    "id": 4203,
                    "argument_list_id": 187,
                    "value": "35",
                    "name": "Badcritter",
                    "description": "Classifier: 2 19 x"
                },
                {
                    "id": 4204,
                    "argument_list_id": 187,
                    "value": "36",
                    "name": "Critter",
                    "description": "Classifier: 2 20 x"
                },
                {
                    "id": 4205,
                    "argument_list_id": 187,
                    "value": "37",
                    "name": "Seed",
                    "description": "Classifier: 2 21 x"
                },
                {
                    "id": 4206,
                    "argument_list_id": 187,
                    "value": "38",
                    "name": "Leaf",
                    "description": "Classifier: 2 22 x"
                },
                {
                    "id": 4207,
                    "argument_list_id": 187,
                    "value": "39",
                    "name": "Root",
                    "description": "Classifier: 2 23 x"
                },
                {
                    "id": 4208,
                    "argument_list_id": 187,
                    "value": "40",
                    "name": "Flower",
                    "description": "Classifier: 2 24 x Alt: Alternative class"
                },
                {
                    "id": 4209,
                    "argument_list_id": 187,
                    "value": "41",
                    "name": "Fruit",
                    "description": "Classifier: 2 25 x Alt: -----------------"
                },
                {
                    "id": 4210,
                    "argument_list_id": 187,
                    "value": "42",
                    "name": "Mover",
                    "description": "Classifier: 3 1 x Alt: 2 26 x"
                },
                {
                    "id": 4211,
                    "argument_list_id": 187,
                    "value": "43",
                    "name": "Lift",
                    "description": "Classifier: 3 2 x Alt: 2 27 x"
                },
                {
                    "id": 4212,
                    "argument_list_id": 187,
                    "value": "44",
                    "name": "Computer",
                    "description": "Classifier: 3 3 x Alt: 2 28 x"
                },
                {
                    "id": 4213,
                    "argument_list_id": 187,
                    "value": "45",
                    "name": "Mediabox",
                    "description": "Classifier: 3 4 x Alt: 2 29 x"
                },
                {
                    "id": 4214,
                    "argument_list_id": 187,
                    "value": "46",
                    "name": "Message",
                    "description": "Classifier: 3 5 x Alt: 2 30 x"
                },
                {
                    "id": 4215,
                    "argument_list_id": 187,
                    "value": "47",
                    "name": "Leftright",
                    "description": "Classifier: 3 6 x Alt: 2 31 x"
                },
                {
                    "id": 4216,
                    "argument_list_id": 187,
                    "value": "48",
                    "name": "Incubator",
                    "description": "Classifier: 3 7 x Alt: 2 32 x"
                },
                {
                    "id": 4217,
                    "argument_list_id": 187,
                    "value": "49",
                    "name": "Teleporter",
                    "description": "Classifier: 3 8 x Alt: 2 33 x"
                },
                {
                    "id": 4218,
                    "argument_list_id": 187,
                    "value": "50",
                    "name": "<Empty slot> 3 9 x Alt: 2 34 x"
                },
                {
                    "id": 4219,
                    "argument_list_id": 187,
                    "value": "51",
                    "name": "Machine",
                    "description": "Classifier: 3 10 x Alt: 2 35 x"
                },
                {
                    "id": 4220,
                    "argument_list_id": 187,
                    "value": "52",
                    "name": "Norn",
                    "description": "Classifier: 4 1 x Alt: 2 36 x"
                },
                {
                    "id": 4221,
                    "argument_list_id": 187,
                    "value": "53",
                    "name": "Grendel",
                    "description": "Classifier: 4 2 x Alt: 2 37 x"
                },
                {
                    "id": 4222,
                    "argument_list_id": 187,
                    "value": "54",
                    "name": "Ettin",
                    "description": "Classifier: 4 3 x Alt: 2 38 x"
                },
                {
                    "id": 4223,
                    "argument_list_id": 187,
                    "value": "55",
                    "name": "Shee",
                    "description": "Classifier: 4 4 x; Alt: 2 39 x"
                },
                {
                    "id": 4225,
                    "argument_list_id": 187,
                    "value": "56",
                    "name": "Pain"
                },
                {
                    "id": 4226,
                    "argument_list_id": 187,
                    "value": "57",
                    "name": "Sad"
                },
                {
                    "id": 4227,
                    "argument_list_id": 187,
                    "value": "58",
                    "name": "Hungry"
                },
                {
                    "id": 4228,
                    "argument_list_id": 187,
                    "value": "59",
                    "name": "Cold"
                },
                {
                    "id": 4229,
                    "argument_list_id": 187,
                    "value": "60",
                    "name": "Hot"
                },
                {
                    "id": 4230,
                    "argument_list_id": 187,
                    "value": "61",
                    "name": "Tired"
                },
                {
                    "id": 4231,
                    "argument_list_id": 187,
                    "value": "62",
                    "name": "Sleepy"
                },
                {
                    "id": 4232,
                    "argument_list_id": 187,
                    "value": "63",
                    "name": "Lonely"
                },
                {
                    "id": 4233,
                    "argument_list_id": 187,
                    "value": "64",
                    "name": "Crowded"
                },
                {
                    "id": 4234,
                    "argument_list_id": 187,
                    "value": "65",
                    "name": "Scared"
                },
                {
                    "id": 4235,
                    "argument_list_id": 187,
                    "value": "66",
                    "name": "Bored"
                },
                {
                    "id": 4236,
                    "argument_list_id": 187,
                    "value": "67",
                    "name": "Angry"
                },
                {
                    "id": 4237,
                    "argument_list_id": 187,
                    "value": "68",
                    "name": "Friendly"
                },
                {
                    "id": 4238,
                    "argument_list_id": 187,
                    "value": "69",
                    "name": "Hurt"
                },
                {
                    "id": 4239,
                    "argument_list_id": 187,
                    "value": "70",
                    "name": "Choking"
                },
                {
                    "id": 4240,
                    "argument_list_id": 187,
                    "value": "71",
                    "name": "Thirsty"
                },
                {
                    "id": 4241,
                    "argument_list_id": 187,
                    "value": "72",
                    "name": "Stressed"
                },
                {
                    "id": 4242,
                    "argument_list_id": 187,
                    "value": "73",
                    "name": "Yes",
                    "description": "Reward creature (creature will not react)."
                },
                {
                    "id": 4243,
                    "argument_list_id": 187,
                    "value": "74",
                    "name": "No",
                    "description": "Punish creature (creature will flinch)."
                },
                {
                    "id": 4244,
                    "argument_list_id": 187,
                    "value": "75",
                    "name": "Look",
                    "description": "Helps focus attention on hand or whatever hand is holding or pointing at."
                },
                {
                    "id": 4245,
                    "argument_list_id": 187,
                    "value": "76",
                    "name": "What",
                    "description": "Say whatever action and/or object creature is thinking about."
                },
                {
                    "id": 4246,
                    "argument_list_id": 187,
                    "value": "77",
                    "name": "Very"
                },
                {
                    "id": 4247,
                    "argument_list_id": 187,
                    "value": "78",
                    "name": "Really"
                },
                {
                    "id": 4248,
                    "argument_list_id": 187,
                    "value": "79",
                    "name": "Seriously"
                },
                {
                    "id": 4249,
                    "argument_list_id": 187,
                    "value": "80",
                    "name": "Intensely"
                },
                {
                    "id": 4250,
                    "argument_list_id": 187,
                    "value": "81",
                    "name": "Extremely"
                }
            ],
            "variants": 2
        },
        "list_185": {
            "id": 185,
            "variant": "AL",
            "name": "Bump",
            "description": "Vehicle collision bump values",
            "extension_type": "BitFlags",
            "base_values_list_id": 69,
            "arguments": [
                {
                    "id": 4160,
                    "argument_list_id": 185,
                    "value": "1",
                    "name": "Left"
                },
                {
                    "id": 4161,
                    "argument_list_id": 185,
                    "value": "2",
                    "name": "Right"
                },
                {
                    "id": 4162,
                    "argument_list_id": 185,
                    "value": "4",
                    "name": "Top"
                },
                {
                    "id": 4163,
                    "argument_list_id": 185,
                    "value": "8",
                    "name": "Bottom"
                }
            ],
            "variants": 3
        },
        "list_285": {
            "id": 285,
            "variant": "AL",
            "name": "CameraPan",
            "description": "How should the camera move to track target",
            "arguments": [
                {
                    "id": 8245,
                    "argument_list_id": 285,
                    "value": "0",
                    "name": "jump",
                    "description": "jump straight to location"
                },
                {
                    "id": 8246,
                    "argument_list_id": 285,
                    "value": "1",
                    "name": "smooth",
                    "description": "Smooth scroll to location unless in another metaroom"
                },
                {
                    "id": 8247,
                    "argument_list_id": 285,
                    "value": "2",
                    "name": "SmoothInView",
                    "description": "smooth scroll only if the destination is already visible"
                }
            ],
            "variants": 24
        },
        "list_167": {
            "id": 167,
            "variant": "AL",
            "name": "CanMove",
            "extension_type": "bool",
            "base_values_list_id": 52,
            "arguments": [
                {
                    "id": 3724,
                    "argument_list_id": 167,
                    "value": "0",
                    "name": "Cannot Move"
                },
                {
                    "id": 3725,
                    "argument_list_id": 167,
                    "value": "1",
                    "name": "Can Move"
                }
            ],
            "variants": 60
        },
        "list_169": {
            "id": 169,
            "variant": "AL",
            "name": "CanSee",
            "extension_type": "bool",
            "base_values_list_id": 54,
            "arguments": [
                {
                    "id": 3728,
                    "argument_list_id": 169,
                    "value": "0",
                    "name": "Cannot See"
                },
                {
                    "id": 3729,
                    "argument_list_id": 169,
                    "value": "1",
                    "name": "Can See"
                }
            ],
            "variants": 60
        },
        "list_211": {
            "id": 211,
            "variant": "AL",
            "name": "CaosSortOrder",
            "base_values_list_id": 90,
            "arguments": [
                {
                    "id": 4324,
                    "argument_list_id": 211,
                    "value": "0",
                    "name": "Alphabetical"
                },
                {
                    "id": 4325,
                    "argument_list_id": 211,
                    "value": "1",
                    "name": "Categorical"
                }
            ],
            "variants": 60
        },
        "list_96": {
            "id": 96,
            "variant": "AL",
            "name": "CardinalDirection",
            "base_values_list_id": 29,
            "arguments": [
                {
                    "id": 1219,
                    "argument_list_id": 96,
                    "value": "0",
                    "name": "North (back to viewer)"
                },
                {
                    "id": 1220,
                    "argument_list_id": 96,
                    "value": "1",
                    "name": "South (facing viewer)"
                },
                {
                    "id": 1221,
                    "argument_list_id": 96,
                    "value": "2",
                    "name": "East"
                },
                {
                    "id": 1222,
                    "argument_list_id": 96,
                    "value": "3",
                    "name": "West"
                }
            ],
            "variants": 62
        },
        "list_183": {
            "id": 183,
            "variant": "AL",
            "name": "CAs",
            "description": "Agent smells",
            "base_values_list_id": 67,
            "arguments": [
                {
                    "id": 4090,
                    "argument_list_id": 183,
                    "value": "0",
                    "name": "<not used>"
                },
                {
                    "id": 4091,
                    "argument_list_id": 183,
                    "value": "1",
                    "name": "Light"
                },
                {
                    "id": 4092,
                    "argument_list_id": 183,
                    "value": "2",
                    "name": "Heat"
                },
                {
                    "id": 4093,
                    "argument_list_id": 183,
                    "value": "3",
                    "name": "Water (Soil)",
                    "description": "Soil moisture only"
                },
                {
                    "id": 4094,
                    "argument_list_id": 183,
                    "value": "4",
                    "name": "Nutrients"
                },
                {
                    "id": 4095,
                    "argument_list_id": 183,
                    "value": "5",
                    "name": "Water (Bodies of)",
                    "description": "Bodies of water"
                },
                {
                    "id": 4096,
                    "argument_list_id": 183,
                    "value": "6",
                    "name": "Protein"
                },
                {
                    "id": 4097,
                    "argument_list_id": 183,
                    "value": "7",
                    "name": "Carbohydrate"
                },
                {
                    "id": 4098,
                    "argument_list_id": 183,
                    "value": "8",
                    "name": "Fat"
                },
                {
                    "id": 4099,
                    "argument_list_id": 183,
                    "value": "9",
                    "name": "<not used>"
                },
                {
                    "id": 4100,
                    "argument_list_id": 183,
                    "value": "10",
                    "name": "Machinery"
                },
                {
                    "id": 4101,
                    "argument_list_id": 183,
                    "value": "11",
                    "name": "Creature Egg Smell"
                },
                {
                    "id": 4102,
                    "argument_list_id": 183,
                    "value": "12",
                    "name": "Norns"
                },
                {
                    "id": 4103,
                    "argument_list_id": 183,
                    "value": "13",
                    "name": "Grendels"
                },
                {
                    "id": 4104,
                    "argument_list_id": 183,
                    "value": "14",
                    "name": "Ettins"
                },
                {
                    "id": 4105,
                    "argument_list_id": 183,
                    "value": "15",
                    "name": "Norn homes"
                },
                {
                    "id": 4106,
                    "argument_list_id": 183,
                    "value": "16",
                    "name": "Grendel homes"
                },
                {
                    "id": 4107,
                    "argument_list_id": 183,
                    "value": "17",
                    "name": "Ettin homes"
                },
                {
                    "id": 5919,
                    "argument_list_id": 183,
                    "value": "18",
                    "name": "Gadgets"
                }
            ],
            "variants": 56
        },
        "list_244": {
            "id": 244,
            "variant": "CV",
            "name": "CAs",
            "description": "Agent Smells",
            "base_values_list_id": 67,
            "arguments": [
                {
                    "id": 5920,
                    "argument_list_id": 244,
                    "value": "1",
                    "name": "Movers",
                    "description": "Movers (2 2 0)"
                },
                {
                    "id": 5921,
                    "argument_list_id": 244,
                    "value": "2",
                    "name": "Anims",
                    "description": "Animated toys that lower boredom and raise sleepiness (2 3 0)"
                },
                {
                    "id": 5922,
                    "argument_list_id": 244,
                    "value": "3",
                    "name": "Lonelies",
                    "description": "Toys that reduce boredom and loneliness (2 8 0)"
                },
                {
                    "id": 5923,
                    "argument_list_id": 244,
                    "value": "4",
                    "name": "Instruments",
                    "description": "Instruments (2 11 0)"
                },
                {
                    "id": 5924,
                    "argument_list_id": 244,
                    "value": "5",
                    "name": "Clothes",
                    "description": "Clothes (2 26 0)"
                },
                {
                    "id": 5925,
                    "argument_list_id": 244,
                    "value": "7",
                    "name": "Protein",
                    "description": "(2 22 0)"
                },
                {
                    "id": 5926,
                    "argument_list_id": 244,
                    "value": "8",
                    "name": "Fat",
                    "description": "ie. Cake (2 23 0)"
                },
                {
                    "id": 5927,
                    "argument_list_id": 244,
                    "value": "9",
                    "name": "Carbohydrates",
                    "description": "ie.Carrots, fruit (2 24 0)"
                },
                {
                    "id": 5928,
                    "argument_list_id": 244,
                    "value": "10",
                    "name": "Food Vendors",
                    "description": "(2 35 0)"
                },
                {
                    "id": 5929,
                    "argument_list_id": 244,
                    "value": "11",
                    "name": "Scaries",
                    "description": "Things that go bump in the night and scare norns."
                },
                {
                    "id": 5930,
                    "argument_list_id": 244,
                    "value": "12",
                    "name": "Male Norns"
                },
                {
                    "id": 5931,
                    "argument_list_id": 244,
                    "value": "13",
                    "name": "Female Norns"
                }
            ],
            "variants": 4
        },
        "list_79": {
            "id": 79,
            "variant": "C1",
            "name": "Chemicals",
            "base_values_list_id": 13,
            "arguments": [
                {
                    "id": 1022,
                    "argument_list_id": 79,
                    "value": "0",
                    "name": "<NONE>"
                },
                {
                    "id": 1023,
                    "argument_list_id": 79,
                    "value": "1",
                    "name": "Pain"
                },
                {
                    "id": 1024,
                    "argument_list_id": 79,
                    "value": "2",
                    "name": "Need for Pleasure"
                },
                {
                    "id": 1025,
                    "argument_list_id": 79,
                    "value": "3",
                    "name": "Hunger"
                },
                {
                    "id": 1026,
                    "argument_list_id": 79,
                    "value": "4",
                    "name": "Coldness"
                },
                {
                    "id": 1027,
                    "argument_list_id": 79,
                    "value": "5",
                    "name": "Hotness"
                },
                {
                    "id": 1028,
                    "argument_list_id": 79,
                    "value": "6",
                    "name": "Tiredness"
                },
                {
                    "id": 1029,
                    "argument_list_id": 79,
                    "value": "7",
                    "name": "Sleepiness"
                },
                {
                    "id": 1030,
                    "argument_list_id": 79,
                    "value": "8",
                    "name": "Loneliness"
                },
                {
                    "id": 1031,
                    "argument_list_id": 79,
                    "value": "9",
                    "name": "Crowded"
                },
                {
                    "id": 1032,
                    "argument_list_id": 79,
                    "value": "10",
                    "name": "Fear"
                },
                {
                    "id": 1033,
                    "argument_list_id": 79,
                    "value": "11",
                    "name": "Boredom"
                },
                {
                    "id": 1034,
                    "argument_list_id": 79,
                    "value": "12",
                    "name": "Anger"
                },
                {
                    "id": 1035,
                    "argument_list_id": 79,
                    "value": "13",
                    "name": "Sex Drive"
                },
                {
                    "id": 1036,
                    "argument_list_id": 79,
                    "value": "17",
                    "name": "Pain Increase"
                },
                {
                    "id": 1037,
                    "argument_list_id": 79,
                    "value": "18",
                    "name": "Need for Pleasure Increase"
                },
                {
                    "id": 1038,
                    "argument_list_id": 79,
                    "value": "19",
                    "name": "Hunger Increase"
                },
                {
                    "id": 1039,
                    "argument_list_id": 79,
                    "value": "20",
                    "name": "Coldness Increase"
                },
                {
                    "id": 1040,
                    "argument_list_id": 79,
                    "value": "21",
                    "name": "Hotness Increase"
                },
                {
                    "id": 1041,
                    "argument_list_id": 79,
                    "value": "22",
                    "name": "Tiredness Increase"
                },
                {
                    "id": 1042,
                    "argument_list_id": 79,
                    "value": "23",
                    "name": "Sleepiness Increase"
                },
                {
                    "id": 1043,
                    "argument_list_id": 79,
                    "value": "24",
                    "name": "Loneliness Increase"
                },
                {
                    "id": 1044,
                    "argument_list_id": 79,
                    "value": "25",
                    "name": "Crowded Increase"
                },
                {
                    "id": 1045,
                    "argument_list_id": 79,
                    "value": "26",
                    "name": "Fear Increase"
                },
                {
                    "id": 1046,
                    "argument_list_id": 79,
                    "value": "27",
                    "name": "Boredom Increase"
                },
                {
                    "id": 1047,
                    "argument_list_id": 79,
                    "value": "28",
                    "name": "Anger Increase"
                },
                {
                    "id": 1048,
                    "argument_list_id": 79,
                    "value": "29",
                    "name": "Sex Drive Increase"
                },
                {
                    "id": 1049,
                    "argument_list_id": 79,
                    "value": "33",
                    "name": "Pain Decrease"
                },
                {
                    "id": 1050,
                    "argument_list_id": 79,
                    "value": "34",
                    "name": "Need for Pleasure Decrease"
                },
                {
                    "id": 1051,
                    "argument_list_id": 79,
                    "value": "35",
                    "name": "Hunger Decrease",
                    "description": "Saccharin is a sweetener only. It has no nutritional value (unlike carbohydrate) but satisfies hunger. (hi sugar lo carb = junk food!)"
                },
                {
                    "id": 1052,
                    "argument_list_id": 79,
                    "value": "36",
                    "name": "Coldness Decrease"
                },
                {
                    "id": 1053,
                    "argument_list_id": 79,
                    "value": "37",
                    "name": "Hotness Decrease"
                },
                {
                    "id": 1054,
                    "argument_list_id": 79,
                    "value": "38",
                    "name": "Tiredness Decrease"
                },
                {
                    "id": 1055,
                    "argument_list_id": 79,
                    "value": "39",
                    "name": "Sleepiness Decrease"
                },
                {
                    "id": 1056,
                    "argument_list_id": 79,
                    "value": "40",
                    "name": "Loneliness Decrease"
                },
                {
                    "id": 1057,
                    "argument_list_id": 79,
                    "value": "41",
                    "name": "Crowded Decrease"
                },
                {
                    "id": 1058,
                    "argument_list_id": 79,
                    "value": "42",
                    "name": "Fear Decrease"
                },
                {
                    "id": 1059,
                    "argument_list_id": 79,
                    "value": "43",
                    "name": "Boredom Decrease"
                },
                {
                    "id": 1060,
                    "argument_list_id": 79,
                    "value": "44",
                    "name": "Anger Decrease"
                },
                {
                    "id": 1061,
                    "argument_list_id": 79,
                    "value": "45",
                    "name": "Sex Drive Decrease"
                },
                {
                    "id": 1062,
                    "argument_list_id": 79,
                    "value": "49",
                    "name": "Reward",
                    "description": "learning reinforcer"
                },
                {
                    "id": 1063,
                    "argument_list_id": 79,
                    "value": "50",
                    "name": "Punishment",
                    "description": "learning reinforcer"
                },
                {
                    "id": 1064,
                    "argument_list_id": 79,
                    "value": "51",
                    "name": "Reinforcement",
                    "description": "Both punishment and reward chems decay to produce this shortlife chemical It allows eg concept space dens to get stronger when ANY form of reinforcement occurs"
                },
                {
                    "id": 1065,
                    "argument_list_id": 79,
                    "value": "52",
                    "name": "ConASH",
                    "description": "Concept layer Atrophy Suppressing Hormone  emitted by loose CON NEUS  stops further con neu dens from atrophying thus ensuring a minimal supply of unallocated cells for new concepts"
                },
                {
                    "id": 1066,
                    "argument_list_id": 79,
                    "value": "53",
                    "name": "DecASH1",
                    "description": "Decision layer Atrophy Suppressing Hormone  emitted by loose DEC DENS type0  stops further dec dens from atrophying thus ensuring a minimal supply of unallocated dens for new associations"
                },
                {
                    "id": 1067,
                    "argument_list_id": 79,
                    "value": "54",
                    "name": "Reward Echo",
                    "description": "Reward chem must decay rapidly this longer lasting chem is generated during that decay Useful chem to monitor to see if reward has occurred Biochemical use as a measure of recent reward"
                },
                {
                    "id": 1068,
                    "argument_list_id": 79,
                    "value": "55",
                    "name": "Punish Echo",
                    "description": "Punishment chem must decay rapidly this longer lasting chem is generated during that decay Useful chem to monitor to see if punishment has occurred Biochemical use as a measure of recent punishment"
                },
                {
                    "id": 1069,
                    "argument_list_id": 79,
                    "value": "56",
                    "name": "Ageing",
                    "description": "Decays over time switching on receptors to change the stage of life from embryo through to senile Stage changes then switch on new genes"
                },
                {
                    "id": 1070,
                    "argument_list_id": 79,
                    "value": "57",
                    "name": "Starch",
                    "description": "Emitted by food objects  converts to Glucose for energy Does NOT decrease hunger  this is done directly by Hunger saccharin so that junk food can contain high saccharin levels but low starch etcZ"
                },
                {
                    "id": 1071,
                    "argument_list_id": 79,
                    "value": "58",
                    "name": "Glucose",
                    "description": "Produced from starch and in a reversible reaction from glycogen Used up by muscle action"
                },
                {
                    "id": 1072,
                    "argument_list_id": 79,
                    "value": "59",
                    "name": "Glycogen",
                    "description": "LIFEFORCE Longterm energy reserve produced in reversible reaction from glucose Produces Glucose to replenish supplies for muscle action Absence of Glycogen is life threatningp"
                },
                {
                    "id": 1073,
                    "argument_list_id": 79,
                    "value": "60",
                    "name": "Waste Water",
                    "description": "Waste product from the conversion of glucose to energy May deplete naturally or may cause behaviour changes"
                },
                {
                    "id": 1074,
                    "argument_list_id": 79,
                    "value": "61",
                    "name": "Hexokinase",
                    "description": "Enzyme Converts glucose to Urea during the production of energy Emitted by muscles as they demand energy Consumed in the reaction to prevent residue"
                },
                {
                    "id": 1075,
                    "argument_list_id": 79,
                    "value": "62",
                    "name": "Carbon Dioxide",
                    "description": "CO2 is produced by muscle action Its a useful indicator of shortterm average energy consumption and could be used to simulate heart rate or similar data for plots"
                },
                {
                    "id": 1076,
                    "argument_list_id": 79,
                    "value": "63",
                    "name": "Oestrogen",
                    "description": "Controls fertility cycle in females"
                },
                {
                    "id": 1077,
                    "argument_list_id": 79,
                    "value": "64",
                    "name": "Testosterone",
                    "description": "Controls fertility in males"
                },
                {
                    "id": 1078,
                    "argument_list_id": 79,
                    "value": "65",
                    "name": "Gonadotrophin",
                    "description": "Produced immediately when pregnant in large quantities Used to eg suppress menstrual cycle"
                },
                {
                    "id": 1079,
                    "argument_list_id": 79,
                    "value": "66",
                    "name": "Progesterone",
                    "description": "Produced progressively during pregnancy When it reaches a threshold it fires a receptor to cause the egg to be laid"
                },
                {
                    "id": 1080,
                    "argument_list_id": 79,
                    "value": "67",
                    "name": "Glycotoxin",
                    "description": "Extreme poison  breaks down Glycogen Fatal if Gly falls to zero"
                },
                {
                    "id": 1081,
                    "argument_list_id": 79,
                    "value": "68",
                    "name": "Alcohol",
                    "description": "Ingested from fermented fruit etc Causes drunken gait and possible sickness etc"
                },
                {
                    "id": 1082,
                    "argument_list_id": 79,
                    "value": "69",
                    "name": "Adrenaline",
                    "description": "Natural adrenaline level builds up due to stress from excessive boredom anger and suchlike Has various deleterious effects on health"
                },
                {
                    "id": 1083,
                    "argument_list_id": 79,
                    "value": "70",
                    "name": "DecASH2",
                    "description": "Decision layer Atrophy Suppressing Hormone  emitted by loose DEC DENS type1  stops further dec dens from atrophying thus ensuring a minimal suppky of unallocated dens for new associations6"
                },
                {
                    "id": 1084,
                    "argument_list_id": 79,
                    "value": "71",
                    "name": "Vitamin E",
                    "description": "Fat Soluble vitamin deficiency can cause infertility"
                },
                {
                    "id": 1085,
                    "argument_list_id": 79,
                    "value": "72",
                    "name": "Vitamin C",
                    "description": "Water soluble vitamin used to mantian healthy connective tissue"
                },
                {
                    "id": 1086,
                    "argument_list_id": 79,
                    "value": "80",
                    "name": "Purple Mountain Alcohol[ aka Dancing].",
                    "description": "Reduces Need for Pleasure and Boredom over time. Present in the Purple Mountain Norns, and the Life Kit norns."
                },
                {
                    "id": 1087,
                    "argument_list_id": 79,
                    "value": "91",
                    "name": "Activase",
                    "description": "Produced by muscle action in Forest Norns and Ron Norns. Reacts with Adrenaline to reduce fear and anger."
                },
                {
                    "id": 1088,
                    "argument_list_id": 79,
                    "value": "92",
                    "name": "Turnase",
                    "description": "Produced when the Norn is cornered or a creature is approaching. Converts fear to anger."
                },
                {
                    "id": 1089,
                    "argument_list_id": 79,
                    "value": "93",
                    "name": "Collapsase",
                    "description": "Generated by Retreating. Converts anger to fear."
                },
                {
                    "id": 1090,
                    "argument_list_id": 79,
                    "value": "100",
                    "name": "Energy",
                    "description": "for IV"
                },
                {
                    "id": 1091,
                    "argument_list_id": 79,
                    "value": "101",
                    "name": "Adrenaline",
                    "description": "for IV"
                },
                {
                    "id": 1092,
                    "argument_list_id": 79,
                    "value": "102",
                    "name": "Pain Killer",
                    "description": "for IV"
                },
                {
                    "id": 1093,
                    "argument_list_id": 79,
                    "value": "103",
                    "name": "Cough Medicine",
                    "description": "for IV"
                },
                {
                    "id": 1094,
                    "argument_list_id": 79,
                    "value": "104",
                    "name": "Sleeping Pill",
                    "description": "for IV"
                },
                {
                    "id": 1095,
                    "argument_list_id": 79,
                    "value": "105",
                    "name": "Wake-Up Pill",
                    "description": "for IV"
                },
                {
                    "id": 1096,
                    "argument_list_id": 79,
                    "value": "106",
                    "name": "Anti-Oxidant",
                    "description": "for IV"
                },
                {
                    "id": 1097,
                    "argument_list_id": 79,
                    "value": "231",
                    "name": "Geddonase",
                    "description": "Geddonase attacks both glycogen and glucose, making it a more potent toxin than glycotoxin.\nThis chemical is only present in Purple Mountain, Ron and Forest norns"
                },
                {
                    "id": 1098,
                    "argument_list_id": 79,
                    "value": "232",
                    "name": "Histamine A",
                    "description": "Produced by some bacteria; causes sneezing (thus making disease contagious)."
                },
                {
                    "id": 1099,
                    "argument_list_id": 79,
                    "value": "233",
                    "name": "Histamine B",
                    "description": "Same as histamine A, but causes coughing instead of sneezing and is not cured by Cough Medicine."
                },
                {
                    "id": 1100,
                    "argument_list_id": 79,
                    "value": "234",
                    "name": "Sleep toxin",
                    "description": "Produced by some bacteria; causes sleepiness"
                },
                {
                    "id": 1101,
                    "argument_list_id": 79,
                    "value": "235",
                    "name": "Fever toxin",
                    "description": "Produced by some bacteria; raises body temperature."
                },
                {
                    "id": 1102,
                    "argument_list_id": 79,
                    "value": "240",
                    "name": "Antibody 0"
                },
                {
                    "id": 1103,
                    "argument_list_id": 79,
                    "value": "241",
                    "name": "Antibody 1"
                },
                {
                    "id": 1104,
                    "argument_list_id": 79,
                    "value": "242",
                    "name": "Antibody 2"
                },
                {
                    "id": 1105,
                    "argument_list_id": 79,
                    "value": "243",
                    "name": "Antibody 3"
                },
                {
                    "id": 1106,
                    "argument_list_id": 79,
                    "value": "244",
                    "name": "Antibody 4"
                },
                {
                    "id": 1107,
                    "argument_list_id": 79,
                    "value": "245",
                    "name": "Antibody 5"
                },
                {
                    "id": 1108,
                    "argument_list_id": 79,
                    "value": "246",
                    "name": "Antibody 6"
                },
                {
                    "id": 1109,
                    "argument_list_id": 79,
                    "value": "247",
                    "name": "Antibody 7"
                },
                {
                    "id": 1110,
                    "argument_list_id": 79,
                    "value": "248",
                    "name": "Antigen 0"
                },
                {
                    "id": 1111,
                    "argument_list_id": 79,
                    "value": "249",
                    "name": "Antigen 1"
                },
                {
                    "id": 1112,
                    "argument_list_id": 79,
                    "value": "250",
                    "name": "Antigen 2"
                },
                {
                    "id": 1113,
                    "argument_list_id": 79,
                    "value": "251",
                    "name": "Antigen 3"
                },
                {
                    "id": 1114,
                    "argument_list_id": 79,
                    "value": "252",
                    "name": "Antigen 4"
                },
                {
                    "id": 1115,
                    "argument_list_id": 79,
                    "value": "253",
                    "name": "Antigen 5"
                },
                {
                    "id": 1116,
                    "argument_list_id": 79,
                    "value": "254",
                    "name": "Antigen 6"
                },
                {
                    "id": 1117,
                    "argument_list_id": 79,
                    "value": "255",
                    "name": "Antigen 7"
                }
            ],
            "variants": 1
        },
        "list_135": {
            "id": 135,
            "variant": "C2",
            "name": "Chemicals",
            "base_values_list_id": 13,
            "arguments": [
                {
                    "id": 5932,
                    "argument_list_id": 135,
                    "value": "0",
                    "name": "<NOTHING>"
                },
                {
                    "id": 3861,
                    "argument_list_id": 135,
                    "value": "1",
                    "name": "Pain"
                },
                {
                    "id": 3862,
                    "argument_list_id": 135,
                    "value": "2",
                    "name": "Need for Pleasure"
                },
                {
                    "id": 3863,
                    "argument_list_id": 135,
                    "value": "3",
                    "name": "Hunger"
                },
                {
                    "id": 3864,
                    "argument_list_id": 135,
                    "value": "4",
                    "name": "Coldness"
                },
                {
                    "id": 3865,
                    "argument_list_id": 135,
                    "value": "5",
                    "name": "Hotness"
                },
                {
                    "id": 3866,
                    "argument_list_id": 135,
                    "value": "6",
                    "name": "Tiredness"
                },
                {
                    "id": 3867,
                    "argument_list_id": 135,
                    "value": "7",
                    "name": "Sleepiness"
                },
                {
                    "id": 3868,
                    "argument_list_id": 135,
                    "value": "8",
                    "name": "Loneliness"
                },
                {
                    "id": 3869,
                    "argument_list_id": 135,
                    "value": "9",
                    "name": "Crowded"
                },
                {
                    "id": 3870,
                    "argument_list_id": 135,
                    "value": "10",
                    "name": "Fear"
                },
                {
                    "id": 3871,
                    "argument_list_id": 135,
                    "value": "11",
                    "name": "Boredom"
                },
                {
                    "id": 3872,
                    "argument_list_id": 135,
                    "value": "12",
                    "name": "Anger"
                },
                {
                    "id": 3873,
                    "argument_list_id": 135,
                    "value": "13",
                    "name": "Sex Drive"
                },
                {
                    "id": 3874,
                    "argument_list_id": 135,
                    "value": "14",
                    "name": "Injury"
                },
                {
                    "id": 3875,
                    "argument_list_id": 135,
                    "value": "15",
                    "name": "Suffocation"
                },
                {
                    "id": 3876,
                    "argument_list_id": 135,
                    "value": "16",
                    "name": "Thirst"
                },
                {
                    "id": 3877,
                    "argument_list_id": 135,
                    "value": "17",
                    "name": "Stress"
                },
                {
                    "id": 3878,
                    "argument_list_id": 135,
                    "value": "18",
                    "name": "Pain Increase"
                },
                {
                    "id": 3879,
                    "argument_list_id": 135,
                    "value": "19",
                    "name": "Need for Pleasure Increase"
                },
                {
                    "id": 3880,
                    "argument_list_id": 135,
                    "value": "20",
                    "name": "Hunger Increase"
                },
                {
                    "id": 3881,
                    "argument_list_id": 135,
                    "value": "21",
                    "name": "Coldness Increase"
                },
                {
                    "id": 3882,
                    "argument_list_id": 135,
                    "value": "22",
                    "name": "Hotness Increase"
                },
                {
                    "id": 3883,
                    "argument_list_id": 135,
                    "value": "23",
                    "name": "Tiredness Increase"
                },
                {
                    "id": 3884,
                    "argument_list_id": 135,
                    "value": "24",
                    "name": "Sleepiness Increase"
                },
                {
                    "id": 3885,
                    "argument_list_id": 135,
                    "value": "25",
                    "name": "Loneliness Increase"
                },
                {
                    "id": 3886,
                    "argument_list_id": 135,
                    "value": "26",
                    "name": "Crowded Increase"
                },
                {
                    "id": 3887,
                    "argument_list_id": 135,
                    "value": "27",
                    "name": "Fear Increase"
                },
                {
                    "id": 3888,
                    "argument_list_id": 135,
                    "value": "28",
                    "name": "Boredom Increase"
                },
                {
                    "id": 3889,
                    "argument_list_id": 135,
                    "value": "29",
                    "name": "Anger Increase"
                },
                {
                    "id": 3890,
                    "argument_list_id": 135,
                    "value": "30",
                    "name": "Sex Drive Increase"
                },
                {
                    "id": 3891,
                    "argument_list_id": 135,
                    "value": "31",
                    "name": "Injury Increase"
                },
                {
                    "id": 3892,
                    "argument_list_id": 135,
                    "value": "32",
                    "name": "Suffocation Increase"
                },
                {
                    "id": 3893,
                    "argument_list_id": 135,
                    "value": "33",
                    "name": "Thirst Increase"
                },
                {
                    "id": 3894,
                    "argument_list_id": 135,
                    "value": "34",
                    "name": "Stress Increase"
                },
                {
                    "id": 3895,
                    "argument_list_id": 135,
                    "value": "35",
                    "name": "Pain Decrease"
                },
                {
                    "id": 3896,
                    "argument_list_id": 135,
                    "value": "36",
                    "name": "Need for Pleasure Decrease"
                },
                {
                    "id": 3897,
                    "argument_list_id": 135,
                    "value": "37",
                    "name": "Hunger Decrease"
                },
                {
                    "id": 3898,
                    "argument_list_id": 135,
                    "value": "38",
                    "name": "Coldness Decrease"
                },
                {
                    "id": 3899,
                    "argument_list_id": 135,
                    "value": "39",
                    "name": "Hotness Decrease"
                },
                {
                    "id": 3900,
                    "argument_list_id": 135,
                    "value": "40",
                    "name": "Tiredness Decrease"
                },
                {
                    "id": 3901,
                    "argument_list_id": 135,
                    "value": "41",
                    "name": "Sleepiness Decrease"
                },
                {
                    "id": 3902,
                    "argument_list_id": 135,
                    "value": "42",
                    "name": "Loneliness Decrease"
                },
                {
                    "id": 3903,
                    "argument_list_id": 135,
                    "value": "43",
                    "name": "Crowded Decrease"
                },
                {
                    "id": 3904,
                    "argument_list_id": 135,
                    "value": "44",
                    "name": "Fear Decrease"
                },
                {
                    "id": 3905,
                    "argument_list_id": 135,
                    "value": "45",
                    "name": "Boredom Decrease"
                },
                {
                    "id": 3906,
                    "argument_list_id": 135,
                    "value": "46",
                    "name": "Anger Decrease"
                },
                {
                    "id": 3907,
                    "argument_list_id": 135,
                    "value": "47",
                    "name": "Sex Drive Decrease"
                },
                {
                    "id": 3908,
                    "argument_list_id": 135,
                    "value": "48",
                    "name": "Injury Decrease"
                },
                {
                    "id": 3909,
                    "argument_list_id": 135,
                    "value": "49",
                    "name": "Suffocation Decrease"
                },
                {
                    "id": 3910,
                    "argument_list_id": 135,
                    "value": "50",
                    "name": "Thirst Decrease"
                },
                {
                    "id": 3911,
                    "argument_list_id": 135,
                    "value": "51",
                    "name": "Stress Decrease"
                },
                {
                    "id": 3912,
                    "argument_list_id": 135,
                    "value": "52",
                    "name": "Reward"
                },
                {
                    "id": 3913,
                    "argument_list_id": 135,
                    "value": "53",
                    "name": "Punishment"
                },
                {
                    "id": 3914,
                    "argument_list_id": 135,
                    "value": "54",
                    "name": "Reinforcement"
                },
                {
                    "id": 3915,
                    "argument_list_id": 135,
                    "value": "55",
                    "name": "ConASH"
                },
                {
                    "id": 3916,
                    "argument_list_id": 135,
                    "value": "56",
                    "name": "DecASH1"
                },
                {
                    "id": 3917,
                    "argument_list_id": 135,
                    "value": "57",
                    "name": "Reward Echo"
                },
                {
                    "id": 3918,
                    "argument_list_id": 135,
                    "value": "58",
                    "name": "Punish Echo"
                },
                {
                    "id": 3919,
                    "argument_list_id": 135,
                    "value": "59",
                    "name": "DecASH2"
                },
                {
                    "id": 3920,
                    "argument_list_id": 135,
                    "value": "68",
                    "name": "Lactate"
                },
                {
                    "id": 3921,
                    "argument_list_id": 135,
                    "value": "69",
                    "name": "Pyruvate"
                },
                {
                    "id": 3922,
                    "argument_list_id": 135,
                    "value": "70",
                    "name": "Glucose"
                },
                {
                    "id": 3923,
                    "argument_list_id": 135,
                    "value": "71",
                    "name": "Fatty Acid"
                },
                {
                    "id": 3924,
                    "argument_list_id": 135,
                    "value": "72",
                    "name": "Glycogen"
                },
                {
                    "id": 3925,
                    "argument_list_id": 135,
                    "value": "73",
                    "name": "Starch"
                },
                {
                    "id": 3926,
                    "argument_list_id": 135,
                    "value": "74",
                    "name": "Fat"
                },
                {
                    "id": 3927,
                    "argument_list_id": 135,
                    "value": "75",
                    "name": "Adipose Tissue"
                },
                {
                    "id": 3928,
                    "argument_list_id": 135,
                    "value": "76",
                    "name": "Ageing"
                },
                {
                    "id": 3929,
                    "argument_list_id": 135,
                    "value": "77",
                    "name": "Muscle Tissue"
                },
                {
                    "id": 3930,
                    "argument_list_id": 135,
                    "value": "78",
                    "name": "Triglyceride"
                },
                {
                    "id": 3931,
                    "argument_list_id": 135,
                    "value": "79",
                    "name": "Protein"
                },
                {
                    "id": 3932,
                    "argument_list_id": 135,
                    "value": "80",
                    "name": "Amino Acid"
                },
                {
                    "id": 3933,
                    "argument_list_id": 135,
                    "value": "90",
                    "name": "Carbon Dioxide"
                },
                {
                    "id": 3934,
                    "argument_list_id": 135,
                    "value": "92",
                    "name": "Urea"
                },
                {
                    "id": 3935,
                    "argument_list_id": 135,
                    "value": "93",
                    "name": "Ammonia"
                },
                {
                    "id": 3936,
                    "argument_list_id": 135,
                    "value": "95",
                    "name": "Oxygen"
                },
                {
                    "id": 3937,
                    "argument_list_id": 135,
                    "value": "96",
                    "name": "Air"
                },
                {
                    "id": 3938,
                    "argument_list_id": 135,
                    "value": "97",
                    "name": "Water"
                },
                {
                    "id": 3939,
                    "argument_list_id": 135,
                    "value": "98",
                    "name": "Energy"
                },
                {
                    "id": 3940,
                    "argument_list_id": 135,
                    "value": "104",
                    "name": "Bilin"
                },
                {
                    "id": 3941,
                    "argument_list_id": 135,
                    "value": "105",
                    "name": "Oestrogen"
                },
                {
                    "id": 3942,
                    "argument_list_id": 135,
                    "value": "106",
                    "name": "Testosterone"
                },
                {
                    "id": 3943,
                    "argument_list_id": 135,
                    "value": "107",
                    "name": "Gonadotrophin"
                },
                {
                    "id": 3944,
                    "argument_list_id": 135,
                    "value": "108",
                    "name": "Progesterone"
                },
                {
                    "id": 3945,
                    "argument_list_id": 135,
                    "value": "109",
                    "name": "Inhibin"
                },
                {
                    "id": 3946,
                    "argument_list_id": 135,
                    "value": "110",
                    "name": "LH"
                },
                {
                    "id": 3947,
                    "argument_list_id": 135,
                    "value": "111",
                    "name": "FSH"
                },
                {
                    "id": 3948,
                    "argument_list_id": 135,
                    "value": "112",
                    "name": "Steroidone"
                },
                {
                    "id": 3949,
                    "argument_list_id": 135,
                    "value": "113",
                    "name": "Cholesterol"
                },
                {
                    "id": 3950,
                    "argument_list_id": 135,
                    "value": "114",
                    "name": "Arousal Potential"
                },
                {
                    "id": 3951,
                    "argument_list_id": 135,
                    "value": "115",
                    "name": "Mating Pheramone"
                },
                {
                    "id": 3952,
                    "argument_list_id": 135,
                    "value": "116",
                    "name": "Species Pheramone"
                },
                {
                    "id": 3953,
                    "argument_list_id": 135,
                    "value": "117",
                    "name": "Parent Pheramone"
                },
                {
                    "id": 3954,
                    "argument_list_id": 135,
                    "value": "118",
                    "name": "Child Pheramone"
                },
                {
                    "id": 3955,
                    "argument_list_id": 135,
                    "value": "119",
                    "name": "Sibling Pheramone"
                },
                {
                    "id": 3956,
                    "argument_list_id": 135,
                    "value": "120",
                    "name": "Opposite Sex Pheramone"
                },
                {
                    "id": 3957,
                    "argument_list_id": 135,
                    "value": "121",
                    "name": "Norn Smell"
                },
                {
                    "id": 3958,
                    "argument_list_id": 135,
                    "value": "122",
                    "name": "Grendel smell"
                },
                {
                    "id": 3959,
                    "argument_list_id": 135,
                    "value": "123",
                    "name": "Ettin smell"
                },
                {
                    "id": 3960,
                    "argument_list_id": 135,
                    "value": "140",
                    "name": "Heavy Metals"
                },
                {
                    "id": 3961,
                    "argument_list_id": 135,
                    "value": "141",
                    "name": "Cyanide"
                },
                {
                    "id": 3962,
                    "argument_list_id": 135,
                    "value": "143",
                    "name": "Belladonna"
                },
                {
                    "id": 3963,
                    "argument_list_id": 135,
                    "value": "144",
                    "name": "Geddonase"
                },
                {
                    "id": 3964,
                    "argument_list_id": 135,
                    "value": "145",
                    "name": "Glycotoxin"
                },
                {
                    "id": 3965,
                    "argument_list_id": 135,
                    "value": "146",
                    "name": "Fullness"
                },
                {
                    "id": 3966,
                    "argument_list_id": 135,
                    "value": "150",
                    "name": "Vitamin E"
                },
                {
                    "id": 3967,
                    "argument_list_id": 135,
                    "value": "151",
                    "name": "Vitamin C"
                },
                {
                    "id": 3968,
                    "argument_list_id": 135,
                    "value": "152",
                    "name": "Bile Acid"
                },
                {
                    "id": 3969,
                    "argument_list_id": 135,
                    "value": "153",
                    "name": "Insulin Shots"
                },
                {
                    "id": 3970,
                    "argument_list_id": 135,
                    "value": "154",
                    "name": "Glycogen Synthetase"
                },
                {
                    "id": 3971,
                    "argument_list_id": 135,
                    "value": "155",
                    "name": "Dehydrogenase"
                },
                {
                    "id": 3972,
                    "argument_list_id": 135,
                    "value": "156",
                    "name": "Prostaglandin"
                },
                {
                    "id": 3973,
                    "argument_list_id": 135,
                    "value": "157",
                    "name": "EDTA"
                },
                {
                    "id": 3974,
                    "argument_list_id": 135,
                    "value": "158",
                    "name": "Sodium thiosulphite"
                },
                {
                    "id": 3975,
                    "argument_list_id": 135,
                    "value": "159",
                    "name": "Arnica"
                },
                {
                    "id": 3976,
                    "argument_list_id": 135,
                    "value": "168",
                    "name": "Tyrosine"
                },
                {
                    "id": 3977,
                    "argument_list_id": 135,
                    "value": "169",
                    "name": "Triptophan"
                },
                {
                    "id": 3978,
                    "argument_list_id": 135,
                    "value": "170",
                    "name": "Alcohol"
                },
                {
                    "id": 3979,
                    "argument_list_id": 135,
                    "value": "171",
                    "name": "Dancing"
                },
                {
                    "id": 3980,
                    "argument_list_id": 135,
                    "value": "172",
                    "name": "Adrenaline"
                },
                {
                    "id": 3981,
                    "argument_list_id": 135,
                    "value": "173",
                    "name": "Hexokinase"
                },
                {
                    "id": 3982,
                    "argument_list_id": 135,
                    "value": "174",
                    "name": "Activase"
                },
                {
                    "id": 3983,
                    "argument_list_id": 135,
                    "value": "175",
                    "name": "Turnase"
                },
                {
                    "id": 3984,
                    "argument_list_id": 135,
                    "value": "176",
                    "name": "Collapsase"
                },
                {
                    "id": 3985,
                    "argument_list_id": 135,
                    "value": "177",
                    "name": "Downatrophin"
                },
                {
                    "id": 3986,
                    "argument_list_id": 135,
                    "value": "178",
                    "name": "Upatrophin"
                },
                {
                    "id": 3987,
                    "argument_list_id": 135,
                    "value": "232",
                    "name": "Histamine A"
                },
                {
                    "id": 3988,
                    "argument_list_id": 135,
                    "value": "233",
                    "name": "Histamine B"
                },
                {
                    "id": 3989,
                    "argument_list_id": 135,
                    "value": "234",
                    "name": "Sleep toxin"
                },
                {
                    "id": 3990,
                    "argument_list_id": 135,
                    "value": "235",
                    "name": "Fever toxin"
                },
                {
                    "id": 3991,
                    "argument_list_id": 135,
                    "value": "236",
                    "name": "Unknown Toxin"
                },
                {
                    "id": 3992,
                    "argument_list_id": 135,
                    "value": "237",
                    "name": "Unknown Toxin"
                },
                {
                    "id": 3993,
                    "argument_list_id": 135,
                    "value": "238",
                    "name": "Unknown Toxin"
                },
                {
                    "id": 3994,
                    "argument_list_id": 135,
                    "value": "239",
                    "name": "Unknown Toxin"
                },
                {
                    "id": 3995,
                    "argument_list_id": 135,
                    "value": "240",
                    "name": "Antibody 0"
                },
                {
                    "id": 3996,
                    "argument_list_id": 135,
                    "value": "241",
                    "name": "Antibody 1"
                },
                {
                    "id": 3997,
                    "argument_list_id": 135,
                    "value": "242",
                    "name": "Antibody 2"
                },
                {
                    "id": 3998,
                    "argument_list_id": 135,
                    "value": "243",
                    "name": "Antibody 3"
                },
                {
                    "id": 3999,
                    "argument_list_id": 135,
                    "value": "244",
                    "name": "Antibody 4"
                },
                {
                    "id": 4000,
                    "argument_list_id": 135,
                    "value": "245",
                    "name": "Antibody 5"
                },
                {
                    "id": 4001,
                    "argument_list_id": 135,
                    "value": "246",
                    "name": "Antibody 6"
                },
                {
                    "id": 4002,
                    "argument_list_id": 135,
                    "value": "247",
                    "name": "Antibody 7"
                },
                {
                    "id": 4003,
                    "argument_list_id": 135,
                    "value": "248",
                    "name": "Antigen 0"
                },
                {
                    "id": 4004,
                    "argument_list_id": 135,
                    "value": "249",
                    "name": "Antigen 1"
                },
                {
                    "id": 4005,
                    "argument_list_id": 135,
                    "value": "250",
                    "name": "Antigen 2"
                },
                {
                    "id": 4006,
                    "argument_list_id": 135,
                    "value": "251",
                    "name": "Antigen 3"
                },
                {
                    "id": 4007,
                    "argument_list_id": 135,
                    "value": "252",
                    "name": "Antigen 4"
                },
                {
                    "id": 4008,
                    "argument_list_id": 135,
                    "value": "253",
                    "name": "Antigen 5"
                },
                {
                    "id": 4009,
                    "argument_list_id": 135,
                    "value": "254",
                    "name": "Antigen 6"
                },
                {
                    "id": 4010,
                    "argument_list_id": 135,
                    "value": "255",
                    "name": "Antigen 7"
                }
            ],
            "variants": 2
        },
        "list_140": {
            "id": 140,
            "variant": "AL",
            "name": "Chemicals",
            "base_values_list_id": 13,
            "arguments": [
                {
                    "id": 5933,
                    "argument_list_id": 140,
                    "value": "0",
                    "name": "<NOTHING>"
                },
                {
                    "id": 2938,
                    "argument_list_id": 140,
                    "value": "1",
                    "name": "Lactate"
                },
                {
                    "id": 2939,
                    "argument_list_id": 140,
                    "value": "2",
                    "name": "Pyruvate"
                },
                {
                    "id": 2940,
                    "argument_list_id": 140,
                    "value": "3",
                    "name": "Glucose"
                },
                {
                    "id": 2941,
                    "argument_list_id": 140,
                    "value": "4",
                    "name": "Glycogen"
                },
                {
                    "id": 2942,
                    "argument_list_id": 140,
                    "value": "5",
                    "name": "Starch"
                },
                {
                    "id": 2943,
                    "argument_list_id": 140,
                    "value": "6",
                    "name": "Fatty acid"
                },
                {
                    "id": 2944,
                    "argument_list_id": 140,
                    "value": "7",
                    "name": "Cholesterol"
                },
                {
                    "id": 2945,
                    "argument_list_id": 140,
                    "value": "8",
                    "name": "Triglyceride"
                },
                {
                    "id": 2946,
                    "argument_list_id": 140,
                    "value": "9",
                    "name": "Adipose tissue"
                },
                {
                    "id": 2947,
                    "argument_list_id": 140,
                    "value": "10",
                    "name": "Fat"
                },
                {
                    "id": 2948,
                    "argument_list_id": 140,
                    "value": "11",
                    "name": "Muscle tissue"
                },
                {
                    "id": 2949,
                    "argument_list_id": 140,
                    "value": "12",
                    "name": "Protein"
                },
                {
                    "id": 2950,
                    "argument_list_id": 140,
                    "value": "13",
                    "name": "Amino acid"
                },
                {
                    "id": 2951,
                    "argument_list_id": 140,
                    "value": "17",
                    "name": "Downatrophin"
                },
                {
                    "id": 2952,
                    "argument_list_id": 140,
                    "value": "18",
                    "name": "Upatrophin"
                },
                {
                    "id": 2953,
                    "argument_list_id": 140,
                    "value": "24",
                    "name": "Dissolved carbon dioxide"
                },
                {
                    "id": 2954,
                    "argument_list_id": 140,
                    "value": "25",
                    "name": "Urea"
                },
                {
                    "id": 2955,
                    "argument_list_id": 140,
                    "value": "26",
                    "name": "Ammonia"
                },
                {
                    "id": 2956,
                    "argument_list_id": 140,
                    "value": "29",
                    "name": "Air"
                },
                {
                    "id": 2957,
                    "argument_list_id": 140,
                    "value": "30",
                    "name": "Oxygen"
                },
                {
                    "id": 2958,
                    "argument_list_id": 140,
                    "value": "33",
                    "name": "Water"
                },
                {
                    "id": 2959,
                    "argument_list_id": 140,
                    "value": "34",
                    "name": "Energy"
                },
                {
                    "id": 2960,
                    "argument_list_id": 140,
                    "value": "35",
                    "name": "ATP"
                },
                {
                    "id": 2961,
                    "argument_list_id": 140,
                    "value": "36",
                    "name": "ADP"
                },
                {
                    "id": 2962,
                    "argument_list_id": 140,
                    "value": "39",
                    "name": "Arousal potential"
                },
                {
                    "id": 2963,
                    "argument_list_id": 140,
                    "value": "40",
                    "name": "Libido lowerer"
                },
                {
                    "id": 2964,
                    "argument_list_id": 140,
                    "value": "41",
                    "name": "Opposite sex pheromone"
                },
                {
                    "id": 2965,
                    "argument_list_id": 140,
                    "value": "46",
                    "name": "Oestrogen"
                },
                {
                    "id": 2966,
                    "argument_list_id": 140,
                    "value": "48",
                    "name": "Progesterone"
                },
                {
                    "id": 2967,
                    "argument_list_id": 140,
                    "value": "53",
                    "name": "Testosterone"
                },
                {
                    "id": 2968,
                    "argument_list_id": 140,
                    "value": "54",
                    "name": "Inhibin"
                },
                {
                    "id": 2969,
                    "argument_list_id": 140,
                    "value": "66",
                    "name": "Heavy metals"
                },
                {
                    "id": 2970,
                    "argument_list_id": 140,
                    "value": "67",
                    "name": "Cyanide"
                },
                {
                    "id": 2971,
                    "argument_list_id": 140,
                    "value": "68",
                    "name": "Belladonna"
                },
                {
                    "id": 2972,
                    "argument_list_id": 140,
                    "value": "69",
                    "name": "Geddonase"
                },
                {
                    "id": 2973,
                    "argument_list_id": 140,
                    "value": "70",
                    "name": "Glycotoxin"
                },
                {
                    "id": 2974,
                    "argument_list_id": 140,
                    "value": "71",
                    "name": "Sleep toxin"
                },
                {
                    "id": 2975,
                    "argument_list_id": 140,
                    "value": "72",
                    "name": "Fever toxin"
                },
                {
                    "id": 2976,
                    "argument_list_id": 140,
                    "value": "73",
                    "name": "Histamine A"
                },
                {
                    "id": 2977,
                    "argument_list_id": 140,
                    "value": "74",
                    "name": "Histamine B"
                },
                {
                    "id": 2978,
                    "argument_list_id": 140,
                    "value": "75",
                    "name": "Alcohol"
                },
                {
                    "id": 2979,
                    "argument_list_id": 140,
                    "value": "78",
                    "name": "ATP decoupler",
                    "description": "Instant death"
                },
                {
                    "id": 2980,
                    "argument_list_id": 140,
                    "value": "79",
                    "name": "Carbon monoxide"
                },
                {
                    "id": 2981,
                    "argument_list_id": 140,
                    "value": "80",
                    "name": "Fear toxin"
                },
                {
                    "id": 2982,
                    "argument_list_id": 140,
                    "value": "81",
                    "name": "Muscle toxin"
                },
                {
                    "id": 2983,
                    "argument_list_id": 140,
                    "value": "82",
                    "name": "Antigen 0",
                    "description": "Histamine B"
                },
                {
                    "id": 2984,
                    "argument_list_id": 140,
                    "value": "83",
                    "name": "Antigen 1",
                    "description": "Histamine A"
                },
                {
                    "id": 2985,
                    "argument_list_id": 140,
                    "value": "84",
                    "name": "Antigen 2",
                    "description": "Coldness"
                },
                {
                    "id": 2986,
                    "argument_list_id": 140,
                    "value": "85",
                    "name": "Antigen 3",
                    "description": "Coldness"
                },
                {
                    "id": 2987,
                    "argument_list_id": 140,
                    "value": "86",
                    "name": "Antigen 4",
                    "description": "Hotness"
                },
                {
                    "id": 2988,
                    "argument_list_id": 140,
                    "value": "87",
                    "name": "Antigen 5",
                    "description": "Wounded"
                },
                {
                    "id": 2989,
                    "argument_list_id": 140,
                    "value": "88",
                    "name": "Antigen 6",
                    "description": "Hotness"
                },
                {
                    "id": 2990,
                    "argument_list_id": 140,
                    "value": "89",
                    "name": "Antigen 7",
                    "description": "Pain"
                },
                {
                    "id": 2991,
                    "argument_list_id": 140,
                    "value": "90",
                    "name": "Wounded",
                    "description": "Dangerous"
                },
                {
                    "id": 2992,
                    "argument_list_id": 140,
                    "value": "92",
                    "name": "Medicine one",
                    "description": "Cures ATP decoupler poisoning, but it's nearly impossible to get it in fast enough."
                },
                {
                    "id": 2993,
                    "argument_list_id": 140,
                    "value": "93",
                    "name": "Anti-oxidant",
                    "description": "Cures carbon monoxide poisoning."
                },
                {
                    "id": 2994,
                    "argument_list_id": 140,
                    "value": "94",
                    "name": "Prostaglandin",
                    "description": "Aids in healing from injuries."
                },
                {
                    "id": 2995,
                    "argument_list_id": 140,
                    "value": "95",
                    "name": "EDTA",
                    "description": "Cures heavy metal poisoning."
                },
                {
                    "id": 2996,
                    "argument_list_id": 140,
                    "value": "96",
                    "name": "Sodium thiosulphate",
                    "description": "Cures cyanide poisoning."
                },
                {
                    "id": 2997,
                    "argument_list_id": 140,
                    "value": "97",
                    "name": "Arnica",
                    "description": "Cures glycotoxin poisoning."
                },
                {
                    "id": 2998,
                    "argument_list_id": 140,
                    "value": "98",
                    "name": "Vitamin E",
                    "description": "Keeps reproductive organs healthy."
                },
                {
                    "id": 2999,
                    "argument_list_id": 140,
                    "value": "99",
                    "name": "Vitamin C",
                    "description": "Keeps bones healthy, aids in healing from injuries."
                },
                {
                    "id": 3000,
                    "argument_list_id": 140,
                    "value": "100",
                    "name": "Antihistamine",
                    "description": "Combats histamines, stopping sneezing and coughing."
                },
                {
                    "id": 9413,
                    "argument_list_id": 140,
                    "value": "102",
                    "name": "ANTIBODY 0"
                },
                {
                    "id": 9414,
                    "argument_list_id": 140,
                    "value": "103",
                    "name": "ANTIBODY 1"
                },
                {
                    "id": 9415,
                    "argument_list_id": 140,
                    "value": "104",
                    "name": "ANTIBODY 2"
                },
                {
                    "id": 9416,
                    "argument_list_id": 140,
                    "value": "105",
                    "name": "ANTIBODY 3"
                },
                {
                    "id": 9417,
                    "argument_list_id": 140,
                    "value": "106",
                    "name": "ANTIBODY 4"
                },
                {
                    "id": 9418,
                    "argument_list_id": 140,
                    "value": "107",
                    "name": "ANTIBODY 5"
                },
                {
                    "id": 9419,
                    "argument_list_id": 140,
                    "value": "108",
                    "name": "ANTIBODY 6"
                },
                {
                    "id": 9420,
                    "argument_list_id": 140,
                    "value": "109",
                    "name": "ANTIBODY 7"
                },
                {
                    "id": 3001,
                    "argument_list_id": 140,
                    "value": "112",
                    "name": "Anabolic steroid"
                },
                {
                    "id": 3002,
                    "argument_list_id": 140,
                    "value": "113",
                    "name": "Pistle"
                },
                {
                    "id": 3003,
                    "argument_list_id": 140,
                    "value": "114",
                    "name": "Insulin"
                },
                {
                    "id": 3004,
                    "argument_list_id": 140,
                    "value": "115",
                    "name": "Glycolase"
                },
                {
                    "id": 3005,
                    "argument_list_id": 140,
                    "value": "116",
                    "name": "Dehydrogenase"
                },
                {
                    "id": 3006,
                    "argument_list_id": 140,
                    "value": "117",
                    "name": "Adrenaline"
                },
                {
                    "id": 3007,
                    "argument_list_id": 140,
                    "value": "118",
                    "name": "Grendel nitrate"
                },
                {
                    "id": 3008,
                    "argument_list_id": 140,
                    "value": "119",
                    "name": "Ettin nitrate"
                },
                {
                    "id": 3009,
                    "argument_list_id": 140,
                    "value": "121",
                    "name": "Protease"
                },
                {
                    "id": 3010,
                    "argument_list_id": 140,
                    "value": "124",
                    "name": "Activase"
                },
                {
                    "id": 3011,
                    "argument_list_id": 140,
                    "value": "125",
                    "name": "Life"
                },
                {
                    "id": 3012,
                    "argument_list_id": 140,
                    "value": "127",
                    "name": "Injury"
                },
                {
                    "id": 3013,
                    "argument_list_id": 140,
                    "value": "128",
                    "name": "Stress"
                },
                {
                    "id": 3014,
                    "argument_list_id": 140,
                    "value": "129",
                    "name": "Sleepase"
                },
                {
                    "id": 3015,
                    "argument_list_id": 140,
                    "value": "131",
                    "name": "Pain backup"
                },
                {
                    "id": 3016,
                    "argument_list_id": 140,
                    "value": "132",
                    "name": "Hunger for protein backup"
                },
                {
                    "id": 3017,
                    "argument_list_id": 140,
                    "value": "133",
                    "name": "Hunger for carb backup"
                },
                {
                    "id": 3018,
                    "argument_list_id": 140,
                    "value": "134",
                    "name": "Hunger for fat backup"
                },
                {
                    "id": 3019,
                    "argument_list_id": 140,
                    "value": "135",
                    "name": "Coldness backup"
                },
                {
                    "id": 3020,
                    "argument_list_id": 140,
                    "value": "136",
                    "name": "Hotness backup"
                },
                {
                    "id": 3021,
                    "argument_list_id": 140,
                    "value": "137",
                    "name": "Tiredness backup"
                },
                {
                    "id": 3022,
                    "argument_list_id": 140,
                    "value": "138",
                    "name": "Sleepiness backup"
                },
                {
                    "id": 3023,
                    "argument_list_id": 140,
                    "value": "139",
                    "name": "Loneliness backup"
                },
                {
                    "id": 3024,
                    "argument_list_id": 140,
                    "value": "140",
                    "name": "Crowdedness backup"
                },
                {
                    "id": 3025,
                    "argument_list_id": 140,
                    "value": "141",
                    "name": "Fear backup"
                },
                {
                    "id": 3026,
                    "argument_list_id": 140,
                    "value": "142",
                    "name": "Boredom backup"
                },
                {
                    "id": 3027,
                    "argument_list_id": 140,
                    "value": "143",
                    "name": "Anger backup"
                },
                {
                    "id": 3028,
                    "argument_list_id": 140,
                    "value": "144",
                    "name": "Sex drive backup"
                },
                {
                    "id": 3029,
                    "argument_list_id": 140,
                    "value": "145",
                    "name": "Comfort drive backup"
                },
                {
                    "id": 3030,
                    "argument_list_id": 140,
                    "value": "148",
                    "name": "Pain"
                },
                {
                    "id": 3031,
                    "argument_list_id": 140,
                    "value": "149",
                    "name": "Hunger for protein"
                },
                {
                    "id": 3032,
                    "argument_list_id": 140,
                    "value": "150",
                    "name": "Hunger for carb"
                },
                {
                    "id": 3033,
                    "argument_list_id": 140,
                    "value": "151",
                    "name": "Hunger for fat"
                },
                {
                    "id": 3034,
                    "argument_list_id": 140,
                    "value": "152",
                    "name": "Coldness"
                },
                {
                    "id": 3035,
                    "argument_list_id": 140,
                    "value": "153",
                    "name": "Hotness"
                },
                {
                    "id": 3036,
                    "argument_list_id": 140,
                    "value": "154",
                    "name": "Tiredness"
                },
                {
                    "id": 3037,
                    "argument_list_id": 140,
                    "value": "155",
                    "name": "Sleepiness"
                },
                {
                    "id": 3038,
                    "argument_list_id": 140,
                    "value": "156",
                    "name": "Loneliness"
                },
                {
                    "id": 3039,
                    "argument_list_id": 140,
                    "value": "157",
                    "name": "Crowded"
                },
                {
                    "id": 3040,
                    "argument_list_id": 140,
                    "value": "158",
                    "name": "Fear"
                },
                {
                    "id": 3041,
                    "argument_list_id": 140,
                    "value": "159",
                    "name": "Boredom"
                },
                {
                    "id": 3042,
                    "argument_list_id": 140,
                    "value": "160",
                    "name": "Anger"
                },
                {
                    "id": 3043,
                    "argument_list_id": 140,
                    "value": "161",
                    "name": "Sex Drive"
                },
                {
                    "id": 3044,
                    "argument_list_id": 140,
                    "value": "162",
                    "name": "Comfort drive"
                },
                {
                    "id": 3045,
                    "argument_list_id": 140,
                    "value": "165",
                    "name": "CA Sound"
                },
                {
                    "id": 3046,
                    "argument_list_id": 140,
                    "value": "166",
                    "name": "CA Light"
                },
                {
                    "id": 3047,
                    "argument_list_id": 140,
                    "value": "167",
                    "name": "CA Heat"
                },
                {
                    "id": 3048,
                    "argument_list_id": 140,
                    "value": "168",
                    "name": "CA Water (from the sky)"
                },
                {
                    "id": 3049,
                    "argument_list_id": 140,
                    "value": "169",
                    "name": "CA Nutrient (plants)"
                },
                {
                    "id": 3050,
                    "argument_list_id": 140,
                    "value": "170",
                    "name": "CA Water (bodies of)"
                },
                {
                    "id": 3051,
                    "argument_list_id": 140,
                    "value": "171",
                    "name": "CA Protein"
                },
                {
                    "id": 3052,
                    "argument_list_id": 140,
                    "value": "172",
                    "name": "CA Carbohydrate"
                },
                {
                    "id": 3053,
                    "argument_list_id": 140,
                    "value": "173",
                    "name": "CA Fat"
                },
                {
                    "id": 3054,
                    "argument_list_id": 140,
                    "value": "174",
                    "name": "CA Flowers"
                },
                {
                    "id": 3055,
                    "argument_list_id": 140,
                    "value": "175",
                    "name": "CA Machinery"
                },
                {
                    "id": 3056,
                    "argument_list_id": 140,
                    "value": "176",
                    "name": "CA Creature egg"
                },
                {
                    "id": 3057,
                    "argument_list_id": 140,
                    "value": "177",
                    "name": "CA Norn smell"
                },
                {
                    "id": 3058,
                    "argument_list_id": 140,
                    "value": "178",
                    "name": "CA Grendel smell"
                },
                {
                    "id": 3059,
                    "argument_list_id": 140,
                    "value": "179",
                    "name": "CA Ettin smell"
                },
                {
                    "id": 3060,
                    "argument_list_id": 140,
                    "value": "180",
                    "name": "CA Norn home smell"
                },
                {
                    "id": 3061,
                    "argument_list_id": 140,
                    "value": "181",
                    "name": "CA Grendel home smell"
                },
                {
                    "id": 3062,
                    "argument_list_id": 140,
                    "value": "182",
                    "name": "CA Ettin home smell"
                },
                {
                    "id": 3063,
                    "argument_list_id": 140,
                    "value": "183",
                    "name": "CA Gadget smell"
                },
                {
                    "id": 3064,
                    "argument_list_id": 140,
                    "value": "184",
                    "name": "CA smell 19 [not used]"
                },
                {
                    "id": 3065,
                    "argument_list_id": 140,
                    "value": "187",
                    "name": "Stress (high H4C) [hunger for carbohydrate]"
                },
                {
                    "id": 3066,
                    "argument_list_id": 140,
                    "value": "188",
                    "name": "Stress (high H4P) [hunger for protein]"
                },
                {
                    "id": 3067,
                    "argument_list_id": 140,
                    "value": "189",
                    "name": "Stress (high H4F) [hunger for fat]"
                },
                {
                    "id": 3068,
                    "argument_list_id": 140,
                    "value": "190",
                    "name": "Stress (high Anger)"
                },
                {
                    "id": 3069,
                    "argument_list_id": 140,
                    "value": "191",
                    "name": "Stress (high Fear)"
                },
                {
                    "id": 3070,
                    "argument_list_id": 140,
                    "value": "192",
                    "name": "Stress (high Pain)"
                },
                {
                    "id": 3071,
                    "argument_list_id": 140,
                    "value": "193",
                    "name": "Stress (high Tired)"
                },
                {
                    "id": 3072,
                    "argument_list_id": 140,
                    "value": "194",
                    "name": "Stress (high Sleep)"
                },
                {
                    "id": 3073,
                    "argument_list_id": 140,
                    "value": "195",
                    "name": "Stress (high Crowded)"
                },
                {
                    "id": 3074,
                    "argument_list_id": 140,
                    "value": "198",
                    "name": "Disappointment",
                    "description": "Produced when the creature tries something that doesn't work."
                },
                {
                    "id": 3075,
                    "argument_list_id": 140,
                    "value": "199",
                    "name": "Up",
                    "before_region": "Navigation"
                },
                {
                    "id": 3076,
                    "argument_list_id": 140,
                    "value": "200",
                    "name": "Down"
                },
                {
                    "id": 3077,
                    "argument_list_id": 140,
                    "value": "201",
                    "name": "Exit"
                },
                {
                    "id": 3078,
                    "argument_list_id": 140,
                    "value": "202",
                    "name": "Enter"
                },
                {
                    "id": 3079,
                    "argument_list_id": 140,
                    "value": "203",
                    "name": "Wait"
                },
                {
                    "id": 3080,
                    "argument_list_id": 140,
                    "value": "204",
                    "name": "Reward",
                    "description": "Produced when the Hand rewards the creature."
                },
                {
                    "id": 3081,
                    "argument_list_id": 140,
                    "value": "205",
                    "name": "Punishment",
                    "description": "Produced when the Hand punishes the creature."
                },
                {
                    "id": 3082,
                    "argument_list_id": 140,
                    "value": "206",
                    "name": "Brain chemical 9",
                    "description": "Not used."
                },
                {
                    "id": 3083,
                    "argument_list_id": 140,
                    "value": "207",
                    "name": "Brain chemical 10",
                    "description": "Not used."
                },
                {
                    "id": 3084,
                    "argument_list_id": 140,
                    "value": "208",
                    "name": "Brain chemical 11",
                    "description": "Not used."
                },
                {
                    "id": 3085,
                    "argument_list_id": 140,
                    "value": "209",
                    "name": "Brain chemical 12",
                    "description": "Not used."
                },
                {
                    "id": 3086,
                    "argument_list_id": 140,
                    "value": "210",
                    "name": "Brain chemical 13",
                    "description": "Not used."
                },
                {
                    "id": 3087,
                    "argument_list_id": 140,
                    "value": "211",
                    "name": "Brain chemical 14",
                    "description": "Not used."
                },
                {
                    "id": 3088,
                    "argument_list_id": 140,
                    "value": "212",
                    "name": "Pre-REM",
                    "description": "Controls dreaming. Your creature learns its instinctual behaviors while it dreams."
                },
                {
                    "id": 3089,
                    "argument_list_id": 140,
                    "value": "213",
                    "name": "REM",
                    "description": "Controls dreaming."
                }
            ],
            "variants": 56
        },
        "list_233": {
            "id": 233,
            "variant": "CV",
            "name": "Chemicals",
            "base_values_list_id": 13,
            "arguments": [
                {
                    "id": 5755,
                    "argument_list_id": 233,
                    "value": "0",
                    "name": "<<NOTHING>>",
                    "description": "There is no chemical zero - it's used internally as a placeholder"
                },
                {
                    "id": 5756,
                    "argument_list_id": 233,
                    "value": "1",
                    "name": "Lactate"
                },
                {
                    "id": 5757,
                    "argument_list_id": 233,
                    "value": "2",
                    "name": "Pyruvate"
                },
                {
                    "id": 5758,
                    "argument_list_id": 233,
                    "value": "3",
                    "name": "Glucose"
                },
                {
                    "id": 5759,
                    "argument_list_id": 233,
                    "value": "4",
                    "name": "Glycogen"
                },
                {
                    "id": 5760,
                    "argument_list_id": 233,
                    "value": "5",
                    "name": "Starch"
                },
                {
                    "id": 5761,
                    "argument_list_id": 233,
                    "value": "6",
                    "name": "Fatty Acid"
                },
                {
                    "id": 5762,
                    "argument_list_id": 233,
                    "value": "7",
                    "name": "Cholesterol"
                },
                {
                    "id": 5763,
                    "argument_list_id": 233,
                    "value": "8",
                    "name": "Triglyceride"
                },
                {
                    "id": 5764,
                    "argument_list_id": 233,
                    "value": "9",
                    "name": "Adipose Tissue"
                },
                {
                    "id": 5765,
                    "argument_list_id": 233,
                    "value": "10",
                    "name": "Fat"
                },
                {
                    "id": 5766,
                    "argument_list_id": 233,
                    "value": "11",
                    "name": "Muscle Tissue"
                },
                {
                    "id": 5767,
                    "argument_list_id": 233,
                    "value": "12",
                    "name": "Protein"
                },
                {
                    "id": 5768,
                    "argument_list_id": 233,
                    "value": "13",
                    "name": "Amino Acid"
                },
                {
                    "id": 5769,
                    "argument_list_id": 233,
                    "value": "14",
                    "name": "Fullness"
                },
                {
                    "id": 5770,
                    "argument_list_id": 233,
                    "value": "17",
                    "name": "Downatrophin"
                },
                {
                    "id": 5771,
                    "argument_list_id": 233,
                    "value": "18",
                    "name": "Upatrophin"
                },
                {
                    "id": 5772,
                    "argument_list_id": 233,
                    "value": "21",
                    "name": "Dancing"
                },
                {
                    "id": 5773,
                    "argument_list_id": 233,
                    "value": "24",
                    "name": "Dissolved carbon dioxide"
                },
                {
                    "id": 5774,
                    "argument_list_id": 233,
                    "value": "25",
                    "name": "Urea"
                },
                {
                    "id": 5775,
                    "argument_list_id": 233,
                    "value": "26",
                    "name": "Ammonia"
                },
                {
                    "id": 5776,
                    "argument_list_id": 233,
                    "value": "29",
                    "name": "Air"
                },
                {
                    "id": 5777,
                    "argument_list_id": 233,
                    "value": "30",
                    "name": "Oxygen"
                },
                {
                    "id": 5778,
                    "argument_list_id": 233,
                    "value": "33",
                    "name": "Water"
                },
                {
                    "id": 5779,
                    "argument_list_id": 233,
                    "value": "34",
                    "name": "Energy"
                },
                {
                    "id": 5780,
                    "argument_list_id": 233,
                    "value": "35",
                    "name": "ATP"
                },
                {
                    "id": 5781,
                    "argument_list_id": 233,
                    "value": "36",
                    "name": "ADP"
                },
                {
                    "id": 5782,
                    "argument_list_id": 233,
                    "value": "39",
                    "name": "Arousal Potential"
                },
                {
                    "id": 5783,
                    "argument_list_id": 233,
                    "value": "40",
                    "name": "Libido lowerer"
                },
                {
                    "id": 5784,
                    "argument_list_id": 233,
                    "value": "41",
                    "name": "Opposite Sex Pheromone"
                },
                {
                    "id": 5785,
                    "argument_list_id": 233,
                    "value": "46",
                    "name": "Oestrogen"
                },
                {
                    "id": 5786,
                    "argument_list_id": 233,
                    "value": "48",
                    "name": "Progesterone"
                },
                {
                    "id": 5787,
                    "argument_list_id": 233,
                    "value": "53",
                    "name": "Testosterone"
                },
                {
                    "id": 5788,
                    "argument_list_id": 233,
                    "value": "54",
                    "name": "Inhibin"
                },
                {
                    "id": 5789,
                    "argument_list_id": 233,
                    "value": "66",
                    "name": "Heavy Metals"
                },
                {
                    "id": 5790,
                    "argument_list_id": 233,
                    "value": "67",
                    "name": "Cyanide"
                },
                {
                    "id": 5791,
                    "argument_list_id": 233,
                    "value": "68",
                    "name": "Belladonna"
                },
                {
                    "id": 5792,
                    "argument_list_id": 233,
                    "value": "69",
                    "name": "Geddonase"
                },
                {
                    "id": 5793,
                    "argument_list_id": 233,
                    "value": "70",
                    "name": "Glycotoxin"
                },
                {
                    "id": 5794,
                    "argument_list_id": 233,
                    "value": "71",
                    "name": "Sleep toxin"
                },
                {
                    "id": 5795,
                    "argument_list_id": 233,
                    "value": "72",
                    "name": "Fever toxin"
                },
                {
                    "id": 5796,
                    "argument_list_id": 233,
                    "value": "73",
                    "name": "Histamine A"
                },
                {
                    "id": 5797,
                    "argument_list_id": 233,
                    "value": "74",
                    "name": "Histamine B"
                },
                {
                    "id": 5798,
                    "argument_list_id": 233,
                    "value": "75",
                    "name": "Alcohol"
                },
                {
                    "id": 5799,
                    "argument_list_id": 233,
                    "value": "78",
                    "name": "ATP Decoupler"
                },
                {
                    "id": 5800,
                    "argument_list_id": 233,
                    "value": "79",
                    "name": "Carbon monoxide"
                },
                {
                    "id": 5801,
                    "argument_list_id": 233,
                    "value": "80",
                    "name": "Fear toxin"
                },
                {
                    "id": 5802,
                    "argument_list_id": 233,
                    "value": "81",
                    "name": "Muscle toxin"
                },
                {
                    "id": 5803,
                    "argument_list_id": 233,
                    "value": "82",
                    "name": "Antigen 0"
                },
                {
                    "id": 5804,
                    "argument_list_id": 233,
                    "value": "83",
                    "name": "Antigen 1"
                },
                {
                    "id": 5805,
                    "argument_list_id": 233,
                    "value": "84",
                    "name": "Antigen 2"
                },
                {
                    "id": 5806,
                    "argument_list_id": 233,
                    "value": "85",
                    "name": "Antigen 3"
                },
                {
                    "id": 5807,
                    "argument_list_id": 233,
                    "value": "86",
                    "name": "Antigen 4"
                },
                {
                    "id": 5808,
                    "argument_list_id": 233,
                    "value": "87",
                    "name": "Antigen 5"
                },
                {
                    "id": 5809,
                    "argument_list_id": 233,
                    "value": "88",
                    "name": "Antigen 6"
                },
                {
                    "id": 5810,
                    "argument_list_id": 233,
                    "value": "89",
                    "name": "Antigen 7"
                },
                {
                    "id": 5811,
                    "argument_list_id": 233,
                    "value": "90",
                    "name": "Wounded"
                },
                {
                    "id": 5812,
                    "argument_list_id": 233,
                    "value": "92",
                    "name": "Medicine one"
                },
                {
                    "id": 5813,
                    "argument_list_id": 233,
                    "value": "93",
                    "name": "Anti-oxidant"
                },
                {
                    "id": 5814,
                    "argument_list_id": 233,
                    "value": "94",
                    "name": "Prostaglandin"
                },
                {
                    "id": 5815,
                    "argument_list_id": 233,
                    "value": "95",
                    "name": "EDTA"
                },
                {
                    "id": 5816,
                    "argument_list_id": 233,
                    "value": "96",
                    "name": "Sodium thiosulphite"
                },
                {
                    "id": 5817,
                    "argument_list_id": 233,
                    "value": "97",
                    "name": "Arnica"
                },
                {
                    "id": 5818,
                    "argument_list_id": 233,
                    "value": "98",
                    "name": "Vitamin E"
                },
                {
                    "id": 5819,
                    "argument_list_id": 233,
                    "value": "99",
                    "name": "Vitamin C"
                },
                {
                    "id": 5820,
                    "argument_list_id": 233,
                    "value": "100",
                    "name": "Antihistamine"
                },
                {
                    "id": 5821,
                    "argument_list_id": 233,
                    "value": "102",
                    "name": "Antibody 0"
                },
                {
                    "id": 5822,
                    "argument_list_id": 233,
                    "value": "103",
                    "name": "Antibody 1"
                },
                {
                    "id": 5823,
                    "argument_list_id": 233,
                    "value": "104",
                    "name": "Antibody 2"
                },
                {
                    "id": 5824,
                    "argument_list_id": 233,
                    "value": "105",
                    "name": "Antibody 3"
                },
                {
                    "id": 5825,
                    "argument_list_id": 233,
                    "value": "106",
                    "name": "Antibody 4"
                },
                {
                    "id": 5826,
                    "argument_list_id": 233,
                    "value": "107",
                    "name": "Antibody 5"
                },
                {
                    "id": 5827,
                    "argument_list_id": 233,
                    "value": "108",
                    "name": "Antibody 6"
                },
                {
                    "id": 5828,
                    "argument_list_id": 233,
                    "value": "109",
                    "name": "Antibody 7"
                },
                {
                    "id": 5829,
                    "argument_list_id": 233,
                    "value": "112",
                    "name": "Anabolic steroid"
                },
                {
                    "id": 5830,
                    "argument_list_id": 233,
                    "value": "113",
                    "name": "Pistle"
                },
                {
                    "id": 5831,
                    "argument_list_id": 233,
                    "value": "114",
                    "name": "Insulin"
                },
                {
                    "id": 5832,
                    "argument_list_id": 233,
                    "value": "115",
                    "name": "Glycolase"
                },
                {
                    "id": 5833,
                    "argument_list_id": 233,
                    "value": "116",
                    "name": "Dehydrogenase"
                },
                {
                    "id": 5834,
                    "argument_list_id": 233,
                    "value": "117",
                    "name": "Adrenalin"
                },
                {
                    "id": 5835,
                    "argument_list_id": 233,
                    "value": "118",
                    "name": "Grendel nitrate"
                },
                {
                    "id": 5836,
                    "argument_list_id": 233,
                    "value": "119",
                    "name": "Ettin nitrate"
                },
                {
                    "id": 5837,
                    "argument_list_id": 233,
                    "value": "121",
                    "name": "Protease"
                },
                {
                    "id": 5838,
                    "argument_list_id": 233,
                    "value": "124",
                    "name": "Activase"
                },
                {
                    "id": 5839,
                    "argument_list_id": 233,
                    "value": "125",
                    "name": "Life"
                },
                {
                    "id": 5840,
                    "argument_list_id": 233,
                    "value": "126",
                    "name": "CAdv Exercise meter"
                },
                {
                    "id": 5841,
                    "argument_list_id": 233,
                    "value": "127",
                    "name": "Injury"
                },
                {
                    "id": 5842,
                    "argument_list_id": 233,
                    "value": "128",
                    "name": "Stress"
                },
                {
                    "id": 5843,
                    "argument_list_id": 233,
                    "value": "129",
                    "name": "Sleepase"
                },
                {
                    "id": 5844,
                    "argument_list_id": 233,
                    "value": "131",
                    "name": "Pain backup"
                },
                {
                    "id": 5845,
                    "argument_list_id": 233,
                    "value": "132",
                    "name": "Hunger for protein backup"
                },
                {
                    "id": 5846,
                    "argument_list_id": 233,
                    "value": "133",
                    "name": "Hunger for carb backup"
                },
                {
                    "id": 5847,
                    "argument_list_id": 233,
                    "value": "134",
                    "name": "Hunger for fat backup"
                },
                {
                    "id": 5848,
                    "argument_list_id": 233,
                    "value": "135",
                    "name": "Coldness backup"
                },
                {
                    "id": 5849,
                    "argument_list_id": 233,
                    "value": "136",
                    "name": "Hotness backup"
                },
                {
                    "id": 5850,
                    "argument_list_id": 233,
                    "value": "137",
                    "name": "Tiredness backup"
                },
                {
                    "id": 5851,
                    "argument_list_id": 233,
                    "value": "138",
                    "name": "Sleepiness backup"
                },
                {
                    "id": 5852,
                    "argument_list_id": 233,
                    "value": "139",
                    "name": "Loneliness backup"
                },
                {
                    "id": 5853,
                    "argument_list_id": 233,
                    "value": "140",
                    "name": "Crowded backup"
                },
                {
                    "id": 5854,
                    "argument_list_id": 233,
                    "value": "141",
                    "name": "Fear backup"
                },
                {
                    "id": 5855,
                    "argument_list_id": 233,
                    "value": "142",
                    "name": "Boredom backup"
                },
                {
                    "id": 5856,
                    "argument_list_id": 233,
                    "value": "143",
                    "name": "Anger backup"
                },
                {
                    "id": 5857,
                    "argument_list_id": 233,
                    "value": "144",
                    "name": "Sex drive backup"
                },
                {
                    "id": 5858,
                    "argument_list_id": 233,
                    "value": "145",
                    "name": "Comfort backup"
                },
                {
                    "id": 5859,
                    "argument_list_id": 233,
                    "value": "148",
                    "name": "Pain"
                },
                {
                    "id": 5860,
                    "argument_list_id": 233,
                    "value": "149",
                    "name": "Hunger for protein"
                },
                {
                    "id": 5861,
                    "argument_list_id": 233,
                    "value": "150",
                    "name": "Hunger for carbohydrate"
                },
                {
                    "id": 5862,
                    "argument_list_id": 233,
                    "value": "151",
                    "name": "Hunger for fat"
                },
                {
                    "id": 5863,
                    "argument_list_id": 233,
                    "value": "152",
                    "name": "Coldness"
                },
                {
                    "id": 5864,
                    "argument_list_id": 233,
                    "value": "153",
                    "name": "Hotness"
                },
                {
                    "id": 5865,
                    "argument_list_id": 233,
                    "value": "154",
                    "name": "Tiredness"
                },
                {
                    "id": 5866,
                    "argument_list_id": 233,
                    "value": "155",
                    "name": "Sleepiness"
                },
                {
                    "id": 5867,
                    "argument_list_id": 233,
                    "value": "156",
                    "name": "Loneliness"
                },
                {
                    "id": 5868,
                    "argument_list_id": 233,
                    "value": "157",
                    "name": "Crowded"
                },
                {
                    "id": 5869,
                    "argument_list_id": 233,
                    "value": "158",
                    "name": "Fear"
                },
                {
                    "id": 5870,
                    "argument_list_id": 233,
                    "value": "159",
                    "name": "Boredom"
                },
                {
                    "id": 5871,
                    "argument_list_id": 233,
                    "value": "160",
                    "name": "Anger"
                },
                {
                    "id": 5872,
                    "argument_list_id": 233,
                    "value": "161",
                    "name": "Sex drive"
                },
                {
                    "id": 5873,
                    "argument_list_id": 233,
                    "value": "162",
                    "name": "Comfort"
                },
                {
                    "id": 5874,
                    "argument_list_id": 233,
                    "value": "165",
                    "name": "Ca smell 0 (sound)"
                },
                {
                    "id": 5875,
                    "argument_list_id": 233,
                    "value": "166",
                    "name": "CA smell 1 (light)"
                },
                {
                    "id": 5876,
                    "argument_list_id": 233,
                    "value": "167",
                    "name": "CA smell 2 (heat)"
                },
                {
                    "id": 5877,
                    "argument_list_id": 233,
                    "value": "168",
                    "name": "Ca smell 3 (water)"
                },
                {
                    "id": 5878,
                    "argument_list_id": 233,
                    "value": "169",
                    "name": "CA smell 4 (nutrient)"
                },
                {
                    "id": 5879,
                    "argument_list_id": 233,
                    "value": "170",
                    "name": "CA smell 5 (water)"
                },
                {
                    "id": 5880,
                    "argument_list_id": 233,
                    "value": "171",
                    "name": "CA smell 6 (protein)"
                },
                {
                    "id": 5881,
                    "argument_list_id": 233,
                    "value": "172",
                    "name": "CA smell 7 (carbohydrate)"
                },
                {
                    "id": 5882,
                    "argument_list_id": 233,
                    "value": "173",
                    "name": "CA smell 8 (fat)"
                },
                {
                    "id": 5883,
                    "argument_list_id": 233,
                    "value": "174",
                    "name": "CA smell 9 (flowers)"
                },
                {
                    "id": 5884,
                    "argument_list_id": 233,
                    "value": "175",
                    "name": "CA smell 10 (machinery)"
                },
                {
                    "id": 5885,
                    "argument_list_id": 233,
                    "value": "176",
                    "name": "CA smell 11"
                },
                {
                    "id": 5886,
                    "argument_list_id": 233,
                    "value": "177",
                    "name": "CA smell 12 (Norn)"
                },
                {
                    "id": 5887,
                    "argument_list_id": 233,
                    "value": "178",
                    "name": "CA smell 13 (Grendel)"
                },
                {
                    "id": 5888,
                    "argument_list_id": 233,
                    "value": "179",
                    "name": "CA smell 14 (Ettin)"
                },
                {
                    "id": 5889,
                    "argument_list_id": 233,
                    "value": "180",
                    "name": "CA smell 15 (Norn home)"
                },
                {
                    "id": 5890,
                    "argument_list_id": 233,
                    "value": "181",
                    "name": "CA smell 16 (Grendel home)"
                },
                {
                    "id": 5891,
                    "argument_list_id": 233,
                    "value": "182",
                    "name": "CA smell 17 (Ettin home)"
                },
                {
                    "id": 5892,
                    "argument_list_id": 233,
                    "value": "183",
                    "name": "CA smell 18"
                },
                {
                    "id": 5893,
                    "argument_list_id": 233,
                    "value": "184",
                    "name": "CA smell 19"
                },
                {
                    "id": 5894,
                    "argument_list_id": 233,
                    "value": "187",
                    "name": "Stress (H4C)"
                },
                {
                    "id": 5895,
                    "argument_list_id": 233,
                    "value": "188",
                    "name": "Stress (H4P)"
                },
                {
                    "id": 5896,
                    "argument_list_id": 233,
                    "value": "189",
                    "name": "Stress (H4F)"
                },
                {
                    "id": 5897,
                    "argument_list_id": 233,
                    "value": "190",
                    "name": "Stress (Anger)"
                },
                {
                    "id": 5898,
                    "argument_list_id": 233,
                    "value": "191",
                    "name": "Stress (Fear)"
                },
                {
                    "id": 5899,
                    "argument_list_id": 233,
                    "value": "192",
                    "name": "Stress (Pain)"
                },
                {
                    "id": 5900,
                    "argument_list_id": 233,
                    "value": "193",
                    "name": "Stress (Sleep)"
                },
                {
                    "id": 5901,
                    "argument_list_id": 233,
                    "value": "194",
                    "name": "Stress (Tired)"
                },
                {
                    "id": 5902,
                    "argument_list_id": 233,
                    "value": "195",
                    "name": "Stress (Crowded)"
                },
                {
                    "id": 5903,
                    "argument_list_id": 233,
                    "value": "198",
                    "name": "Disappointment"
                },
                {
                    "id": 5904,
                    "argument_list_id": 233,
                    "value": "199",
                    "name": "Up"
                },
                {
                    "id": 5905,
                    "argument_list_id": 233,
                    "value": "200",
                    "name": "Down"
                },
                {
                    "id": 5906,
                    "argument_list_id": 233,
                    "value": "201",
                    "name": "Exit"
                },
                {
                    "id": 5907,
                    "argument_list_id": 233,
                    "value": "202",
                    "name": "Enter"
                },
                {
                    "id": 5908,
                    "argument_list_id": 233,
                    "value": "203",
                    "name": "Wait"
                },
                {
                    "id": 5909,
                    "argument_list_id": 233,
                    "value": "204",
                    "name": "Reward"
                },
                {
                    "id": 5910,
                    "argument_list_id": 233,
                    "value": "205",
                    "name": "Punishment"
                },
                {
                    "id": 5911,
                    "argument_list_id": 233,
                    "value": "206",
                    "name": "Brain chemical 9"
                },
                {
                    "id": 5912,
                    "argument_list_id": 233,
                    "value": "207",
                    "name": "Brain chemical 10"
                },
                {
                    "id": 5913,
                    "argument_list_id": 233,
                    "value": "208",
                    "name": "Brain chemical 11"
                },
                {
                    "id": 5914,
                    "argument_list_id": 233,
                    "value": "209",
                    "name": "brain chemical 12"
                },
                {
                    "id": 5915,
                    "argument_list_id": 233,
                    "value": "210",
                    "name": "Brain chemical 13"
                },
                {
                    "id": 5916,
                    "argument_list_id": 233,
                    "value": "211",
                    "name": "Brain chemical 14"
                },
                {
                    "id": 5917,
                    "argument_list_id": 233,
                    "value": "212",
                    "name": "Pre-REM Sleep"
                },
                {
                    "id": 5918,
                    "argument_list_id": 233,
                    "value": "213",
                    "name": "REM sleep"
                }
            ],
            "variants": 4
        },
        "list_189": {
            "id": 189,
            "variant": "AL",
            "name": "ClikWhich",
            "base_values_list_id": 71,
            "arguments": [
                {
                    "id": 4256,
                    "argument_list_id": 189,
                    "value": "0",
                    "name": "Current click action number (1,2,3)"
                },
                {
                    "id": 4257,
                    "argument_list_id": 189,
                    "value": "1",
                    "name": "First CLIK action."
                },
                {
                    "id": 4258,
                    "argument_list_id": 189,
                    "value": "2",
                    "name": "Second CLIK action."
                },
                {
                    "id": 4259,
                    "argument_list_id": 189,
                    "value": "3",
                    "name": "Third CLIK action"
                }
            ],
            "variants": 60
        },
        "list_174": {
            "id": 174,
            "variant": "DS",
            "name": "Connected",
            "extension_type": "bool",
            "base_values_list_id": 59,
            "arguments": [
                {
                    "id": 3744,
                    "argument_list_id": 174,
                    "value": "0",
                    "name": "Not-Connected",
                    "description": "Not connected to Babel server"
                },
                {
                    "id": 3745,
                    "argument_list_id": 174,
                    "value": "1",
                    "name": "Connected",
                    "description": "Connected to babel server"
                }
            ],
            "variants": 48
        },
        "list_182": {
            "id": 182,
            "variant": "AL",
            "name": "Dead",
            "extension_type": "bool",
            "base_values_list_id": 42,
            "arguments": [
                {
                    "id": 3820,
                    "argument_list_id": 182,
                    "value": "0",
                    "name": "Alive"
                },
                {
                    "id": 3821,
                    "argument_list_id": 182,
                    "value": ">0",
                    "name": "Dead"
                }
            ],
            "variants": 63
        },
        "list_222": {
            "id": 222,
            "variant": "C2",
            "name": "DendriteType",
            "base_values_list_id": 99,
            "arguments": [
                {
                    "id": 4364,
                    "argument_list_id": 222,
                    "value": "0",
                    "name": "Type 0 Dendrites"
                },
                {
                    "id": 4365,
                    "argument_list_id": 222,
                    "value": "1",
                    "name": "Type 1 Dendrites"
                }
            ],
            "variants": 2
        },
        "list_87": {
            "id": 87,
            "variant": "C2",
            "name": "Direction",
            "base_values_list_id": 21,
            "arguments": [
                {
                    "id": 1180,
                    "argument_list_id": 87,
                    "value": "0",
                    "name": "Left"
                },
                {
                    "id": 1181,
                    "argument_list_id": 87,
                    "value": "1",
                    "name": "Right"
                },
                {
                    "id": 1182,
                    "argument_list_id": 87,
                    "value": "2",
                    "name": "Up"
                },
                {
                    "id": 1183,
                    "argument_list_id": 87,
                    "value": "3",
                    "name": "Down"
                },
                {
                    "id": 1184,
                    "argument_list_id": 87,
                    "value": "4",
                    "name": "Unknown"
                }
            ],
            "variants": 2
        },
        "list_157": {
            "id": 157,
            "variant": "AL",
            "name": "Dreaming",
            "extension_type": "bool",
            "base_values_list_id": 43,
            "arguments": [
                {
                    "id": 3689,
                    "argument_list_id": 157,
                    "value": "0",
                    "name": "Awake"
                },
                {
                    "id": 3687,
                    "argument_list_id": 157,
                    "value": "1",
                    "name": "Dreaming"
                }
            ],
            "variants": 60
        },
        "list_78": {
            "id": 78,
            "variant": "C1",
            "name": "Drives",
            "base_values_list_id": 12,
            "arguments": [
                {
                    "id": 1006,
                    "argument_list_id": 78,
                    "value": "1",
                    "name": "Pain"
                },
                {
                    "id": 1007,
                    "argument_list_id": 78,
                    "value": "2",
                    "name": "Need for pleasure"
                },
                {
                    "id": 1008,
                    "argument_list_id": 78,
                    "value": "3",
                    "name": "Hunger"
                },
                {
                    "id": 1009,
                    "argument_list_id": 78,
                    "value": "4",
                    "name": "Coldness"
                },
                {
                    "id": 1010,
                    "argument_list_id": 78,
                    "value": "5",
                    "name": "Hotness"
                },
                {
                    "id": 1011,
                    "argument_list_id": 78,
                    "value": "6",
                    "name": "Tiredness"
                },
                {
                    "id": 1012,
                    "argument_list_id": 78,
                    "value": "7",
                    "name": "Sleepiness"
                },
                {
                    "id": 1013,
                    "argument_list_id": 78,
                    "value": "8",
                    "name": "Loneliness"
                },
                {
                    "id": 1014,
                    "argument_list_id": 78,
                    "value": "9",
                    "name": "Crowded"
                },
                {
                    "id": 1015,
                    "argument_list_id": 78,
                    "value": "10",
                    "name": "Fear"
                },
                {
                    "id": 1016,
                    "argument_list_id": 78,
                    "value": "11",
                    "name": "Boredom"
                },
                {
                    "id": 1017,
                    "argument_list_id": 78,
                    "value": "12",
                    "name": "Anger"
                },
                {
                    "id": 1018,
                    "argument_list_id": 78,
                    "value": "13",
                    "name": "Sex Drive"
                },
                {
                    "id": 1019,
                    "argument_list_id": 78,
                    "value": "14",
                    "name": "Not Allocated 2"
                },
                {
                    "id": 1020,
                    "argument_list_id": 78,
                    "value": "15",
                    "name": "Not allocated 3"
                },
                {
                    "id": 1021,
                    "argument_list_id": 78,
                    "value": "16",
                    "name": "Not allocated 4"
                }
            ],
            "variants": 1
        },
        "list_134": {
            "id": 134,
            "variant": "C2",
            "name": "Drives",
            "base_values_list_id": 12,
            "arguments": [
                {
                    "id": 2649,
                    "argument_list_id": 134,
                    "value": "1",
                    "name": "Pain"
                },
                {
                    "id": 2650,
                    "argument_list_id": 134,
                    "value": "2",
                    "name": "Need For Pleasure"
                },
                {
                    "id": 2651,
                    "argument_list_id": 134,
                    "value": "3",
                    "name": "Hunger"
                },
                {
                    "id": 2652,
                    "argument_list_id": 134,
                    "value": "4",
                    "name": "Coldness"
                },
                {
                    "id": 2653,
                    "argument_list_id": 134,
                    "value": "5",
                    "name": "Hotness"
                },
                {
                    "id": 2654,
                    "argument_list_id": 134,
                    "value": "6",
                    "name": "Tiredness"
                },
                {
                    "id": 2655,
                    "argument_list_id": 134,
                    "value": "7",
                    "name": "Sleepiness"
                },
                {
                    "id": 2656,
                    "argument_list_id": 134,
                    "value": "8",
                    "name": "Loneliness"
                },
                {
                    "id": 2657,
                    "argument_list_id": 134,
                    "value": "9",
                    "name": "Overcrowdedness"
                },
                {
                    "id": 2658,
                    "argument_list_id": 134,
                    "value": "10",
                    "name": "Fear"
                },
                {
                    "id": 2659,
                    "argument_list_id": 134,
                    "value": "11",
                    "name": "Boredom"
                },
                {
                    "id": 2660,
                    "argument_list_id": 134,
                    "value": "12",
                    "name": "Anger"
                },
                {
                    "id": 2661,
                    "argument_list_id": 134,
                    "value": "13",
                    "name": "Sex Drive"
                },
                {
                    "id": 2662,
                    "argument_list_id": 134,
                    "value": "14",
                    "name": "Injury"
                },
                {
                    "id": 2663,
                    "argument_list_id": 134,
                    "value": "15",
                    "name": "Suffocation"
                },
                {
                    "id": 2664,
                    "argument_list_id": 134,
                    "value": "16",
                    "name": "Thirst"
                },
                {
                    "id": 2665,
                    "argument_list_id": 134,
                    "value": "17",
                    "name": "Stress"
                }
            ],
            "variants": 2
        },
        "list_234": {
            "id": 234,
            "variant": "AL",
            "name": "Drives",
            "base_values_list_id": 12,
            "arguments": [
                {
                    "id": 4603,
                    "argument_list_id": 234,
                    "value": "0",
                    "name": "Pain"
                },
                {
                    "id": 4604,
                    "argument_list_id": 234,
                    "value": "1",
                    "name": "Hunger for protein"
                },
                {
                    "id": 4605,
                    "argument_list_id": 234,
                    "value": "2",
                    "name": "Hunger for carb"
                },
                {
                    "id": 4606,
                    "argument_list_id": 234,
                    "value": "3",
                    "name": "Hunger for fat"
                },
                {
                    "id": 4607,
                    "argument_list_id": 234,
                    "value": "4",
                    "name": "Coldness"
                },
                {
                    "id": 4608,
                    "argument_list_id": 234,
                    "value": "5",
                    "name": "Hotness"
                },
                {
                    "id": 4609,
                    "argument_list_id": 234,
                    "value": "6",
                    "name": "Tiredness"
                },
                {
                    "id": 4610,
                    "argument_list_id": 234,
                    "value": "7",
                    "name": "Sleepiness"
                },
                {
                    "id": 4611,
                    "argument_list_id": 234,
                    "value": "8",
                    "name": "Loneliness"
                },
                {
                    "id": 4612,
                    "argument_list_id": 234,
                    "value": "9",
                    "name": "Crowded"
                },
                {
                    "id": 4613,
                    "argument_list_id": 234,
                    "value": "10",
                    "name": "Fear"
                },
                {
                    "id": 4614,
                    "argument_list_id": 234,
                    "value": "11",
                    "name": "Boredom"
                },
                {
                    "id": 4615,
                    "argument_list_id": 234,
                    "value": "12",
                    "name": "Anger"
                },
                {
                    "id": 4616,
                    "argument_list_id": 234,
                    "value": "13",
                    "name": "Sex drive"
                },
                {
                    "id": 4617,
                    "argument_list_id": 234,
                    "value": "14",
                    "name": "Comfort"
                }
            ],
            "variants": 60
        },
        "list_227": {
            "id": 227,
            "variant": "AL",
            "name": "EmitType",
            "extension_type": "bool",
            "base_values_list_id": 104,
            "arguments": [
                {
                    "id": 4378,
                    "argument_list_id": 227,
                    "value": "0",
                    "name": "As Read"
                },
                {
                    "id": 4379,
                    "argument_list_id": 227,
                    "value": ">0",
                    "name": "As Audible"
                }
            ],
            "variants": 3
        },
        "list_170": {
            "id": 170,
            "variant": "AL",
            "name": "Enabled",
            "extension_type": "bool",
            "base_values_list_id": 55,
            "arguments": [
                {
                    "id": 3730,
                    "argument_list_id": 170,
                    "value": "0",
                    "name": "Disabled"
                },
                {
                    "id": 3731,
                    "argument_list_id": 170,
                    "value": "1",
                    "name": "Enabled"
                }
            ],
            "variants": 60
        },
        "list_266": {
            "id": 266,
            "variant": "SM",
            "name": "EventNumbers",
            "base_values_list_id": 32,
            "arguments": [
                {
                    "id": 6596,
                    "argument_list_id": 266,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "Called when the agent receives an activate 1 message."
                },
                {
                    "id": 6597,
                    "argument_list_id": 266,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "Called when the agent receives an activate 2 message."
                },
                {
                    "id": 6598,
                    "argument_list_id": 266,
                    "value": "3",
                    "name": "Hit",
                    "description": "Called when the agent receives a hit message."
                },
                {
                    "id": 6599,
                    "argument_list_id": 266,
                    "value": "4",
                    "name": "Pickup",
                    "description": "Called when the agent has been picked up by something other than a vehicle."
                },
                {
                    "id": 6600,
                    "argument_list_id": 266,
                    "value": "5",
                    "name": "Drop",
                    "description": "Called when the agent has been dropped by something other than a vehicle."
                },
                {
                    "id": 6601,
                    "argument_list_id": 266,
                    "value": "6",
                    "name": "Collision",
                    "description": "Called when the agent collides with an obstacle. _P1_ and _P2_ are the x and y components of the collision velocity."
                },
                {
                    "id": 6602,
                    "argument_list_id": 266,
                    "value": "7",
                    "name": "Bump",
                    "description": "Called when a creature walks into a wall."
                },
                {
                    "id": 6603,
                    "argument_list_id": 266,
                    "value": "8",
                    "name": "Impact",
                    "description": "Called when an agent's presence impacts with another agent's presence (this is assuming both agents have their presence switched on)."
                },
                {
                    "id": 6604,
                    "argument_list_id": 266,
                    "value": "9",
                    "name": "Timer",
                    "description": "Called at a regular time interval, as set by TICK."
                },
                {
                    "id": 6605,
                    "argument_list_id": 266,
                    "value": "10",
                    "name": "Constructor",
                    "description": "Called on creation."
                },
                {
                    "id": 6606,
                    "argument_list_id": 266,
                    "value": "12",
                    "name": "Eat",
                    "description": "Called when the creature eats something."
                },
                {
                    "id": 6607,
                    "argument_list_id": 266,
                    "value": "13",
                    "name": "Start Hold Hands",
                    "description": "Called when a creature starts holding hands with the pointer."
                },
                {
                    "id": 6608,
                    "argument_list_id": 266,
                    "value": "14",
                    "name": "Stop Hold Hands",
                    "description": "Called when a creature stops holding hands with the pointer."
                },
                {
                    "id": 6609,
                    "argument_list_id": 266,
                    "value": "16",
                    "name": "Quiescent on Agents",
                    "description": "Scripts 16 - 30 are executed on a creature when it decides to do something with its attention on an ordinary agent (rather than a creature). The script should perform this action. Quiescent means stand and watch it. The catalogue entry \"Action Script To Neuron Mappings\" maps the brain to these scripts, although which scripts require an it object are hard-wired."
                },
                {
                    "id": 6610,
                    "argument_list_id": 266,
                    "value": "17",
                    "name": "Activate 1 on Agents",
                    "description": "Activate 1 it."
                },
                {
                    "id": 6611,
                    "argument_list_id": 266,
                    "value": "18",
                    "name": "Activate 2 on Agents",
                    "description": "Activate 2 it."
                },
                {
                    "id": 6612,
                    "argument_list_id": 266,
                    "value": "19",
                    "name": "Deactivate on Agents",
                    "description": "Deactivate it."
                },
                {
                    "id": 6613,
                    "argument_list_id": 266,
                    "value": "20",
                    "name": "Approach on Agents",
                    "description": "Go up and look at it."
                },
                {
                    "id": 6614,
                    "argument_list_id": 266,
                    "value": "21",
                    "name": "Retreat on Agents",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 6615,
                    "argument_list_id": 266,
                    "value": "22",
                    "name": "Pickup on Agents",
                    "description": "Pick it up."
                },
                {
                    "id": 6616,
                    "argument_list_id": 266,
                    "value": "23",
                    "name": "Drop on Agents",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 6617,
                    "argument_list_id": 266,
                    "value": "24",
                    "name": "Need on Agents",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 6618,
                    "argument_list_id": 266,
                    "value": "25",
                    "name": "Rest on Agents",
                    "description": "Becoming sleepy."
                },
                {
                    "id": 6619,
                    "argument_list_id": 266,
                    "value": "26",
                    "name": "West on Agents",
                    "description": "Walk idly to west."
                },
                {
                    "id": 6620,
                    "argument_list_id": 266,
                    "value": "27",
                    "name": "East on Agents",
                    "description": "Walk idly to east."
                },
                {
                    "id": 6621,
                    "argument_list_id": 266,
                    "value": "28",
                    "name": "Eat on Agents",
                    "description": "Eat it."
                },
                {
                    "id": 6622,
                    "argument_list_id": 266,
                    "value": "29",
                    "name": "Hit on Agents",
                    "description": "Hit it."
                },
                {
                    "id": 6623,
                    "argument_list_id": 266,
                    "value": "30",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 6624,
                    "argument_list_id": 266,
                    "value": "31",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 6625,
                    "argument_list_id": 266,
                    "value": "32",
                    "name": "Quiescent on Creatures",
                    "description": "Scripts 32 - 47 are executed on a creature when it decides to do something with its attention on another creature. Quiescent means stand and twiddle your thumbs."
                },
                {
                    "id": 6626,
                    "argument_list_id": 266,
                    "value": "33",
                    "name": "Activate 1 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 6627,
                    "argument_list_id": 266,
                    "value": "34",
                    "name": "Activate 2 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 6628,
                    "argument_list_id": 266,
                    "value": "35",
                    "name": "Deactivate on Creatures",
                    "description": "Deactivate it."
                },
                {
                    "id": 6629,
                    "argument_list_id": 266,
                    "value": "36",
                    "name": "Approach on Creatures",
                    "description": "Go up and look at it."
                },
                {
                    "id": 6630,
                    "argument_list_id": 266,
                    "value": "37",
                    "name": "Retreat on Creatures",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 6631,
                    "argument_list_id": 266,
                    "value": "38",
                    "name": "Pickup on Creatures",
                    "description": "Pick it up."
                },
                {
                    "id": 6632,
                    "argument_list_id": 266,
                    "value": "39",
                    "name": "Drop on Creatures",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 6633,
                    "argument_list_id": 266,
                    "value": "40",
                    "name": "Need on Creatures",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 6634,
                    "argument_list_id": 266,
                    "value": "41",
                    "name": "Rest on Creatures",
                    "description": "Rest or sleep."
                },
                {
                    "id": 6635,
                    "argument_list_id": 266,
                    "value": "42",
                    "name": "West on Creatures",
                    "description": "Walk idly to west."
                },
                {
                    "id": 6636,
                    "argument_list_id": 266,
                    "value": "43",
                    "name": "East on Creatures",
                    "description": "Walk idly to east."
                },
                {
                    "id": 6637,
                    "argument_list_id": 266,
                    "value": "44",
                    "name": "Eat on Creatures",
                    "description": "Eat it."
                },
                {
                    "id": 6638,
                    "argument_list_id": 266,
                    "value": "45",
                    "name": "Hit on Creatures",
                    "description": "Hit it."
                },
                {
                    "id": 6639,
                    "argument_list_id": 266,
                    "value": "46",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 6640,
                    "argument_list_id": 266,
                    "value": "47",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 6641,
                    "argument_list_id": 266,
                    "value": "64",
                    "name": "Flinch",
                    "description": "Involuntary action called when the creature flinches."
                },
                {
                    "id": 6642,
                    "argument_list_id": 266,
                    "value": "65",
                    "name": "Lay Egg",
                    "description": "Involuntary action called when the creature lays an egg."
                },
                {
                    "id": 6643,
                    "argument_list_id": 266,
                    "value": "66",
                    "name": "Sneeze",
                    "description": "Involuntary action called when the creature sneezes."
                },
                {
                    "id": 6644,
                    "argument_list_id": 266,
                    "value": "67",
                    "name": "Cough",
                    "description": "Involuntary action called when the creature coughs."
                },
                {
                    "id": 6645,
                    "argument_list_id": 266,
                    "value": "68",
                    "name": "Shiver",
                    "description": "Involuntary action called when the creature shivers."
                },
                {
                    "id": 6646,
                    "argument_list_id": 266,
                    "value": "69",
                    "name": "Sleep",
                    "description": "Involuntary action called when the creature sleeps."
                },
                {
                    "id": 6647,
                    "argument_list_id": 266,
                    "value": "70",
                    "name": "Fainting",
                    "description": "Involuntary action called when the creature faints."
                },
                {
                    "id": 6648,
                    "argument_list_id": 266,
                    "value": "71",
                    "name": "Unassigned",
                    "description": "Involuntary action for future expansion."
                },
                {
                    "id": 6649,
                    "argument_list_id": 266,
                    "value": "72",
                    "name": "Die",
                    "description": "Special involuntary action called when a creature dies. Any death animations go here."
                },
                {
                    "id": 6650,
                    "argument_list_id": 266,
                    "value": "73",
                    "name": "Raw Key Down",
                    "description": "Called when a key is pressed and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 6651,
                    "argument_list_id": 266,
                    "value": "74",
                    "name": "Raw Key Up",
                    "description": "Called when a key is released and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 6652,
                    "argument_list_id": 266,
                    "value": "75",
                    "name": "Raw Mouse Move",
                    "description": "Called when the mouse moves and IMSK is set. The new x and y position is sent in _P1_ and _P2_"
                },
                {
                    "id": 6653,
                    "argument_list_id": 266,
                    "value": "76",
                    "name": "Raw Mouse Down",
                    "description": "Called when a mouse button is pressed and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 6654,
                    "argument_list_id": 266,
                    "value": "77",
                    "name": "Raw Mouse Up",
                    "description": "Called when a mouse button is released and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 6655,
                    "argument_list_id": 266,
                    "value": "78",
                    "name": "Raw Mouse Wheel",
                    "description": "Called when the mouse wheel is moved and IMSK is set. The delta value is sent in _P1_ - 120 units per 'click'."
                },
                {
                    "id": 6656,
                    "argument_list_id": 266,
                    "value": "79",
                    "name": "Raw Translated Char",
                    "description": "Called when a translated character is received and IMSK is set. For example, on Japanese systems the raw key down and up codes can be in Roman characters, but the Input Method Editor converts them to Japanese characters, which are sent to the game with this message. The translated key code is sent in _P1_. You can use this for character input, but it is easier to use PAT: TEXT."
                },
                {
                    "id": 6657,
                    "argument_list_id": 266,
                    "value": "92",
                    "name": "UI Mouse Down",
                    "description": "Called when the mouse clicks on an agent."
                },
                {
                    "id": 6658,
                    "argument_list_id": 266,
                    "value": "101",
                    "name": "Pointer Activate 1",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 6659,
                    "argument_list_id": 266,
                    "value": "102",
                    "name": "Pointer Activate 2",
                    "description": "Called on the pointer when an agent is activated 2. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 6660,
                    "argument_list_id": 266,
                    "value": "103",
                    "name": "Pointer Deactivate",
                    "description": "Called on the pointer when an agent is deactivated. The script has the same classifier as the agent being deactivated."
                },
                {
                    "id": 6661,
                    "argument_list_id": 266,
                    "value": "104",
                    "name": "Pointer Pickup",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 6662,
                    "argument_list_id": 266,
                    "value": "105",
                    "name": "Pointer Drop",
                    "description": "Called on the pointer when an agent is dropped. The script has the same classifier as the agent being dropped."
                },
                {
                    "id": 6663,
                    "argument_list_id": 266,
                    "value": "110",
                    "name": "Pointer Port Select",
                    "description": "Called on the pointer when you manipulate a port."
                },
                {
                    "id": 6664,
                    "argument_list_id": 266,
                    "value": "111",
                    "name": "Pointer Port Connect",
                    "description": "Called on the pointer when you complete the connection between two ports."
                },
                {
                    "id": 6665,
                    "argument_list_id": 266,
                    "value": "112",
                    "name": "Pointer Port Disconnect",
                    "description": "Called on the pointer when you complete the disconnection of two previously connected ports."
                },
                {
                    "id": 6666,
                    "argument_list_id": 266,
                    "value": "113",
                    "name": "Pointer Port Cancel",
                    "description": "Called on the pointer if you cancel a port change part way through."
                },
                {
                    "id": 6667,
                    "argument_list_id": 266,
                    "value": "114",
                    "name": "Pointer Port Error",
                    "description": "Called on the pointer if there is some error with the configuration of ports the user is trying to make."
                },
                {
                    "id": 6668,
                    "argument_list_id": 266,
                    "value": "116",
                    "name": "Pointer Clicked Background",
                    "description": "Called when the pointer is clicked but there aren't any agents under it."
                },
                {
                    "id": 6669,
                    "argument_list_id": 266,
                    "value": "117",
                    "name": "Pointer Action Dispatch",
                    "description": "Called on the pointer to tell it what action clicking would take on the creature under it. _P1_ says what will happen: 0 means no action or not above a creature, 1 means deactivate (slap), 2 means activate 1 (tickle)."
                },
                {
                    "id": 6670,
                    "argument_list_id": 266,
                    "value": "118",
                    "name": "Connection Break",
                    "description": "Called on an agent when any of its ports are broken as a result of exceeding the maximum connection distance."
                },
                {
                    "id": 6671,
                    "argument_list_id": 266,
                    "value": "120",
                    "name": "Selected Creature Changed",
                    "description": "Called on all agents with this script when the selected creature is changed by NORN. _P1_ is the new creature, _P2_ is the previously selected creature."
                },
                {
                    "id": 6672,
                    "argument_list_id": 266,
                    "value": "121",
                    "name": "Vehicle Pickup",
                    "description": "Called when an agent has been picked up by a vehicle."
                },
                {
                    "id": 6673,
                    "argument_list_id": 266,
                    "value": "122",
                    "name": "Vehicle Drop",
                    "description": "Called when an agent has been dropped by a vehicle."
                },
                {
                    "id": 6674,
                    "argument_list_id": 266,
                    "value": "123",
                    "name": "Window Resized",
                    "description": "Called on all agents with this script whenever the main view is resized."
                },
                {
                    "id": 6675,
                    "argument_list_id": 266,
                    "value": "124",
                    "name": "Got Carried Agent",
                    "description": "Tells an agent that they have just picked something up."
                },
                {
                    "id": 6676,
                    "argument_list_id": 266,
                    "value": "125",
                    "name": "Lost Carried Agent",
                    "description": "Tells an agent that they have just dropped something."
                },
                {
                    "id": 6677,
                    "argument_list_id": 266,
                    "value": "126",
                    "name": "Make Speech Bubble",
                    "description": "Called when a creature speaks, so scripts can display a speech bubble. Every agent which has this script is called. _P1_ is the text being spoken, _P2_ is the creature who is speaking."
                },
                {
                    "id": 6678,
                    "argument_list_id": 266,
                    "value": "127",
                    "name": "Life Event",
                    "description": "Called whenever there is a new life event, whether an event built into the engine, or a custom event sent with HIST EVNT. _P1_ is the moniker that the event happened to, _P2_ is the event number as an index into the events for that moniker."
                },
                {
                    "id": 6679,
                    "argument_list_id": 266,
                    "value": "128",
                    "name": "World Loaded",
                    "description": "Called when the world had just been loaded, whether from bootstrap or from a saved file."
                },
                {
                    "id": 6680,
                    "argument_list_id": 266,
                    "value": "135",
                    "name": "Net Online",
                    "description": "Connection to the Babel server has been made."
                },
                {
                    "id": 6681,
                    "argument_list_id": 266,
                    "value": "136",
                    "name": "Net Offline",
                    "description": "Connection to the Babel server is broken."
                },
                {
                    "id": 6682,
                    "argument_list_id": 266,
                    "value": "137",
                    "name": "User Online",
                    "description": "User chosen with NET: WHON has gone online. _P1_ contains the user's id."
                },
                {
                    "id": 6683,
                    "argument_list_id": 266,
                    "value": "138",
                    "name": "User Offline",
                    "description": "User chosen with NET: WHON has gone offline. _P1_ contains the user's id."
                },
                {
                    "id": 6684,
                    "argument_list_id": 266,
                    "value": "150",
                    "name": "Creature Navigation Callback Valid It",
                    "description": "Called by the approach command with _P1_ and _P2_ set to the IT object's X and Y coordinates respectively."
                },
                {
                    "id": 6685,
                    "argument_list_id": 266,
                    "value": "151",
                    "name": "Creature Navigation Callback Outside Room System",
                    "description": "Called by the approach command when you are unable to use the CA because you're outside the room system."
                },
                {
                    "id": 6686,
                    "argument_list_id": 266,
                    "value": "152",
                    "name": "Creature Navigation Callback Neighbour",
                    "description": "Called by the approach command if there is no IT object. _P1_ and _P2_ are set to the X and Y coordinates of the room's centre with the highest (or lowest if retreating) smell of IT nearby."
                },
                {
                    "id": 6687,
                    "argument_list_id": 266,
                    "value": "153",
                    "name": "Creature Navigation Callback Link",
                    "description": "As for 152 but called when the best room is a link."
                },
                {
                    "id": 6688,
                    "argument_list_id": 266,
                    "value": "154",
                    "name": "Creature Navigation Callback Current Room Best",
                    "description": "As for 152 but called when the room you're in is already the best one."
                },
                {
                    "id": 6689,
                    "argument_list_id": 266,
                    "value": "160",
                    "name": "Creature Ageing Callback",
                    "description": "Called when the creature is about to age. _P1_ contains the value of the next age stage."
                },
                {
                    "id": 6690,
                    "argument_list_id": 266,
                    "value": "200",
                    "name": "Mate",
                    "description": "Reserved for use in the mating scripts, but not directly used by the engine. Tells a male to mate."
                },
                {
                    "id": 6691,
                    "argument_list_id": 266,
                    "value": "255",
                    "name": "Agent Exception",
                    "description": "This script specifies the behaviour when an agent tries to do something to an invalid agent. For example, if you try and access an OVxx with a NULL target. If this script isn't present for OWNR, you get a run time error. If it is present, that script is called and you can reset variables as necessary."
                }
            ],
            "variants": 32
        },
        "list_120": {
            "id": 120,
            "variant": "C2",
            "name": "EventNumbers",
            "base_values_list_id": 32,
            "arguments": [
                {
                    "id": 2118,
                    "argument_list_id": 120,
                    "value": "0",
                    "name": "Deactivate",
                    "description": "An action generally used to disable an active object \u2013 STOP to a creature"
                },
                {
                    "id": 2119,
                    "argument_list_id": 120,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "An action performed on an object \u2013 PUSH to a creature"
                },
                {
                    "id": 2120,
                    "argument_list_id": 120,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "An action performed on an object \u2013 PULL to a creature"
                },
                {
                    "id": 2121,
                    "argument_list_id": 120,
                    "value": "3",
                    "name": "Hit",
                    "description": "An action performed on an object \u2013 HIT to a creature"
                },
                {
                    "id": 2122,
                    "argument_list_id": 120,
                    "value": "4",
                    "name": "Pickup",
                    "description": "The event that is run when an object is picked up \u2013 GET to a creature"
                },
                {
                    "id": 2123,
                    "argument_list_id": 120,
                    "value": "5",
                    "name": "Drop",
                    "description": "The event that is run when an object is dropped \u2013 DROP to a creature"
                },
                {
                    "id": 2124,
                    "argument_list_id": 120,
                    "value": "6",
                    "name": "Collision",
                    "description": "The event that is run when an object has collided with a room boundary or floor"
                },
                {
                    "id": 2125,
                    "argument_list_id": 120,
                    "value": "7",
                    "name": "Enter scope",
                    "description": "The event an object receives when the world starts up"
                },
                {
                    "id": 7328,
                    "argument_list_id": 120,
                    "value": "8",
                    "name": "Leave Scope",
                    "description": "Object has just left scope"
                },
                {
                    "id": 2126,
                    "argument_list_id": 120,
                    "value": "9",
                    "name": "Timer",
                    "description": "The event an object receives when it\u2019s tick has reached zero"
                },
                {
                    "id": 2127,
                    "argument_list_id": 120,
                    "value": "10",
                    "name": "Push left",
                    "description": "An action performed on an object"
                },
                {
                    "id": 2128,
                    "argument_list_id": 120,
                    "value": "11",
                    "name": "Push right",
                    "description": "An action performed on an object"
                },
                {
                    "id": 2129,
                    "argument_list_id": 120,
                    "value": "12",
                    "name": "Eat",
                    "description": "An action performed on an object"
                },
                {
                    "id": 2130,
                    "argument_list_id": 120,
                    "value": "16",
                    "name": "Extra Quiescent",
                    "description": "CREATURE - Stand and watch it"
                },
                {
                    "id": 2131,
                    "argument_list_id": 120,
                    "value": "17",
                    "name": "Extra Activate 1",
                    "description": "CREATURE \u2013 Activate 1 it"
                },
                {
                    "id": 2132,
                    "argument_list_id": 120,
                    "value": "18",
                    "name": "Extra Activate 2",
                    "description": "CREATURE \u2013 Activate 2 it"
                },
                {
                    "id": 2133,
                    "argument_list_id": 120,
                    "value": "19",
                    "name": "Extra Deactivate",
                    "description": "CREATURE \u2013 Deactivate it"
                },
                {
                    "id": 2134,
                    "argument_list_id": 120,
                    "value": "20",
                    "name": "Extra Seek",
                    "description": "CREATURE \u2013 Go up and look at it"
                },
                {
                    "id": 2135,
                    "argument_list_id": 120,
                    "value": "21",
                    "name": "Extra Avoid",
                    "description": "CREATURE \u2013 Walk/run away from it"
                },
                {
                    "id": 2136,
                    "argument_list_id": 120,
                    "value": "22",
                    "name": "Extra Pickup",
                    "description": "CREATURE \u2013 Pick it up"
                },
                {
                    "id": 2137,
                    "argument_list_id": 120,
                    "value": "23",
                    "name": "Extra Drop",
                    "description": "CREATURE \u2013 Drop anything you are carrying"
                },
                {
                    "id": 2138,
                    "argument_list_id": 120,
                    "value": "24",
                    "name": "Extra Need",
                    "description": "CREATURE \u2013 Say what\u2019s bothering you"
                },
                {
                    "id": 2139,
                    "argument_list_id": 120,
                    "value": "25",
                    "name": "Extra Rest",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2140,
                    "argument_list_id": 120,
                    "value": "26",
                    "name": "Extra West",
                    "description": "CREATURE \u2013 Walk idly to west"
                },
                {
                    "id": 2141,
                    "argument_list_id": 120,
                    "value": "27",
                    "name": "Extra East",
                    "description": "CREATURE \u2013 Walk idly to east"
                },
                {
                    "id": 2142,
                    "argument_list_id": 120,
                    "value": "28",
                    "name": "Extra Eat",
                    "description": "CREATURE \u2013 Eat it"
                },
                {
                    "id": 2143,
                    "argument_list_id": 120,
                    "value": "29",
                    "name": "Extra Hit",
                    "description": "CREATURE \u2013 Hit it"
                },
                {
                    "id": 2144,
                    "argument_list_id": 120,
                    "value": "32",
                    "name": "Intro Quiescent",
                    "description": "CREATURE \u2013 Stand and twiddle your thumbs"
                },
                {
                    "id": 2145,
                    "argument_list_id": 120,
                    "value": "33",
                    "name": "Intro Activate 1",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2146,
                    "argument_list_id": 120,
                    "value": "34",
                    "name": "Intro Activate 2",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2147,
                    "argument_list_id": 120,
                    "value": "35",
                    "name": "Intro Deactivate",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2148,
                    "argument_list_id": 120,
                    "value": "36",
                    "name": "Intro Seek",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2149,
                    "argument_list_id": 120,
                    "value": "37",
                    "name": "Intro Avoid",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2150,
                    "argument_list_id": 120,
                    "value": "38",
                    "name": "Intro Pickup",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2151,
                    "argument_list_id": 120,
                    "value": "39",
                    "name": "Intro Drop",
                    "description": "CREATURE \u2013 Drop anything you are carrying"
                },
                {
                    "id": 2152,
                    "argument_list_id": 120,
                    "value": "40",
                    "name": "Intro Need",
                    "description": "CREATURE \u2013 Say what\u2019s bothering you"
                },
                {
                    "id": 2153,
                    "argument_list_id": 120,
                    "value": "41",
                    "name": "Intro Rest",
                    "description": "CREATURE \u2013 rest or sleep"
                },
                {
                    "id": 2154,
                    "argument_list_id": 120,
                    "value": "42",
                    "name": "Intro West",
                    "description": "CREATURE \u2013 Walk idly to west"
                },
                {
                    "id": 2155,
                    "argument_list_id": 120,
                    "value": "43",
                    "name": "Intro East",
                    "description": "CREATURE \u2013 Walk idly to east"
                },
                {
                    "id": 2156,
                    "argument_list_id": 120,
                    "value": "44",
                    "name": "Intro Eat",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2157,
                    "argument_list_id": 120,
                    "value": "45",
                    "name": "Intro Hit",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 2158,
                    "argument_list_id": 120,
                    "value": "50",
                    "name": "Pointer Activate 1",
                    "description": "POINTER \u2013 Left button click causing an Activate 1"
                },
                {
                    "id": 2159,
                    "argument_list_id": 120,
                    "value": "51",
                    "name": "Pointer Activate 2",
                    "description": "POINTER \u2013 Left button click causing an Activate 2"
                },
                {
                    "id": 2160,
                    "argument_list_id": 120,
                    "value": "52",
                    "name": "Pointer Deactivate",
                    "description": "POINTER \u2013 Left button click causing a Deactivate"
                },
                {
                    "id": 2161,
                    "argument_list_id": 120,
                    "value": "53",
                    "name": "Pointer Pickup",
                    "description": "POINTER \u2013 Right button click, grab object"
                },
                {
                    "id": 2162,
                    "argument_list_id": 120,
                    "value": "54",
                    "name": "Pointer Drop",
                    "description": "POINTER \u2013 Right button click to drop a held object"
                },
                {
                    "id": 2163,
                    "argument_list_id": 120,
                    "value": "55",
                    "name": "Pointer Push Left",
                    "description": "POINTER \u2013 Left button click in push pointer mode"
                },
                {
                    "id": 2164,
                    "argument_list_id": 120,
                    "value": "56",
                    "name": "Pointer Push Right",
                    "description": "POINTER \u2013 Left button click in push pointer mode"
                },
                {
                    "id": 2165,
                    "argument_list_id": 120,
                    "value": "64",
                    "name": "Involuntary 0",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2166,
                    "argument_list_id": 120,
                    "value": "65",
                    "name": "Involuntary 1",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2167,
                    "argument_list_id": 120,
                    "value": "66",
                    "name": "Involuntary 2",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2168,
                    "argument_list_id": 120,
                    "value": "67",
                    "name": "Involuntary 3",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2169,
                    "argument_list_id": 120,
                    "value": "68",
                    "name": "Involuntary 4",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2170,
                    "argument_list_id": 120,
                    "value": "69",
                    "name": "Involuntary 5",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2171,
                    "argument_list_id": 120,
                    "value": "70",
                    "name": "Involuntary 6",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2172,
                    "argument_list_id": 120,
                    "value": "71",
                    "name": "Involuntary 7",
                    "description": "CREATURE - Chemically invoked reflex or pathological behaviour"
                },
                {
                    "id": 2173,
                    "argument_list_id": 120,
                    "value": "72",
                    "name": "Death",
                    "description": "CREATURE \u2013 Death event"
                },
                {
                    "id": 2174,
                    "argument_list_id": 120,
                    "value": "200",
                    "name": "Donate Sperm",
                    "description": "MALE CREATURE \u2013 event that can triggered by a female during mating."
                },
                {
                    "id": 2175,
                    "argument_list_id": 120,
                    "value": "255",
                    "name": "Exception",
                    "description": "A script was referencing an object that has been destroyed"
                }
            ],
            "variants": 2
        },
        "list_146": {
            "id": 146,
            "variant": "C3",
            "name": "EventNumbers",
            "base_values_list_id": 32,
            "arguments": [
                {
                    "id": 3356,
                    "argument_list_id": 146,
                    "value": "0",
                    "name": "Deactivate",
                    "description": "Called when the agent receives a deactivate message."
                },
                {
                    "id": 3357,
                    "argument_list_id": 146,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "Called when the agent receives an activate 1 message."
                },
                {
                    "id": 3358,
                    "argument_list_id": 146,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "Called when the agent receives an activate 2 message."
                },
                {
                    "id": 3359,
                    "argument_list_id": 146,
                    "value": "3",
                    "name": "Hit",
                    "description": "Called when the agent receives a hit message."
                },
                {
                    "id": 3360,
                    "argument_list_id": 146,
                    "value": "4",
                    "name": "Pickup",
                    "description": "Called when the agent has been picked up by something other than a vehicle."
                },
                {
                    "id": 3361,
                    "argument_list_id": 146,
                    "value": "5",
                    "name": "Drop",
                    "description": "Called when the agent has been dropped by something other than a vehicle."
                },
                {
                    "id": 3362,
                    "argument_list_id": 146,
                    "value": "6",
                    "name": "Collision",
                    "description": "Called when the agent collides with an obstacle. _P1_ and _P2_ are the x and y components of the collision velocity."
                },
                {
                    "id": 3363,
                    "argument_list_id": 146,
                    "value": "7",
                    "name": "Bump",
                    "description": "Called when a creature walks into a wall."
                },
                {
                    "id": 3364,
                    "argument_list_id": 146,
                    "value": "8",
                    "name": "Impact",
                    "description": "Called when an agent's presence impacts with another agent's presence (this is assuming both agents have their presence switched on)."
                },
                {
                    "id": 3365,
                    "argument_list_id": 146,
                    "value": "9",
                    "name": "Timer",
                    "description": "Called at a regular time interval, as set by TICK."
                },
                {
                    "id": 3366,
                    "argument_list_id": 146,
                    "value": "10",
                    "name": "Constructor",
                    "description": "Called on creation."
                },
                {
                    "id": 3367,
                    "argument_list_id": 146,
                    "value": "12",
                    "name": "Eat",
                    "description": "Called when the creature eats something."
                },
                {
                    "id": 3368,
                    "argument_list_id": 146,
                    "value": "13",
                    "name": "Start Hold Hands",
                    "description": "Called when a creature starts holding hands with the pointer."
                },
                {
                    "id": 3369,
                    "argument_list_id": 146,
                    "value": "14",
                    "name": "Stop Hold Hands",
                    "description": "Called when a creature stops holding hands with the pointer."
                },
                {
                    "id": 3370,
                    "argument_list_id": 146,
                    "value": "16",
                    "name": "Quiescent on Agents",
                    "description": "Scripts 16 - 30 are executed on a creature when it decides to do something with its attention on an ordinary agent (rather than a creature). The script should perform this action. Quiescent means stand and watch it. The catalogue entry \"Action Script To Neuron Mappings\" maps the brain to these scripts, although which scripts require an it object are hard-wired."
                },
                {
                    "id": 3371,
                    "argument_list_id": 146,
                    "value": "17",
                    "name": "Activate 1 on Agents",
                    "description": "Activate 1 it."
                },
                {
                    "id": 3372,
                    "argument_list_id": 146,
                    "value": "18",
                    "name": "Activate 2 on Agents",
                    "description": "Activate 2 it."
                },
                {
                    "id": 3373,
                    "argument_list_id": 146,
                    "value": "19",
                    "name": "Deactivate on Agents",
                    "description": "Deactivate it."
                },
                {
                    "id": 3374,
                    "argument_list_id": 146,
                    "value": "20",
                    "name": "Approach on Agents",
                    "description": "Go up and look at it."
                },
                {
                    "id": 3375,
                    "argument_list_id": 146,
                    "value": "21",
                    "name": "Retreat on Agents",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 3376,
                    "argument_list_id": 146,
                    "value": "22",
                    "name": "Pickup on Agents",
                    "description": "Pick it up."
                },
                {
                    "id": 3377,
                    "argument_list_id": 146,
                    "value": "23",
                    "name": "Drop on Agents",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 3378,
                    "argument_list_id": 146,
                    "value": "24",
                    "name": "Need on Agents",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 3379,
                    "argument_list_id": 146,
                    "value": "25",
                    "name": "Rest on Agents",
                    "description": "Becoming sleepy."
                },
                {
                    "id": 3380,
                    "argument_list_id": 146,
                    "value": "26",
                    "name": "West on Agents",
                    "description": "Walk idly to west."
                },
                {
                    "id": 3381,
                    "argument_list_id": 146,
                    "value": "27",
                    "name": "East on Agents",
                    "description": "Walk idly to east."
                },
                {
                    "id": 3382,
                    "argument_list_id": 146,
                    "value": "28",
                    "name": "Eat on Agents",
                    "description": "Eat it."
                },
                {
                    "id": 3383,
                    "argument_list_id": 146,
                    "value": "29",
                    "name": "Hit on Agents",
                    "description": "Hit it."
                },
                {
                    "id": 3384,
                    "argument_list_id": 146,
                    "value": "30",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 3385,
                    "argument_list_id": 146,
                    "value": "31",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 3386,
                    "argument_list_id": 146,
                    "value": "32",
                    "name": "Quiescent on Creatures",
                    "description": "Scripts 32 - 47 are executed on a creature when it decides to do something with its attention on another creature. Quiescent means stand and twiddle your thumbs."
                },
                {
                    "id": 3387,
                    "argument_list_id": 146,
                    "value": "33",
                    "name": "Activate 1 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 3388,
                    "argument_list_id": 146,
                    "value": "34",
                    "name": "Activate 2 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 3389,
                    "argument_list_id": 146,
                    "value": "35",
                    "name": "Deactivate on Creatures",
                    "description": "Deactivate it."
                },
                {
                    "id": 3390,
                    "argument_list_id": 146,
                    "value": "36",
                    "name": "Approach on Creatures",
                    "description": "Go up and look at it."
                },
                {
                    "id": 3391,
                    "argument_list_id": 146,
                    "value": "37",
                    "name": "Retreat on Creatures",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 3392,
                    "argument_list_id": 146,
                    "value": "38",
                    "name": "Pickup on Creatures",
                    "description": "Pick it up."
                },
                {
                    "id": 3393,
                    "argument_list_id": 146,
                    "value": "39",
                    "name": "Drop on Creatures",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 3394,
                    "argument_list_id": 146,
                    "value": "40",
                    "name": "Need on Creatures",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 3395,
                    "argument_list_id": 146,
                    "value": "41",
                    "name": "Rest on Creatures",
                    "description": "Rest or sleep."
                },
                {
                    "id": 3396,
                    "argument_list_id": 146,
                    "value": "42",
                    "name": "West on Creatures",
                    "description": "Walk idly to west."
                },
                {
                    "id": 3397,
                    "argument_list_id": 146,
                    "value": "43",
                    "name": "East on Creatures",
                    "description": "Walk idly to east."
                },
                {
                    "id": 3398,
                    "argument_list_id": 146,
                    "value": "44",
                    "name": "Eat on Creatures",
                    "description": "Eat it."
                },
                {
                    "id": 3399,
                    "argument_list_id": 146,
                    "value": "45",
                    "name": "Hit on Creatures",
                    "description": "Hit it."
                },
                {
                    "id": 3400,
                    "argument_list_id": 146,
                    "value": "46",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 3401,
                    "argument_list_id": 146,
                    "value": "47",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 3402,
                    "argument_list_id": 146,
                    "value": "64",
                    "name": "Flinch",
                    "description": "Involuntary action called when the creature flinches."
                },
                {
                    "id": 3403,
                    "argument_list_id": 146,
                    "value": "65",
                    "name": "Lay Egg",
                    "description": "Involuntary action called when the creature lays an egg."
                },
                {
                    "id": 3404,
                    "argument_list_id": 146,
                    "value": "66",
                    "name": "Sneeze",
                    "description": "Involuntary action called when the creature sneezes."
                },
                {
                    "id": 3405,
                    "argument_list_id": 146,
                    "value": "67",
                    "name": "Cough",
                    "description": "Involuntary action called when the creature coughs."
                },
                {
                    "id": 3406,
                    "argument_list_id": 146,
                    "value": "68",
                    "name": "Shiver",
                    "description": "Involuntary action called when the creature shivers."
                },
                {
                    "id": 3407,
                    "argument_list_id": 146,
                    "value": "69",
                    "name": "Sleep",
                    "description": "Involuntary action called when the creature sleeps."
                },
                {
                    "id": 3408,
                    "argument_list_id": 146,
                    "value": "70",
                    "name": "Fainting",
                    "description": "Involuntary action called when the creature faints."
                },
                {
                    "id": 3409,
                    "argument_list_id": 146,
                    "value": "71",
                    "name": "Unassigned",
                    "description": "Involuntary action for future expansion."
                },
                {
                    "id": 3410,
                    "argument_list_id": 146,
                    "value": "72",
                    "name": "Die",
                    "description": "Special involuntary action called when a creature dies. Any death animations go here."
                },
                {
                    "id": 3411,
                    "argument_list_id": 146,
                    "value": "73",
                    "name": "Raw Key Down",
                    "description": "Called when a key is pressed and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 3412,
                    "argument_list_id": 146,
                    "value": "74",
                    "name": "Raw Key Up",
                    "description": "Called when a key is released and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 3413,
                    "argument_list_id": 146,
                    "value": "75",
                    "name": "Raw Mouse Move",
                    "description": "Called when the mouse moves and IMSK is set. The new x and y position is sent in _P1_ and _P2_"
                },
                {
                    "id": 3414,
                    "argument_list_id": 146,
                    "value": "76",
                    "name": "Raw Mouse Down",
                    "description": "Called when a mouse button is pressed and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 3415,
                    "argument_list_id": 146,
                    "value": "77",
                    "name": "Raw Mouse Up",
                    "description": "Called when a mouse button is released and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 3416,
                    "argument_list_id": 146,
                    "value": "78",
                    "name": "Raw Mouse Wheel",
                    "description": "Called when the mouse wheel is moved and IMSK is set. The delta value is sent in _P1_ - 120 units per 'click'."
                },
                {
                    "id": 3417,
                    "argument_list_id": 146,
                    "value": "79",
                    "name": "Raw Translated Char",
                    "description": "Called when a translated character is received and IMSK is set. For example, on Japanese systems the raw key down and up codes can be in Roman characters, but the Input Method Editor converts them to Japanese characters, which are sent to the game with this message. The translated key code is sent in _P1_. You can use this for character input, but it is easier to use PAT: TEXT."
                },
                {
                    "id": 3418,
                    "argument_list_id": 146,
                    "value": "92",
                    "name": "UI Mouse Down",
                    "description": "Called when the mouse clicks on an agent."
                },
                {
                    "id": 3419,
                    "argument_list_id": 146,
                    "value": "101",
                    "name": "Pointer Activate 1",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3420,
                    "argument_list_id": 146,
                    "value": "102",
                    "name": "Pointer Activate 2",
                    "description": "Called on the pointer when an agent is activated 2. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3421,
                    "argument_list_id": 146,
                    "value": "103",
                    "name": "Pointer Deactivate",
                    "description": "Called on the pointer when an agent is deactivated. The script has the same classifier as the agent being deactivated."
                },
                {
                    "id": 3422,
                    "argument_list_id": 146,
                    "value": "104",
                    "name": "Pointer Pickup",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3423,
                    "argument_list_id": 146,
                    "value": "105",
                    "name": "Pointer Drop",
                    "description": "Called on the pointer when an agent is dropped. The script has the same classifier as the agent being dropped."
                },
                {
                    "id": 3424,
                    "argument_list_id": 146,
                    "value": "110",
                    "name": "Pointer Port Select",
                    "description": "Called on the pointer when you manipulate a port."
                },
                {
                    "id": 3425,
                    "argument_list_id": 146,
                    "value": "111",
                    "name": "Pointer Port Connect",
                    "description": "Called on the pointer when you complete the connection between two ports."
                },
                {
                    "id": 3426,
                    "argument_list_id": 146,
                    "value": "112",
                    "name": "Pointer Port Disconnect",
                    "description": "Called on the pointer when you complete the disconnection of two previously connected ports."
                },
                {
                    "id": 3427,
                    "argument_list_id": 146,
                    "value": "113",
                    "name": "Pointer Port Cancel",
                    "description": "Called on the pointer if you cancel a port change part way through."
                },
                {
                    "id": 3428,
                    "argument_list_id": 146,
                    "value": "114",
                    "name": "Pointer Port Error",
                    "description": "Called on the pointer if there is some error with the configuration of ports the user is trying to make."
                },
                {
                    "id": 3429,
                    "argument_list_id": 146,
                    "value": "116",
                    "name": "Pointer Clicked Background",
                    "description": "Called when the pointer is clicked but there aren't any agents under it."
                },
                {
                    "id": 3430,
                    "argument_list_id": 146,
                    "value": "117",
                    "name": "Pointer Action Dispatch",
                    "description": "Called on the pointer to tell it what action clicking would take on the creature under it. _P1_ says what will happen: 0 means no action or not above a creature, 1 means deactivate (slap), 2 means activate 1 (tickle)."
                },
                {
                    "id": 3431,
                    "argument_list_id": 146,
                    "value": "118",
                    "name": "Connection Break",
                    "description": "Called on an agent when any of its ports are broken as a result of exceeding the maximum connection distance."
                },
                {
                    "id": 3432,
                    "argument_list_id": 146,
                    "value": "120",
                    "name": "Selected Creature Changed",
                    "description": "Called on all agents with this script when the selected creature is changed by NORN. _P1_ is the new creature, _P2_ is the previously selected creature."
                },
                {
                    "id": 3433,
                    "argument_list_id": 146,
                    "value": "121",
                    "name": "Vehicle Pickup",
                    "description": "Called when an agent has been picked up by a vehicle."
                },
                {
                    "id": 3434,
                    "argument_list_id": 146,
                    "value": "122",
                    "name": "Vehicle Drop",
                    "description": "Called when an agent has been dropped by a vehicle."
                },
                {
                    "id": 3435,
                    "argument_list_id": 146,
                    "value": "123",
                    "name": "Window Resized",
                    "description": "Called on all agents with this script whenever the main view is resized."
                },
                {
                    "id": 3436,
                    "argument_list_id": 146,
                    "value": "124",
                    "name": "Got Carried Agent",
                    "description": "Tells an agent that they have just picked something up."
                },
                {
                    "id": 3437,
                    "argument_list_id": 146,
                    "value": "125",
                    "name": "Lost Carried Agent",
                    "description": "Tells an agent that they have just dropped something."
                },
                {
                    "id": 3438,
                    "argument_list_id": 146,
                    "value": "126",
                    "name": "Make Speech Bubble",
                    "description": "Called when a creature speaks, so scripts can display a speech bubble. Every agent which has this script is called. _P1_ is the text being spoken, _P2_ is the creature who is speaking."
                },
                {
                    "id": 3439,
                    "argument_list_id": 146,
                    "value": "127",
                    "name": "Life Event",
                    "description": "Called whenever there is a new life event, whether an event built into the engine, or a custom event sent with HIST EVNT. _P1_ is the moniker that the event happened to, _P2_ is the event number as an index into the events for that moniker."
                },
                {
                    "id": 3440,
                    "argument_list_id": 146,
                    "value": "128",
                    "name": "World Loaded",
                    "description": "Called when the world had just been loaded, whether from bootstrap or from a saved file."
                },
                {
                    "id": 3441,
                    "argument_list_id": 146,
                    "value": "135",
                    "name": "Net Online",
                    "description": "Connection to the Babel server has been made."
                },
                {
                    "id": 3442,
                    "argument_list_id": 146,
                    "value": "136",
                    "name": "Net Offline",
                    "description": "Connection to the Babel server is broken."
                },
                {
                    "id": 3443,
                    "argument_list_id": 146,
                    "value": "137",
                    "name": "User Online",
                    "description": "User chosen with NET: WHON has gone online. _P1_ contains the user's id."
                },
                {
                    "id": 3444,
                    "argument_list_id": 146,
                    "value": "138",
                    "name": "User Offline",
                    "description": "User chosen with NET: WHON has gone offline. _P1_ contains the user's id."
                },
                {
                    "id": 3445,
                    "argument_list_id": 146,
                    "value": "150",
                    "name": "Creature Navigation Callback Valid It",
                    "description": "Called by the approach command with _P1_ and _P2_ set to the IT object's X and Y coordinates respectively."
                },
                {
                    "id": 3446,
                    "argument_list_id": 146,
                    "value": "151",
                    "name": "Creature Navigation Callback Outside Room System",
                    "description": "Called by the approach command when you are unable to use the CA because you're outside the room system."
                },
                {
                    "id": 3447,
                    "argument_list_id": 146,
                    "value": "152",
                    "name": "Creature Navigation Callback Neighbour",
                    "description": "Called by the approach command if there is no IT object. _P1_ and _P2_ are set to the X and Y coordinates of the room's centre with the highest (or lowest if retreating) smell of IT nearby."
                },
                {
                    "id": 3448,
                    "argument_list_id": 146,
                    "value": "153",
                    "name": "Creature Navigation Callback Link",
                    "description": "As for 152 but called when the best room is a link."
                },
                {
                    "id": 3449,
                    "argument_list_id": 146,
                    "value": "154",
                    "name": "Creature Navigation Callback Current Room Best",
                    "description": "As for 152 but called when the room you're in is already the best one."
                },
                {
                    "id": 3450,
                    "argument_list_id": 146,
                    "value": "160",
                    "name": "Creature Ageing Callback",
                    "description": "Called when the creature is about to age. _P1_ contains the value of the next age stage."
                },
                {
                    "id": 3451,
                    "argument_list_id": 146,
                    "value": "200",
                    "name": "Mate",
                    "description": "Reserved for use in the mating scripts, but not directly used by the engine. Tells a male to mate."
                },
                {
                    "id": 3452,
                    "argument_list_id": 146,
                    "value": "255",
                    "name": "Agent Exception",
                    "description": "This script specifies the behaviour when an agent tries to do something to an invalid agent. For example, if you try and access an OVxx with a NULL target. If this script isn't present for OWNR, you get a run time error. If it is present, that script is called and you can reset variables as necessary."
                }
            ],
            "variants": 8
        },
        "list_147": {
            "id": 147,
            "variant": "CV",
            "name": "EventNumbers",
            "base_values_list_id": 32,
            "arguments": [
                {
                    "id": 3453,
                    "argument_list_id": 147,
                    "value": "0",
                    "name": "Deactivate",
                    "description": "Called when the agent receives a deactivate message."
                },
                {
                    "id": 3454,
                    "argument_list_id": 147,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "Called when the agent receives an activate 1 message."
                },
                {
                    "id": 3455,
                    "argument_list_id": 147,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "Called when the agent receives an activate 2 message."
                },
                {
                    "id": 3456,
                    "argument_list_id": 147,
                    "value": "3",
                    "name": "Hit",
                    "description": "Called when the agent receives a hit message."
                },
                {
                    "id": 3457,
                    "argument_list_id": 147,
                    "value": "4",
                    "name": "Pickup",
                    "description": "Called when the agent has been picked up by something other than a vehicle."
                },
                {
                    "id": 3458,
                    "argument_list_id": 147,
                    "value": "5",
                    "name": "Drop",
                    "description": "Called when the agent has been dropped by something other than a vehicle."
                },
                {
                    "id": 3459,
                    "argument_list_id": 147,
                    "value": "6",
                    "name": "Collision",
                    "description": "Called when the agent collides with an obstacle. _P1_ and _P2_ are the x and y components of the collision velocity."
                },
                {
                    "id": 3460,
                    "argument_list_id": 147,
                    "value": "7",
                    "name": "Bump",
                    "description": "Called when a creature walks into a wall."
                },
                {
                    "id": 3461,
                    "argument_list_id": 147,
                    "value": "9",
                    "name": "Timer",
                    "description": "Called at a regular time interval, as set by TICK."
                },
                {
                    "id": 3462,
                    "argument_list_id": 147,
                    "value": "12",
                    "name": "Eat",
                    "description": "Called when the creature eats something."
                },
                {
                    "id": 3463,
                    "argument_list_id": 147,
                    "value": "13",
                    "name": "Start Hold Hands",
                    "description": "Called when a creature starts holding hands with the pointer."
                },
                {
                    "id": 3464,
                    "argument_list_id": 147,
                    "value": "14",
                    "name": "Stop Hold Hands",
                    "description": "Called when a creature stops holding hands with the pointer."
                },
                {
                    "id": 3465,
                    "argument_list_id": 147,
                    "value": "16",
                    "name": "Quiescent on Agents",
                    "description": "Scripts 16 - 30 are executed on a creature when it decides to do something with its attention on an ordinary agent (rather than a creature). The script should perform this action. Quiescent means stand and watch it. The catalogue entry \"Action Script To Neuron Mappings\" maps the brain to these scripts, although which scripts require an it object are hard-wired."
                },
                {
                    "id": 3466,
                    "argument_list_id": 147,
                    "value": "17",
                    "name": "Activate 1 on Agents",
                    "description": "Activate 1 it."
                },
                {
                    "id": 3467,
                    "argument_list_id": 147,
                    "value": "18",
                    "name": "Activate 2 on Agents",
                    "description": "Activate 2 it."
                },
                {
                    "id": 3468,
                    "argument_list_id": 147,
                    "value": "19",
                    "name": "Deactivate on Agents",
                    "description": "Deactivate it."
                },
                {
                    "id": 3469,
                    "argument_list_id": 147,
                    "value": "20",
                    "name": "Approach on Agents",
                    "description": "Go up and look at it."
                },
                {
                    "id": 3470,
                    "argument_list_id": 147,
                    "value": "21",
                    "name": "Retreat on Agents",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 3471,
                    "argument_list_id": 147,
                    "value": "22",
                    "name": "Pickup on Agents",
                    "description": "Pick it up."
                },
                {
                    "id": 3472,
                    "argument_list_id": 147,
                    "value": "23",
                    "name": "Drop on Agents",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 3473,
                    "argument_list_id": 147,
                    "value": "24",
                    "name": "Need on Agents",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 3474,
                    "argument_list_id": 147,
                    "value": "25",
                    "name": "Rest on Agents",
                    "description": "Becoming sleepy."
                },
                {
                    "id": 3475,
                    "argument_list_id": 147,
                    "value": "26",
                    "name": "West on Agents",
                    "description": "Walk idly to west."
                },
                {
                    "id": 3476,
                    "argument_list_id": 147,
                    "value": "27",
                    "name": "East on Agents",
                    "description": "Walk idly to east."
                },
                {
                    "id": 3477,
                    "argument_list_id": 147,
                    "value": "28",
                    "name": "Eat on Agents",
                    "description": "Eat it."
                },
                {
                    "id": 3478,
                    "argument_list_id": 147,
                    "value": "29",
                    "name": "Hit on Agents",
                    "description": "Hit it."
                },
                {
                    "id": 3479,
                    "argument_list_id": 147,
                    "value": "30",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 3480,
                    "argument_list_id": 147,
                    "value": "31",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 3481,
                    "argument_list_id": 147,
                    "value": "32",
                    "name": "Quiescent on Creatures",
                    "description": "Scripts 32 - 47 are executed on a creature when it decides to do something with its attention on another creature. Quiescent means stand and twiddle your thumbs."
                },
                {
                    "id": 3482,
                    "argument_list_id": 147,
                    "value": "33",
                    "name": "Activate 1 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 3483,
                    "argument_list_id": 147,
                    "value": "34",
                    "name": "Activate 2 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 3484,
                    "argument_list_id": 147,
                    "value": "35",
                    "name": "Deactivate on Creatures",
                    "description": "Deactivate it."
                },
                {
                    "id": 3485,
                    "argument_list_id": 147,
                    "value": "36",
                    "name": "Approach on Creatures",
                    "description": "Go up and look at it."
                },
                {
                    "id": 3486,
                    "argument_list_id": 147,
                    "value": "37",
                    "name": "Retreat on Creatures",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 3487,
                    "argument_list_id": 147,
                    "value": "38",
                    "name": "Pickup on Creatures",
                    "description": "Pick it up."
                },
                {
                    "id": 3488,
                    "argument_list_id": 147,
                    "value": "39",
                    "name": "Drop on Creatures",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 3489,
                    "argument_list_id": 147,
                    "value": "40",
                    "name": "Need on Creatures",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 3490,
                    "argument_list_id": 147,
                    "value": "41",
                    "name": "Rest on Creatures",
                    "description": "Rest or sleep."
                },
                {
                    "id": 3491,
                    "argument_list_id": 147,
                    "value": "42",
                    "name": "West on Creatures",
                    "description": "Walk idly to west."
                },
                {
                    "id": 3492,
                    "argument_list_id": 147,
                    "value": "43",
                    "name": "East on Creatures",
                    "description": "Walk idly to east."
                },
                {
                    "id": 3493,
                    "argument_list_id": 147,
                    "value": "44",
                    "name": "Eat on Creatures",
                    "description": "Eat it."
                },
                {
                    "id": 3494,
                    "argument_list_id": 147,
                    "value": "45",
                    "name": "Hit on Creatures",
                    "description": "Hit it."
                },
                {
                    "id": 3495,
                    "argument_list_id": 147,
                    "value": "46",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 3496,
                    "argument_list_id": 147,
                    "value": "47",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 3497,
                    "argument_list_id": 147,
                    "value": "64",
                    "name": "Flinch",
                    "description": "Involuntary action called when the creature flinches."
                },
                {
                    "id": 3498,
                    "argument_list_id": 147,
                    "value": "65",
                    "name": "Lay Egg",
                    "description": "Involuntary action called when the creature lays an egg."
                },
                {
                    "id": 3499,
                    "argument_list_id": 147,
                    "value": "66",
                    "name": "Sneeze",
                    "description": "Involuntary action called when the creature sneezes."
                },
                {
                    "id": 3500,
                    "argument_list_id": 147,
                    "value": "67",
                    "name": "Cough",
                    "description": "Involuntary action called when the creature coughs."
                },
                {
                    "id": 3501,
                    "argument_list_id": 147,
                    "value": "68",
                    "name": "Shiver",
                    "description": "Involuntary action called when the creature shivers."
                },
                {
                    "id": 3502,
                    "argument_list_id": 147,
                    "value": "69",
                    "name": "Sleep",
                    "description": "Involuntary action called when the creature sleeps."
                },
                {
                    "id": 3503,
                    "argument_list_id": 147,
                    "value": "70",
                    "name": "Fainting",
                    "description": "Involuntary action called when the creature faints."
                },
                {
                    "id": 3504,
                    "argument_list_id": 147,
                    "value": "71",
                    "name": "Unassigned",
                    "description": "Involuntary action for future expansion."
                },
                {
                    "id": 3505,
                    "argument_list_id": 147,
                    "value": "72",
                    "name": "Die",
                    "description": "Special involuntary action called when a creature dies. Any death animations go here."
                },
                {
                    "id": 3506,
                    "argument_list_id": 147,
                    "value": "73",
                    "name": "Raw Key Down",
                    "description": "Called when a key is pressed and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 3507,
                    "argument_list_id": 147,
                    "value": "74",
                    "name": "Raw Key Up",
                    "description": "Called when a key is released and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 3508,
                    "argument_list_id": 147,
                    "value": "75",
                    "name": "Raw Mouse Move",
                    "description": "Called when the mouse moves and IMSK is set. The new x and y position is sent in _P1_ and _P2_"
                },
                {
                    "id": 3509,
                    "argument_list_id": 147,
                    "value": "76",
                    "name": "Raw Mouse Down",
                    "description": "Called when a mouse button is pressed and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 3510,
                    "argument_list_id": 147,
                    "value": "77",
                    "name": "Raw Mouse Up",
                    "description": "Called when a mouse button is released and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 3511,
                    "argument_list_id": 147,
                    "value": "78",
                    "name": "Raw Mouse Wheel",
                    "description": "Called when the mouse wheel is moved and IMSK is set. The delta value is sent in _P1_ - 120 units per 'click'."
                },
                {
                    "id": 3512,
                    "argument_list_id": 147,
                    "value": "79",
                    "name": "Raw Translated Char",
                    "description": "Called when a translated character is received and IMSK is set. For example, on Japanese systems the raw key down and up codes can be in Roman characters, but the Input Method Editor converts them to Japanese characters, which are sent to the game with this message. The translated key code is sent in _P1_. You can use this for character input, but it is easier to use PAT: TEXT."
                },
                {
                    "id": 3513,
                    "argument_list_id": 147,
                    "value": "92",
                    "name": "UI Mouse Down",
                    "description": "Called when the mouse clicks on an agent."
                },
                {
                    "id": 3514,
                    "argument_list_id": 147,
                    "value": "101",
                    "name": "Pointer Activate 1",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3515,
                    "argument_list_id": 147,
                    "value": "102",
                    "name": "Pointer Activate 2",
                    "description": "Called on the pointer when an agent is activated 2. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3516,
                    "argument_list_id": 147,
                    "value": "103",
                    "name": "Pointer Deactivate",
                    "description": "Called on the pointer when an agent is deactivated. The script has the same classifier as the agent being deactivated."
                },
                {
                    "id": 3517,
                    "argument_list_id": 147,
                    "value": "104",
                    "name": "Pointer Pickup",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3518,
                    "argument_list_id": 147,
                    "value": "105",
                    "name": "Pointer Drop",
                    "description": "Called on the pointer when an agent is dropped. The script has the same classifier as the agent being dropped."
                },
                {
                    "id": 3519,
                    "argument_list_id": 147,
                    "value": "110",
                    "name": "Pointer Port Select",
                    "description": "Called on the pointer when you manipulate a port."
                },
                {
                    "id": 3520,
                    "argument_list_id": 147,
                    "value": "111",
                    "name": "Pointer Port Connect",
                    "description": "Called on the pointer when you complete the connection between two ports."
                },
                {
                    "id": 3521,
                    "argument_list_id": 147,
                    "value": "112",
                    "name": "Pointer Port Disconnect",
                    "description": "Called on the pointer when you complete the disconnection of two previously connected ports."
                },
                {
                    "id": 3522,
                    "argument_list_id": 147,
                    "value": "113",
                    "name": "Pointer Port Cancel",
                    "description": "Called on the pointer if you cancel a port change part way through."
                },
                {
                    "id": 3523,
                    "argument_list_id": 147,
                    "value": "114",
                    "name": "Pointer Port Error",
                    "description": "Called on the pointer if there is some error with the configuration of ports the user is trying to make."
                },
                {
                    "id": 3524,
                    "argument_list_id": 147,
                    "value": "116",
                    "name": "Pointer Clicked Background",
                    "description": "Called when the pointer is clicked but there aren't any agents under it."
                },
                {
                    "id": 3525,
                    "argument_list_id": 147,
                    "value": "117",
                    "name": "Pointer Action Dispatch",
                    "description": "Called on the pointer to tell it what action clicking would take on the creature under it. _P1_ says what will happen: 0 means no action or not above a creature, 1 means deactivate (slap), 2 means activate 1 (tickle)."
                },
                {
                    "id": 3526,
                    "argument_list_id": 147,
                    "value": "118",
                    "name": "Connection Break",
                    "description": "Called on an agent when any of its ports are broken as a result of exceeding the maximum connection distance."
                },
                {
                    "id": 3527,
                    "argument_list_id": 147,
                    "value": "120",
                    "name": "Selected Creature Changed",
                    "description": "Called on all agents with this script when the selected creature is changed by NORN. _P1_ is the new creature, _P2_ is the previously selected creature."
                },
                {
                    "id": 3528,
                    "argument_list_id": 147,
                    "value": "121",
                    "name": "Vehicle Pickup",
                    "description": "Called when an agent has been picked up by a vehicle."
                },
                {
                    "id": 3529,
                    "argument_list_id": 147,
                    "value": "122",
                    "name": "Vehicle Drop",
                    "description": "Called when an agent has been dropped by a vehicle."
                },
                {
                    "id": 3530,
                    "argument_list_id": 147,
                    "value": "123",
                    "name": "Window Resized",
                    "description": "Called on all agents with this script whenever the main view is resized."
                },
                {
                    "id": 3531,
                    "argument_list_id": 147,
                    "value": "124",
                    "name": "Got Carried Agent",
                    "description": "Tells an agent that they have just picked something up."
                },
                {
                    "id": 3532,
                    "argument_list_id": 147,
                    "value": "125",
                    "name": "Lost Carried Agent",
                    "description": "Tells an agent that they have just dropped something."
                },
                {
                    "id": 3533,
                    "argument_list_id": 147,
                    "value": "126",
                    "name": "Make Speech Bubble",
                    "description": "Called when a creature speaks, so scripts can display a speech bubble. Every agent which has this script is called. _P1_ is the text being spoken, _P2_ is the creature who is speaking."
                },
                {
                    "id": 3534,
                    "argument_list_id": 147,
                    "value": "127",
                    "name": "Life Event",
                    "description": "Called whenever there is a new life event, whether an event build into the engine, or a custom event sent with HIST EVNT. _P1_ is the moniker that the event happened to, _P2_ is the event number as an index into the events for that moniker."
                },
                {
                    "id": 3535,
                    "argument_list_id": 147,
                    "value": "128",
                    "name": "World Loaded",
                    "description": "Called when the world had just been loaded, whether from bootstrap or from a saved file."
                },
                {
                    "id": 3536,
                    "argument_list_id": 147,
                    "value": "200",
                    "name": "Mate",
                    "description": "Reserved for use in the mating scripts, but not directly used by the engine. Tells a male to mate."
                },
                {
                    "id": 3537,
                    "argument_list_id": 147,
                    "value": "255",
                    "name": "Agent Exception",
                    "description": "This script specifies the behaviour when an agent tries to do something to an invalid agent. For example, if you try and access an OVxx with a NULL target. If this script isn't present for OWNR, you get a run time error. If it is present, that script is called and you can reset variables as necessary."
                }
            ],
            "variants": 4
        },
        "list_149": {
            "id": 149,
            "variant": "DS",
            "name": "EventNumbers",
            "description": "Standard event numbers for Docking Station agents",
            "base_values_list_id": 32,
            "arguments": [
                {
                    "id": 3539,
                    "argument_list_id": 149,
                    "value": "0",
                    "name": "Deactivate",
                    "description": "Called when the agent receives a deactivate message."
                },
                {
                    "id": 3540,
                    "argument_list_id": 149,
                    "value": "1",
                    "name": "Activate 1",
                    "description": "Called when the agent receives an activate 1 message."
                },
                {
                    "id": 3541,
                    "argument_list_id": 149,
                    "value": "2",
                    "name": "Activate 2",
                    "description": "Called when the agent receives an activate 2 message."
                },
                {
                    "id": 3542,
                    "argument_list_id": 149,
                    "value": "3",
                    "name": "Hit",
                    "description": "Called when the agent receives a hit message."
                },
                {
                    "id": 3543,
                    "argument_list_id": 149,
                    "value": "4",
                    "name": "Pickup",
                    "description": "Called when the agent has been picked up by something other than a vehicle."
                },
                {
                    "id": 3544,
                    "argument_list_id": 149,
                    "value": "5",
                    "name": "Drop",
                    "description": "Called when the agent has been dropped by something other than a vehicle."
                },
                {
                    "id": 3545,
                    "argument_list_id": 149,
                    "value": "6",
                    "name": "Collision",
                    "description": "Called when the agent collides with an obstacle. _P1_ and _P2_ are the x and y components of the collision velocity."
                },
                {
                    "id": 3546,
                    "argument_list_id": 149,
                    "value": "7",
                    "name": "Bump",
                    "description": "Called when a creature walks into a wall."
                },
                {
                    "id": 3547,
                    "argument_list_id": 149,
                    "value": "8",
                    "name": "Impact",
                    "description": "Called when an agent's presence impacts with another agent's presence (this is assuming both agents have their presence switched on)."
                },
                {
                    "id": 3548,
                    "argument_list_id": 149,
                    "value": "9",
                    "name": "Timer",
                    "description": "Called at a regular time interval, as set by TICK."
                },
                {
                    "id": 3549,
                    "argument_list_id": 149,
                    "value": "10",
                    "name": "Constructor",
                    "description": "Called on creation."
                },
                {
                    "id": 3550,
                    "argument_list_id": 149,
                    "value": "12",
                    "name": "Eat",
                    "description": "Called when the creature eats something."
                },
                {
                    "id": 3551,
                    "argument_list_id": 149,
                    "value": "13",
                    "name": "Start Hold Hands",
                    "description": "Called when a creature starts holding hands with the pointer."
                },
                {
                    "id": 3552,
                    "argument_list_id": 149,
                    "value": "14",
                    "name": "Stop Hold Hands",
                    "description": "Called when a creature stops holding hands with the pointer."
                },
                {
                    "id": 3553,
                    "argument_list_id": 149,
                    "value": "16",
                    "name": "Quiescent on Agents",
                    "description": "Scripts 16 - 30 are executed on a creature when it decides to do something with its attention on an ordinary agent (rather than a creature). The script should perform this action. Quiescent means stand and watch it. The catalogue entry \"Action Script To Neuron Mappings\" maps the brain to these scripts, although which scripts require an it object are hard-wired."
                },
                {
                    "id": 3554,
                    "argument_list_id": 149,
                    "value": "17",
                    "name": "Activate 1 on Agents",
                    "description": "Activate 1 it."
                },
                {
                    "id": 3555,
                    "argument_list_id": 149,
                    "value": "18",
                    "name": "Activate 2 on Agents",
                    "description": "Activate 2 it."
                },
                {
                    "id": 3556,
                    "argument_list_id": 149,
                    "value": "19",
                    "name": "Deactivate on Agents",
                    "description": "Deactivate it."
                },
                {
                    "id": 3557,
                    "argument_list_id": 149,
                    "value": "20",
                    "name": "Approach on Agents",
                    "description": "Go up and look at it."
                },
                {
                    "id": 3558,
                    "argument_list_id": 149,
                    "value": "21",
                    "name": "Retreat on Agents",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 3559,
                    "argument_list_id": 149,
                    "value": "22",
                    "name": "Pickup on Agents",
                    "description": "Pick it up."
                },
                {
                    "id": 3560,
                    "argument_list_id": 149,
                    "value": "23",
                    "name": "Drop on Agents",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 3561,
                    "argument_list_id": 149,
                    "value": "24",
                    "name": "Need on Agents",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 3562,
                    "argument_list_id": 149,
                    "value": "25",
                    "name": "Rest on Agents",
                    "description": "Becoming sleepy."
                },
                {
                    "id": 3563,
                    "argument_list_id": 149,
                    "value": "26",
                    "name": "West on Agents",
                    "description": "Walk idly to west."
                },
                {
                    "id": 3564,
                    "argument_list_id": 149,
                    "value": "27",
                    "name": "East on Agents",
                    "description": "Walk idly to east."
                },
                {
                    "id": 3565,
                    "argument_list_id": 149,
                    "value": "28",
                    "name": "Eat on Agents",
                    "description": "Eat it."
                },
                {
                    "id": 3566,
                    "argument_list_id": 149,
                    "value": "29",
                    "name": "Hit on Agents",
                    "description": "Hit it."
                },
                {
                    "id": 3567,
                    "argument_list_id": 149,
                    "value": "30",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 3568,
                    "argument_list_id": 149,
                    "value": "31",
                    "name": "Undefined on Agents",
                    "description": "For future expansion."
                },
                {
                    "id": 3569,
                    "argument_list_id": 149,
                    "value": "32",
                    "name": "Quiescent on Creatures",
                    "description": "Scripts 32 - 47 are executed on a creature when it decides to do something with its attention on another creature. Quiescent means stand and twiddle your thumbs."
                },
                {
                    "id": 3570,
                    "argument_list_id": 149,
                    "value": "33",
                    "name": "Activate 1 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 3571,
                    "argument_list_id": 149,
                    "value": "34",
                    "name": "Activate 2 on Creatures",
                    "description": "Mating script."
                },
                {
                    "id": 3572,
                    "argument_list_id": 149,
                    "value": "35",
                    "name": "Deactivate on Creatures",
                    "description": "Deactivate it."
                },
                {
                    "id": 3573,
                    "argument_list_id": 149,
                    "value": "36",
                    "name": "Approach on Creatures",
                    "description": "Go up and look at it."
                },
                {
                    "id": 3574,
                    "argument_list_id": 149,
                    "value": "37",
                    "name": "Retreat on Creatures",
                    "description": "Walk or run away from it."
                },
                {
                    "id": 3575,
                    "argument_list_id": 149,
                    "value": "38",
                    "name": "Pickup on Creatures",
                    "description": "Pick it up."
                },
                {
                    "id": 3576,
                    "argument_list_id": 149,
                    "value": "39",
                    "name": "Drop on Creatures",
                    "description": "Drop anything you're carrying."
                },
                {
                    "id": 3577,
                    "argument_list_id": 149,
                    "value": "40",
                    "name": "Need on Creatures",
                    "description": "Say what's bothering you."
                },
                {
                    "id": 3578,
                    "argument_list_id": 149,
                    "value": "41",
                    "name": "Rest on Creatures",
                    "description": "Rest or sleep."
                },
                {
                    "id": 3579,
                    "argument_list_id": 149,
                    "value": "42",
                    "name": "West on Creatures",
                    "description": "Walk idly to west."
                },
                {
                    "id": 3580,
                    "argument_list_id": 149,
                    "value": "43",
                    "name": "East on Creatures",
                    "description": "Walk idly to east."
                },
                {
                    "id": 3581,
                    "argument_list_id": 149,
                    "value": "44",
                    "name": "Eat on Creatures",
                    "description": "Eat it."
                },
                {
                    "id": 3582,
                    "argument_list_id": 149,
                    "value": "45",
                    "name": "Hit on Creatures",
                    "description": "Hit it."
                },
                {
                    "id": 3583,
                    "argument_list_id": 149,
                    "value": "46",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 3584,
                    "argument_list_id": 149,
                    "value": "47",
                    "name": "Undefined on Creatures",
                    "description": "For future expansion."
                },
                {
                    "id": 3585,
                    "argument_list_id": 149,
                    "value": "64",
                    "name": "Flinch",
                    "description": "Involuntary action called when the creature flinches."
                },
                {
                    "id": 3586,
                    "argument_list_id": 149,
                    "value": "65",
                    "name": "Lay Egg",
                    "description": "Involuntary action called when the creature lays an egg."
                },
                {
                    "id": 3587,
                    "argument_list_id": 149,
                    "value": "66",
                    "name": "Sneeze",
                    "description": "Involuntary action called when the creature sneezes."
                },
                {
                    "id": 3588,
                    "argument_list_id": 149,
                    "value": "67",
                    "name": "Cough",
                    "description": "Involuntary action called when the creature coughs."
                },
                {
                    "id": 3589,
                    "argument_list_id": 149,
                    "value": "68",
                    "name": "Shiver",
                    "description": "Involuntary action called when the creature shivers."
                },
                {
                    "id": 3590,
                    "argument_list_id": 149,
                    "value": "69",
                    "name": "Sleep",
                    "description": "Involuntary action called when the creature sleeps."
                },
                {
                    "id": 3591,
                    "argument_list_id": 149,
                    "value": "70",
                    "name": "Fainting",
                    "description": "Involuntary action called when the creature faints."
                },
                {
                    "id": 3592,
                    "argument_list_id": 149,
                    "value": "71",
                    "name": "Unassigned",
                    "description": "Involuntary action for future expansion."
                },
                {
                    "id": 3593,
                    "argument_list_id": 149,
                    "value": "72",
                    "name": "Die",
                    "description": "Special involuntary action called when a creature dies. Any death animations go here."
                },
                {
                    "id": 3594,
                    "argument_list_id": 149,
                    "value": "73",
                    "name": "Raw Key Down",
                    "description": "Called when a key is pressed and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 3595,
                    "argument_list_id": 149,
                    "value": "74",
                    "name": "Raw Key Up",
                    "description": "Called when a key is released and IMSK is set. The key code is sent in _P1_."
                },
                {
                    "id": 3596,
                    "argument_list_id": 149,
                    "value": "75",
                    "name": "Raw Mouse Move",
                    "description": "Called when the mouse moves and IMSK is set. The new x and y position is sent in _P1_ and _P2_"
                },
                {
                    "id": 3597,
                    "argument_list_id": 149,
                    "value": "76",
                    "name": "Raw Mouse Down",
                    "description": "Called when a mouse button is pressed and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 3598,
                    "argument_list_id": 149,
                    "value": "77",
                    "name": "Raw Mouse Up",
                    "description": "Called when a mouse button is released and IMSK is set. The button is sent in _P1_ - 1 left, 2 right, 4 middle."
                },
                {
                    "id": 3599,
                    "argument_list_id": 149,
                    "value": "78",
                    "name": "Raw Mouse Wheel",
                    "description": "Called when the mouse wheel is moved and IMSK is set. The delta value is sent in _P1_ - 120 units per 'click'."
                },
                {
                    "id": 3600,
                    "argument_list_id": 149,
                    "value": "79",
                    "name": "Raw Translated Char",
                    "description": "Called when a translated character is received and IMSK is set. For example, on Japanese systems the raw key down and up codes can be in Roman characters, but the Input Method Editor converts them to Japanese characters, which are sent to the game with this message. The translated key code is sent in _P1_. You can use this for character input, but it is easier to use PAT: TEXT."
                },
                {
                    "id": 3601,
                    "argument_list_id": 149,
                    "value": "92",
                    "name": "UI Mouse Down",
                    "description": "Called when the mouse clicks on an agent."
                },
                {
                    "id": 3602,
                    "argument_list_id": 149,
                    "value": "101",
                    "name": "Pointer Activate 1",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3603,
                    "argument_list_id": 149,
                    "value": "102",
                    "name": "Pointer Activate 2",
                    "description": "Called on the pointer when an agent is activated 2. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3604,
                    "argument_list_id": 149,
                    "value": "103",
                    "name": "Pointer Deactivate",
                    "description": "Called on the pointer when an agent is deactivated. The script has the same classifier as the agent being deactivated."
                },
                {
                    "id": 3605,
                    "argument_list_id": 149,
                    "value": "104",
                    "name": "Pointer Pickup",
                    "description": "Called on the pointer when an agent is activated 1. The script has the same classifier as the agent being activated."
                },
                {
                    "id": 3606,
                    "argument_list_id": 149,
                    "value": "105",
                    "name": "Pointer Drop",
                    "description": "Called on the pointer when an agent is dropped. The script has the same classifier as the agent being dropped."
                },
                {
                    "id": 3607,
                    "argument_list_id": 149,
                    "value": "110",
                    "name": "Pointer Port Select",
                    "description": "Called on the pointer when you manipulate a port."
                },
                {
                    "id": 3608,
                    "argument_list_id": 149,
                    "value": "111",
                    "name": "Pointer Port Connect",
                    "description": "Called on the pointer when you complete the connection between two ports."
                },
                {
                    "id": 3609,
                    "argument_list_id": 149,
                    "value": "112",
                    "name": "Pointer Port Disconnect",
                    "description": "Called on the pointer when you complete the disconnection of two previously connected ports."
                },
                {
                    "id": 3610,
                    "argument_list_id": 149,
                    "value": "113",
                    "name": "Pointer Port Cancel",
                    "description": "Called on the pointer if you cancel a port change part way through."
                },
                {
                    "id": 3611,
                    "argument_list_id": 149,
                    "value": "114",
                    "name": "Pointer Port Error",
                    "description": "Called on the pointer if there is some error with the configuration of ports the user is trying to make."
                },
                {
                    "id": 3612,
                    "argument_list_id": 149,
                    "value": "116",
                    "name": "Pointer Clicked Background",
                    "description": "Called when the pointer is clicked but there aren't any agents under it."
                },
                {
                    "id": 3613,
                    "argument_list_id": 149,
                    "value": "117",
                    "name": "Pointer Action Dispatch",
                    "description": "Called on the pointer to tell it what action clicking would take on the creature under it. _P1_ says what will happen: 0 means no action or not above a creature, 1 means deactivate (slap), 2 means activate 1 (tickle)."
                },
                {
                    "id": 3614,
                    "argument_list_id": 149,
                    "value": "118",
                    "name": "Connection Break",
                    "description": "Called on an agent when any of its ports are broken as a result of exceeding the maximum connection distance."
                },
                {
                    "id": 3615,
                    "argument_list_id": 149,
                    "value": "120",
                    "name": "Selected Creature Changed",
                    "description": "Called on all agents with this script when the selected creature is changed by NORN. _P1_ is the new creature, _P2_ is the previously selected creature."
                },
                {
                    "id": 3616,
                    "argument_list_id": 149,
                    "value": "121",
                    "name": "Vehicle Pickup",
                    "description": "Called when an agent has been picked up by a vehicle."
                },
                {
                    "id": 3617,
                    "argument_list_id": 149,
                    "value": "122",
                    "name": "Vehicle Drop",
                    "description": "Called when an agent has been dropped by a vehicle."
                },
                {
                    "id": 3618,
                    "argument_list_id": 149,
                    "value": "123",
                    "name": "Window Resized",
                    "description": "Called on all agents with this script whenever the main view is resized."
                },
                {
                    "id": 3619,
                    "argument_list_id": 149,
                    "value": "124",
                    "name": "Got Carried Agent",
                    "description": "Tells an agent that they have just picked something up."
                },
                {
                    "id": 3620,
                    "argument_list_id": 149,
                    "value": "125",
                    "name": "Lost Carried Agent",
                    "description": "Tells an agent that they have just dropped something."
                },
                {
                    "id": 3621,
                    "argument_list_id": 149,
                    "value": "126",
                    "name": "Make Speech Bubble",
                    "description": "Called when a creature speaks, so scripts can display a speech bubble. Every agent which has this script is called. _P1_ is the text being spoken, _P2_ is the creature who is speaking."
                },
                {
                    "id": 3622,
                    "argument_list_id": 149,
                    "value": "127",
                    "name": "Life Event",
                    "description": "Called whenever there is a new life event, whether an event built into the engine, or a custom event sent with HIST EVNT. _P1_ is the moniker that the event happened to, _P2_ is the event number as an index into the events for that moniker."
                },
                {
                    "id": 3623,
                    "argument_list_id": 149,
                    "value": "128",
                    "name": "World Loaded",
                    "description": "Called when the world had just been loaded, whether from bootstrap or from a saved file."
                },
                {
                    "id": 3624,
                    "argument_list_id": 149,
                    "value": "135",
                    "name": "Net Online",
                    "description": "Connection to the Babel server has been made."
                },
                {
                    "id": 3625,
                    "argument_list_id": 149,
                    "value": "136",
                    "name": "Net Offline",
                    "description": "Connection to the Babel server is broken."
                },
                {
                    "id": 3626,
                    "argument_list_id": 149,
                    "value": "137",
                    "name": "User Online",
                    "description": "User chosen with NET: WHON has gone online. _P1_ contains the user's id."
                },
                {
                    "id": 3627,
                    "argument_list_id": 149,
                    "value": "138",
                    "name": "User Offline",
                    "description": "User chosen with NET: WHON has gone offline. _P1_ contains the user's id."
                },
                {
                    "id": 3628,
                    "argument_list_id": 149,
                    "value": "150",
                    "name": "Creature Navigation Callback Valid It",
                    "description": "Called by the approach command with _P1_ and _P2_ set to the IT object's X and Y coordinates respectively."
                },
                {
                    "id": 3629,
                    "argument_list_id": 149,
                    "value": "151",
                    "name": "Creature Navigation Callback Outside Room System",
                    "description": "Called by the approach command when you are unable to use the CA because you're outside the room system."
                },
                {
                    "id": 3630,
                    "argument_list_id": 149,
                    "value": "152",
                    "name": "Creature Navigation Callback Neighbour",
                    "description": "Called by the approach command if there is no IT object. _P1_ and _P2_ are set to the X and Y coordinates of the room's centre with the highest (or lowest if retreating) smell of IT nearby."
                },
                {
                    "id": 3631,
                    "argument_list_id": 149,
                    "value": "153",
                    "name": "Creature Navigation Callback Link",
                    "description": "As for 152 but called when the best room is a link."
                },
                {
                    "id": 3632,
                    "argument_list_id": 149,
                    "value": "154",
                    "name": "Creature Navigation Callback Current Room Best",
                    "description": "As for 152 but called when the room you're in is already the best one."
                },
                {
                    "id": 3633,
                    "argument_list_id": 149,
                    "value": "160",
                    "name": "Creature Ageing Callback",
                    "description": "Called when the creature is about to age. _P1_ contains the value of the next age stage."
                },
                {
                    "id": 3634,
                    "argument_list_id": 149,
                    "value": "200",
                    "name": "Mate",
                    "description": "Reserved for use in the mating scripts, but not directly used by the engine. Tells a male to mate."
                },
                {
                    "id": 3635,
                    "argument_list_id": 149,
                    "value": "255",
                    "name": "Agent Exception",
                    "description": "This script specifies the behaviour when an agent tries to do something to an invalid agent. For example, if you try and access an OVxx with a NULL target. If this script isn't present for OWNR, you get a run time error. If it is present, that script is called and you can reset variables as necessary."
                }
            ],
            "variants": 16
        },
        "list_150": {
            "id": 150,
            "variant": "C1",
            "name": "EventNumbers",
            "base_values_list_id": 32,
            "arguments": [
                {
                    "id": 3770,
                    "argument_list_id": 150,
                    "value": "0",
                    "name": "Deactivate"
                },
                {
                    "id": 3771,
                    "argument_list_id": 150,
                    "value": "1",
                    "name": "Activate 1"
                },
                {
                    "id": 3772,
                    "argument_list_id": 150,
                    "value": "2",
                    "name": "Activate 2"
                },
                {
                    "id": 3773,
                    "argument_list_id": 150,
                    "value": "3",
                    "name": "Hit"
                },
                {
                    "id": 3774,
                    "argument_list_id": 150,
                    "value": "4",
                    "name": "Picked-Up"
                },
                {
                    "id": 3775,
                    "argument_list_id": 150,
                    "value": "5",
                    "name": "Dropped"
                },
                {
                    "id": 3776,
                    "argument_list_id": 150,
                    "value": "6",
                    "name": "collision"
                },
                {
                    "id": 3777,
                    "argument_list_id": 150,
                    "value": "7",
                    "name": "Enter Scope"
                },
                {
                    "id": 3778,
                    "argument_list_id": 150,
                    "value": "8",
                    "name": "Leavescope"
                },
                {
                    "id": 3779,
                    "argument_list_id": 150,
                    "value": "9",
                    "name": "Timer"
                },
                {
                    "id": 3780,
                    "argument_list_id": 150,
                    "value": "16",
                    "name": "Extra Quiescent"
                },
                {
                    "id": 3781,
                    "argument_list_id": 150,
                    "value": "17",
                    "name": "Extra Activate 1"
                },
                {
                    "id": 3782,
                    "argument_list_id": 150,
                    "value": "18",
                    "name": "Extra Activate 2"
                },
                {
                    "id": 3783,
                    "argument_list_id": 150,
                    "value": "19",
                    "name": "Extra Deactivate"
                },
                {
                    "id": 3784,
                    "argument_list_id": 150,
                    "value": "20",
                    "name": "Extra Seek"
                },
                {
                    "id": 3785,
                    "argument_list_id": 150,
                    "value": "21",
                    "name": "Extra Avoid"
                },
                {
                    "id": 3786,
                    "argument_list_id": 150,
                    "value": "22",
                    "name": "Extra Pickup"
                },
                {
                    "id": 3787,
                    "argument_list_id": 150,
                    "value": "23",
                    "name": "Extra Drop"
                },
                {
                    "id": 3788,
                    "argument_list_id": 150,
                    "value": "24",
                    "name": "Extra Say Need"
                },
                {
                    "id": 3789,
                    "argument_list_id": 150,
                    "value": "25",
                    "name": "Extra Rest"
                },
                {
                    "id": 3790,
                    "argument_list_id": 150,
                    "value": "26",
                    "name": "Extra Go West"
                },
                {
                    "id": 3791,
                    "argument_list_id": 150,
                    "value": "27",
                    "name": "Extra Go East"
                },
                {
                    "id": 3792,
                    "argument_list_id": 150,
                    "value": "28",
                    "name": "Extra Undef 1"
                },
                {
                    "id": 3793,
                    "argument_list_id": 150,
                    "value": "29",
                    "name": "Extra Undef 2"
                },
                {
                    "id": 3794,
                    "argument_list_id": 150,
                    "value": "30",
                    "name": "Extra Undef 3"
                },
                {
                    "id": 3795,
                    "argument_list_id": 150,
                    "value": "31",
                    "name": "Extra Undef 4"
                },
                {
                    "id": 3796,
                    "argument_list_id": 150,
                    "value": "32",
                    "name": "Intro Quiescent"
                },
                {
                    "id": 7329,
                    "argument_list_id": 150,
                    "value": "33",
                    "name": "Intro Activate 1",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 7330,
                    "argument_list_id": 150,
                    "value": "34",
                    "name": "Intro Activate 2",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 7331,
                    "argument_list_id": 150,
                    "value": "35",
                    "name": "Intro Deactivate",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 7332,
                    "argument_list_id": 150,
                    "value": "36",
                    "name": "Intro Seek",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 7333,
                    "argument_list_id": 150,
                    "value": "37",
                    "name": "Intro Avoid",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 7334,
                    "argument_list_id": 150,
                    "value": "38",
                    "name": "Intro Pickup",
                    "description": "No such action needed \u2013 do not script"
                },
                {
                    "id": 3797,
                    "argument_list_id": 150,
                    "value": "39",
                    "name": "Intro Drop"
                },
                {
                    "id": 3798,
                    "argument_list_id": 150,
                    "value": "40",
                    "name": "Intro Say Need"
                },
                {
                    "id": 3799,
                    "argument_list_id": 150,
                    "value": "41",
                    "name": "Intro Rest"
                },
                {
                    "id": 3800,
                    "argument_list_id": 150,
                    "value": "42",
                    "name": "Intro Go West"
                },
                {
                    "id": 3801,
                    "argument_list_id": 150,
                    "value": "43",
                    "name": "Intro Go East"
                },
                {
                    "id": 3802,
                    "argument_list_id": 150,
                    "value": "44",
                    "name": "Intro Undef 1"
                },
                {
                    "id": 3803,
                    "argument_list_id": 150,
                    "value": "45",
                    "name": "Intro Undef 2"
                },
                {
                    "id": 3804,
                    "argument_list_id": 150,
                    "value": "46",
                    "name": "Intro Undef 3"
                },
                {
                    "id": 3805,
                    "argument_list_id": 150,
                    "value": "47",
                    "name": "Intro Undef 4"
                },
                {
                    "id": 3806,
                    "argument_list_id": 150,
                    "value": "50",
                    "name": "Pointer Activate 1"
                },
                {
                    "id": 3807,
                    "argument_list_id": 150,
                    "value": "51",
                    "name": "Pointer Activate 2"
                },
                {
                    "id": 3808,
                    "argument_list_id": 150,
                    "value": "52",
                    "name": "Pointer Deactivate"
                },
                {
                    "id": 3809,
                    "argument_list_id": 150,
                    "value": "53",
                    "name": "Pointer Pickup"
                },
                {
                    "id": 3810,
                    "argument_list_id": 150,
                    "value": "54",
                    "name": "Pointer Drop"
                },
                {
                    "id": 3811,
                    "argument_list_id": 150,
                    "value": "64",
                    "name": "Involuntary Action 0"
                },
                {
                    "id": 3812,
                    "argument_list_id": 150,
                    "value": "65",
                    "name": "Involuntary Action 1"
                },
                {
                    "id": 3813,
                    "argument_list_id": 150,
                    "value": "66",
                    "name": "Involuntary Action 2"
                },
                {
                    "id": 3814,
                    "argument_list_id": 150,
                    "value": "67",
                    "name": "Involuntary Action 3"
                },
                {
                    "id": 3815,
                    "argument_list_id": 150,
                    "value": "68",
                    "name": "Involuntary Action 4"
                },
                {
                    "id": 3816,
                    "argument_list_id": 150,
                    "value": "69",
                    "name": "Involuntary Action 5"
                },
                {
                    "id": 3817,
                    "argument_list_id": 150,
                    "value": "70",
                    "name": "Involuntary Action 6"
                },
                {
                    "id": 3818,
                    "argument_list_id": 150,
                    "value": "71",
                    "name": "Involuntary Action 7"
                },
                {
                    "id": 3819,
                    "argument_list_id": 150,
                    "value": "72",
                    "name": "Creature Death Script"
                }
            ],
            "variants": 1
        },
        "list_179": {
            "id": 179,
            "variant": "AL",
            "name": "Exists",
            "extension_type": "bool",
            "base_values_list_id": 64,
            "arguments": [
                {
                    "id": 3761,
                    "argument_list_id": 179,
                    "value": "0",
                    "name": "Does Not Exist"
                },
                {
                    "id": 3762,
                    "argument_list_id": 179,
                    "value": "1",
                    "name": "Exists"
                }
            ],
            "variants": 2
        },
        "list_192": {
            "id": 192,
            "variant": "CV",
            "name": "ExprIndex",
            "base_values_list_id": 73,
            "arguments": [
                {
                    "id": 4274,
                    "argument_list_id": 192,
                    "value": "0",
                    "name": "laugh"
                },
                {
                    "id": 4275,
                    "argument_list_id": 192,
                    "value": "1",
                    "name": "cry"
                },
                {
                    "id": 4276,
                    "argument_list_id": 192,
                    "value": "2",
                    "name": "eat"
                }
            ],
            "variants": 4
        },
        "list_286": {
            "id": 286,
            "variant": "AL",
            "name": "FallStatus",
            "extension_type": "bool",
            "arguments": [
                {
                    "id": 8249,
                    "argument_list_id": 286,
                    "value": "0",
                    "name": "Not Falling",
                    "description": "TARG is not moving under the influence of gravity"
                },
                {
                    "id": 8248,
                    "argument_list_id": 286,
                    "value": "1",
                    "name": "Falling",
                    "description": "TARG is moving under the influence of gravity"
                }
            ],
            "variants": 24
        },
        "list_283": {
            "id": 283,
            "variant": "AL",
            "name": "File.BLK",
            "extension_type": "File",
            "base_values_list_id": 111,
            "arguments": [],
            "variants": 60
        },
        "list_238": {
            "id": 238,
            "variant": "AL",
            "name": "File.C16/S16",
            "extension_type": "File",
            "base_values_list_id": 111,
            "arguments": [],
            "variants": 60
        },
        "list_284": {
            "id": 284,
            "variant": "AL",
            "name": "File.COS",
            "extension_type": "File",
            "base_values_list_id": 108,
            "arguments": [],
            "variants": 60
        },
        "list_296": {
            "id": 296,
            "variant": "AL",
            "name": "File.GEN",
            "extension_type": "File",
            "arguments": [],
            "variants": 63
        },
        "list_295": {
            "id": 295,
            "variant": "AL",
            "name": "File.JOURNAL",
            "extension_type": "File",
            "arguments": [],
            "variants": 60
        },
        "list_297": {
            "id": 297,
            "variant": "AL",
            "name": "File.MIDI",
            "extension_type": "File",
            "arguments": [],
            "variants": 60
        },
        "list_240": {
            "id": 240,
            "variant": "C2",
            "name": "File.S16",
            "extension_type": "File",
            "base_values_list_id": 112,
            "arguments": [],
            "variants": 2
        },
        "list_236": {
            "id": 236,
            "variant": "AL",
            "name": "File.SPR",
            "extension_type": "File",
            "base_values_list_id": 109,
            "arguments": [],
            "variants": 1
        },
        "list_235": {
            "id": 235,
            "variant": "AL",
            "name": "File.WAV",
            "extension_type": "File",
            "base_values_list_id": 108,
            "arguments": [],
            "variants": 63
        },
        "list_212": {
            "id": 212,
            "variant": "AL",
            "name": "FileOopeDirectory",
            "base_values_list_id": 91,
            "arguments": [
                {
                    "id": 4326,
                    "argument_list_id": 212,
                    "value": "0",
                    "name": "Current World Journal"
                },
                {
                    "id": 4327,
                    "argument_list_id": 212,
                    "value": "1",
                    "name": "Main Journal"
                },
                {
                    "id": 4328,
                    "argument_list_id": 212,
                    "value": "2",
                    "name": "Other World's Journal",
                    "description": "World set in variable GAME \"engine_other_world\""
                }
            ],
            "variants": 60
        },
        "list_267": {
            "id": 267,
            "variant": "AL",
            "name": "Frozen",
            "extension_type": "bool",
            "base_values_list_id": 256,
            "arguments": [
                {
                    "id": 6693,
                    "argument_list_id": 267,
                    "value": "0",
                    "name": "Not Frozen"
                },
                {
                    "id": 6696,
                    "argument_list_id": 267,
                    "value": ">0",
                    "name": "Frozen"
                }
            ],
            "variants": 2
        },
        "list_163": {
            "id": 163,
            "variant": "AL",
            "name": "FullScreen",
            "base_values_list_id": 48,
            "arguments": [
                {
                    "id": 3711,
                    "argument_list_id": 163,
                    "value": "0",
                    "name": "Windowed Mode"
                },
                {
                    "id": 3712,
                    "argument_list_id": 163,
                    "value": "1",
                    "name": "Fullscreen Mode"
                }
            ],
            "variants": 60
        },
        "list_281": {
            "id": 281,
            "variant": "AL",
            "name": "GameVariables",
            "arguments": [
                {
                    "id": 8204,
                    "argument_list_id": 281,
                    "value": "engine_debug_keys",
                    "name": "Debug Keys::Integer",
                    "description": "This determines if the debug keys are operative. If the value is 1 then the keys described in the Debug Keys table are functional. For non-numeric keypad keys, you must hold Shift down with the key"
                },
                {
                    "id": 8205,
                    "argument_list_id": 281,
                    "value": "engine_full_screen_toggle",
                    "name": "Full Screen Toggle::Integer",
                    "description": "Alt+Enter usually toggles full screen mode. Set to 0 to disable this"
                },
                {
                    "id": 8206,
                    "argument_list_id": 281,
                    "value": "engine_SkeletonUpdateDoubleSpeed",
                    "name": "SkeletonUpdateDoubleSpeed::Integer",
                    "description": "If non-zero, skeleton updates happen each tick. If Zero, they happen every other tick (default, NULL)"
                },
                {
                    "id": 8207,
                    "argument_list_id": 281,
                    "value": "engine_creature_pickup_status",
                    "name": "CreaturePickupStatus::Integer",
                    "description": "If zero, right click on a creature is pickup. If one, right click is holding hands. If two, hold shift to pickup, don't hold shift to hold hands. If three, as two but creature must be a selectable one as according to the Grettin game variable"
                },
                {
                    "id": 8208,
                    "argument_list_id": 281,
                    "value": "engine_dumb_creatures",
                    "name": "DumbCreatures::Integer",
                    "description": "If non-zero, creatures do not burble"
                },
                {
                    "id": 8209,
                    "argument_list_id": 281,
                    "value": "engine_pointerCanCarryObjectsBetweenMetaRooms",
                    "name": "PointerCanCarryObjectsBetweenMetaRooms::Integer",
                    "description": "If zero, the pointer drops objects when a metaroom change occurs. If non-zero, then it continues to carry them allowing objects to be moved between metarooms by the pointer"
                },
                {
                    "id": 8210,
                    "argument_list_id": 281,
                    "value": "engine_password",
                    "name": "Password::String",
                    "description": "If set, this allows the determining of the password for the world. This does not set anything other than the pswd returned - enabling world-switchers to correctly deal with the passwords"
                },
                {
                    "id": 8211,
                    "argument_list_id": 281,
                    "value": "engine_creature_template_size_in_mb",
                    "name": "CreatureTemplateSizeInMb::Integer",
                    "description": "This is the amount of data space allocated to the creature gallery sprite files. If a single life stage image set exceeds this value - problems will ensue"
                },
                {
                    "id": 8212,
                    "argument_list_id": 281,
                    "value": "engine_near_death_track_name",
                    "name": "NearDeathTrackName::String",
                    "description": "This sets the track (and optionally MNG file, NULL) for the track which the engine will play when a creature gets near death within the game"
                },
                {
                    "id": 8213,
                    "argument_list_id": 281,
                    "value": "engine_plane_for_lines",
                    "name": "PlaneForLines::Integer",
                    "description": "This sets the plane for lines drawn on entity images. This includes Connective agent lines and the debug cabins"
                },
                {
                    "id": 8214,
                    "argument_list_id": 281,
                    "value": "engine_synchronous_learning",
                    "name": "SynchronousLearning::Integer",
                    "description": "By default learning is asynchronous, so the creature learns from all STIMs. Set to 1 to make the creatures learn only from STIMs caused by the action they are thinking about carried out by the agent their attention is on"
                },
                {
                    "id": 8215,
                    "argument_list_id": 281,
                    "value": "engine_zlib_compression",
                    "name": "ZlibCompression::Integer",
                    "description": "Saved worlds and other archives are compressed using zlib. This sets the compression level. The value ranges between: 0 - No compression, 1 - Best speed, 9 - Best compression"
                },
                {
                    "id": 8216,
                    "argument_list_id": 281,
                    "value": "engine_other_world",
                    "name": "OtherWorld::String",
                    "description": "Used by FILE OOPE to allow saving to other world's journal directories"
                },
                {
                    "id": 8217,
                    "argument_list_id": 281,
                    "value": "engine_netbabel_save_passwords",
                    "name": "NetBabel Save Passwords::Integer",
                    "description": "Set to 1 to tell the netbabel module to save passwords in user.cfg, 0 for it to forget them"
                },
                {
                    "id": 8218,
                    "argument_list_id": 281,
                    "value": "engine_multiple_birth_first_chance",
                    "name": "Multiple Birth First Chance::Float",
                    "description": "This sets the chance (from 0 to 1, NULL) that a mate event will result in multiple pregnancies",
                    "before_region": "Multiple Births"
                },
                {
                    "id": 8219,
                    "argument_list_id": 281,
                    "value": "engine_multiple_birth_subsequent_chance",
                    "name": "Multiple Birth Subsequent Chance::Float",
                    "description": "This sets the subsequent chance (from 0 to 1, NULL) that more than two children are conceived"
                },
                {
                    "id": 8220,
                    "argument_list_id": 281,
                    "value": "engine_multiple_birth_maximum",
                    "name": "Multiple Birth Maximum::Integer",
                    "description": "This sets the maximum number of births allowed by the engine"
                },
                {
                    "id": 8221,
                    "argument_list_id": 281,
                    "value": "engine_multiple_birth_identical_chance",
                    "name": "Multiple Birth Identical Chance::Float",
                    "description": "This sets the chance that the children will be genetically identical"
                },
                {
                    "id": 8222,
                    "argument_list_id": 281,
                    "value": "engine_LengthOfDayInMinutes",
                    "name": "LengthOfDayInMinutes::Integer",
                    "description": "This sets the number of minutes in a day. (Game time, NULL)",
                    "before_region": "Days and Seasons"
                },
                {
                    "id": 8223,
                    "argument_list_id": 281,
                    "value": "engine_LengthOfSeasonInDays",
                    "name": "LengthOfSeasonInDays::Integer",
                    "description": "This sets the number of days in a season. (Game time, NULL)"
                },
                {
                    "id": 8224,
                    "argument_list_id": 281,
                    "value": "engine_NumberOfSeasons",
                    "name": "NumberOfSeasons::Integer",
                    "description": "This sets the number of seasons in a year. (Game Time, NULL)"
                },
                {
                    "id": 8225,
                    "argument_list_id": 281,
                    "value": "engine_mute",
                    "name": "Mute::Integer",
                    "description": "This sets whether (non zero, NULL) or not (zero, NULL) to mute the MIDI player",
                    "before_region": "Sounds and Music"
                },
                {
                    "id": 8226,
                    "argument_list_id": 281,
                    "value": "engine_playAllSoundsAtMaximumLevel",
                    "name": "Play All Sounds At Maximum Level::Integer",
                    "description": "If non-zero, all sounds played by agents are set to full volume and center pan"
                },
                {
                    "id": 8227,
                    "argument_list_id": 281,
                    "value": "engine_usemidimusicsystem",
                    "name": "Use Midi Music System::Integer",
                    "description": "If non-zero, this tells the engine to use MIDI music instead of the MUNGED data usually used"
                },
                {
                    "id": 8228,
                    "argument_list_id": 281,
                    "value": "cav_birthdate",
                    "name": "Birthdate::String",
                    "description": "If set, the engine uses this to inform the birthday agent when it is the player's birthday",
                    "before_region": "Countdown and Birthdays"
                },
                {
                    "id": 8229,
                    "argument_list_id": 281,
                    "value": "cav_quittime",
                    "name": "Quit Time::String",
                    "description": "If set, the engine uses this to inform the countdown clock agent to show its countdown, and also to quit the game at the specified time"
                },
                {
                    "id": 8230,
                    "argument_list_id": 281,
                    "value": "cav_gamelengthIsPerDay",
                    "name": "Game Length is Per Day::String",
                    "description": "If set, the engine uses this to inform the countdown clock agent when the maximum play time for the day is up"
                },
                {
                    "id": 8231,
                    "argument_list_id": 281,
                    "value": "cav_useparentmenu",
                    "name": "Use Parent Menu::Integer",
                    "description": "If non-zero, this causes the engine to deal with extra information such as the countdown clock and birthday agents. These are activated by registry settings"
                },
                {
                    "id": 8232,
                    "argument_list_id": 281,
                    "value": "cav_CountdownClockAgent",
                    "name": "Countdown Clock Agent::Agent",
                    "description": "If not null, countdown messages are sent to this agent"
                },
                {
                    "id": 8233,
                    "argument_list_id": 281,
                    "value": "cav_BirthdayBannerAgent",
                    "name": "Birthday Banner Agent::Agent",
                    "description": "If not null, birthday messages are sent to this agent"
                },
                {
                    "id": 8234,
                    "argument_list_id": 281,
                    "value": "engine_distance_before_port_line_warns",
                    "name": "Distance Before Port Line Warns::Float",
                    "description": "At this distance, port lines will pulse red not blue to indicate that they are nearning their maximum length before they snap",
                    "before_region": "Ports"
                },
                {
                    "id": 8235,
                    "argument_list_id": 281,
                    "value": "engine_distance_before_port_line_snaps",
                    "name": "Distance Before Port Line Snaps::Float",
                    "description": "At this distance, port lines will simply snap"
                }
            ],
            "variants": 24
        },
        "list_71": {
            "id": 71,
            "variant": "AL",
            "name": "Gender",
            "base_values_list_id": 5,
            "arguments": [
                {
                    "id": 944,
                    "argument_list_id": 71,
                    "value": "0",
                    "name": "Random"
                },
                {
                    "id": 945,
                    "argument_list_id": 71,
                    "value": "1",
                    "name": "Male"
                },
                {
                    "id": 946,
                    "argument_list_id": 71,
                    "value": "2",
                    "name": "Female"
                }
            ],
            "variants": 63
        },
        "list_228": {
            "id": 228,
            "variant": "C1",
            "name": "Genus",
            "base_values_list_id": 105,
            "arguments": [
                {
                    "id": 4575,
                    "argument_list_id": 228,
                    "value": "2 1",
                    "name": "Hand"
                },
                {
                    "id": 4576,
                    "argument_list_id": 228,
                    "value": "2 2",
                    "name": "Call(lift call button)"
                },
                {
                    "id": 4577,
                    "argument_list_id": 228,
                    "value": "2 3",
                    "name": "Invisible"
                },
                {
                    "id": 4578,
                    "argument_list_id": 228,
                    "value": "2 4",
                    "name": "Plant (or herb)"
                },
                {
                    "id": 4579,
                    "argument_list_id": 228,
                    "value": "2 5",
                    "name": "Egg"
                },
                {
                    "id": 4580,
                    "argument_list_id": 228,
                    "value": "2 6",
                    "name": "Food"
                },
                {
                    "id": 4581,
                    "argument_list_id": 228,
                    "value": "2 7",
                    "name": "Drink"
                },
                {
                    "id": 4582,
                    "argument_list_id": 228,
                    "value": "2 8",
                    "name": "Vendor"
                },
                {
                    "id": 4583,
                    "argument_list_id": 228,
                    "value": "2 9",
                    "name": "Music(Instruments)"
                },
                {
                    "id": 4584,
                    "argument_list_id": 228,
                    "value": "2 10",
                    "name": "Animal"
                },
                {
                    "id": 4585,
                    "argument_list_id": 228,
                    "value": "2 11",
                    "name": "Hot"
                },
                {
                    "id": 4586,
                    "argument_list_id": 228,
                    "value": "2 12",
                    "name": "Shower/clock"
                },
                {
                    "id": 4587,
                    "argument_list_id": 228,
                    "value": "2 13",
                    "name": "Toy"
                },
                {
                    "id": 4588,
                    "argument_list_id": 228,
                    "value": "2 14",
                    "name": "Big Toy"
                },
                {
                    "id": 4589,
                    "argument_list_id": 228,
                    "value": "2 15",
                    "name": "Weed"
                },
                {
                    "id": 4590,
                    "argument_list_id": 228,
                    "value": "3 1",
                    "name": "Mover (Vehicle)"
                },
                {
                    "id": 4591,
                    "argument_list_id": 228,
                    "value": "3 2",
                    "name": "Lift"
                },
                {
                    "id": 4592,
                    "argument_list_id": 228,
                    "value": "3 3",
                    "name": "Computer"
                },
                {
                    "id": 4593,
                    "argument_list_id": 228,
                    "value": "3 4",
                    "name": "Fun (Projector)"
                },
                {
                    "id": 4594,
                    "argument_list_id": 228,
                    "value": "3 5",
                    "name": "Bang (Cannon)"
                },
                {
                    "id": 9254,
                    "argument_list_id": 228,
                    "value": "4 0",
                    "name": "Creature"
                },
                {
                    "id": 4595,
                    "argument_list_id": 228,
                    "value": "4 1",
                    "name": "Norn"
                },
                {
                    "id": 4596,
                    "argument_list_id": 228,
                    "value": "4 2",
                    "name": "Grendel"
                },
                {
                    "id": 4597,
                    "argument_list_id": 228,
                    "value": "4 3",
                    "name": "Ettin"
                },
                {
                    "id": 4598,
                    "argument_list_id": 228,
                    "value": "4 4",
                    "name": "Shee"
                }
            ],
            "variants": 1
        },
        "list_229": {
            "id": 229,
            "variant": "AL",
            "name": "Genus",
            "base_values_list_id": 105,
            "arguments": [
                {
                    "id": 4455,
                    "argument_list_id": 229,
                    "value": "1 1",
                    "name": "Invisible"
                },
                {
                    "id": 4456,
                    "argument_list_id": 229,
                    "value": "1 2",
                    "name": "User Interface"
                },
                {
                    "id": 4457,
                    "argument_list_id": 229,
                    "value": "1 3",
                    "name": "Favorite Place Signposts"
                },
                {
                    "id": 4458,
                    "argument_list_id": 229,
                    "value": "1 4",
                    "name": "Favorite Place Icons"
                },
                {
                    "id": 4459,
                    "argument_list_id": 229,
                    "value": "2 1",
                    "name": "Hand"
                },
                {
                    "id": 4460,
                    "argument_list_id": 229,
                    "value": "2 2",
                    "name": "Door"
                },
                {
                    "id": 4461,
                    "argument_list_id": 229,
                    "value": "2 3",
                    "name": "Seed"
                },
                {
                    "id": 4462,
                    "argument_list_id": 229,
                    "value": "2 4",
                    "name": "Good Plant"
                },
                {
                    "id": 4463,
                    "argument_list_id": 229,
                    "value": "2 5",
                    "name": "Bad Plant"
                },
                {
                    "id": 4464,
                    "argument_list_id": 229,
                    "value": "2 6",
                    "name": "Leaf"
                },
                {
                    "id": 4465,
                    "argument_list_id": 229,
                    "value": "2 7",
                    "name": "Flower"
                },
                {
                    "id": 4466,
                    "argument_list_id": 229,
                    "value": "2 8",
                    "name": "Good Fruit"
                },
                {
                    "id": 4467,
                    "argument_list_id": 229,
                    "value": "2 9",
                    "name": "Bad Fruit"
                },
                {
                    "id": 4468,
                    "argument_list_id": 229,
                    "value": "2 10",
                    "name": "Detritus"
                },
                {
                    "id": 4469,
                    "argument_list_id": 229,
                    "value": "2 11",
                    "name": "Food"
                },
                {
                    "id": 4470,
                    "argument_list_id": 229,
                    "value": "2 12",
                    "name": "Button"
                },
                {
                    "id": 4471,
                    "argument_list_id": 229,
                    "value": "2 13",
                    "name": "Good Bug"
                },
                {
                    "id": 4472,
                    "argument_list_id": 229,
                    "value": "2 14",
                    "name": "Bad Bug"
                },
                {
                    "id": 4473,
                    "argument_list_id": 229,
                    "value": "2 15",
                    "name": "Good Critter"
                },
                {
                    "id": 4474,
                    "argument_list_id": 229,
                    "value": "2 16",
                    "name": "Bad Critter"
                },
                {
                    "id": 4475,
                    "argument_list_id": 229,
                    "value": "2 17",
                    "name": "Nest"
                },
                {
                    "id": 4476,
                    "argument_list_id": 229,
                    "value": "2 18",
                    "name": "Agent Egg"
                },
                {
                    "id": 4477,
                    "argument_list_id": 229,
                    "value": "2 19",
                    "name": "Weather"
                },
                {
                    "id": 4478,
                    "argument_list_id": 229,
                    "value": "2 20",
                    "name": "Bad"
                },
                {
                    "id": 4479,
                    "argument_list_id": 229,
                    "value": "2 21",
                    "name": "Toy"
                },
                {
                    "id": 4480,
                    "argument_list_id": 229,
                    "value": "2 22",
                    "name": "Incubator"
                },
                {
                    "id": 4481,
                    "argument_list_id": 229,
                    "value": "2 23",
                    "name": "Vendor"
                },
                {
                    "id": 4482,
                    "argument_list_id": 229,
                    "value": "2 24",
                    "name": "Tool"
                },
                {
                    "id": 4483,
                    "argument_list_id": 229,
                    "value": "2 25",
                    "name": "Potion"
                },
                {
                    "id": 4484,
                    "argument_list_id": 229,
                    "value": "3 1",
                    "name": "Lift"
                },
                {
                    "id": 4485,
                    "argument_list_id": 229,
                    "value": "3 2",
                    "name": "Teleporter"
                },
                {
                    "id": 4486,
                    "argument_list_id": 229,
                    "value": "3 3",
                    "name": "Machinery"
                },
                {
                    "id": 4487,
                    "argument_list_id": 229,
                    "value": "3 4",
                    "name": "Creature Egg"
                },
                {
                    "id": 4488,
                    "argument_list_id": 229,
                    "value": "3 5",
                    "name": "Norn Home"
                },
                {
                    "id": 4489,
                    "argument_list_id": 229,
                    "value": "3 6",
                    "name": "Grendel Home"
                },
                {
                    "id": 4490,
                    "argument_list_id": 229,
                    "value": "3 7",
                    "name": "Ettin Home"
                },
                {
                    "id": 4491,
                    "argument_list_id": 229,
                    "value": "3 8",
                    "name": "Gadget"
                },
                {
                    "id": 4492,
                    "argument_list_id": 229,
                    "value": "3 9",
                    "name": "Portal"
                },
                {
                    "id": 4493,
                    "argument_list_id": 229,
                    "value": "3 10",
                    "name": "Vehicles"
                },
                {
                    "id": 9255,
                    "argument_list_id": 229,
                    "value": "4 0",
                    "name": "Creature"
                },
                {
                    "id": 4494,
                    "argument_list_id": 229,
                    "value": "4 1",
                    "name": "Norn"
                },
                {
                    "id": 4495,
                    "argument_list_id": 229,
                    "value": "4 2",
                    "name": "Grendel"
                },
                {
                    "id": 4496,
                    "argument_list_id": 229,
                    "value": "4 3",
                    "name": "Ettin"
                },
                {
                    "id": 4497,
                    "argument_list_id": 229,
                    "value": "4 4",
                    "name": "Geat?"
                }
            ],
            "variants": 24
        },
        "list_230": {
            "id": 230,
            "variant": "C2",
            "name": "Genus",
            "base_values_list_id": 105,
            "arguments": [
                {
                    "id": 4498,
                    "argument_list_id": 230,
                    "value": "2 1",
                    "name": "System"
                },
                {
                    "id": 4499,
                    "argument_list_id": 230,
                    "value": "2 2",
                    "name": "Call Button"
                },
                {
                    "id": 4500,
                    "argument_list_id": 230,
                    "value": "2 3",
                    "name": "Nature"
                },
                {
                    "id": 4501,
                    "argument_list_id": 230,
                    "value": "2 4",
                    "name": "Good Plant"
                },
                {
                    "id": 4502,
                    "argument_list_id": 230,
                    "value": "2 5",
                    "name": "Creature Egg"
                },
                {
                    "id": 4503,
                    "argument_list_id": 230,
                    "value": "2 6",
                    "name": "Processed Food"
                },
                {
                    "id": 4504,
                    "argument_list_id": 230,
                    "value": "2 7",
                    "name": "Drink"
                },
                {
                    "id": 4505,
                    "argument_list_id": 230,
                    "value": "2 8",
                    "name": "Dispenser"
                },
                {
                    "id": 4506,
                    "argument_list_id": 230,
                    "value": "2 9",
                    "name": "Implements"
                },
                {
                    "id": 4507,
                    "argument_list_id": 230,
                    "value": "2 10",
                    "name": "Cliff Edge"
                },
                {
                    "id": 4508,
                    "argument_list_id": 230,
                    "value": "2 11",
                    "name": "Detritus"
                },
                {
                    "id": 4509,
                    "argument_list_id": 230,
                    "value": "2 12",
                    "name": "Medicine"
                },
                {
                    "id": 4510,
                    "argument_list_id": 230,
                    "value": "2 13",
                    "name": "Toy"
                },
                {
                    "id": 4511,
                    "argument_list_id": 230,
                    "value": "2 14",
                    "name": "Weather"
                },
                {
                    "id": 4512,
                    "argument_list_id": 230,
                    "value": "2 15",
                    "name": "Bad Plant"
                },
                {
                    "id": 4513,
                    "argument_list_id": 230,
                    "value": "2 16",
                    "name": "Nest"
                },
                {
                    "id": 4514,
                    "argument_list_id": 230,
                    "value": "2 17",
                    "name": "Badbug"
                },
                {
                    "id": 4515,
                    "argument_list_id": 230,
                    "value": "2 18",
                    "name": "Bug"
                },
                {
                    "id": 4516,
                    "argument_list_id": 230,
                    "value": "2 19",
                    "name": "Bad Critter"
                },
                {
                    "id": 4517,
                    "argument_list_id": 230,
                    "value": "2 20",
                    "name": "Critter"
                },
                {
                    "id": 4518,
                    "argument_list_id": 230,
                    "value": "2 21",
                    "name": "Seed"
                },
                {
                    "id": 4519,
                    "argument_list_id": 230,
                    "value": "2 22",
                    "name": "Leaf"
                },
                {
                    "id": 4520,
                    "argument_list_id": 230,
                    "value": "2 23",
                    "name": "Root"
                },
                {
                    "id": 4521,
                    "argument_list_id": 230,
                    "value": "2 24",
                    "name": "Flower"
                },
                {
                    "id": 4522,
                    "argument_list_id": 230,
                    "value": "2 25",
                    "name": "Fruit"
                },
                {
                    "id": 4523,
                    "argument_list_id": 230,
                    "value": "3 1",
                    "name": "Mover"
                },
                {
                    "id": 4524,
                    "argument_list_id": 230,
                    "value": "3 2",
                    "name": "Lift"
                },
                {
                    "id": 4525,
                    "argument_list_id": 230,
                    "value": "3 3",
                    "name": "Computer"
                },
                {
                    "id": 4526,
                    "argument_list_id": 230,
                    "value": "3 4",
                    "name": "Fun"
                },
                {
                    "id": 4527,
                    "argument_list_id": 230,
                    "value": "3 5",
                    "name": "Messages"
                },
                {
                    "id": 4528,
                    "argument_list_id": 230,
                    "value": "3 6",
                    "name": "LeftRight"
                },
                {
                    "id": 4529,
                    "argument_list_id": 230,
                    "value": "3 7",
                    "name": "Incubator"
                },
                {
                    "id": 4530,
                    "argument_list_id": 230,
                    "value": "3 8",
                    "name": "Teleporter"
                },
                {
                    "id": 4531,
                    "argument_list_id": 230,
                    "value": "3 9",
                    "name": "<Empty slot>"
                },
                {
                    "id": 4532,
                    "argument_list_id": 230,
                    "value": "3 10",
                    "name": "Machine"
                },
                {
                    "id": 9256,
                    "argument_list_id": 230,
                    "value": "4 0",
                    "name": "Creature"
                },
                {
                    "id": 4533,
                    "argument_list_id": 230,
                    "value": "4 1",
                    "name": "Norn"
                },
                {
                    "id": 4534,
                    "argument_list_id": 230,
                    "value": "4 2",
                    "name": "Grendel"
                },
                {
                    "id": 4535,
                    "argument_list_id": 230,
                    "value": "4 3",
                    "name": "Ettin"
                },
                {
                    "id": 4536,
                    "argument_list_id": 230,
                    "value": "4 4",
                    "name": "Geat?"
                }
            ],
            "variants": 2
        },
        "list_196": {
            "id": 196,
            "variant": "AL",
            "name": "HeapIndices",
            "base_values_list_id": 77,
            "arguments": [
                {
                    "id": 4292,
                    "argument_list_id": 196,
                    "value": "0",
                    "name": "current allocated heap memory (development builds only)"
                },
                {
                    "id": 4293,
                    "argument_list_id": 196,
                    "value": "1",
                    "name": "Total Agents",
                    "description": "Total agents, including ones waiting to be garbage collected"
                },
                {
                    "id": 4294,
                    "argument_list_id": 196,
                    "value": "2",
                    "name": "Creature Agents",
                    "description": "Similar to total agents, but just for creatures"
                }
            ],
            "variants": 60
        },
        "list_162": {
            "id": 162,
            "variant": "AL",
            "name": "HistGender",
            "base_values_list_id": 47,
            "arguments": [
                {
                    "id": 3710,
                    "argument_list_id": 162,
                    "value": "-1",
                    "name": "Unborn"
                },
                {
                    "id": 3708,
                    "argument_list_id": 162,
                    "value": "1",
                    "name": "Male"
                },
                {
                    "id": 3709,
                    "argument_list_id": 162,
                    "value": "2",
                    "name": "Female"
                }
            ],
            "variants": 60
        },
        "list_202": {
            "id": 202,
            "variant": "AL",
            "name": "HistGnus",
            "base_values_list_id": 82,
            "arguments": [
                {
                    "id": 4310,
                    "argument_list_id": 202,
                    "value": "1",
                    "name": "Norn"
                },
                {
                    "id": 4311,
                    "argument_list_id": 202,
                    "value": "2",
                    "name": "Grendel"
                },
                {
                    "id": 4312,
                    "argument_list_id": 202,
                    "value": "3",
                    "name": "Ettin"
                },
                {
                    "id": 4313,
                    "argument_list_id": 202,
                    "value": "4",
                    "name": "Shee"
                }
            ],
            "variants": 60
        },
        "list_168": {
            "id": 168,
            "variant": "AL",
            "name": "ImageExists",
            "extension_type": "bool",
            "base_values_list_id": 53,
            "arguments": [
                {
                    "id": 3726,
                    "argument_list_id": 168,
                    "value": "0",
                    "name": "Does Not Exist"
                },
                {
                    "id": 3727,
                    "argument_list_id": 168,
                    "value": "1",
                    "name": "Image Exists"
                }
            ],
            "variants": 60
        },
        "list_265": {
            "id": 265,
            "variant": "AL",
            "name": "IMSKFlags",
            "extension_type": "BitFlags",
            "base_values_list_id": 128,
            "arguments": [
                {
                    "id": 6586,
                    "argument_list_id": 265,
                    "value": "1",
                    "name": "Key Down",
                    "description": "Raw Key Down"
                },
                {
                    "id": 6587,
                    "argument_list_id": 265,
                    "value": "2",
                    "name": "Key Up",
                    "description": "Raw Key Up"
                },
                {
                    "id": 6588,
                    "argument_list_id": 265,
                    "value": "4",
                    "name": "Mouse Move",
                    "description": "Raw Mouse Move"
                },
                {
                    "id": 6589,
                    "argument_list_id": 265,
                    "value": "8",
                    "name": "Mouse Down",
                    "description": "Raw Mouse Down"
                },
                {
                    "id": 6590,
                    "argument_list_id": 265,
                    "value": "16",
                    "name": "Mouse Up",
                    "description": "Raw Mouse Up"
                },
                {
                    "id": 6591,
                    "argument_list_id": 265,
                    "value": "32",
                    "name": "Mouse Wheel",
                    "description": "Raw Mouse Wheel"
                },
                {
                    "id": 6592,
                    "argument_list_id": 265,
                    "value": "64",
                    "name": "Translated Char",
                    "description": "Raw Translated Char"
                }
            ],
            "variants": 60
        },
        "list_198": {
            "id": 198,
            "variant": "AL",
            "name": "JectFlags",
            "extension_type": "BitFlags",
            "base_values_list_id": 79,
            "arguments": [
                {
                    "id": 4299,
                    "argument_list_id": 198,
                    "value": "1",
                    "name": "Remove sctipt"
                },
                {
                    "id": 4300,
                    "argument_list_id": 198,
                    "value": "2",
                    "name": "Event scripts"
                },
                {
                    "id": 4301,
                    "argument_list_id": 198,
                    "value": "4",
                    "name": "Install script"
                }
            ],
            "variants": 56
        },
        "list_206": {
            "id": 206,
            "variant": "AL",
            "name": "JournalSpot",
            "base_values_list_id": 86,
            "arguments": [
                {
                    "id": 4318,
                    "argument_list_id": 206,
                    "value": "0",
                    "name": "World journal"
                },
                {
                    "id": 4319,
                    "argument_list_id": 206,
                    "value": "1",
                    "name": "Global Journal"
                }
            ],
            "variants": 60
        },
        "list_188": {
            "id": 188,
            "variant": "CV",
            "name": "Justification",
            "extension_type": "BitFlags",
            "base_values_list_id": 70,
            "arguments": [
                {
                    "id": 4260,
                    "argument_list_id": 188,
                    "value": "0",
                    "name": "Left"
                },
                {
                    "id": 4261,
                    "argument_list_id": 188,
                    "value": "1",
                    "name": "Right"
                },
                {
                    "id": 4262,
                    "argument_list_id": 188,
                    "value": "2",
                    "name": "Center"
                },
                {
                    "id": 4263,
                    "argument_list_id": 188,
                    "value": "4",
                    "name": "Bottom"
                },
                {
                    "id": 4264,
                    "argument_list_id": 188,
                    "value": "8",
                    "name": "Middle"
                }
            ],
            "variants": 4
        },
        "list_190": {
            "id": 190,
            "variant": "AL",
            "name": "Justification",
            "extension_type": "BitFlags",
            "base_values_list_id": 70,
            "arguments": [
                {
                    "id": 4265,
                    "argument_list_id": 190,
                    "value": "0",
                    "name": "Left"
                },
                {
                    "id": 4266,
                    "argument_list_id": 190,
                    "value": "1",
                    "name": "Right"
                },
                {
                    "id": 4267,
                    "argument_list_id": 190,
                    "value": "2",
                    "name": "Center"
                },
                {
                    "id": 4268,
                    "argument_list_id": 190,
                    "value": "4",
                    "name": "Bottom"
                },
                {
                    "id": 4269,
                    "argument_list_id": 190,
                    "value": "8",
                    "name": "Middle"
                },
                {
                    "id": 4270,
                    "argument_list_id": 190,
                    "value": "16",
                    "name": "Last Page Scroll",
                    "description": "if you add extra text to the part and show the last page, it will scroll upwards"
                }
            ],
            "variants": 56
        },
        "list_272": {
            "id": 272,
            "variant": "AL",
            "name": "KeyCodes",
            "description": "Keyboard key codes for use in KEYD",
            "arguments": [
                {
                    "id": 7176,
                    "argument_list_id": 272,
                    "value": "8",
                    "name": "Backspace"
                },
                {
                    "id": 7177,
                    "argument_list_id": 272,
                    "value": "9",
                    "name": "Tab"
                },
                {
                    "id": 7178,
                    "argument_list_id": 272,
                    "value": "13",
                    "name": "Enter"
                },
                {
                    "id": 7179,
                    "argument_list_id": 272,
                    "value": "16",
                    "name": "Shift"
                },
                {
                    "id": 7180,
                    "argument_list_id": 272,
                    "value": "17",
                    "name": "Ctrl"
                },
                {
                    "id": 7181,
                    "argument_list_id": 272,
                    "value": "18",
                    "name": "Alt"
                },
                {
                    "id": 7182,
                    "argument_list_id": 272,
                    "value": "19",
                    "name": "Pause/break"
                },
                {
                    "id": 7183,
                    "argument_list_id": 272,
                    "value": "20",
                    "name": "CapsLock"
                },
                {
                    "id": 7184,
                    "argument_list_id": 272,
                    "value": "27",
                    "name": "Escape"
                },
                {
                    "id": 7185,
                    "argument_list_id": 272,
                    "value": "33",
                    "name": "PageUp"
                },
                {
                    "id": 7186,
                    "argument_list_id": 272,
                    "value": "34",
                    "name": "PageDown"
                },
                {
                    "id": 7187,
                    "argument_list_id": 272,
                    "value": "35",
                    "name": "End"
                },
                {
                    "id": 7188,
                    "argument_list_id": 272,
                    "value": "36",
                    "name": "Home"
                },
                {
                    "id": 7189,
                    "argument_list_id": 272,
                    "value": "37",
                    "name": "LeftArrow"
                },
                {
                    "id": 7190,
                    "argument_list_id": 272,
                    "value": "38",
                    "name": "UpArrow"
                },
                {
                    "id": 7191,
                    "argument_list_id": 272,
                    "value": "39",
                    "name": "RightArrow"
                },
                {
                    "id": 7192,
                    "argument_list_id": 272,
                    "value": "40",
                    "name": "DownArrow"
                },
                {
                    "id": 7193,
                    "argument_list_id": 272,
                    "value": "45",
                    "name": "Insert"
                },
                {
                    "id": 7194,
                    "argument_list_id": 272,
                    "value": "46",
                    "name": "Delete"
                },
                {
                    "id": 7195,
                    "argument_list_id": 272,
                    "value": "49",
                    "name": "1"
                },
                {
                    "id": 7196,
                    "argument_list_id": 272,
                    "value": "50",
                    "name": "2"
                },
                {
                    "id": 7197,
                    "argument_list_id": 272,
                    "value": "51",
                    "name": "3"
                },
                {
                    "id": 7198,
                    "argument_list_id": 272,
                    "value": "52",
                    "name": "4"
                },
                {
                    "id": 7199,
                    "argument_list_id": 272,
                    "value": "53",
                    "name": "5"
                },
                {
                    "id": 7200,
                    "argument_list_id": 272,
                    "value": "54",
                    "name": "6"
                },
                {
                    "id": 7201,
                    "argument_list_id": 272,
                    "value": "55",
                    "name": "7"
                },
                {
                    "id": 7202,
                    "argument_list_id": 272,
                    "value": "56",
                    "name": "8"
                },
                {
                    "id": 7203,
                    "argument_list_id": 272,
                    "value": "57",
                    "name": "9"
                },
                {
                    "id": 7204,
                    "argument_list_id": 272,
                    "value": "65",
                    "name": "A"
                },
                {
                    "id": 7205,
                    "argument_list_id": 272,
                    "value": "66",
                    "name": "B"
                },
                {
                    "id": 7206,
                    "argument_list_id": 272,
                    "value": "67",
                    "name": "C"
                },
                {
                    "id": 7207,
                    "argument_list_id": 272,
                    "value": "68",
                    "name": "D"
                },
                {
                    "id": 7208,
                    "argument_list_id": 272,
                    "value": "69",
                    "name": "E"
                },
                {
                    "id": 7209,
                    "argument_list_id": 272,
                    "value": "70",
                    "name": "F"
                },
                {
                    "id": 7210,
                    "argument_list_id": 272,
                    "value": "71",
                    "name": "G"
                },
                {
                    "id": 7211,
                    "argument_list_id": 272,
                    "value": "72",
                    "name": "H"
                },
                {
                    "id": 7212,
                    "argument_list_id": 272,
                    "value": "73",
                    "name": "I"
                },
                {
                    "id": 7213,
                    "argument_list_id": 272,
                    "value": "74",
                    "name": "J"
                },
                {
                    "id": 7214,
                    "argument_list_id": 272,
                    "value": "75",
                    "name": "K"
                },
                {
                    "id": 7215,
                    "argument_list_id": 272,
                    "value": "76",
                    "name": "L"
                },
                {
                    "id": 7216,
                    "argument_list_id": 272,
                    "value": "77",
                    "name": "M"
                },
                {
                    "id": 7217,
                    "argument_list_id": 272,
                    "value": "78",
                    "name": "N"
                },
                {
                    "id": 7218,
                    "argument_list_id": 272,
                    "value": "79",
                    "name": "O"
                },
                {
                    "id": 7219,
                    "argument_list_id": 272,
                    "value": "80",
                    "name": "P"
                },
                {
                    "id": 7220,
                    "argument_list_id": 272,
                    "value": "81",
                    "name": "Q"
                },
                {
                    "id": 7221,
                    "argument_list_id": 272,
                    "value": "82",
                    "name": "R"
                },
                {
                    "id": 7222,
                    "argument_list_id": 272,
                    "value": "83",
                    "name": "S"
                },
                {
                    "id": 7223,
                    "argument_list_id": 272,
                    "value": "84",
                    "name": "T"
                },
                {
                    "id": 7224,
                    "argument_list_id": 272,
                    "value": "85",
                    "name": "U"
                },
                {
                    "id": 7225,
                    "argument_list_id": 272,
                    "value": "86",
                    "name": "V"
                },
                {
                    "id": 7226,
                    "argument_list_id": 272,
                    "value": "87",
                    "name": "W"
                },
                {
                    "id": 7227,
                    "argument_list_id": 272,
                    "value": "88",
                    "name": "X"
                },
                {
                    "id": 7228,
                    "argument_list_id": 272,
                    "value": "89",
                    "name": "Y"
                },
                {
                    "id": 7229,
                    "argument_list_id": 272,
                    "value": "90",
                    "name": "Z"
                },
                {
                    "id": 7230,
                    "argument_list_id": 272,
                    "value": "91",
                    "name": "LeftWindowKey"
                },
                {
                    "id": 7231,
                    "argument_list_id": 272,
                    "value": "92",
                    "name": "RightWindowKey"
                },
                {
                    "id": 7232,
                    "argument_list_id": 272,
                    "value": "93",
                    "name": "SelectKey"
                },
                {
                    "id": 7233,
                    "argument_list_id": 272,
                    "value": "96",
                    "name": "Numpad_0"
                },
                {
                    "id": 7234,
                    "argument_list_id": 272,
                    "value": "97",
                    "name": "Numpad_1"
                },
                {
                    "id": 7235,
                    "argument_list_id": 272,
                    "value": "98",
                    "name": "Numpad_2"
                },
                {
                    "id": 7236,
                    "argument_list_id": 272,
                    "value": "99",
                    "name": "Numpad_3"
                },
                {
                    "id": 7237,
                    "argument_list_id": 272,
                    "value": "100",
                    "name": "Numpad_4"
                },
                {
                    "id": 7238,
                    "argument_list_id": 272,
                    "value": "101",
                    "name": "Numpad_5"
                },
                {
                    "id": 7239,
                    "argument_list_id": 272,
                    "value": "102",
                    "name": "Numpad_6"
                },
                {
                    "id": 7240,
                    "argument_list_id": 272,
                    "value": "103",
                    "name": "Numpad_7"
                },
                {
                    "id": 7241,
                    "argument_list_id": 272,
                    "value": "104",
                    "name": "Numpad_8"
                },
                {
                    "id": 7242,
                    "argument_list_id": 272,
                    "value": "105",
                    "name": "Numpad_9"
                },
                {
                    "id": 7243,
                    "argument_list_id": 272,
                    "value": "106",
                    "name": "Multiply"
                },
                {
                    "id": 7244,
                    "argument_list_id": 272,
                    "value": "107",
                    "name": "Add"
                },
                {
                    "id": 7245,
                    "argument_list_id": 272,
                    "value": "109",
                    "name": "Subtract"
                },
                {
                    "id": 7246,
                    "argument_list_id": 272,
                    "value": "110",
                    "name": "DecimalPoint"
                },
                {
                    "id": 7247,
                    "argument_list_id": 272,
                    "value": "111",
                    "name": "Divide"
                },
                {
                    "id": 7248,
                    "argument_list_id": 272,
                    "value": "112",
                    "name": "F1"
                },
                {
                    "id": 7249,
                    "argument_list_id": 272,
                    "value": "113",
                    "name": "F2"
                },
                {
                    "id": 7250,
                    "argument_list_id": 272,
                    "value": "114",
                    "name": "F3"
                },
                {
                    "id": 7251,
                    "argument_list_id": 272,
                    "value": "115",
                    "name": "F4"
                },
                {
                    "id": 7252,
                    "argument_list_id": 272,
                    "value": "116",
                    "name": "F5"
                },
                {
                    "id": 7253,
                    "argument_list_id": 272,
                    "value": "117",
                    "name": "F6"
                },
                {
                    "id": 7254,
                    "argument_list_id": 272,
                    "value": "118",
                    "name": "F7"
                },
                {
                    "id": 7255,
                    "argument_list_id": 272,
                    "value": "119",
                    "name": "F8"
                },
                {
                    "id": 7256,
                    "argument_list_id": 272,
                    "value": "120",
                    "name": "F9"
                },
                {
                    "id": 7257,
                    "argument_list_id": 272,
                    "value": "121",
                    "name": "F10"
                },
                {
                    "id": 7258,
                    "argument_list_id": 272,
                    "value": "122",
                    "name": "F11"
                },
                {
                    "id": 7259,
                    "argument_list_id": 272,
                    "value": "123",
                    "name": "F12"
                },
                {
                    "id": 7260,
                    "argument_list_id": 272,
                    "value": "144",
                    "name": "NumLock"
                },
                {
                    "id": 7261,
                    "argument_list_id": 272,
                    "value": "145",
                    "name": "ScrollLock"
                },
                {
                    "id": 7262,
                    "argument_list_id": 272,
                    "value": "186",
                    "name": "Semi-colon"
                },
                {
                    "id": 7263,
                    "argument_list_id": 272,
                    "value": "187",
                    "name": "EqualSign"
                },
                {
                    "id": 7264,
                    "argument_list_id": 272,
                    "value": "188",
                    "name": "Comma"
                },
                {
                    "id": 7265,
                    "argument_list_id": 272,
                    "value": "189",
                    "name": "Dash"
                },
                {
                    "id": 7266,
                    "argument_list_id": 272,
                    "value": "190",
                    "name": "Period"
                },
                {
                    "id": 7267,
                    "argument_list_id": 272,
                    "value": "191",
                    "name": "ForwardSlash"
                },
                {
                    "id": 7268,
                    "argument_list_id": 272,
                    "value": "192",
                    "name": "GraveAccent"
                },
                {
                    "id": 7269,
                    "argument_list_id": 272,
                    "value": "219",
                    "name": "OpenBracket"
                },
                {
                    "id": 7270,
                    "argument_list_id": 272,
                    "value": "220",
                    "name": "BackSlash"
                },
                {
                    "id": 7271,
                    "argument_list_id": 272,
                    "value": "221",
                    "name": "CloseBracket"
                },
                {
                    "id": 7272,
                    "argument_list_id": 272,
                    "value": "222",
                    "name": "SingleQuote"
                }
            ],
            "variants": 60
        },
        "list_91": {
            "id": 91,
            "variant": "C2",
            "name": "KnobFlag",
            "base_values_list_id": 25,
            "arguments": [
                {
                    "id": 1200,
                    "argument_list_id": 91,
                    "value": "1",
                    "name": "Only creature can use this knob"
                },
                {
                    "id": 1201,
                    "argument_list_id": 91,
                    "value": "2",
                    "name": "Only pointer can use this knob"
                },
                {
                    "id": 1202,
                    "argument_list_id": 91,
                    "value": "3",
                    "name": "Both creature and pointer can use this knob"
                }
            ],
            "variants": 2
        },
        "list_90": {
            "id": 90,
            "variant": "C2",
            "name": "KnobFunction",
            "base_values_list_id": 24,
            "arguments": [
                {
                    "id": 1194,
                    "argument_list_id": 90,
                    "value": "0",
                    "name": "Activate 1"
                },
                {
                    "id": 1195,
                    "argument_list_id": 90,
                    "value": "1",
                    "name": "Activate 2"
                },
                {
                    "id": 1196,
                    "argument_list_id": 90,
                    "value": "2",
                    "name": "Deactivate"
                },
                {
                    "id": 1197,
                    "argument_list_id": 90,
                    "value": "3",
                    "name": "PointerActivate1"
                },
                {
                    "id": 1198,
                    "argument_list_id": 90,
                    "value": "4",
                    "name": "PointerActivate2"
                },
                {
                    "id": 1199,
                    "argument_list_id": 90,
                    "value": "5",
                    "name": "PointerDeactivate"
                }
            ],
            "variants": 2
        },
        "list_85": {
            "id": 85,
            "variant": "C2",
            "name": "Languages",
            "base_values_list_id": 19,
            "arguments": [
                {
                    "id": 1136,
                    "argument_list_id": 85,
                    "value": "0x00",
                    "name": "Neutral"
                },
                {
                    "id": 1137,
                    "argument_list_id": 85,
                    "value": "0x04",
                    "name": "Chinese"
                },
                {
                    "id": 1138,
                    "argument_list_id": 85,
                    "value": "0x05",
                    "name": "Czech"
                },
                {
                    "id": 1139,
                    "argument_list_id": 85,
                    "value": "0x06",
                    "name": "Danish"
                },
                {
                    "id": 1140,
                    "argument_list_id": 85,
                    "value": "0x13",
                    "name": "Dutch"
                },
                {
                    "id": 1141,
                    "argument_list_id": 85,
                    "value": "0x09",
                    "name": "English"
                },
                {
                    "id": 1142,
                    "argument_list_id": 85,
                    "value": "0x0b",
                    "name": "Finnish"
                },
                {
                    "id": 1143,
                    "argument_list_id": 85,
                    "value": "0x0c",
                    "name": "French"
                },
                {
                    "id": 1144,
                    "argument_list_id": 85,
                    "value": "0x07",
                    "name": "German"
                },
                {
                    "id": 1145,
                    "argument_list_id": 85,
                    "value": "0x08",
                    "name": "Greek"
                },
                {
                    "id": 1146,
                    "argument_list_id": 85,
                    "value": "0x0e",
                    "name": "Hungarian"
                },
                {
                    "id": 1147,
                    "argument_list_id": 85,
                    "value": "0x0F",
                    "name": "Icelandic"
                },
                {
                    "id": 1148,
                    "argument_list_id": 85,
                    "value": "0x10",
                    "name": "Italian"
                },
                {
                    "id": 1149,
                    "argument_list_id": 85,
                    "value": "0x11",
                    "name": "Japanese"
                },
                {
                    "id": 1150,
                    "argument_list_id": 85,
                    "value": "0x12",
                    "name": "Korean"
                },
                {
                    "id": 1151,
                    "argument_list_id": 85,
                    "value": "0x14",
                    "name": "Norwegian"
                },
                {
                    "id": 1152,
                    "argument_list_id": 85,
                    "value": "0x15",
                    "name": "Polish"
                },
                {
                    "id": 1153,
                    "argument_list_id": 85,
                    "value": "0x16",
                    "name": "Portuguese"
                },
                {
                    "id": 1154,
                    "argument_list_id": 85,
                    "value": "0x19",
                    "name": "Russian"
                },
                {
                    "id": 1155,
                    "argument_list_id": 85,
                    "value": "0x1a",
                    "name": "Croatian"
                },
                {
                    "id": 1156,
                    "argument_list_id": 85,
                    "value": "0x1b",
                    "name": "Slovak"
                },
                {
                    "id": 1157,
                    "argument_list_id": 85,
                    "value": "0x0a",
                    "name": "Spanish"
                },
                {
                    "id": 1158,
                    "argument_list_id": 85,
                    "value": "0x1d",
                    "name": "Swedish"
                },
                {
                    "id": 1159,
                    "argument_list_id": 85,
                    "value": "0x1F",
                    "name": "Turkish"
                }
            ],
            "variants": 2
        },
        "list_269": {
            "id": 269,
            "variant": "AL",
            "name": "LifeEventTypes",
            "base_values_list_id": 257,
            "arguments": [
                {
                    "id": 6716,
                    "argument_list_id": 269,
                    "value": "0",
                    "name": "Conceived",
                    "description": "A natural start to life, associated monikers are the mother's and father's",
                    "before_region": "Life Start Events"
                },
                {
                    "id": 6699,
                    "argument_list_id": 269,
                    "value": "1",
                    "name": "Spliced",
                    "description": "created using GENE CROS to crossover the two associated monikers"
                },
                {
                    "id": 6700,
                    "argument_list_id": 269,
                    "value": "2",
                    "name": "Engineered",
                    "description": "from a human made genome with GENE LOAD, the first associated moniker is blank, and the second is the filename"
                },
                {
                    "id": 6702,
                    "argument_list_id": 269,
                    "value": "3",
                    "name": "Born",
                    "description": "triggered by the BORN command, associated monikers are the parents.",
                    "before_region": "Creature's Life Time Events"
                },
                {
                    "id": 6703,
                    "argument_list_id": 269,
                    "value": "4",
                    "name": "Aged",
                    "description": "reached the next life stage, either naturally from the ageing loci or with AGES"
                },
                {
                    "id": 6704,
                    "argument_list_id": 269,
                    "value": "5",
                    "name": "Exported",
                    "description": "emmigrated to another world"
                },
                {
                    "id": 6705,
                    "argument_list_id": 269,
                    "value": "6",
                    "name": "Imported",
                    "description": "immigrated back again"
                },
                {
                    "id": 6706,
                    "argument_list_id": 269,
                    "value": "7",
                    "name": "Died",
                    "description": "triggered naturally with the death trigger locus, or by the DEAD command"
                },
                {
                    "id": 6707,
                    "argument_list_id": 269,
                    "value": "8",
                    "name": "Became pregnant",
                    "description": "the first associated moniker is the child, and the second the father"
                },
                {
                    "id": 6708,
                    "argument_list_id": 269,
                    "value": "9",
                    "name": "Impregnated",
                    "description": "first associated moniker is the child, second the mother"
                },
                {
                    "id": 6709,
                    "argument_list_id": 269,
                    "value": "10",
                    "name": "Child born",
                    "description": "first moniker is the child, second the other parent"
                },
                {
                    "id": 6713,
                    "argument_list_id": 269,
                    "value": "11",
                    "name": "Laid by mother",
                    "before_region": "Non-Engine Triggered Events"
                },
                {
                    "id": 6714,
                    "argument_list_id": 269,
                    "value": "12",
                    "name": "Laid an egg"
                },
                {
                    "id": 6715,
                    "argument_list_id": 269,
                    "value": "13",
                    "name": "Photographed"
                },
                {
                    "id": 6701,
                    "argument_list_id": 269,
                    "value": "14",
                    "name": "Cloned",
                    "description": "such as when importing a creature that already exists in the world and reallocating the new moniker, when TWINing or GENE CLONing; associated moniker is who we were cloned from"
                },
                {
                    "id": 6710,
                    "argument_list_id": 269,
                    "value": "15",
                    "name": "Clone source",
                    "description": "someone was cloned from you, first moniker is whom"
                },
                {
                    "id": 6711,
                    "argument_list_id": 269,
                    "value": "16",
                    "name": "Warped out",
                    "description": "exported through a worm hole with NET: EXPO"
                },
                {
                    "id": 6712,
                    "argument_list_id": 269,
                    "value": "17",
                    "name": "Warped in",
                    "description": "imported through a worm hole"
                }
            ],
            "variants": 60
        },
        "list_248": {
            "id": 248,
            "variant": "C2",
            "name": "LocusOrEmitter",
            "base_values_list_id": 116,
            "arguments": [
                {
                    "id": 6323,
                    "argument_list_id": 248,
                    "value": "0",
                    "name": "Receptor"
                },
                {
                    "id": 6324,
                    "argument_list_id": 248,
                    "value": "1",
                    "name": "Emitter"
                }
            ],
            "variants": 24
        },
        "list_223": {
            "id": 223,
            "variant": "C2",
            "name": "LocusType",
            "base_values_list_id": 100,
            "arguments": [
                {
                    "id": 4366,
                    "argument_list_id": 223,
                    "value": "0",
                    "name": "Receptor Loci"
                },
                {
                    "id": 4367,
                    "argument_list_id": 223,
                    "value": "1",
                    "name": "Emmiter Loci"
                }
            ],
            "variants": 2
        },
        "list_80": {
            "id": 80,
            "variant": "C1",
            "name": "MessageNumbers",
            "base_values_list_id": 14,
            "arguments": [
                {
                    "id": 1118,
                    "argument_list_id": 80,
                    "value": "0",
                    "name": "Activate1"
                },
                {
                    "id": 1119,
                    "argument_list_id": 80,
                    "value": "1",
                    "name": "Activate2"
                },
                {
                    "id": 1120,
                    "argument_list_id": 80,
                    "value": "2",
                    "name": "Deactivate"
                },
                {
                    "id": 1121,
                    "argument_list_id": 80,
                    "value": "4",
                    "name": "Pickup"
                },
                {
                    "id": 1122,
                    "argument_list_id": 80,
                    "value": "5",
                    "name": "Drop"
                },
                {
                    "id": 1123,
                    "argument_list_id": 80,
                    "value": "8",
                    "name": "Enterscope"
                },
                {
                    "id": 8386,
                    "argument_list_id": 80,
                    "value": "9",
                    "name": "Leavescope"
                }
            ],
            "variants": 1
        },
        "list_115": {
            "id": 115,
            "variant": "AL",
            "name": "MessageNumbers",
            "base_values_list_id": 14,
            "arguments": [
                {
                    "id": 2082,
                    "argument_list_id": 115,
                    "value": "0",
                    "name": "Activate 1",
                    "description": "Calls the Activate 1 script. If the message is from a creature, and the permissions set with [BHVR] disallow it, then the script is not executed."
                },
                {
                    "id": 2083,
                    "argument_list_id": 115,
                    "value": "1",
                    "name": "Activate 2",
                    "description": "Calls the Activate 2 script. The permissions set with [BHVR] are checked first."
                },
                {
                    "id": 2084,
                    "argument_list_id": 115,
                    "value": "2",
                    "name": "Deactivate",
                    "description": "Calls the Deactivate script. The permissions set with [BHVR] are checked first."
                },
                {
                    "id": 2085,
                    "argument_list_id": 115,
                    "value": "3",
                    "name": "Hit",
                    "description": "Calls the Hit script. If the message is from a creature, and the permissions set with [BHVR] disallow it, then the message is not sent."
                },
                {
                    "id": 2086,
                    "argument_list_id": 115,
                    "value": "4",
                    "name": "Pickup",
                    "description": "The agent is picked up by the agent that the message was [FROM]. The permissions set with [BHVR] are checked first."
                },
                {
                    "id": 2087,
                    "argument_list_id": 115,
                    "value": "5",
                    "name": "Drop",
                    "description": "If the agent is being carried, then it is dropped."
                },
                {
                    "id": 2088,
                    "argument_list_id": 115,
                    "value": "12",
                    "name": "Eat",
                    "description": "Calls the Eat script. The permissions set with [BHVR] are checked first."
                },
                {
                    "id": 2089,
                    "argument_list_id": 115,
                    "value": "13",
                    "name": "Hold Hands",
                    "description": "Causes a creature to hold hands with the pointer."
                },
                {
                    "id": 2090,
                    "argument_list_id": 115,
                    "value": "14",
                    "name": "Stop Holding Hands",
                    "description": "Causes a creature to stop holding hands with the pointer. Since messages take a tick to be procesed, calling [NOHH] is quicker than using this message."
                }
            ],
            "variants": 60
        },
        "list_123": {
            "id": 123,
            "variant": "C2",
            "name": "MessageNumbers",
            "base_values_list_id": 14,
            "arguments": [
                {
                    "id": 2583,
                    "argument_list_id": 123,
                    "value": "0",
                    "name": "Activate 1"
                },
                {
                    "id": 2584,
                    "argument_list_id": 123,
                    "value": "1",
                    "name": "Activate 2"
                },
                {
                    "id": 2585,
                    "argument_list_id": 123,
                    "value": "3",
                    "name": "Hit"
                },
                {
                    "id": 2586,
                    "argument_list_id": 123,
                    "value": "4",
                    "name": "Pickup"
                },
                {
                    "id": 2587,
                    "argument_list_id": 123,
                    "value": "5",
                    "name": "Drop"
                },
                {
                    "id": 2588,
                    "argument_list_id": 123,
                    "value": "8",
                    "name": "Enterscope"
                },
                {
                    "id": 2589,
                    "argument_list_id": 123,
                    "value": "10",
                    "name": "Push Left"
                },
                {
                    "id": 2590,
                    "argument_list_id": 123,
                    "value": "11",
                    "name": "Push Right"
                },
                {
                    "id": 2591,
                    "argument_list_id": 123,
                    "value": "12",
                    "name": "Eat"
                }
            ],
            "variants": 2
        },
        "list_191": {
            "id": 191,
            "variant": "AL",
            "name": "MetaTransition",
            "base_values_list_id": 72,
            "arguments": [
                {
                    "id": 4271,
                    "argument_list_id": 191,
                    "value": "0",
                    "name": "None",
                    "description": "No transition effect"
                },
                {
                    "id": 4272,
                    "argument_list_id": 191,
                    "value": "1",
                    "name": "Flip",
                    "description": "Flip Horizontally"
                },
                {
                    "id": 4273,
                    "argument_list_id": 191,
                    "value": "2",
                    "name": "Burst"
                }
            ],
            "variants": 60
        },
        "list_177": {
            "id": 177,
            "variant": "AL",
            "name": "Mirrored",
            "extension_type": "bool",
            "base_values_list_id": 62,
            "arguments": [
                {
                    "id": 3757,
                    "argument_list_id": 177,
                    "value": "0",
                    "name": "Not-Mirrored"
                },
                {
                    "id": 3758,
                    "argument_list_id": 177,
                    "value": "1",
                    "name": "Mirrored"
                }
            ],
            "variants": 60
        },
        "list_172": {
            "id": 172,
            "variant": "AL",
            "name": "MonikerStatus",
            "base_values_list_id": 57,
            "arguments": [
                {
                    "id": 3734,
                    "argument_list_id": 172,
                    "value": "0",
                    "name": "Never Existed"
                },
                {
                    "id": 3735,
                    "argument_list_id": 172,
                    "value": "1",
                    "name": "Referenced By Slot"
                },
                {
                    "id": 3736,
                    "argument_list_id": 172,
                    "value": "2",
                    "name": "Creature From [NEW: CREA]"
                },
                {
                    "id": 3737,
                    "argument_list_id": 172,
                    "value": "3",
                    "name": "Creature Properly Born"
                },
                {
                    "id": 3738,
                    "argument_list_id": 172,
                    "value": "4",
                    "name": "Out of World"
                },
                {
                    "id": 3739,
                    "argument_list_id": 172,
                    "value": "5",
                    "name": "Dead, Body Still Exists"
                },
                {
                    "id": 3740,
                    "argument_list_id": 172,
                    "value": "6",
                    "name": "Dead, Body [KILL]ed"
                },
                {
                    "id": 3741,
                    "argument_list_id": 172,
                    "value": "7",
                    "name": "Unreferenced Genome"
                }
            ],
            "variants": 60
        },
        "list_251": {
            "id": 251,
            "variant": "AL",
            "name": "Mous",
            "description": "MOUS command values",
            "base_values_list_id": 119,
            "arguments": [
                {
                    "id": 6350,
                    "argument_list_id": 251,
                    "value": "0",
                    "name": "Normal",
                    "description": "Is Normal"
                },
                {
                    "id": 6351,
                    "argument_list_id": 251,
                    "value": "1",
                    "name": "Right button as left",
                    "description": "right button does what the left button does"
                },
                {
                    "id": 6352,
                    "argument_list_id": 251,
                    "value": "2",
                    "name": "Left Button as Right",
                    "description": "left button does what the right button does"
                }
            ],
            "variants": 60
        },
        "list_276": {
            "id": 276,
            "variant": "AL",
            "name": "MouseButton",
            "description": "Mouse button clicked or released",
            "arguments": [
                {
                    "id": 7278,
                    "argument_list_id": 276,
                    "value": "1",
                    "name": "Left Mouse Button"
                },
                {
                    "id": 7279,
                    "argument_list_id": 276,
                    "value": "2",
                    "name": "Right Mouse Button"
                },
                {
                    "id": 7280,
                    "argument_list_id": 276,
                    "value": "4",
                    "name": "Middle Mouse Button"
                }
            ],
            "variants": 60
        },
        "list_67": {
            "id": 67,
            "variant": "C1",
            "name": "MovementStatus",
            "base_values_list_id": 1,
            "arguments": [
                {
                    "id": 924,
                    "argument_list_id": 67,
                    "value": "0",
                    "name": "Autonomous"
                },
                {
                    "id": 925,
                    "argument_list_id": 67,
                    "value": "1",
                    "name": "MouseDriven"
                },
                {
                    "id": 926,
                    "argument_list_id": 67,
                    "value": "2",
                    "name": "Floating"
                },
                {
                    "id": 927,
                    "argument_list_id": 67,
                    "value": "3",
                    "name": "In Vehicle"
                },
                {
                    "id": 928,
                    "argument_list_id": 67,
                    "value": "4",
                    "name": "Carried"
                }
            ],
            "variants": 1
        },
        "list_125": {
            "id": 125,
            "variant": "C2",
            "name": "MovementStatus",
            "base_values_list_id": 1,
            "arguments": [
                {
                    "id": 2597,
                    "argument_list_id": 125,
                    "value": "0",
                    "name": "Autonomous",
                    "description": "Default \u2013 normal object in world"
                },
                {
                    "id": 2598,
                    "argument_list_id": 125,
                    "value": "1",
                    "name": "Mouse-Driven",
                    "description": "Simple Object connected to mouse"
                },
                {
                    "id": 2599,
                    "argument_list_id": 125,
                    "value": "2",
                    "name": "Floating",
                    "description": "Object is in fixed place on screen"
                },
                {
                    "id": 2600,
                    "argument_list_id": 125,
                    "value": "3",
                    "name": "In Vehicle",
                    "description": "Object is carried in a vehicle"
                },
                {
                    "id": 2601,
                    "argument_list_id": 125,
                    "value": "4",
                    "name": "Carried",
                    "description": "Object is carried by a creature"
                }
            ],
            "variants": 2
        },
        "list_128": {
            "id": 128,
            "variant": "C3",
            "name": "MovementStatus",
            "base_values_list_id": 1,
            "arguments": [
                {
                    "id": 2605,
                    "argument_list_id": 128,
                    "value": "0",
                    "name": "Autonomous",
                    "description": "Default \u2013 normal object in world"
                },
                {
                    "id": 2606,
                    "argument_list_id": 128,
                    "value": "1",
                    "name": "Mouse-Driven",
                    "description": "Simple Object connected to mouse"
                },
                {
                    "id": 2607,
                    "argument_list_id": 128,
                    "value": "2",
                    "name": "Floating",
                    "description": "Object is in fixed place on screen"
                },
                {
                    "id": 2608,
                    "argument_list_id": 128,
                    "value": "3",
                    "name": "In Vehicle",
                    "description": "Object is carried in a vehicle"
                },
                {
                    "id": 2609,
                    "argument_list_id": 128,
                    "value": "4",
                    "name": "Carried",
                    "description": "Object is carried by a creature"
                }
            ],
            "variants": 60
        },
        "list_213": {
            "id": 213,
            "variant": "AL",
            "name": "Muted",
            "base_values_list_id": 92,
            "arguments": [
                {
                    "id": 4333,
                    "argument_list_id": 213,
                    "value": "0",
                    "name": "Nothing Muted"
                },
                {
                    "id": 4336,
                    "argument_list_id": 213,
                    "value": "1",
                    "name": "Sound Muted"
                },
                {
                    "id": 4337,
                    "argument_list_id": 213,
                    "value": "2",
                    "name": "Music Muted"
                },
                {
                    "id": 4338,
                    "argument_list_id": 213,
                    "value": "3",
                    "name": "Sound and Music Muted"
                }
            ],
            "variants": 60
        },
        "list_176": {
            "id": 176,
            "variant": "DS",
            "name": "NetErrorCodes",
            "base_values_list_id": 61,
            "arguments": [
                {
                    "id": 3749,
                    "argument_list_id": 176,
                    "value": "0",
                    "name": "Unknown"
                },
                {
                    "id": 3750,
                    "argument_list_id": 176,
                    "value": "1",
                    "name": "OK"
                },
                {
                    "id": 3751,
                    "argument_list_id": 176,
                    "value": "2",
                    "name": "Offline",
                    "description": "You or Server Offline"
                },
                {
                    "id": 3752,
                    "argument_list_id": 176,
                    "value": "3",
                    "name": "Invalid Username/Password"
                },
                {
                    "id": 3753,
                    "argument_list_id": 176,
                    "value": "4",
                    "name": "Already Logged In",
                    "description": "You are already logged in somewhere else"
                },
                {
                    "id": 3754,
                    "argument_list_id": 176,
                    "value": "5",
                    "name": "Too many users",
                    "description": "To many users for server"
                },
                {
                    "id": 3755,
                    "argument_list_id": 176,
                    "value": "6",
                    "name": "Internal Error"
                },
                {
                    "id": 3756,
                    "argument_list_id": 176,
                    "value": "7",
                    "name": "Version Out Of Date",
                    "description": "New client version required"
                }
            ],
            "variants": 48
        },
        "list_291": {
            "id": 291,
            "variant": "AL",
            "name": "Nouns",
            "description": "Noun Ids",
            "arguments": [
                {
                    "id": 9373,
                    "argument_list_id": 291,
                    "value": "0",
                    "name": "self"
                },
                {
                    "id": 9374,
                    "argument_list_id": 291,
                    "value": "1",
                    "name": "hand"
                },
                {
                    "id": 9375,
                    "argument_list_id": 291,
                    "value": "2",
                    "name": "door"
                },
                {
                    "id": 9376,
                    "argument_list_id": 291,
                    "value": "3",
                    "name": "seed"
                },
                {
                    "id": 9377,
                    "argument_list_id": 291,
                    "value": "4",
                    "name": "plant"
                },
                {
                    "id": 9378,
                    "argument_list_id": 291,
                    "value": "5",
                    "name": "weed"
                },
                {
                    "id": 9379,
                    "argument_list_id": 291,
                    "value": "6",
                    "name": "leaf"
                },
                {
                    "id": 9380,
                    "argument_list_id": 291,
                    "value": "7",
                    "name": "flower"
                },
                {
                    "id": 9381,
                    "argument_list_id": 291,
                    "value": "8",
                    "name": "fruit"
                },
                {
                    "id": 9382,
                    "argument_list_id": 291,
                    "value": "9",
                    "name": "manky"
                },
                {
                    "id": 9383,
                    "argument_list_id": 291,
                    "value": "10",
                    "name": "detritus"
                },
                {
                    "id": 9384,
                    "argument_list_id": 291,
                    "value": "11",
                    "name": "food"
                },
                {
                    "id": 9385,
                    "argument_list_id": 291,
                    "value": "12",
                    "name": "button"
                },
                {
                    "id": 9386,
                    "argument_list_id": 291,
                    "value": "13",
                    "name": "bug"
                },
                {
                    "id": 9387,
                    "argument_list_id": 291,
                    "value": "14",
                    "name": "pest"
                },
                {
                    "id": 9388,
                    "argument_list_id": 291,
                    "value": "15",
                    "name": "critter"
                },
                {
                    "id": 9389,
                    "argument_list_id": 291,
                    "value": "16",
                    "name": "beast"
                },
                {
                    "id": 9390,
                    "argument_list_id": 291,
                    "value": "17",
                    "name": "nest"
                },
                {
                    "id": 9391,
                    "argument_list_id": 291,
                    "value": "18",
                    "name": "animal egg"
                },
                {
                    "id": 9392,
                    "argument_list_id": 291,
                    "value": "19",
                    "name": "weather"
                },
                {
                    "id": 9393,
                    "argument_list_id": 291,
                    "value": "20",
                    "name": "bad"
                },
                {
                    "id": 9394,
                    "argument_list_id": 291,
                    "value": "21",
                    "name": "toy"
                },
                {
                    "id": 9395,
                    "argument_list_id": 291,
                    "value": "22",
                    "name": "incubator"
                },
                {
                    "id": 9396,
                    "argument_list_id": 291,
                    "value": "23",
                    "name": "dispenser"
                },
                {
                    "id": 9397,
                    "argument_list_id": 291,
                    "value": "24",
                    "name": "tool"
                },
                {
                    "id": 9398,
                    "argument_list_id": 291,
                    "value": "25",
                    "name": "potion"
                },
                {
                    "id": 9399,
                    "argument_list_id": 291,
                    "value": "26",
                    "name": "elevator"
                },
                {
                    "id": 9400,
                    "argument_list_id": 291,
                    "value": "27",
                    "name": "teleporter"
                },
                {
                    "id": 9401,
                    "argument_list_id": 291,
                    "value": "28",
                    "name": "machinery"
                },
                {
                    "id": 9402,
                    "argument_list_id": 291,
                    "value": "29",
                    "name": "creature egg"
                },
                {
                    "id": 9403,
                    "argument_list_id": 291,
                    "value": "30",
                    "name": "norn home"
                },
                {
                    "id": 9404,
                    "argument_list_id": 291,
                    "value": "31",
                    "name": "grendel home"
                },
                {
                    "id": 9405,
                    "argument_list_id": 291,
                    "value": "32",
                    "name": "ettin home"
                },
                {
                    "id": 9406,
                    "argument_list_id": 291,
                    "value": "33",
                    "name": "gadget"
                },
                {
                    "id": 9407,
                    "argument_list_id": 291,
                    "value": "34",
                    "name": "portal"
                },
                {
                    "id": 9408,
                    "argument_list_id": 291,
                    "value": "35",
                    "name": "vehicle"
                },
                {
                    "id": 9409,
                    "argument_list_id": 291,
                    "value": "36",
                    "name": "norn"
                },
                {
                    "id": 9410,
                    "argument_list_id": 291,
                    "value": "37",
                    "name": "grendel"
                },
                {
                    "id": 9411,
                    "argument_list_id": 291,
                    "value": "38",
                    "name": "ettin"
                },
                {
                    "id": 9412,
                    "argument_list_id": 291,
                    "value": "39",
                    "name": "something"
                }
            ],
            "variants": 24
        },
        "list_173": {
            "id": 173,
            "variant": "AL",
            "name": "Online",
            "extension_type": "bool",
            "base_values_list_id": 58,
            "arguments": [
                {
                    "id": 3742,
                    "argument_list_id": 173,
                    "value": "0",
                    "name": "Offline"
                },
                {
                    "id": 3743,
                    "argument_list_id": 173,
                    "value": "1",
                    "name": "Online"
                }
            ],
            "variants": 48
        },
        "list_181": {
            "id": 181,
            "variant": "AL",
            "name": "OnOff",
            "extension_type": "bool",
            "base_values_list_id": 66,
            "arguments": [
                {
                    "id": 3765,
                    "argument_list_id": 181,
                    "value": "0",
                    "name": "Off"
                },
                {
                    "id": 3766,
                    "argument_list_id": 181,
                    "value": "1",
                    "name": "On"
                }
            ],
            "variants": 58
        },
        "list_290": {
            "id": 290,
            "variant": "AL",
            "name": "OpaqueOnly",
            "description": "How should click handle transparent pixels",
            "extension_type": "bool",
            "arguments": [
                {
                    "id": 9257,
                    "argument_list_id": 290,
                    "value": "0",
                    "name": "Click Anywhere",
                    "description": "Click anywhere on the part even transparent pixels"
                },
                {
                    "id": 9258,
                    "argument_list_id": 290,
                    "value": "1",
                    "name": "Click Opaque Only",
                    "description": "Click only opaque/non-transparent pixels on part"
                }
            ],
            "variants": 60
        },
        "list_249": {
            "id": 249,
            "variant": "C2",
            "name": "OrganNumbers",
            "description": "Organ numbers for the [LCUS] command",
            "base_values_list_id": 117,
            "arguments": [
                {
                    "id": 6325,
                    "argument_list_id": 249,
                    "value": "1",
                    "name": "Brain"
                },
                {
                    "id": 6326,
                    "argument_list_id": 249,
                    "value": "2",
                    "name": "DriveLobeSupport"
                },
                {
                    "id": 6327,
                    "argument_list_id": 249,
                    "value": "3",
                    "name": "ConceptLobeSupport"
                },
                {
                    "id": 6328,
                    "argument_list_id": 249,
                    "value": "4",
                    "name": "DecisionLobeSupport"
                },
                {
                    "id": 6329,
                    "argument_list_id": 249,
                    "value": "5",
                    "name": "RegulatorLobeSupport"
                },
                {
                    "id": 6330,
                    "argument_list_id": 249,
                    "value": "6",
                    "name": "Times Arrow"
                },
                {
                    "id": 6331,
                    "argument_list_id": 249,
                    "value": "7",
                    "name": "Environmental If"
                },
                {
                    "id": 6332,
                    "argument_list_id": 249,
                    "value": "8",
                    "name": "Muscle"
                },
                {
                    "id": 6333,
                    "argument_list_id": 249,
                    "value": "9",
                    "name": "Heart"
                },
                {
                    "id": 6334,
                    "argument_list_id": 249,
                    "value": "10",
                    "name": "Lung"
                },
                {
                    "id": 6335,
                    "argument_list_id": 249,
                    "value": "11",
                    "name": "Liver"
                },
                {
                    "id": 6336,
                    "argument_list_id": 249,
                    "value": "12",
                    "name": "PancreasAlpha"
                },
                {
                    "id": 6337,
                    "argument_list_id": 249,
                    "value": "13",
                    "name": "PancreasBeta"
                },
                {
                    "id": 6338,
                    "argument_list_id": 249,
                    "value": "14",
                    "name": "Tummy"
                },
                {
                    "id": 6339,
                    "argument_list_id": 249,
                    "value": "15",
                    "name": "Kidney"
                },
                {
                    "id": 6340,
                    "argument_list_id": 249,
                    "value": "16",
                    "name": "Bones"
                },
                {
                    "id": 6341,
                    "argument_list_id": 249,
                    "value": "17",
                    "name": "Spleen"
                },
                {
                    "id": 6342,
                    "argument_list_id": 249,
                    "value": "18",
                    "name": "Skin"
                },
                {
                    "id": 6343,
                    "argument_list_id": 249,
                    "value": "19",
                    "name": "Gonad"
                },
                {
                    "id": 6344,
                    "argument_list_id": 249,
                    "value": "20",
                    "name": "Uterus"
                }
            ],
            "variants": 2
        },
        "list_193": {
            "id": 193,
            "variant": "AL",
            "name": "OrgfDataType",
            "base_values_list_id": 74,
            "arguments": [
                {
                    "id": 4277,
                    "argument_list_id": 193,
                    "value": "0",
                    "name": "Clock rate",
                    "description": "Clock rate in updates per tick (as locus)"
                },
                {
                    "id": 4278,
                    "argument_list_id": 193,
                    "value": "1",
                    "name": "Short term life force",
                    "description": "Short term life forceas a proportion of intial (as locus)"
                },
                {
                    "id": 4279,
                    "argument_list_id": 193,
                    "value": "2",
                    "name": "Repair Modulating Factor",
                    "description": "Factor to modulate rate of repair (as locus)"
                },
                {
                    "id": 4280,
                    "argument_list_id": 193,
                    "value": "3",
                    "name": "Injury",
                    "description": "Injury to apply (as locus)"
                },
                {
                    "id": 4281,
                    "argument_list_id": 193,
                    "value": "4",
                    "name": "Initial life force",
                    "description": "Initial life force. A million is the largest initial value"
                },
                {
                    "id": 4282,
                    "argument_list_id": 193,
                    "value": "5",
                    "name": "Short term life force",
                    "description": "Temporary damage"
                },
                {
                    "id": 4283,
                    "argument_list_id": 193,
                    "value": "6",
                    "name": "Long term life force",
                    "description": "Permanent damage"
                },
                {
                    "id": 4284,
                    "argument_list_id": 193,
                    "value": "7",
                    "name": "Long term rate damage during repair"
                },
                {
                    "id": 4285,
                    "argument_list_id": 193,
                    "value": "8",
                    "name": "Energy Cost",
                    "description": "Cost to run this organ, calculated from the number of receptors, emitters and reactions"
                },
                {
                    "id": 4286,
                    "argument_list_id": 193,
                    "value": "9",
                    "name": "Damage",
                    "description": "Damage done to the organ if no energy is available"
                }
            ],
            "variants": 60
        },
        "list_195": {
            "id": 195,
            "variant": "AL",
            "name": "OrgiDataType",
            "base_values_list_id": 76,
            "arguments": [],
            "variants": 60
        },
        "list_161": {
            "id": 161,
            "variant": "AL",
            "name": "Paused",
            "extension_type": "bool",
            "base_values_list_id": 16,
            "arguments": [
                {
                    "id": 3706,
                    "argument_list_id": 161,
                    "value": "0",
                    "name": "Not-Paused"
                },
                {
                    "id": 3707,
                    "argument_list_id": 161,
                    "value": "1",
                    "name": "Paused"
                }
            ],
            "variants": 62
        },
        "list_171": {
            "id": 171,
            "variant": "AL",
            "name": "PawsDisabled",
            "extension_type": "bool",
            "base_values_list_id": 56,
            "arguments": [
                {
                    "id": 3733,
                    "argument_list_id": 171,
                    "value": "0",
                    "name": "Not Paws'd"
                },
                {
                    "id": 3732,
                    "argument_list_id": 171,
                    "value": "1",
                    "name": "Paws'd"
                }
            ],
            "variants": 60
        },
        "list_275": {
            "id": 275,
            "variant": "AL",
            "name": "PointerAction",
            "description": "Action performed on creature when pointer clicks",
            "arguments": [
                {
                    "id": 7275,
                    "argument_list_id": 275,
                    "value": "0",
                    "name": "None",
                    "description": "No Action or pointer not above creature)"
                },
                {
                    "id": 7276,
                    "argument_list_id": 275,
                    "value": "1",
                    "name": "Slap"
                },
                {
                    "id": 7277,
                    "argument_list_id": 275,
                    "value": "2",
                    "name": "Tickle"
                }
            ],
            "variants": 60
        },
        "list_194": {
            "id": 194,
            "variant": "AL",
            "name": "PrayCreatureImportCode",
            "base_values_list_id": 75,
            "arguments": [
                {
                    "id": 4287,
                    "argument_list_id": 194,
                    "value": "0",
                    "name": "Success"
                },
                {
                    "id": 4288,
                    "argument_list_id": 194,
                    "value": "1",
                    "name": "Creature Cloned",
                    "description": "Couldn't reconcile histories so creature was cloned"
                },
                {
                    "id": 4289,
                    "argument_list_id": 194,
                    "value": "2",
                    "name": "Moniker Not Found",
                    "description": "Moniker not found in PRAY system"
                },
                {
                    "id": 4290,
                    "argument_list_id": 194,
                    "value": "3",
                    "name": "<<Unused>>",
                    "description": "Unused error code"
                },
                {
                    "id": 4291,
                    "argument_list_id": 194,
                    "value": "4",
                    "name": "Internal Error / File Format Error"
                }
            ],
            "variants": 60
        },
        "list_204": {
            "id": 204,
            "variant": "AL",
            "name": "PrayFileSuccess",
            "extension_type": "bool",
            "base_values_list_id": 84,
            "arguments": [
                {
                    "id": 4316,
                    "argument_list_id": 204,
                    "value": "0",
                    "name": "Success"
                },
                {
                    "id": 4317,
                    "argument_list_id": 204,
                    "value": "1",
                    "name": "Error"
                }
            ],
            "variants": 60
        },
        "list_205": {
            "id": 205,
            "variant": "AL",
            "name": "PrayInjtSuccess",
            "base_values_list_id": 85,
            "arguments": [],
            "variants": 60
        },
        "list_208": {
            "id": 208,
            "variant": "AL",
            "name": "PraySpot",
            "base_values_list_id": 87,
            "arguments": [
                {
                    "id": 4320,
                    "argument_list_id": 208,
                    "value": "0",
                    "name": "My Agents"
                },
                {
                    "id": 4321,
                    "argument_list_id": 208,
                    "value": "1",
                    "name": "My Creatures"
                }
            ],
            "variants": 24
        },
        "list_197": {
            "id": 197,
            "variant": "AL",
            "name": "PrayTestResult",
            "base_values_list_id": 78,
            "arguments": [
                {
                    "id": 4295,
                    "argument_list_id": 197,
                    "value": "0",
                    "name": "Unavailable",
                    "description": "Chunk not available at this time"
                },
                {
                    "id": 4296,
                    "argument_list_id": 197,
                    "value": "1",
                    "name": "Cached",
                    "description": "Chunk Available, Cached and ready for use"
                },
                {
                    "id": 4297,
                    "argument_list_id": 197,
                    "value": "2",
                    "name": "Uncompressed",
                    "description": "On disk uncompressed and fine for loading"
                },
                {
                    "id": 4298,
                    "argument_list_id": 197,
                    "value": "3",
                    "name": "Compressed",
                    "description": "On disk compressed and ready for loading."
                }
            ],
            "variants": 60
        },
        "list_178": {
            "id": 178,
            "variant": "AL",
            "name": "Pressed",
            "extension_type": "bool",
            "base_values_list_id": 63,
            "arguments": [
                {
                    "id": 3759,
                    "argument_list_id": 178,
                    "value": "0",
                    "name": "Not-Pressed"
                },
                {
                    "id": 3760,
                    "argument_list_id": 178,
                    "value": "1",
                    "name": "Pressed"
                }
            ],
            "variants": 60
        },
        "list_70": {
            "id": 70,
            "variant": "AL",
            "name": "PutBOption",
            "base_values_list_id": 4,
            "arguments": [
                {
                    "id": 942,
                    "argument_list_id": 70,
                    "value": "DATA",
                    "name": "SetAll",
                    "description": "Set all creatures details"
                },
                {
                    "id": 943,
                    "argument_list_id": 70,
                    "value": "CNAM",
                    "name": "SetName",
                    "description": "Set the creature's name from the string"
                }
            ],
            "variants": 3
        },
        "list_94": {
            "id": 94,
            "variant": "C2",
            "name": "RainProperty",
            "base_values_list_id": 27,
            "arguments": [
                {
                    "id": 1207,
                    "argument_list_id": 94,
                    "value": "0",
                    "name": "X-Position",
                    "description": "X-Position, relative to object"
                },
                {
                    "id": 1208,
                    "argument_list_id": 94,
                    "value": "1",
                    "name": "Y-Position",
                    "description": "Y-Position, relative to object"
                },
                {
                    "id": 1209,
                    "argument_list_id": 94,
                    "value": "2",
                    "name": "Width"
                },
                {
                    "id": 1210,
                    "argument_list_id": 94,
                    "value": "3",
                    "name": "Height"
                },
                {
                    "id": 1211,
                    "argument_list_id": 94,
                    "value": "4",
                    "name": "Angle Of Effect",
                    "description": "Angle of Effect (updated by wind)"
                },
                {
                    "id": 1212,
                    "argument_list_id": 94,
                    "value": "5",
                    "name": "Speed",
                    "description": "Number of pixels moved per update"
                },
                {
                    "id": 1213,
                    "argument_list_id": 94,
                    "value": "6",
                    "name": "Mode",
                    "description": "0=stopped, 1=running, 2=start!, 3=stop!"
                },
                {
                    "id": 1214,
                    "argument_list_id": 94,
                    "value": "7",
                    "name": "Rain Image Number",
                    "description": "Rain image number(0-11)"
                }
            ],
            "variants": 2
        },
        "list_280": {
            "id": 280,
            "variant": "AL",
            "name": "ReceptorLocusLoci",
            "arguments": [
                {
                    "id": 7988,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Somatic"
                },
                {
                    "id": 8257,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "NeuronState_0"
                },
                {
                    "id": 8266,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Muscles",
                    "description": "How much energy has been expended on movement this tick"
                },
                {
                    "id": 8273,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Floating Loci 0"
                },
                {
                    "id": 8305,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Fertile",
                    "description": "If male has a sperm or female has an egg available"
                },
                {
                    "id": 7796,
                    "argument_list_id": 280,
                    "value": "(0-255)%3+0",
                    "name": "NeuronState_0"
                },
                {
                    "id": 7797,
                    "argument_list_id": 280,
                    "value": "(0-255)%3+1",
                    "name": "NeuronState_1"
                },
                {
                    "id": 8309,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Dead",
                    "description": ">0 if creature is dead (allows post-mortem chemistry)"
                },
                {
                    "id": 7798,
                    "argument_list_id": 280,
                    "value": "(0-255)%3+2",
                    "name": "NeuronState_2"
                },
                {
                    "id": 8310,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Constant",
                    "description": "Always 1.0 (for regular emitters)."
                },
                {
                    "id": 8335,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Pain",
                    "description": "Drive 0"
                },
                {
                    "id": 8083,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Age 0|Baby",
                    "description": "If on and currently BABY, become CHILD"
                },
                {
                    "id": 8090,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Floating Loci 0"
                },
                {
                    "id": 8122,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Ovulate",
                    "description": "If low, remove any egg/sperm from .Gamete; if high, add one"
                },
                {
                    "id": 8126,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Die",
                    "description": "If on, creature dies (ill health, poison, starvation...)"
                },
                {
                    "id": 8127,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Involuntary 0",
                    "description": "Trigger flinching"
                },
                {
                    "id": 8152,
                    "argument_list_id": 280,
                    "value": "0",
                    "name": "Pain",
                    "description": "Drive 0"
                },
                {
                    "id": 7989,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Circulatory"
                },
                {
                    "id": 8258,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "NeuronState_1"
                },
                {
                    "id": 8274,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Floating Loci 1"
                },
                {
                    "id": 8306,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Pregnant",
                    "description": "If female has both egg and sperm & so is pregnant"
                },
                {
                    "id": 8311,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Asleep",
                    "description": "1.0 if asleep, 0.0 otherwise."
                },
                {
                    "id": 8336,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Hunger for protein",
                    "description": "Drive 1"
                },
                {
                    "id": 8084,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Age 1|Child",
                    "description": "If on and currently CHILD, become ADOLESCENT"
                },
                {
                    "id": 8091,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Floating Loci 1"
                },
                {
                    "id": 8123,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Receptive",
                    "description": "If >0, female is receptive to incoming sperm & will conceive"
                },
                {
                    "id": 8128,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Involuntary 1",
                    "description": "Lay egg."
                },
                {
                    "id": 8153,
                    "argument_list_id": 280,
                    "value": "1",
                    "name": "Hunger for protein",
                    "description": "Drive 1"
                },
                {
                    "id": 7990,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Reproductive"
                },
                {
                    "id": 8259,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "NeuronState_2"
                },
                {
                    "id": 8275,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Floating Loci 2"
                },
                {
                    "id": 8312,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Coldness (DEPRECATED)"
                },
                {
                    "id": 8337,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Hunger for carbs",
                    "description": "Drive 2"
                },
                {
                    "id": 8085,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Age 2|Adolescent",
                    "description": "If on and currently ADOLESCENT, become YOUTH"
                },
                {
                    "id": 8092,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Floating Loci 2"
                },
                {
                    "id": 8124,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "ChanceOfMutation"
                },
                {
                    "id": 8129,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Involuntary 2",
                    "description": "Sneeze."
                },
                {
                    "id": 8385,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Ovulate",
                    "description": "If low, remove any egg/sperm from .Gamete; if high, add one"
                },
                {
                    "id": 8154,
                    "argument_list_id": 280,
                    "value": "2",
                    "name": "Hunger for carbs",
                    "description": "Drive 2"
                },
                {
                    "id": 7991,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Immune"
                },
                {
                    "id": 8276,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Floating Loci 3"
                },
                {
                    "id": 8313,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Hotness (DEPRECATED)"
                },
                {
                    "id": 8338,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Hunger for fat",
                    "description": "Drive 3"
                },
                {
                    "id": 8086,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Age 3|Youth",
                    "description": "If on and currently YOUTH, become ADULT"
                },
                {
                    "id": 8093,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Floating Loci 3"
                },
                {
                    "id": 8125,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "DegreeOfMutation"
                },
                {
                    "id": 8384,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Receptive",
                    "description": "If >0, female is receptive to incoming sperm & will conceive"
                },
                {
                    "id": 8130,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Involuntary 3",
                    "description": "Cough."
                },
                {
                    "id": 8155,
                    "argument_list_id": 280,
                    "value": "3",
                    "name": "Hunger for fat",
                    "description": "Drive 3"
                },
                {
                    "id": 7992,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Sensorimotor"
                },
                {
                    "id": 8277,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Floating Loci 4"
                },
                {
                    "id": 8307,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "ChanceOfMutation"
                },
                {
                    "id": 8314,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Lightlevel (DEPRECATED)"
                },
                {
                    "id": 8339,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Coldness",
                    "description": "Drive 4"
                },
                {
                    "id": 8087,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Age 4|Adult",
                    "description": "If on and currently ADULT, become OLD"
                },
                {
                    "id": 8094,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Floating Loci 4"
                },
                {
                    "id": 8131,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Involuntary 4",
                    "description": "Shiver."
                },
                {
                    "id": 8156,
                    "argument_list_id": 280,
                    "value": "4",
                    "name": "Coldness",
                    "description": "Drive 4"
                },
                {
                    "id": 7993,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Drives"
                },
                {
                    "id": 8278,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Floating Loci 5"
                },
                {
                    "id": 8308,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "DegreeOfMutation"
                },
                {
                    "id": 8315,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Crowdedness",
                    "description": "How many and how close others of your kind are"
                },
                {
                    "id": 8340,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Hotness",
                    "description": "Drive 5"
                },
                {
                    "id": 8088,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Age 5|Old",
                    "description": "If on and currently OLD, become SENILE"
                },
                {
                    "id": 8095,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Floating Loci 5"
                },
                {
                    "id": 8132,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Involuntary 5",
                    "description": "Sleep"
                },
                {
                    "id": 8157,
                    "argument_list_id": 280,
                    "value": "5",
                    "name": "Hotness",
                    "description": "Drive 5"
                },
                {
                    "id": 8279,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Floating Loci 6"
                },
                {
                    "id": 8316,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Radiation (DEPRECATED)"
                },
                {
                    "id": 8341,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Tiredness",
                    "description": "Drive 6"
                },
                {
                    "id": 8089,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Age 6|Senile",
                    "description": "If on DIE IMMEDIATELY of old age"
                },
                {
                    "id": 8096,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Floating Loci 6"
                },
                {
                    "id": 8133,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Involuntary 6",
                    "description": "Fainting"
                },
                {
                    "id": 8158,
                    "argument_list_id": 280,
                    "value": "6",
                    "name": "Tiredness",
                    "description": "Drive 6"
                },
                {
                    "id": 8280,
                    "argument_list_id": 280,
                    "value": "7",
                    "name": "Floating Loci 7"
                },
                {
                    "id": 8317,
                    "argument_list_id": 280,
                    "value": "7",
                    "name": "Timeofday (DEPRECATED)"
                },
                {
                    "id": 8342,
                    "argument_list_id": 280,
                    "value": "7",
                    "name": "Sleepines",
                    "description": "Drive 7"
                },
                {
                    "id": 8097,
                    "argument_list_id": 280,
                    "value": "7",
                    "name": "Floating Loci 7"
                },
                {
                    "id": 8134,
                    "argument_list_id": 280,
                    "value": "7",
                    "name": "Involuntary 7",
                    "description": "Drowning"
                },
                {
                    "id": 8159,
                    "argument_list_id": 280,
                    "value": "7",
                    "name": "Sleepines",
                    "description": "Drive 7"
                },
                {
                    "id": 8281,
                    "argument_list_id": 280,
                    "value": "8",
                    "name": "Floating Loci 8"
                },
                {
                    "id": 8318,
                    "argument_list_id": 280,
                    "value": "8",
                    "name": "Season (DEPRECATED)"
                },
                {
                    "id": 8343,
                    "argument_list_id": 280,
                    "value": "8",
                    "name": "Loneliness",
                    "description": "Drive 8"
                },
                {
                    "id": 8098,
                    "argument_list_id": 280,
                    "value": "8",
                    "name": "Floating Loci 8"
                },
                {
                    "id": 8135,
                    "argument_list_id": 280,
                    "value": "8",
                    "name": "Gait 0",
                    "description": "Trigger walking gait 0"
                },
                {
                    "id": 8160,
                    "argument_list_id": 280,
                    "value": "8",
                    "name": "Loneliness",
                    "description": "Drive 8"
                },
                {
                    "id": 8282,
                    "argument_list_id": 280,
                    "value": "9",
                    "name": "Floating Loci 9"
                },
                {
                    "id": 8319,
                    "argument_list_id": 280,
                    "value": "9",
                    "name": "Air Quality",
                    "description": "How breathable is the air (0.0 for air, 1.0 for water)."
                },
                {
                    "id": 8344,
                    "argument_list_id": 280,
                    "value": "9",
                    "name": "Crowded",
                    "description": "Drive 9"
                },
                {
                    "id": 8099,
                    "argument_list_id": 280,
                    "value": "9",
                    "name": "Floating Loci 9"
                },
                {
                    "id": 8136,
                    "argument_list_id": 280,
                    "value": "9",
                    "name": "Gait 1",
                    "description": "Trigger walking gait 1"
                },
                {
                    "id": 8161,
                    "argument_list_id": 280,
                    "value": "9",
                    "name": "Crowded",
                    "description": "Drive 9"
                },
                {
                    "id": 8283,
                    "argument_list_id": 280,
                    "value": "10",
                    "name": "Floating Loci 10"
                },
                {
                    "id": 8320,
                    "argument_list_id": 280,
                    "value": "10",
                    "name": "Upslope",
                    "description": "How steep is the slope I'm facing"
                },
                {
                    "id": 8345,
                    "argument_list_id": 280,
                    "value": "10",
                    "name": "Fear",
                    "description": "Drive 10"
                },
                {
                    "id": 8100,
                    "argument_list_id": 280,
                    "value": "10",
                    "name": "Floating Loci 10"
                },
                {
                    "id": 8137,
                    "argument_list_id": 280,
                    "value": "10",
                    "name": "Gait 2",
                    "description": "Trigger walking gait 2"
                },
                {
                    "id": 8162,
                    "argument_list_id": 280,
                    "value": "10",
                    "name": "Fear",
                    "description": "Drive 10"
                },
                {
                    "id": 8284,
                    "argument_list_id": 280,
                    "value": "11",
                    "name": "Floating Loci 11"
                },
                {
                    "id": 8321,
                    "argument_list_id": 280,
                    "value": "11",
                    "name": "Downslope",
                    "description": "How steep is the slope I'm facing"
                },
                {
                    "id": 8346,
                    "argument_list_id": 280,
                    "value": "11",
                    "name": "Boredom",
                    "description": "Drive 11"
                },
                {
                    "id": 8101,
                    "argument_list_id": 280,
                    "value": "11",
                    "name": "Floating Loci 11"
                },
                {
                    "id": 8138,
                    "argument_list_id": 280,
                    "value": "11",
                    "name": "Gait 3",
                    "description": "Trigger walking gait 3"
                },
                {
                    "id": 8163,
                    "argument_list_id": 280,
                    "value": "11",
                    "name": "Boredom",
                    "description": "Drive 11"
                },
                {
                    "id": 8285,
                    "argument_list_id": 280,
                    "value": "12",
                    "name": "Floating Loci 12"
                },
                {
                    "id": 8322,
                    "argument_list_id": 280,
                    "value": "12",
                    "name": "Headwind (DEPRECATED)"
                },
                {
                    "id": 8347,
                    "argument_list_id": 280,
                    "value": "12",
                    "name": "Anger",
                    "description": "Drive 12"
                },
                {
                    "id": 8102,
                    "argument_list_id": 280,
                    "value": "12",
                    "name": "Floating Loci 12"
                },
                {
                    "id": 8139,
                    "argument_list_id": 280,
                    "value": "12",
                    "name": "Gait 4",
                    "description": "Trigger walking gait 4"
                },
                {
                    "id": 8164,
                    "argument_list_id": 280,
                    "value": "12",
                    "name": "Anger",
                    "description": "Drive 12"
                },
                {
                    "id": 8286,
                    "argument_list_id": 280,
                    "value": "13",
                    "name": "Floating Loci 13"
                },
                {
                    "id": 8323,
                    "argument_list_id": 280,
                    "value": "13",
                    "name": "Tailwind (DEPRECATED)"
                },
                {
                    "id": 8348,
                    "argument_list_id": 280,
                    "value": "13",
                    "name": "Sex Drive",
                    "description": "Drive 13"
                },
                {
                    "id": 8103,
                    "argument_list_id": 280,
                    "value": "13",
                    "name": "Floating Loci 13"
                },
                {
                    "id": 8140,
                    "argument_list_id": 280,
                    "value": "13",
                    "name": "Gait 5",
                    "description": "Trigger walking gait 5"
                },
                {
                    "id": 8165,
                    "argument_list_id": 280,
                    "value": "13",
                    "name": "Sex Drive",
                    "description": "Drive 13"
                },
                {
                    "id": 8287,
                    "argument_list_id": 280,
                    "value": "14",
                    "name": "Floating Loci 14"
                },
                {
                    "id": 8349,
                    "argument_list_id": 280,
                    "value": "14",
                    "name": "Comfort",
                    "description": "Drive 14"
                },
                {
                    "id": 8104,
                    "argument_list_id": 280,
                    "value": "14",
                    "name": "Floating Loci 14"
                },
                {
                    "id": 8141,
                    "argument_list_id": 280,
                    "value": "14",
                    "name": "Gait 6",
                    "description": "Trigger walking gait 6"
                },
                {
                    "id": 8166,
                    "argument_list_id": 280,
                    "value": "14",
                    "name": "Comfort",
                    "description": "Drive 14"
                },
                {
                    "id": 8288,
                    "argument_list_id": 280,
                    "value": "15",
                    "name": "Floating Loci 15"
                },
                {
                    "id": 8350,
                    "argument_list_id": 280,
                    "value": "15",
                    "name": "Drive 15"
                },
                {
                    "id": 8105,
                    "argument_list_id": 280,
                    "value": "15",
                    "name": "Floating Loci 15"
                },
                {
                    "id": 8142,
                    "argument_list_id": 280,
                    "value": "15",
                    "name": "Gait 7",
                    "description": "Trigger walking gait 7"
                },
                {
                    "id": 8167,
                    "argument_list_id": 280,
                    "value": "15",
                    "name": "Drive 15"
                },
                {
                    "id": 8289,
                    "argument_list_id": 280,
                    "value": "16",
                    "name": "Floating Loci 16"
                },
                {
                    "id": 8351,
                    "argument_list_id": 280,
                    "value": "16",
                    "name": "Drive 16"
                },
                {
                    "id": 8106,
                    "argument_list_id": 280,
                    "value": "16",
                    "name": "Floating Loci 16"
                },
                {
                    "id": 8143,
                    "argument_list_id": 280,
                    "value": "16",
                    "name": "Gait 8",
                    "description": "Trigger walking gait 8"
                },
                {
                    "id": 8168,
                    "argument_list_id": 280,
                    "value": "16",
                    "name": "Drive 16"
                },
                {
                    "id": 8290,
                    "argument_list_id": 280,
                    "value": "17",
                    "name": "Floating Loci 17"
                },
                {
                    "id": 8352,
                    "argument_list_id": 280,
                    "value": "17",
                    "name": "Drive 17"
                },
                {
                    "id": 8107,
                    "argument_list_id": 280,
                    "value": "17",
                    "name": "Floating Loci 17"
                },
                {
                    "id": 8144,
                    "argument_list_id": 280,
                    "value": "17",
                    "name": "Gait 9",
                    "description": "Trigger walking gait 9"
                },
                {
                    "id": 8169,
                    "argument_list_id": 280,
                    "value": "17",
                    "name": "Drive 17"
                },
                {
                    "id": 8291,
                    "argument_list_id": 280,
                    "value": "18",
                    "name": "Floating Loci 18"
                },
                {
                    "id": 8353,
                    "argument_list_id": 280,
                    "value": "18",
                    "name": "Drive 18"
                },
                {
                    "id": 8108,
                    "argument_list_id": 280,
                    "value": "18",
                    "name": "Floating Loci 18"
                },
                {
                    "id": 8145,
                    "argument_list_id": 280,
                    "value": "18",
                    "name": "Gait 10",
                    "description": "Trigger walking gait 10"
                },
                {
                    "id": 8170,
                    "argument_list_id": 280,
                    "value": "18",
                    "name": "Drive 18"
                },
                {
                    "id": 8292,
                    "argument_list_id": 280,
                    "value": "19",
                    "name": "Floating Loci 19"
                },
                {
                    "id": 8354,
                    "argument_list_id": 280,
                    "value": "19",
                    "name": "Drive 19"
                },
                {
                    "id": 8109,
                    "argument_list_id": 280,
                    "value": "19",
                    "name": "Floating Loci 19"
                },
                {
                    "id": 8146,
                    "argument_list_id": 280,
                    "value": "19",
                    "name": "Gait 11",
                    "description": "Trigger walking gait 11"
                },
                {
                    "id": 8171,
                    "argument_list_id": 280,
                    "value": "19",
                    "name": "Drive 19"
                },
                {
                    "id": 8293,
                    "argument_list_id": 280,
                    "value": "20",
                    "name": "Floating Loci 20"
                },
                {
                    "id": 8110,
                    "argument_list_id": 280,
                    "value": "20",
                    "name": "Floating Loci 20"
                },
                {
                    "id": 8147,
                    "argument_list_id": 280,
                    "value": "20",
                    "name": "Gait 12",
                    "description": "Trigger walking gait 12"
                },
                {
                    "id": 8294,
                    "argument_list_id": 280,
                    "value": "21",
                    "name": "Floating Loci 21"
                },
                {
                    "id": 8111,
                    "argument_list_id": 280,
                    "value": "21",
                    "name": "Floating Loci 21"
                },
                {
                    "id": 8148,
                    "argument_list_id": 280,
                    "value": "21",
                    "name": "Gait 13",
                    "description": "Trigger walking gait 13"
                },
                {
                    "id": 8295,
                    "argument_list_id": 280,
                    "value": "22",
                    "name": "Floating Loci 22"
                },
                {
                    "id": 8112,
                    "argument_list_id": 280,
                    "value": "22",
                    "name": "Floating Loci 22"
                },
                {
                    "id": 8149,
                    "argument_list_id": 280,
                    "value": "22",
                    "name": "Gait 14",
                    "description": "Trigger walking gait 14"
                },
                {
                    "id": 8296,
                    "argument_list_id": 280,
                    "value": "23",
                    "name": "Floating Loci 23"
                },
                {
                    "id": 8113,
                    "argument_list_id": 280,
                    "value": "23",
                    "name": "Floating Loci 23"
                },
                {
                    "id": 8150,
                    "argument_list_id": 280,
                    "value": "23",
                    "name": "Gait 15",
                    "description": "Trigger walking gait 15"
                },
                {
                    "id": 8297,
                    "argument_list_id": 280,
                    "value": "24",
                    "name": "Floating Loci 24"
                },
                {
                    "id": 8114,
                    "argument_list_id": 280,
                    "value": "24",
                    "name": "Floating Loci 24"
                },
                {
                    "id": 8151,
                    "argument_list_id": 280,
                    "value": "24",
                    "name": "Gait 16",
                    "description": "Trigger walking gait 16"
                },
                {
                    "id": 8298,
                    "argument_list_id": 280,
                    "value": "25",
                    "name": "Floating Loci 25"
                },
                {
                    "id": 8115,
                    "argument_list_id": 280,
                    "value": "25",
                    "name": "Floating Loci 25"
                },
                {
                    "id": 8299,
                    "argument_list_id": 280,
                    "value": "26",
                    "name": "Floating Loci 26"
                },
                {
                    "id": 8116,
                    "argument_list_id": 280,
                    "value": "26",
                    "name": "Floating Loci 26"
                },
                {
                    "id": 8300,
                    "argument_list_id": 280,
                    "value": "27",
                    "name": "Floating Loci 27"
                },
                {
                    "id": 8117,
                    "argument_list_id": 280,
                    "value": "27",
                    "name": "Floating Loci 27"
                },
                {
                    "id": 8301,
                    "argument_list_id": 280,
                    "value": "28",
                    "name": "Floating Loci 28"
                },
                {
                    "id": 8118,
                    "argument_list_id": 280,
                    "value": "28",
                    "name": "Floating Loci 28"
                },
                {
                    "id": 8302,
                    "argument_list_id": 280,
                    "value": "29",
                    "name": "Floating Loci 29"
                },
                {
                    "id": 8119,
                    "argument_list_id": 280,
                    "value": "29",
                    "name": "Floating Loci 29"
                },
                {
                    "id": 8303,
                    "argument_list_id": 280,
                    "value": "30",
                    "name": "Floating Loci 30"
                },
                {
                    "id": 8120,
                    "argument_list_id": 280,
                    "value": "30",
                    "name": "Floating Loci 30"
                },
                {
                    "id": 8304,
                    "argument_list_id": 280,
                    "value": "31",
                    "name": "Floating Loci 31"
                },
                {
                    "id": 8121,
                    "argument_list_id": 280,
                    "value": "31",
                    "name": "Floating Loci 31"
                }
            ],
            "variants": 60
        },
        "list_279": {
            "id": 279,
            "variant": "AL",
            "name": "ReceptorLocusOrgan",
            "arguments": [
                {
                    "id": 7346,
                    "argument_list_id": 279,
                    "value": "0",
                    "name": "Brain"
                },
                {
                    "id": 7347,
                    "argument_list_id": 279,
                    "value": "1",
                    "name": "Creature"
                }
            ],
            "variants": 28
        },
        "list_299": {
            "id": 299,
            "variant": "AL",
            "name": "ReceptorLocusTissue",
            "arguments": [
                {
                    "id": 9421,
                    "argument_list_id": 299,
                    "value": "0",
                    "name": "Somatic"
                },
                {
                    "id": 9422,
                    "argument_list_id": 299,
                    "value": "1",
                    "name": "Circulatory"
                },
                {
                    "id": 9423,
                    "argument_list_id": 299,
                    "value": "2",
                    "name": "Reproductive"
                },
                {
                    "id": 9424,
                    "argument_list_id": 299,
                    "value": "3",
                    "name": "Immune"
                },
                {
                    "id": 9425,
                    "argument_list_id": 299,
                    "value": "4",
                    "name": "Sensorymotor"
                },
                {
                    "id": 9426,
                    "argument_list_id": 299,
                    "value": "5",
                    "name": "Drives"
                }
            ],
            "variants": 28
        },
        "list_143": {
            "id": 143,
            "variant": "AL",
            "name": "RectToUse",
            "extension_type": "bool",
            "base_values_list_id": 38,
            "arguments": [
                {
                    "id": 3348,
                    "argument_list_id": 143,
                    "value": "0",
                    "name": "Agent Bounds",
                    "description": "Nearby means touching bounding rectangle of agent\n"
                },
                {
                    "id": 3349,
                    "argument_list_id": 143,
                    "value": "1",
                    "name": "Cabin Bounds",
                    "description": "Nearby means touching cabin rectangle"
                }
            ],
            "variants": 60
        },
        "list_154": {
            "id": 154,
            "variant": "C2",
            "name": "RenderFormat",
            "base_values_list_id": 41,
            "arguments": [
                {
                    "id": 3680,
                    "argument_list_id": 154,
                    "value": "0",
                    "name": "555"
                },
                {
                    "id": 3681,
                    "argument_list_id": 154,
                    "value": "1",
                    "name": "565"
                }
            ],
            "variants": 2
        },
        "list_69": {
            "id": 69,
            "variant": "C1",
            "name": "RoomEdge",
            "base_values_list_id": 3,
            "arguments": [
                {
                    "id": 937,
                    "argument_list_id": 69,
                    "value": "0",
                    "name": "Left"
                },
                {
                    "id": 938,
                    "argument_list_id": 69,
                    "value": "1",
                    "name": "Top"
                },
                {
                    "id": 939,
                    "argument_list_id": 69,
                    "value": "2",
                    "name": "Right"
                },
                {
                    "id": 940,
                    "argument_list_id": 69,
                    "value": "3",
                    "name": "Bottom"
                },
                {
                    "id": 941,
                    "argument_list_id": 69,
                    "value": "4",
                    "name": "Room Type"
                }
            ],
            "variants": 1
        },
        "list_86": {
            "id": 86,
            "variant": "C2",
            "name": "RoomProperties",
            "base_values_list_id": 20,
            "arguments": [
                {
                    "id": 1160,
                    "argument_list_id": 86,
                    "value": "0",
                    "name": "Left"
                },
                {
                    "id": 1161,
                    "argument_list_id": 86,
                    "value": "1",
                    "name": "Top"
                },
                {
                    "id": 1162,
                    "argument_list_id": 86,
                    "value": "2",
                    "name": "Right"
                },
                {
                    "id": 1163,
                    "argument_list_id": 86,
                    "value": "3",
                    "name": "Bottom"
                },
                {
                    "id": 1164,
                    "argument_list_id": 86,
                    "value": "4",
                    "name": "Type"
                },
                {
                    "id": 1165,
                    "argument_list_id": 86,
                    "value": "5",
                    "name": "FloorValue"
                },
                {
                    "id": 1166,
                    "argument_list_id": 86,
                    "value": "6",
                    "name": "OrganicNutrients"
                },
                {
                    "id": 1167,
                    "argument_list_id": 86,
                    "value": "7",
                    "name": "InorganicNutrients"
                },
                {
                    "id": 1168,
                    "argument_list_id": 86,
                    "value": "8",
                    "name": "Temperature"
                },
                {
                    "id": 1169,
                    "argument_list_id": 86,
                    "value": "9",
                    "name": "Pressure"
                },
                {
                    "id": 1170,
                    "argument_list_id": 86,
                    "value": "10",
                    "name": "WindX"
                },
                {
                    "id": 1171,
                    "argument_list_id": 86,
                    "value": "11",
                    "name": "WindY"
                },
                {
                    "id": 1172,
                    "argument_list_id": 86,
                    "value": "12",
                    "name": "LightLevel"
                },
                {
                    "id": 1173,
                    "argument_list_id": 86,
                    "value": "13",
                    "name": "Radiation"
                },
                {
                    "id": 1174,
                    "argument_list_id": 86,
                    "value": "14",
                    "name": "HeatSource"
                },
                {
                    "id": 1175,
                    "argument_list_id": 86,
                    "value": "15",
                    "name": "Pressure Source"
                },
                {
                    "id": 1176,
                    "argument_list_id": 86,
                    "value": "16",
                    "name": "LightSource"
                },
                {
                    "id": 1177,
                    "argument_list_id": 86,
                    "value": "17",
                    "name": "RadiationSource"
                },
                {
                    "id": 1178,
                    "argument_list_id": 86,
                    "value": "18",
                    "name": "VisitedFlag"
                },
                {
                    "id": 1179,
                    "argument_list_id": 86,
                    "value": "19",
                    "name": "DropStatus"
                }
            ],
            "variants": 2
        },
        "list_278": {
            "id": 278,
            "variant": "AL",
            "name": "RoomType",
            "arguments": [
                {
                    "id": 7335,
                    "argument_list_id": 278,
                    "value": "0",
                    "name": "Atmosphere",
                    "description": "Heat and light travel well, nutrients and water do not."
                },
                {
                    "id": 7336,
                    "argument_list_id": 278,
                    "value": "1",
                    "name": "Wooden Walkway",
                    "description": "Insulates against heat, but permits water to drip through"
                },
                {
                    "id": 7337,
                    "argument_list_id": 278,
                    "value": "2",
                    "name": "Concrete Walkway",
                    "description": "Less permeable to more CA than a wooden walkway."
                },
                {
                    "id": 7338,
                    "argument_list_id": 278,
                    "value": "3",
                    "name": "Indoor Concrete"
                },
                {
                    "id": 7339,
                    "argument_list_id": 278,
                    "value": "4",
                    "name": "Outdoor Concrete"
                },
                {
                    "id": 7340,
                    "argument_list_id": 278,
                    "value": "5",
                    "name": "Normal Soil",
                    "description": "Fairly permeable to most CA"
                },
                {
                    "id": 7341,
                    "argument_list_id": 278,
                    "value": "6",
                    "name": "Boggy Soil",
                    "description": "Retaims more moisture than normal soil"
                },
                {
                    "id": 7342,
                    "argument_list_id": 278,
                    "value": "7",
                    "name": "Drained Soil",
                    "description": "Loses more moister than normal soil"
                },
                {
                    "id": 7343,
                    "argument_list_id": 278,
                    "value": "8",
                    "name": "Fresh Water",
                    "description": "Restrictive to heat"
                },
                {
                    "id": 7344,
                    "argument_list_id": 278,
                    "value": "9",
                    "name": "Salt Water",
                    "description": "Restricted to heat"
                },
                {
                    "id": 7345,
                    "argument_list_id": 278,
                    "value": "10",
                    "name": "Ettin Home",
                    "description": "Loses the smell of machinery"
                }
            ],
            "variants": 28
        },
        "list_72": {
            "id": 72,
            "variant": "C1",
            "name": "RoomType",
            "base_values_list_id": 6,
            "arguments": [
                {
                    "id": 947,
                    "argument_list_id": 72,
                    "value": "0",
                    "name": "Indoors"
                },
                {
                    "id": 948,
                    "argument_list_id": 72,
                    "value": "1",
                    "name": "Surface"
                },
                {
                    "id": 949,
                    "argument_list_id": 72,
                    "value": "2",
                    "name": "Undersea"
                }
            ],
            "variants": 1
        },
        "list_218": {
            "id": 218,
            "variant": "C2",
            "name": "RoomType",
            "base_values_list_id": 6,
            "arguments": [
                {
                    "id": 4351,
                    "argument_list_id": 218,
                    "value": "-1",
                    "name": "Invalid"
                },
                {
                    "id": 4352,
                    "argument_list_id": 218,
                    "value": "0",
                    "name": "Under Ground"
                },
                {
                    "id": 4353,
                    "argument_list_id": 218,
                    "value": "1",
                    "name": "On Surface"
                },
                {
                    "id": 4354,
                    "argument_list_id": 218,
                    "value": "2",
                    "name": "Undersea"
                },
                {
                    "id": 4355,
                    "argument_list_id": 218,
                    "value": "3",
                    "name": "In the Sky"
                }
            ],
            "variants": 2
        },
        "list_199": {
            "id": 199,
            "variant": "AL",
            "name": "ScolFlags",
            "extension_type": "BitFlags",
            "base_values_list_id": 80,
            "arguments": [
                {
                    "id": 4302,
                    "argument_list_id": 199,
                    "value": "1",
                    "name": "Screen edge nudgy scrolling"
                },
                {
                    "id": 4303,
                    "argument_list_id": 199,
                    "value": "2",
                    "name": "Keyboard scrolling"
                },
                {
                    "id": 4304,
                    "argument_list_id": 199,
                    "value": "4",
                    "name": "Middle mouse button screen dragging"
                },
                {
                    "id": 4305,
                    "argument_list_id": 199,
                    "value": "8",
                    "name": "Mouse wheel screen scrolling"
                }
            ],
            "variants": 60
        },
        "list_277": {
            "id": 277,
            "variant": "C1",
            "name": "ScorItems",
            "description": "Numeric keys for the various scores found with C1's SCOR command.\nNOTE: These values are not guaranteed to be correct. Based on observation by a player",
            "arguments": [
                {
                    "id": 7322,
                    "argument_list_id": 277,
                    "value": "1",
                    "name": "Natural Eggs Laid"
                },
                {
                    "id": 7324,
                    "argument_list_id": 277,
                    "value": "2",
                    "name": "Deaths"
                },
                {
                    "id": 7325,
                    "argument_list_id": 277,
                    "value": "3",
                    "name": "Living Norns"
                },
                {
                    "id": 7326,
                    "argument_list_id": 277,
                    "value": "4",
                    "name": "Game Score"
                }
            ],
            "variants": 1
        },
        "list_83": {
            "id": 83,
            "variant": "C2",
            "name": "ScorItems",
            "base_values_list_id": 17,
            "arguments": [
                {
                    "id": 1128,
                    "argument_list_id": 83,
                    "value": "0",
                    "name": "Generation 1 eggs used"
                },
                {
                    "id": 1129,
                    "argument_list_id": 83,
                    "value": "1",
                    "name": "Number of natural eggs laid"
                },
                {
                    "id": 1130,
                    "argument_list_id": 83,
                    "value": "2",
                    "name": "Number of deaths"
                },
                {
                    "id": 1131,
                    "argument_list_id": 83,
                    "value": "3",
                    "name": "Number of creatures imported"
                },
                {
                    "id": 1132,
                    "argument_list_id": 83,
                    "value": "4",
                    "name": "Number of creatures exported"
                },
                {
                    "id": 1133,
                    "argument_list_id": 83,
                    "value": "5",
                    "name": "Number of creatures alive"
                }
            ],
            "variants": 2
        },
        "list_88": {
            "id": 88,
            "variant": "AL",
            "name": "Season",
            "base_values_list_id": 22,
            "arguments": [
                {
                    "id": 1185,
                    "argument_list_id": 88,
                    "value": "0",
                    "name": "Spring"
                },
                {
                    "id": 1186,
                    "argument_list_id": 88,
                    "value": "1",
                    "name": "Summer"
                },
                {
                    "id": 1187,
                    "argument_list_id": 88,
                    "value": "2",
                    "name": "Autumn"
                },
                {
                    "id": 1188,
                    "argument_list_id": 88,
                    "value": "3",
                    "name": "Winter"
                }
            ],
            "variants": 62
        },
        "list_221": {
            "id": 221,
            "variant": "C2",
            "name": "ShowProgress",
            "extension_type": "bool",
            "base_values_list_id": 98,
            "arguments": [
                {
                    "id": 4362,
                    "argument_list_id": 221,
                    "value": "0",
                    "name": "Show Progress Dialog"
                },
                {
                    "id": 4363,
                    "argument_list_id": 221,
                    "value": "1",
                    "name": "No Progress Dialog"
                }
            ],
            "variants": 2
        },
        "list_158": {
            "id": 158,
            "variant": "AL",
            "name": "Sleeping",
            "extension_type": "bool",
            "base_values_list_id": 44,
            "arguments": [
                {
                    "id": 3690,
                    "argument_list_id": 158,
                    "value": "0",
                    "name": "Awake"
                },
                {
                    "id": 3691,
                    "argument_list_id": 158,
                    "value": "1",
                    "name": "Sleeping"
                }
            ],
            "variants": 63
        },
        "list_73": {
            "id": 73,
            "variant": "C1",
            "name": "SndfOption",
            "base_values_list_id": 7,
            "arguments": [
                {
                    "id": 950,
                    "argument_list_id": 73,
                    "value": "ON__",
                    "name": "Sound on"
                },
                {
                    "id": 951,
                    "argument_list_id": 73,
                    "value": "OFF_",
                    "name": "Sound off"
                },
                {
                    "id": 952,
                    "argument_list_id": 73,
                    "value": "FORE",
                    "name": "Foreground Only",
                    "description": "Sound only plays when application is in foreground"
                },
                {
                    "id": 953,
                    "argument_list_id": 73,
                    "value": "CONS",
                    "name": "Play Constantly",
                    "description": "Sound plays all the time"
                }
            ],
            "variants": 1
        },
        "list_282": {
            "id": 282,
            "variant": "AL",
            "name": "Soul",
            "description": "Traits to enable/disable on a creature",
            "arguments": [
                {
                    "id": 8236,
                    "argument_list_id": 282,
                    "value": "0",
                    "name": "Sensory Faculty"
                },
                {
                    "id": 8237,
                    "argument_list_id": 282,
                    "value": "1",
                    "name": "Brain"
                },
                {
                    "id": 8238,
                    "argument_list_id": 282,
                    "value": "2",
                    "name": "Motor Faculty"
                },
                {
                    "id": 8239,
                    "argument_list_id": 282,
                    "value": "3",
                    "name": "Linguistic Faculty"
                },
                {
                    "id": 8240,
                    "argument_list_id": 282,
                    "value": "4",
                    "name": "Biochemistry"
                },
                {
                    "id": 8241,
                    "argument_list_id": 282,
                    "value": "5",
                    "name": "Reproductive Faculty"
                },
                {
                    "id": 8242,
                    "argument_list_id": 282,
                    "value": "6",
                    "name": "Expressive Faculty"
                },
                {
                    "id": 8243,
                    "argument_list_id": 282,
                    "value": "7",
                    "name": "Music Faculty"
                },
                {
                    "id": 8244,
                    "argument_list_id": 282,
                    "value": "8",
                    "name": "Life Faculty"
                }
            ],
            "variants": 56
        },
        "list_77": {
            "id": 77,
            "variant": "C1",
            "name": "Stimulus",
            "base_values_list_id": 11,
            "arguments": [
                {
                    "id": 970,
                    "argument_list_id": 77,
                    "value": "0",
                    "name": "Disappointment"
                },
                {
                    "id": 971,
                    "argument_list_id": 77,
                    "value": "1",
                    "name": "Pointer pats me"
                },
                {
                    "id": 972,
                    "argument_list_id": 77,
                    "value": "2",
                    "name": "Creature pats me"
                },
                {
                    "id": 973,
                    "argument_list_id": 77,
                    "value": "3",
                    "name": "Pointer slaps me"
                },
                {
                    "id": 974,
                    "argument_list_id": 77,
                    "value": "4",
                    "name": "Creature slaps me"
                },
                {
                    "id": 975,
                    "argument_list_id": 77,
                    "value": "5",
                    "name": "It is approaching"
                },
                {
                    "id": 976,
                    "argument_list_id": 77,
                    "value": "6",
                    "name": "It is retreating"
                },
                {
                    "id": 977,
                    "argument_list_id": 77,
                    "value": "7",
                    "name": "I bump into wall"
                },
                {
                    "id": 978,
                    "argument_list_id": 77,
                    "value": "8",
                    "name": "Object comes into view"
                },
                {
                    "id": 979,
                    "argument_list_id": 77,
                    "value": "9",
                    "name": "Unrecognised word"
                },
                {
                    "id": 980,
                    "argument_list_id": 77,
                    "value": "10",
                    "name": "Heard user speak"
                },
                {
                    "id": 981,
                    "argument_list_id": 77,
                    "value": "11",
                    "name": "Heard creature speak"
                },
                {
                    "id": 982,
                    "argument_list_id": 77,
                    "value": "12",
                    "name": "I am quiescent (periodic)"
                },
                {
                    "id": 983,
                    "argument_list_id": 77,
                    "value": "13",
                    "name": "I've activated1"
                },
                {
                    "id": 984,
                    "argument_list_id": 77,
                    "value": "14",
                    "name": "I've activated2"
                },
                {
                    "id": 985,
                    "argument_list_id": 77,
                    "value": "15",
                    "name": "I've deactivated"
                },
                {
                    "id": 986,
                    "argument_list_id": 77,
                    "value": "16",
                    "name": "I am approaching (periodic)"
                },
                {
                    "id": 987,
                    "argument_list_id": 77,
                    "value": "17",
                    "name": "I have retreated"
                },
                {
                    "id": 988,
                    "argument_list_id": 77,
                    "value": "18",
                    "name": "I have got"
                },
                {
                    "id": 989,
                    "argument_list_id": 77,
                    "value": "19",
                    "name": "I have dropped"
                },
                {
                    "id": 990,
                    "argument_list_id": 77,
                    "value": "20",
                    "name": "I've stated need"
                },
                {
                    "id": 991,
                    "argument_list_id": 77,
                    "value": "21",
                    "name": "I am resting (periodic)"
                },
                {
                    "id": 992,
                    "argument_list_id": 77,
                    "value": "22",
                    "name": "I am sleeping (periodic)"
                },
                {
                    "id": 993,
                    "argument_list_id": 77,
                    "value": "23",
                    "name": "I am traveling (periodic)"
                },
                {
                    "id": 994,
                    "argument_list_id": 77,
                    "value": "24",
                    "name": "Laying"
                },
                {
                    "id": 995,
                    "argument_list_id": 77,
                    "value": "25",
                    "name": "Involuntary action 0-7"
                },
                {
                    "id": 996,
                    "argument_list_id": 77,
                    "value": "26",
                    "name": "Traveling (old)"
                },
                {
                    "id": 997,
                    "argument_list_id": 77,
                    "value": "27",
                    "name": "I have Retreated"
                },
                {
                    "id": 998,
                    "argument_list_id": 77,
                    "value": "28",
                    "name": "Involuntary Action 0"
                },
                {
                    "id": 999,
                    "argument_list_id": 77,
                    "value": "29",
                    "name": "Involuntary Action 1"
                },
                {
                    "id": 1000,
                    "argument_list_id": 77,
                    "value": "30",
                    "name": "Involuntary Action 2"
                },
                {
                    "id": 1001,
                    "argument_list_id": 77,
                    "value": "31",
                    "name": "Involuntary Action 3"
                },
                {
                    "id": 1002,
                    "argument_list_id": 77,
                    "value": "32",
                    "name": "Involuntary Action 4"
                },
                {
                    "id": 1003,
                    "argument_list_id": 77,
                    "value": "33",
                    "name": "Involuntary Action 5"
                },
                {
                    "id": 1004,
                    "argument_list_id": 77,
                    "value": "34",
                    "name": "Involuntary Action 6"
                },
                {
                    "id": 1005,
                    "argument_list_id": 77,
                    "value": "35",
                    "name": "Involuntary Action 7"
                }
            ],
            "variants": 1
        },
        "list_113": {
            "id": 113,
            "variant": "AL",
            "name": "Stimulus",
            "base_values_list_id": 11,
            "arguments": [
                {
                    "id": 1887,
                    "argument_list_id": 113,
                    "value": "0",
                    "name": "Disappointment",
                    "description": "Issue to disappoint (punish) a creature for a pointless action (eg. failed to activate)"
                },
                {
                    "id": 1888,
                    "argument_list_id": 113,
                    "value": "1",
                    "name": "Pointer Pats Me",
                    "description": "User has patted creature"
                },
                {
                    "id": 1889,
                    "argument_list_id": 113,
                    "value": "2",
                    "name": "Creature Pats Me",
                    "description": "Another creature has patted you"
                },
                {
                    "id": 1890,
                    "argument_list_id": 113,
                    "value": "3",
                    "name": "Pointer Slaps Me",
                    "description": "User has slapped creature"
                },
                {
                    "id": 1891,
                    "argument_list_id": 113,
                    "value": "4",
                    "name": "Creature Slaps Me",
                    "description": "Another creature has slapped you"
                },
                {
                    "id": 1892,
                    "argument_list_id": 113,
                    "value": "5",
                    "name": "Approaching (deprecated)",
                    "description": "Object is approaching"
                },
                {
                    "id": 1893,
                    "argument_list_id": 113,
                    "value": "6",
                    "name": "Retreating (deprecated)",
                    "description": "Object is retreating"
                },
                {
                    "id": 1894,
                    "argument_list_id": 113,
                    "value": "7",
                    "name": "Bump",
                    "description": "Creature has hit a wall"
                },
                {
                    "id": 1895,
                    "argument_list_id": 113,
                    "value": "8",
                    "name": "New Object (deprecated)",
                    "description": "New object has come into view"
                },
                {
                    "id": 1896,
                    "argument_list_id": 113,
                    "value": "9",
                    "name": "Gobbledygook",
                    "description": "Heard unrecognised speech"
                },
                {
                    "id": 1897,
                    "argument_list_id": 113,
                    "value": "10",
                    "name": "Pointer Word",
                    "description": "Heard user speak"
                },
                {
                    "id": 1898,
                    "argument_list_id": 113,
                    "value": "11",
                    "name": "Creature Word",
                    "description": "Heard creature speak"
                },
                {
                    "id": 1899,
                    "argument_list_id": 113,
                    "value": "12",
                    "name": "Quiescent",
                    "description": "Emit PERIODICALLY while quiescent"
                },
                {
                    "id": 1900,
                    "argument_list_id": 113,
                    "value": "13",
                    "name": "Activate1",
                    "description": "Emit AFTER activation"
                },
                {
                    "id": 1901,
                    "argument_list_id": 113,
                    "value": "14",
                    "name": "Activate2"
                },
                {
                    "id": 1902,
                    "argument_list_id": 113,
                    "value": "15",
                    "name": "Deactivate"
                },
                {
                    "id": 1903,
                    "argument_list_id": 113,
                    "value": "16",
                    "name": "Approach",
                    "description": "Emit PERIODICALLY while watching (after approach phase over)"
                },
                {
                    "id": 1904,
                    "argument_list_id": 113,
                    "value": "17",
                    "name": "Retreat",
                    "description": "Emit AFTER retreat"
                },
                {
                    "id": 1905,
                    "argument_list_id": 113,
                    "value": "18",
                    "name": "Get",
                    "description": "Emit AFTER get"
                },
                {
                    "id": 1906,
                    "argument_list_id": 113,
                    "value": "19",
                    "name": "Drop"
                },
                {
                    "id": 1907,
                    "argument_list_id": 113,
                    "value": "20",
                    "name": "Express Need",
                    "description": "Emit AFTER say need"
                },
                {
                    "id": 1908,
                    "argument_list_id": 113,
                    "value": "21",
                    "name": "Rest",
                    "description": "Emit after resting but before falling asleep"
                },
                {
                    "id": 1909,
                    "argument_list_id": 113,
                    "value": "22",
                    "name": "Sleep",
                    "description": "Emit PERIODICALLY while sleeping (later in REST action)"
                },
                {
                    "id": 1910,
                    "argument_list_id": 113,
                    "value": "23",
                    "name": "Travel West/East",
                    "description": "Emit PERIODICALLY while walking west OR east"
                },
                {
                    "id": 1911,
                    "argument_list_id": 113,
                    "value": "24",
                    "name": "Push",
                    "description": "Emit AFTER being pushed"
                },
                {
                    "id": 1912,
                    "argument_list_id": 113,
                    "value": "25",
                    "name": "Hit",
                    "description": "Emit AFTER being hit"
                },
                {
                    "id": 1913,
                    "argument_list_id": 113,
                    "value": "26",
                    "name": "Eat",
                    "description": "Emit AFTER eating"
                },
                {
                    "id": 1914,
                    "argument_list_id": 113,
                    "value": "27",
                    "name": "Action 6"
                },
                {
                    "id": 1915,
                    "argument_list_id": 113,
                    "value": "28",
                    "name": "Involuntary Action 0",
                    "description": "Flinch"
                },
                {
                    "id": 1916,
                    "argument_list_id": 113,
                    "value": "29",
                    "name": "Involuntary Action 1",
                    "description": "Lay Egg"
                },
                {
                    "id": 1917,
                    "argument_list_id": 113,
                    "value": "30",
                    "name": "Involuntary Action 2",
                    "description": "Sneeze"
                },
                {
                    "id": 1918,
                    "argument_list_id": 113,
                    "value": "31",
                    "name": "Involuntary Action 3",
                    "description": "Cough"
                },
                {
                    "id": 1919,
                    "argument_list_id": 113,
                    "value": "32",
                    "name": "Involuntary Action 4",
                    "description": "Shiver"
                },
                {
                    "id": 1920,
                    "argument_list_id": 113,
                    "value": "33",
                    "name": "Involuntary Action 5",
                    "description": "Sleep"
                },
                {
                    "id": 1921,
                    "argument_list_id": 113,
                    "value": "34",
                    "name": "Involuntary Action 6",
                    "description": "Falter"
                },
                {
                    "id": 1922,
                    "argument_list_id": 113,
                    "value": "35",
                    "name": "Involuntary Action 7",
                    "description": "Downing"
                },
                {
                    "id": 1923,
                    "argument_list_id": 113,
                    "value": "36",
                    "name": "Approaching edge deprecated",
                    "description": "Emit AFTER moving towards an edge object"
                },
                {
                    "id": 1924,
                    "argument_list_id": 113,
                    "value": "37",
                    "name": "Retreating edge deprecated",
                    "description": "Emit AFTER moving away from an edge object"
                },
                {
                    "id": 1925,
                    "argument_list_id": 113,
                    "value": "38",
                    "name": "Falling deprecated",
                    "description": "Emit whilst falling under gravity"
                },
                {
                    "id": 1926,
                    "argument_list_id": 113,
                    "value": "39",
                    "name": "Impact",
                    "description": "Emit after a collision"
                },
                {
                    "id": 1927,
                    "argument_list_id": 113,
                    "value": "40",
                    "name": "Pointeryes",
                    "description": "Emit after user spoken verb YES"
                },
                {
                    "id": 1928,
                    "argument_list_id": 113,
                    "value": "41",
                    "name": "Creatureyes",
                    "description": "Emit after creature spoken verb YES"
                },
                {
                    "id": 1929,
                    "argument_list_id": 113,
                    "value": "42",
                    "name": "Pointerno",
                    "description": "Emit after user spoken verb NO"
                },
                {
                    "id": 1930,
                    "argument_list_id": 113,
                    "value": "43",
                    "name": "Creature No",
                    "description": "Emit after creature spoken verb NO"
                },
                {
                    "id": 1931,
                    "argument_list_id": 113,
                    "value": "44",
                    "name": "Aggression",
                    "description": "Emit after performing a HIT"
                },
                {
                    "id": 1932,
                    "argument_list_id": 113,
                    "value": "45",
                    "name": "Mate",
                    "description": "Emit after mating"
                },
                {
                    "id": 1933,
                    "argument_list_id": 113,
                    "value": "46",
                    "name": "Opposite Sex Tickle"
                },
                {
                    "id": 1934,
                    "argument_list_id": 113,
                    "value": "47",
                    "name": "Same Sex tickle"
                },
                {
                    "id": 1935,
                    "argument_list_id": 113,
                    "value": "48",
                    "name": "Go nowhere"
                },
                {
                    "id": 1936,
                    "argument_list_id": 113,
                    "value": "49",
                    "name": "Go in"
                },
                {
                    "id": 1937,
                    "argument_list_id": 113,
                    "value": "50",
                    "name": "Go out"
                },
                {
                    "id": 1938,
                    "argument_list_id": 113,
                    "value": "51",
                    "name": "Go up"
                },
                {
                    "id": 1939,
                    "argument_list_id": 113,
                    "value": "52",
                    "name": "Go down"
                },
                {
                    "id": 1940,
                    "argument_list_id": 113,
                    "value": "53",
                    "name": "Go left"
                },
                {
                    "id": 1941,
                    "argument_list_id": 113,
                    "value": "54",
                    "name": "Go right"
                },
                {
                    "id": 1942,
                    "argument_list_id": 113,
                    "value": "55",
                    "name": "Reached peak of smell0"
                },
                {
                    "id": 1943,
                    "argument_list_id": 113,
                    "value": "56",
                    "name": "Reached peak of smell1"
                },
                {
                    "id": 1944,
                    "argument_list_id": 113,
                    "value": "57",
                    "name": "Reached peak of smell2"
                },
                {
                    "id": 1945,
                    "argument_list_id": 113,
                    "value": "58",
                    "name": "Reached peak of smell3"
                },
                {
                    "id": 1946,
                    "argument_list_id": 113,
                    "value": "59",
                    "name": "Reached peak of smell4"
                },
                {
                    "id": 1947,
                    "argument_list_id": 113,
                    "value": "60",
                    "name": "Reached peak of smell5"
                },
                {
                    "id": 1948,
                    "argument_list_id": 113,
                    "value": "61",
                    "name": "Reached peak of smell6"
                },
                {
                    "id": 1949,
                    "argument_list_id": 113,
                    "value": "62",
                    "name": "Reached peak of smell7"
                },
                {
                    "id": 1950,
                    "argument_list_id": 113,
                    "value": "63",
                    "name": "Reached peak of smell8"
                },
                {
                    "id": 1951,
                    "argument_list_id": 113,
                    "value": "64",
                    "name": "Reached peak of smell9"
                },
                {
                    "id": 1952,
                    "argument_list_id": 113,
                    "value": "65",
                    "name": "Reached peak of smell10"
                },
                {
                    "id": 1953,
                    "argument_list_id": 113,
                    "value": "66",
                    "name": "Reached peak of smell11"
                },
                {
                    "id": 1954,
                    "argument_list_id": 113,
                    "value": "67",
                    "name": "Reached peak of smell12"
                },
                {
                    "id": 1955,
                    "argument_list_id": 113,
                    "value": "68",
                    "name": "Reached peak of smell13"
                },
                {
                    "id": 1956,
                    "argument_list_id": 113,
                    "value": "69",
                    "name": "Reached peak of smell14"
                },
                {
                    "id": 1957,
                    "argument_list_id": 113,
                    "value": "70",
                    "name": "Reached peak of smell15"
                },
                {
                    "id": 1958,
                    "argument_list_id": 113,
                    "value": "71",
                    "name": "Reached peak of smell16"
                },
                {
                    "id": 1959,
                    "argument_list_id": 113,
                    "value": "72",
                    "name": "Reached peak of smell17"
                },
                {
                    "id": 1960,
                    "argument_list_id": 113,
                    "value": "73",
                    "name": "Reached peak of smell18"
                },
                {
                    "id": 1961,
                    "argument_list_id": 113,
                    "value": "74",
                    "name": "Reached peak of smell19"
                },
                {
                    "id": 1962,
                    "argument_list_id": 113,
                    "value": "75",
                    "name": "Wait"
                },
                {
                    "id": 1963,
                    "argument_list_id": 113,
                    "value": "76",
                    "name": "Discomfort"
                },
                {
                    "id": 1964,
                    "argument_list_id": 113,
                    "value": "77",
                    "name": "Eaten plant"
                },
                {
                    "id": 1965,
                    "argument_list_id": 113,
                    "value": "78",
                    "name": "Eaten fruit"
                },
                {
                    "id": 1966,
                    "argument_list_id": 113,
                    "value": "79",
                    "name": "Eaten food"
                },
                {
                    "id": 1967,
                    "argument_list_id": 113,
                    "value": "80",
                    "name": "Eaten animal"
                },
                {
                    "id": 1968,
                    "argument_list_id": 113,
                    "value": "81",
                    "name": "Eaten detritus"
                },
                {
                    "id": 1969,
                    "argument_list_id": 113,
                    "value": "82",
                    "name": "Consume alchohol"
                },
                {
                    "id": 1970,
                    "argument_list_id": 113,
                    "value": "83",
                    "name": "Danger plant"
                },
                {
                    "id": 1971,
                    "argument_list_id": 113,
                    "value": "84",
                    "name": "Friendly plant"
                },
                {
                    "id": 1972,
                    "argument_list_id": 113,
                    "value": "85",
                    "name": "Play bug"
                },
                {
                    "id": 1973,
                    "argument_list_id": 113,
                    "value": "86",
                    "name": "Play critter"
                },
                {
                    "id": 1974,
                    "argument_list_id": 113,
                    "value": "87",
                    "name": "Hit critter"
                },
                {
                    "id": 1975,
                    "argument_list_id": 113,
                    "value": "88",
                    "name": "Play danger animal"
                },
                {
                    "id": 1976,
                    "argument_list_id": 113,
                    "value": "89",
                    "name": "Activate button"
                },
                {
                    "id": 1977,
                    "argument_list_id": 113,
                    "value": "90",
                    "name": "Activate machine"
                },
                {
                    "id": 1978,
                    "argument_list_id": 113,
                    "value": "91",
                    "name": "Got machine"
                },
                {
                    "id": 1979,
                    "argument_list_id": 113,
                    "value": "92",
                    "name": "Hit machine"
                },
                {
                    "id": 1980,
                    "argument_list_id": 113,
                    "value": "93",
                    "name": "Got creature egg"
                },
                {
                    "id": 1981,
                    "argument_list_id": 113,
                    "value": "94",
                    "name": "Travelled in lift"
                },
                {
                    "id": 1982,
                    "argument_list_id": 113,
                    "value": "95",
                    "name": "Travelled through meta door"
                },
                {
                    "id": 1983,
                    "argument_list_id": 113,
                    "value": "96",
                    "name": "Travelled through internal door"
                },
                {
                    "id": 1984,
                    "argument_list_id": 113,
                    "value": "97",
                    "name": "Played with toy"
                }
            ],
            "variants": 60
        },
        "list_126": {
            "id": 126,
            "variant": "C2",
            "name": "Stimulus",
            "base_values_list_id": 11,
            "arguments": [
                {
                    "id": 2202,
                    "argument_list_id": 126,
                    "value": "0",
                    "name": "Disappointment"
                },
                {
                    "id": 2203,
                    "argument_list_id": 126,
                    "value": "1",
                    "name": "Pointer pats me"
                },
                {
                    "id": 2204,
                    "argument_list_id": 126,
                    "value": "2",
                    "name": "Creature pats me"
                },
                {
                    "id": 2205,
                    "argument_list_id": 126,
                    "value": "3",
                    "name": "Pointer slaps me"
                },
                {
                    "id": 2206,
                    "argument_list_id": 126,
                    "value": "4",
                    "name": "Creature slaps me"
                },
                {
                    "id": 2207,
                    "argument_list_id": 126,
                    "value": "5",
                    "name": "It is approaching"
                },
                {
                    "id": 2208,
                    "argument_list_id": 126,
                    "value": "6",
                    "name": "It is retreating"
                },
                {
                    "id": 2209,
                    "argument_list_id": 126,
                    "value": "7",
                    "name": "I bump into wall"
                },
                {
                    "id": 2210,
                    "argument_list_id": 126,
                    "value": "8",
                    "name": "Object comes into view"
                },
                {
                    "id": 2211,
                    "argument_list_id": 126,
                    "value": "9",
                    "name": "Unrecognised word"
                },
                {
                    "id": 2212,
                    "argument_list_id": 126,
                    "value": "10",
                    "name": "Heard user speak"
                },
                {
                    "id": 2213,
                    "argument_list_id": 126,
                    "value": "11",
                    "name": "Heard creature speak"
                },
                {
                    "id": 2214,
                    "argument_list_id": 126,
                    "value": "12",
                    "name": "I am quiescent (periodic)"
                },
                {
                    "id": 2215,
                    "argument_list_id": 126,
                    "value": "13",
                    "name": "I've Activated1"
                },
                {
                    "id": 2216,
                    "argument_list_id": 126,
                    "value": "14",
                    "name": "I've Activated2"
                },
                {
                    "id": 2217,
                    "argument_list_id": 126,
                    "value": "15",
                    "name": "I've Deactivated"
                },
                {
                    "id": 2218,
                    "argument_list_id": 126,
                    "value": "16",
                    "name": "I am approaching (periodic)"
                },
                {
                    "id": 2219,
                    "argument_list_id": 126,
                    "value": "17",
                    "name": "I have retreated"
                },
                {
                    "id": 2220,
                    "argument_list_id": 126,
                    "value": "18",
                    "name": "I have Got"
                },
                {
                    "id": 2221,
                    "argument_list_id": 126,
                    "value": "19",
                    "name": "I have Dropped"
                },
                {
                    "id": 2222,
                    "argument_list_id": 126,
                    "value": "20",
                    "name": "I've stated need"
                },
                {
                    "id": 2223,
                    "argument_list_id": 126,
                    "value": "21",
                    "name": "I am Resting (periodic)"
                },
                {
                    "id": 2224,
                    "argument_list_id": 126,
                    "value": "22",
                    "name": "I am sleeping (periodic)"
                },
                {
                    "id": 2225,
                    "argument_list_id": 126,
                    "value": "23",
                    "name": "I am travelling (periodic)"
                },
                {
                    "id": 2226,
                    "argument_list_id": 126,
                    "value": "24",
                    "name": "I've been pushed"
                },
                {
                    "id": 2227,
                    "argument_list_id": 126,
                    "value": "25",
                    "name": "I've been hit"
                },
                {
                    "id": 2228,
                    "argument_list_id": 126,
                    "value": "26",
                    "name": "I've eaten something"
                },
                {
                    "id": 2229,
                    "argument_list_id": 126,
                    "value": "27",
                    "name": "<spare action>"
                },
                {
                    "id": 2230,
                    "argument_list_id": 126,
                    "value": "28",
                    "name": "Involuntary Action 0"
                },
                {
                    "id": 2231,
                    "argument_list_id": 126,
                    "value": "29",
                    "name": "involuntary action 1"
                },
                {
                    "id": 2232,
                    "argument_list_id": 126,
                    "value": "30",
                    "name": "Involuntary Action 2"
                },
                {
                    "id": 2233,
                    "argument_list_id": 126,
                    "value": "31",
                    "name": "involuntary action 3"
                },
                {
                    "id": 2234,
                    "argument_list_id": 126,
                    "value": "32",
                    "name": "involuntary action 4"
                },
                {
                    "id": 2235,
                    "argument_list_id": 126,
                    "value": "33",
                    "name": "involuntary action 5"
                },
                {
                    "id": 2236,
                    "argument_list_id": 126,
                    "value": "34",
                    "name": "involuntary action 6"
                },
                {
                    "id": 2237,
                    "argument_list_id": 126,
                    "value": "35",
                    "name": "involuntary action 7"
                },
                {
                    "id": 2238,
                    "argument_list_id": 126,
                    "value": "36",
                    "name": "Approaching edge"
                },
                {
                    "id": 2239,
                    "argument_list_id": 126,
                    "value": "37",
                    "name": "Retreating from edge"
                },
                {
                    "id": 2240,
                    "argument_list_id": 126,
                    "value": "38",
                    "name": "Falling through air"
                },
                {
                    "id": 2241,
                    "argument_list_id": 126,
                    "value": "39",
                    "name": "Impact post fall"
                },
                {
                    "id": 2242,
                    "argument_list_id": 126,
                    "value": "40",
                    "name": "Pointer says yes"
                },
                {
                    "id": 2243,
                    "argument_list_id": 126,
                    "value": "41",
                    "name": "Creature says yes"
                },
                {
                    "id": 2244,
                    "argument_list_id": 126,
                    "value": "42",
                    "name": "Pointer says no"
                },
                {
                    "id": 2245,
                    "argument_list_id": 126,
                    "value": "43",
                    "name": "Creature says no"
                },
                {
                    "id": 2246,
                    "argument_list_id": 126,
                    "value": "44",
                    "name": "Aggression"
                },
                {
                    "id": 2247,
                    "argument_list_id": 126,
                    "value": "45",
                    "name": "Mate"
                }
            ],
            "variants": 2
        },
        "list_180": {
            "id": 180,
            "variant": "AL",
            "name": "StreamStatus",
            "extension_type": "bool",
            "base_values_list_id": 65,
            "arguments": [
                {
                    "id": 3763,
                    "argument_list_id": 180,
                    "value": "0",
                    "name": "Stream Bad"
                },
                {
                    "id": 3764,
                    "argument_list_id": 180,
                    "value": "1",
                    "name": "Stream OK"
                }
            ],
            "variants": 60
        },
        "list_224": {
            "id": 224,
            "variant": "C2",
            "name": "Success",
            "extension_type": "bool",
            "base_values_list_id": 101,
            "arguments": [
                {
                    "id": 4368,
                    "argument_list_id": 224,
                    "value": "0",
                    "name": "Unsuccessful"
                },
                {
                    "id": 4369,
                    "argument_list_id": 224,
                    "value": "1",
                    "name": "Successful"
                }
            ],
            "variants": 2
        },
        "list_245": {
            "id": 245,
            "variant": "C1",
            "name": "SysCommands",
            "description": "Command to number mapping for SYS: CMND calls\nTaken from Shee's Lost Knowledge blog post \"The full \"sys:cmnd\" ID list for Creatures 1 & 2\n@see http://sheeslostknowledge.blogspot.com/2013/12/the-full-syssmnd-id-list-for-creatures.html",
            "base_values_list_id": 113,
            "arguments": [
                {
                    "id": 6143,
                    "argument_list_id": 245,
                    "value": "107",
                    "name": "Tip of the Day"
                },
                {
                    "id": 6110,
                    "argument_list_id": 245,
                    "value": "113",
                    "name": "Which is my norn?"
                },
                {
                    "id": 6113,
                    "argument_list_id": 245,
                    "value": "32771",
                    "name": "Creature's View",
                    "before_region": "Tool Menu"
                },
                {
                    "id": 6082,
                    "argument_list_id": 245,
                    "value": "32774",
                    "name": "Infinite scroll",
                    "before_region": "Testing"
                },
                {
                    "id": 6083,
                    "argument_list_id": 245,
                    "value": "32777",
                    "name": "Instant verb vocabulary"
                },
                {
                    "id": 6108,
                    "argument_list_id": 245,
                    "value": "32783",
                    "name": "Track Norn",
                    "before_region": "Camera"
                },
                {
                    "id": 6085,
                    "argument_list_id": 245,
                    "value": "32786",
                    "name": "Creatures burble"
                },
                {
                    "id": 6115,
                    "argument_list_id": 245,
                    "value": "32788",
                    "name": "Norn 0",
                    "description": "Norn menu item 0"
                },
                {
                    "id": 6116,
                    "argument_list_id": 245,
                    "value": "32789",
                    "name": "Norn 1",
                    "description": "Norn menu item 1"
                },
                {
                    "id": 6117,
                    "argument_list_id": 245,
                    "value": "32790",
                    "name": "Norn 2",
                    "description": "Norn menu item 2"
                },
                {
                    "id": 6118,
                    "argument_list_id": 245,
                    "value": "32791",
                    "name": "Norn 3",
                    "description": "Norn menu item 3"
                },
                {
                    "id": 6119,
                    "argument_list_id": 245,
                    "value": "32792",
                    "name": "Norn 4",
                    "description": "Norn menu item 4"
                },
                {
                    "id": 6120,
                    "argument_list_id": 245,
                    "value": "32793",
                    "name": "Norn 5",
                    "description": "Norn menu item 5"
                },
                {
                    "id": 6121,
                    "argument_list_id": 245,
                    "value": "32794",
                    "name": "Norn 6",
                    "description": "Norn menu item 6"
                },
                {
                    "id": 6122,
                    "argument_list_id": 245,
                    "value": "32795",
                    "name": "Norn 7",
                    "description": "Norn menu item 7"
                },
                {
                    "id": 6123,
                    "argument_list_id": 245,
                    "value": "32796",
                    "name": "Norn 8",
                    "description": "Norn menu item 8"
                },
                {
                    "id": 6124,
                    "argument_list_id": 245,
                    "value": "32797",
                    "name": "Norn 9",
                    "description": "Norn menu item 9"
                },
                {
                    "id": 6125,
                    "argument_list_id": 245,
                    "value": "32798",
                    "name": "Norn 10",
                    "description": "Norn menu item 10"
                },
                {
                    "id": 6126,
                    "argument_list_id": 245,
                    "value": "32799",
                    "name": "Norn 11",
                    "description": "Norn menu item 11"
                },
                {
                    "id": 6127,
                    "argument_list_id": 245,
                    "value": "32800",
                    "name": "Norn 12",
                    "description": "Norn menu item 12"
                },
                {
                    "id": 6128,
                    "argument_list_id": 245,
                    "value": "32801",
                    "name": "Norn \"Last\"",
                    "description": "Norn menu item \"last\""
                },
                {
                    "id": 6114,
                    "argument_list_id": 245,
                    "value": "32803",
                    "name": "Creature Menu Item None available",
                    "before_region": "Creatures Selection Menu"
                },
                {
                    "id": 6080,
                    "argument_list_id": 245,
                    "value": "32804",
                    "name": "Create a male norn"
                },
                {
                    "id": 6081,
                    "argument_list_id": 245,
                    "value": "32805",
                    "name": "Create a female norn"
                },
                {
                    "id": 6086,
                    "argument_list_id": 245,
                    "value": "32807",
                    "name": "Infect current norn"
                },
                {
                    "id": 6089,
                    "argument_list_id": 245,
                    "value": "32808",
                    "name": "Sound",
                    "before_region": "Logging (Disabled)"
                },
                {
                    "id": 6090,
                    "argument_list_id": 245,
                    "value": "32809",
                    "name": "Macros (Disabled)"
                },
                {
                    "id": 6091,
                    "argument_list_id": 245,
                    "value": "32810",
                    "name": "Serialisation (Disabled)"
                },
                {
                    "id": 6092,
                    "argument_list_id": 245,
                    "value": "32811",
                    "name": "Graphics (Disabled)"
                },
                {
                    "id": 6093,
                    "argument_list_id": 245,
                    "value": "32812",
                    "name": "Chemistry (Disabled)"
                },
                {
                    "id": 6094,
                    "argument_list_id": 245,
                    "value": "32813",
                    "name": "Attention (Disabled)"
                },
                {
                    "id": 6095,
                    "argument_list_id": 245,
                    "value": "32814",
                    "name": "Actions (Disabled)"
                },
                {
                    "id": 6096,
                    "argument_list_id": 245,
                    "value": "32815",
                    "name": "Senses (Disabled)"
                },
                {
                    "id": 6097,
                    "argument_list_id": 245,
                    "value": "32816",
                    "name": "Stimuli (Disabled)"
                },
                {
                    "id": 6098,
                    "argument_list_id": 245,
                    "value": "32817",
                    "name": "Genetics (Disabled)"
                },
                {
                    "id": 6099,
                    "argument_list_id": 245,
                    "value": "32818",
                    "name": "Life changes (Disabled)"
                },
                {
                    "id": 6100,
                    "argument_list_id": 245,
                    "value": "32819",
                    "name": "Environment (Disabled)"
                },
                {
                    "id": 6101,
                    "argument_list_id": 245,
                    "value": "32820",
                    "name": "User (Disabled)"
                },
                {
                    "id": 6102,
                    "argument_list_id": 245,
                    "value": "32821",
                    "name": "OLE events (Disabled)"
                },
                {
                    "id": 6103,
                    "argument_list_id": 245,
                    "value": "32822",
                    "name": "Objects (Disabled)"
                },
                {
                    "id": 6104,
                    "argument_list_id": 245,
                    "value": "32823",
                    "name": "Brain (Disabled)"
                },
                {
                    "id": 6088,
                    "argument_list_id": 245,
                    "value": "32832",
                    "name": "Web Connect",
                    "before_region": "Other"
                },
                {
                    "id": 6111,
                    "argument_list_id": 245,
                    "value": "32839",
                    "name": "Add to Favorite places..."
                },
                {
                    "id": 6087,
                    "argument_list_id": 245,
                    "value": "32840",
                    "name": "Euthanasia"
                },
                {
                    "id": 6129,
                    "argument_list_id": 245,
                    "value": "32851",
                    "name": "Favorite Place 0",
                    "before_region": "Favorite Places"
                },
                {
                    "id": 6130,
                    "argument_list_id": 245,
                    "value": "32852",
                    "name": "Favorite Place 1"
                },
                {
                    "id": 6131,
                    "argument_list_id": 245,
                    "value": "32853",
                    "name": "Favorite Place 2"
                },
                {
                    "id": 6132,
                    "argument_list_id": 245,
                    "value": "32854",
                    "name": "Favorite Place 3"
                },
                {
                    "id": 6133,
                    "argument_list_id": 245,
                    "value": "32855",
                    "name": "Favorite Place 4"
                },
                {
                    "id": 6134,
                    "argument_list_id": 245,
                    "value": "32856",
                    "name": "Favorite Place 5"
                },
                {
                    "id": 6135,
                    "argument_list_id": 245,
                    "value": "32857",
                    "name": "Favorite Place 6"
                },
                {
                    "id": 6136,
                    "argument_list_id": 245,
                    "value": "32858",
                    "name": "Favorite Place 7"
                },
                {
                    "id": 6137,
                    "argument_list_id": 245,
                    "value": "32859",
                    "name": "Favorite Place 8"
                },
                {
                    "id": 6138,
                    "argument_list_id": 245,
                    "value": "32860",
                    "name": "Favorite Place 9"
                },
                {
                    "id": 6139,
                    "argument_list_id": 245,
                    "value": "32861",
                    "name": "Favorite Place 10"
                },
                {
                    "id": 6140,
                    "argument_list_id": 245,
                    "value": "32862",
                    "name": "Favorite Place 11"
                },
                {
                    "id": 6079,
                    "argument_list_id": 245,
                    "value": "32863",
                    "name": "Export Current Creature"
                },
                {
                    "id": 6078,
                    "argument_list_id": 245,
                    "value": "32864",
                    "name": "ImportCreature",
                    "before_region": "Creature Commands"
                },
                {
                    "id": 6084,
                    "argument_list_id": 245,
                    "value": "32865",
                    "name": "Force Ageing"
                },
                {
                    "id": 6109,
                    "argument_list_id": 245,
                    "value": "32866",
                    "name": "Smooth Scrolling"
                },
                {
                    "id": 6112,
                    "argument_list_id": 245,
                    "value": "32867",
                    "name": "Remove from Favorite places..."
                },
                {
                    "id": 6105,
                    "argument_list_id": 245,
                    "value": "32869",
                    "name": "Log Window (Disabled)"
                },
                {
                    "id": 6142,
                    "argument_list_id": 245,
                    "value": "32871",
                    "name": "Life Kit #1"
                },
                {
                    "id": 6073,
                    "argument_list_id": 245,
                    "value": "57600",
                    "name": "New World",
                    "before_region": "File"
                },
                {
                    "id": 6074,
                    "argument_list_id": 245,
                    "value": "57601",
                    "name": "Open World"
                },
                {
                    "id": 6075,
                    "argument_list_id": 245,
                    "value": "57603",
                    "name": "Save World"
                },
                {
                    "id": 6076,
                    "argument_list_id": 245,
                    "value": "57604",
                    "name": "Save World As"
                },
                {
                    "id": 6144,
                    "argument_list_id": 245,
                    "value": "57664",
                    "name": "About Creatures..."
                },
                {
                    "id": 6077,
                    "argument_list_id": 245,
                    "value": "57665",
                    "name": "Exit"
                },
                {
                    "id": 6141,
                    "argument_list_id": 245,
                    "value": "57667",
                    "name": "Help Topics"
                },
                {
                    "id": 6106,
                    "argument_list_id": 245,
                    "value": "59392",
                    "name": "Show/hide Toolbar",
                    "before_region": "View"
                },
                {
                    "id": 6107,
                    "argument_list_id": 245,
                    "value": "59393",
                    "name": "Show/hide Status Bar"
                }
            ],
            "variants": 1
        },
        "list_246": {
            "id": 246,
            "variant": "C2",
            "name": "SysCommands",
            "description": "Command to id number mapping for SYS: CMND calls\nTaken from Shee's Lost Knowledge blog post \"The full \"sys:cmnd\" ID list for Creatures 1 & 2\n@see http://sheeslostknowledge.blogspot.com/2013/12/the-full-syssmnd-id-list-for-creatures.html",
            "base_values_list_id": 113,
            "arguments": [
                {
                    "id": 6230,
                    "argument_list_id": 246,
                    "value": "105",
                    "name": "Tip of the Day..."
                },
                {
                    "id": 6197,
                    "argument_list_id": 246,
                    "value": "209",
                    "name": "Norn Indicator"
                },
                {
                    "id": 6187,
                    "argument_list_id": 246,
                    "value": "32771",
                    "name": "Creature's View",
                    "before_region": "View"
                },
                {
                    "id": 6155,
                    "argument_list_id": 246,
                    "value": "32774",
                    "name": "Activate Game States",
                    "before_region": "Testing"
                },
                {
                    "id": 6160,
                    "argument_list_id": 246,
                    "value": "32777",
                    "name": "Instant Vocabulary"
                },
                {
                    "id": 6196,
                    "argument_list_id": 246,
                    "value": "32783",
                    "name": "Track Norn",
                    "before_region": "Camera"
                },
                {
                    "id": 6164,
                    "argument_list_id": 246,
                    "value": "32786",
                    "name": "Creatures burble"
                },
                {
                    "id": 6202,
                    "argument_list_id": 246,
                    "value": "32803",
                    "name": "None Available",
                    "before_region": "Norns"
                },
                {
                    "id": 6157,
                    "argument_list_id": 246,
                    "value": "32804",
                    "name": "Create a male norn"
                },
                {
                    "id": 6158,
                    "argument_list_id": 246,
                    "value": "32805",
                    "name": "Create a female norn"
                },
                {
                    "id": 6165,
                    "argument_list_id": 246,
                    "value": "32807",
                    "name": "Infect current norn"
                },
                {
                    "id": 6184,
                    "argument_list_id": 246,
                    "value": "32808",
                    "name": "Sound (Disabled)"
                },
                {
                    "id": 6179,
                    "argument_list_id": 246,
                    "value": "32809",
                    "name": "Macros (Disabled)"
                },
                {
                    "id": 6183,
                    "argument_list_id": 246,
                    "value": "32810",
                    "name": "Serialisation (Disabled)"
                },
                {
                    "id": 6177,
                    "argument_list_id": 246,
                    "value": "32811",
                    "name": "Graphics (Disabled)"
                },
                {
                    "id": 6174,
                    "argument_list_id": 246,
                    "value": "32812",
                    "name": "Chemistry (Disabled)"
                },
                {
                    "id": 6172,
                    "argument_list_id": 246,
                    "value": "32813",
                    "name": "Attention (Disabled)"
                },
                {
                    "id": 6171,
                    "argument_list_id": 246,
                    "value": "32814",
                    "name": "Actions (Disabled)"
                },
                {
                    "id": 6182,
                    "argument_list_id": 246,
                    "value": "32815",
                    "name": "Senses (Disabled)"
                },
                {
                    "id": 6185,
                    "argument_list_id": 246,
                    "value": "32816",
                    "name": "Stimuli (Disabled)"
                },
                {
                    "id": 6176,
                    "argument_list_id": 246,
                    "value": "32817",
                    "name": "Genetics (Disabled)"
                },
                {
                    "id": 6178,
                    "argument_list_id": 246,
                    "value": "32818",
                    "name": "Life changes (Disabled)"
                },
                {
                    "id": 6175,
                    "argument_list_id": 246,
                    "value": "32819",
                    "name": "Environment (Disabled)"
                },
                {
                    "id": 6186,
                    "argument_list_id": 246,
                    "value": "32820",
                    "name": "User (Disabled)"
                },
                {
                    "id": 6181,
                    "argument_list_id": 246,
                    "value": "32821",
                    "name": "OLE events (Disabled)"
                },
                {
                    "id": 6180,
                    "argument_list_id": 246,
                    "value": "32822",
                    "name": "Objects (Disabled)"
                },
                {
                    "id": 6173,
                    "argument_list_id": 246,
                    "value": "32823",
                    "name": "Brain (Disabled)"
                },
                {
                    "id": 6199,
                    "argument_list_id": 246,
                    "value": "32839",
                    "name": "Add Favorite Place..."
                },
                {
                    "id": 6166,
                    "argument_list_id": 246,
                    "value": "32840",
                    "name": "Euthanasia"
                },
                {
                    "id": 6217,
                    "argument_list_id": 246,
                    "value": "32851",
                    "name": "Favorite Place 0"
                },
                {
                    "id": 6218,
                    "argument_list_id": 246,
                    "value": "32852",
                    "name": "Favorite Place 1"
                },
                {
                    "id": 6219,
                    "argument_list_id": 246,
                    "value": "32853",
                    "name": "Favorite Place 2"
                },
                {
                    "id": 6220,
                    "argument_list_id": 246,
                    "value": "32854",
                    "name": "Favorite Place 3"
                },
                {
                    "id": 6221,
                    "argument_list_id": 246,
                    "value": "32855",
                    "name": "Favorite Place 4"
                },
                {
                    "id": 6222,
                    "argument_list_id": 246,
                    "value": "32856",
                    "name": "Favorite Place 5"
                },
                {
                    "id": 6223,
                    "argument_list_id": 246,
                    "value": "32857",
                    "name": "Favorite Place 6"
                },
                {
                    "id": 6224,
                    "argument_list_id": 246,
                    "value": "32858",
                    "name": "Favorite Place 7"
                },
                {
                    "id": 6225,
                    "argument_list_id": 246,
                    "value": "32859",
                    "name": "Favorite Place 8"
                },
                {
                    "id": 6226,
                    "argument_list_id": 246,
                    "value": "32860",
                    "name": "Favorite Place 9"
                },
                {
                    "id": 6227,
                    "argument_list_id": 246,
                    "value": "32861",
                    "name": "Favorite Place 10"
                },
                {
                    "id": 6228,
                    "argument_list_id": 246,
                    "value": "32862",
                    "name": "Favorite Place 11"
                },
                {
                    "id": 6146,
                    "argument_list_id": 246,
                    "value": "32863",
                    "name": "Export Current Creature...",
                    "before_region": "File"
                },
                {
                    "id": 6147,
                    "argument_list_id": 246,
                    "value": "32864",
                    "name": "Import Creature..."
                },
                {
                    "id": 6159,
                    "argument_list_id": 246,
                    "value": "32865",
                    "name": "Force Ageing"
                },
                {
                    "id": 6198,
                    "argument_list_id": 246,
                    "value": "32866",
                    "name": "Smooth Scrolling"
                },
                {
                    "id": 6200,
                    "argument_list_id": 246,
                    "value": "32867",
                    "name": "Remove Favorite Places..."
                },
                {
                    "id": 6169,
                    "argument_list_id": 246,
                    "value": "32869",
                    "name": "Log Window",
                    "before_region": "Log (Completely Disabled)"
                },
                {
                    "id": 6170,
                    "argument_list_id": 246,
                    "value": "32870",
                    "name": "Verbose Output (Disabled)"
                },
                {
                    "id": 6188,
                    "argument_list_id": 246,
                    "value": "32929",
                    "name": "Standard",
                    "before_region": "Toolbars"
                },
                {
                    "id": 6189,
                    "argument_list_id": 246,
                    "value": "32930",
                    "name": "Pointer"
                },
                {
                    "id": 6191,
                    "argument_list_id": 246,
                    "value": "32931",
                    "name": "Favourites"
                },
                {
                    "id": 6190,
                    "argument_list_id": 246,
                    "value": "32933",
                    "name": "Applets"
                },
                {
                    "id": 6203,
                    "argument_list_id": 246,
                    "value": "32934",
                    "name": "Norn 0"
                },
                {
                    "id": 6204,
                    "argument_list_id": 246,
                    "value": "32935",
                    "name": "Norn 1"
                },
                {
                    "id": 6205,
                    "argument_list_id": 246,
                    "value": "32936",
                    "name": "Norn 2"
                },
                {
                    "id": 6206,
                    "argument_list_id": 246,
                    "value": "32937",
                    "name": "Norn 3"
                },
                {
                    "id": 6207,
                    "argument_list_id": 246,
                    "value": "32938",
                    "name": "Norn 4"
                },
                {
                    "id": 6208,
                    "argument_list_id": 246,
                    "value": "32939",
                    "name": "Norn 5"
                },
                {
                    "id": 6209,
                    "argument_list_id": 246,
                    "value": "32940",
                    "name": "Norn 6"
                },
                {
                    "id": 6210,
                    "argument_list_id": 246,
                    "value": "32941",
                    "name": "Norn 7"
                },
                {
                    "id": 6211,
                    "argument_list_id": 246,
                    "value": "32942",
                    "name": "Norn 8"
                },
                {
                    "id": 6212,
                    "argument_list_id": 246,
                    "value": "32943",
                    "name": "Norn 9"
                },
                {
                    "id": 6213,
                    "argument_list_id": 246,
                    "value": "32944",
                    "name": "Norn 10"
                },
                {
                    "id": 6214,
                    "argument_list_id": 246,
                    "value": "32945",
                    "name": "Norn 11"
                },
                {
                    "id": 6215,
                    "argument_list_id": 246,
                    "value": "32946",
                    "name": "Norn 12"
                },
                {
                    "id": 6216,
                    "argument_list_id": 246,
                    "value": "32955",
                    "name": "Norn..Last"
                },
                {
                    "id": 6167,
                    "argument_list_id": 246,
                    "value": "32956",
                    "name": "Reset mutation count"
                },
                {
                    "id": 6149,
                    "argument_list_id": 246,
                    "value": "32957",
                    "name": "Send To Mail Recipient..."
                },
                {
                    "id": 6201,
                    "argument_list_id": 246,
                    "value": "32959",
                    "name": "The Hatchery",
                    "before_region": "Tools"
                },
                {
                    "id": 6192,
                    "argument_list_id": 246,
                    "value": "32960",
                    "name": "Text Labels"
                },
                {
                    "id": 6195,
                    "argument_list_id": 246,
                    "value": "32988",
                    "name": "Full Screen"
                },
                {
                    "id": 6156,
                    "argument_list_id": 246,
                    "value": "32995",
                    "name": "Show Map ( Draws rooms limits on screen)"
                },
                {
                    "id": 6162,
                    "argument_list_id": 246,
                    "value": "32998",
                    "name": "Next Creature Facial Expression"
                },
                {
                    "id": 6163,
                    "argument_list_id": 246,
                    "value": "33000",
                    "name": "Next Creature Walking Gait"
                },
                {
                    "id": 6161,
                    "argument_list_id": 246,
                    "value": "33002",
                    "name": "Instant Goal Direction"
                },
                {
                    "id": 6148,
                    "argument_list_id": 246,
                    "value": "33004",
                    "name": "Ambient Music"
                },
                {
                    "id": 6168,
                    "argument_list_id": 246,
                    "value": "33006",
                    "name": "Mark All Rooms Visited ( i.e visible on ecology kit map"
                },
                {
                    "id": 6194,
                    "argument_list_id": 246,
                    "value": "33007",
                    "name": "ToolTips for Objects"
                },
                {
                    "id": 6231,
                    "argument_list_id": 246,
                    "value": "33009",
                    "name": "Free Stuff",
                    "before_region": "Creatures on the Web"
                },
                {
                    "id": 6232,
                    "argument_list_id": 246,
                    "value": "33010",
                    "name": "Product News"
                },
                {
                    "id": 6233,
                    "argument_list_id": 246,
                    "value": "33011",
                    "name": "Frequently Asked Questions"
                },
                {
                    "id": 6234,
                    "argument_list_id": 246,
                    "value": "33012",
                    "name": "Online Support"
                },
                {
                    "id": 6235,
                    "argument_list_id": 246,
                    "value": "33033",
                    "name": "Creatures  Home Page"
                },
                {
                    "id": 6151,
                    "argument_list_id": 246,
                    "value": "57600",
                    "name": "New",
                    "before_region": "World"
                },
                {
                    "id": 6152,
                    "argument_list_id": 246,
                    "value": "57601",
                    "name": "Open..."
                },
                {
                    "id": 6153,
                    "argument_list_id": 246,
                    "value": "57603",
                    "name": "Save the world"
                },
                {
                    "id": 6154,
                    "argument_list_id": 246,
                    "value": "57604",
                    "name": "Save As..."
                },
                {
                    "id": 6236,
                    "argument_list_id": 246,
                    "value": "57664",
                    "name": "About Creatures 2..."
                },
                {
                    "id": 6150,
                    "argument_list_id": 246,
                    "value": "57665",
                    "name": "Exit"
                },
                {
                    "id": 6229,
                    "argument_list_id": 246,
                    "value": "57667",
                    "name": "Help Topics",
                    "before_region": "Help"
                },
                {
                    "id": 6193,
                    "argument_list_id": 246,
                    "value": "59393",
                    "name": "Status Bar"
                }
            ],
            "variants": 2
        },
        "list_89": {
            "id": 89,
            "variant": "AL",
            "name": "TimeOfDay",
            "base_values_list_id": 23,
            "arguments": [
                {
                    "id": 1189,
                    "argument_list_id": 89,
                    "value": "0",
                    "name": "Dawn"
                },
                {
                    "id": 1190,
                    "argument_list_id": 89,
                    "value": "1",
                    "name": "Morning"
                },
                {
                    "id": 1191,
                    "argument_list_id": 89,
                    "value": "2",
                    "name": "Afternoon"
                },
                {
                    "id": 1192,
                    "argument_list_id": 89,
                    "value": "3",
                    "name": "Evening"
                },
                {
                    "id": 1193,
                    "argument_list_id": 89,
                    "value": "4",
                    "name": "Night"
                }
            ],
            "variants": 62
        },
        "list_214": {
            "id": 214,
            "variant": "AL",
            "name": "Tint",
            "base_values_list_id": 93,
            "arguments": [
                {
                    "id": 4341,
                    "argument_list_id": 214,
                    "value": "1",
                    "name": "Red"
                },
                {
                    "id": 4342,
                    "argument_list_id": 214,
                    "value": "2",
                    "name": "Green"
                },
                {
                    "id": 4344,
                    "argument_list_id": 214,
                    "value": "3",
                    "name": "Blue"
                },
                {
                    "id": 4345,
                    "argument_list_id": 214,
                    "value": "4",
                    "name": "Rotation"
                },
                {
                    "id": 4346,
                    "argument_list_id": 214,
                    "value": "5",
                    "name": "Swap"
                }
            ],
            "variants": 60
        },
        "list_253": {
            "id": 253,
            "variant": "AL",
            "name": "Touching",
            "extension_type": "bool",
            "base_values_list_id": 121,
            "arguments": [
                {
                    "id": 6355,
                    "argument_list_id": 253,
                    "value": "0",
                    "name": "Not Touching"
                },
                {
                    "id": 6356,
                    "argument_list_id": 253,
                    "value": "1",
                    "name": "Touching"
                }
            ],
            "variants": 63
        },
        "list_258": {
            "id": 258,
            "variant": "AL",
            "name": "TrackStyle",
            "base_values_list_id": 125,
            "arguments": [
                {
                    "id": 6363,
                    "argument_list_id": 258,
                    "value": "0",
                    "name": "Brittle",
                    "description": "If you move the camera so the target is out of the rectangle, then the tracking is broken."
                },
                {
                    "id": 6364,
                    "argument_list_id": 258,
                    "value": "1",
                    "name": "Flexible",
                    "description": "You can move the camera away from the target. If you move it back, then tracking resumes."
                },
                {
                    "id": 6365,
                    "argument_list_id": 258,
                    "value": "2",
                    "name": "Hard",
                    "description": "You can't move the camera so the target is out of the rectangle."
                }
            ],
            "variants": 60
        },
        "list_203": {
            "id": 203,
            "variant": "AL",
            "name": "TransparencyAwareness",
            "base_values_list_id": 83,
            "arguments": [
                {
                    "id": 4314,
                    "argument_list_id": 203,
                    "value": "0",
                    "name": "Click Anywhere",
                    "description": "Allow clicking any part in rectangle"
                },
                {
                    "id": 4315,
                    "argument_list_id": 203,
                    "value": "1",
                    "name": "PixelPerfect",
                    "description": "Transparent areas cannot be clicked"
                }
            ],
            "variants": 60
        },
        "list_175": {
            "id": 175,
            "variant": "DS",
            "name": "TranswarpExitCode",
            "base_values_list_id": 60,
            "arguments": [
                {
                    "id": 3746,
                    "argument_list_id": 175,
                    "value": "0",
                    "name": "Success"
                },
                {
                    "id": 3747,
                    "argument_list_id": 175,
                    "value": "1",
                    "name": "Already On Disk",
                    "description": "If the creature, or if pregnant any of its offspring, are already on disk in some form. This case won't happen much, if you use a special chunk name like WARP."
                },
                {
                    "id": 3748,
                    "argument_list_id": 175,
                    "value": "2",
                    "name": "User/World Unknown",
                    "description": "If the user hasn't been online in this world yet / since the user name changed, so we don't know who they are. When receiving a creature, use NET: FROM to find out who sent it."
                }
            ],
            "variants": 48
        },
        "list_92": {
            "id": 92,
            "variant": "AL",
            "name": "TrueFalse",
            "extension_type": "bool",
            "base_values_list_id": 15,
            "arguments": [
                {
                    "id": 1203,
                    "argument_list_id": 92,
                    "value": "0",
                    "name": "False"
                },
                {
                    "id": 1204,
                    "argument_list_id": 92,
                    "value": "1",
                    "name": "True"
                }
            ],
            "variants": 3
        },
        "list_166": {
            "id": 166,
            "variant": "AL",
            "name": "Unconscious",
            "extension_type": "bool",
            "base_values_list_id": 51,
            "arguments": [
                {
                    "id": 3722,
                    "argument_list_id": 166,
                    "value": "0",
                    "name": "Conscious"
                },
                {
                    "id": 3723,
                    "argument_list_id": 166,
                    "value": "1",
                    "name": "Unconscious"
                }
            ],
            "variants": 62
        },
        "list_220": {
            "id": 220,
            "variant": "C2",
            "name": "UseGravity",
            "extension_type": "bool",
            "base_values_list_id": 97,
            "arguments": [
                {
                    "id": 4360,
                    "argument_list_id": 220,
                    "value": "0",
                    "name": "No Gravity"
                },
                {
                    "id": 4361,
                    "argument_list_id": 220,
                    "value": "!0",
                    "name": "Use Gravity"
                }
            ],
            "variants": 2
        },
        "list_153": {
            "id": 153,
            "variant": "AL",
            "name": "VarTypeAsInt",
            "base_values_list_id": 40,
            "arguments": [
                {
                    "id": 3679,
                    "argument_list_id": 153,
                    "value": "-2",
                    "name": "Unknown agent",
                    "description": "you should never get this"
                },
                {
                    "id": 3678,
                    "argument_list_id": 153,
                    "value": "-1",
                    "name": "NULL agent handle"
                },
                {
                    "id": 3670,
                    "argument_list_id": 153,
                    "value": "0",
                    "name": "integer"
                },
                {
                    "id": 3671,
                    "argument_list_id": 153,
                    "value": "1",
                    "name": "Floating-Point"
                },
                {
                    "id": 3672,
                    "argument_list_id": 153,
                    "value": "2",
                    "name": "string"
                },
                {
                    "id": 3673,
                    "argument_list_id": 153,
                    "value": "3",
                    "name": "simple agent"
                },
                {
                    "id": 3674,
                    "argument_list_id": 153,
                    "value": "4",
                    "name": "pointer agent"
                },
                {
                    "id": 3675,
                    "argument_list_id": 153,
                    "value": "5",
                    "name": "compound agent"
                },
                {
                    "id": 3676,
                    "argument_list_id": 153,
                    "value": "6",
                    "name": "vehicle"
                },
                {
                    "id": 3677,
                    "argument_list_id": 153,
                    "value": "7",
                    "name": "creature"
                }
            ],
            "variants": 60
        },
        "list_292": {
            "id": 292,
            "variant": "AL",
            "name": "Verbs",
            "description": "Verb id's for use in commands like URGE: WRIT",
            "arguments": [
                {
                    "id": 9316,
                    "argument_list_id": 292,
                    "value": "0",
                    "name": "look"
                },
                {
                    "id": 9317,
                    "argument_list_id": 292,
                    "value": "1",
                    "name": "push"
                },
                {
                    "id": 9318,
                    "argument_list_id": 292,
                    "value": "2",
                    "name": "pull"
                },
                {
                    "id": 9319,
                    "argument_list_id": 292,
                    "value": "3",
                    "name": "deactivate"
                },
                {
                    "id": 9320,
                    "argument_list_id": 292,
                    "value": "4",
                    "name": "approach"
                },
                {
                    "id": 9321,
                    "argument_list_id": 292,
                    "value": "5",
                    "name": "retreat"
                },
                {
                    "id": 9322,
                    "argument_list_id": 292,
                    "value": "6",
                    "name": "get"
                },
                {
                    "id": 9323,
                    "argument_list_id": 292,
                    "value": "7",
                    "name": "drop"
                },
                {
                    "id": 9324,
                    "argument_list_id": 292,
                    "value": "8",
                    "name": "express"
                },
                {
                    "id": 9325,
                    "argument_list_id": 292,
                    "value": "9",
                    "name": "rest"
                },
                {
                    "id": 9326,
                    "argument_list_id": 292,
                    "value": "10",
                    "name": "left"
                },
                {
                    "id": 9327,
                    "argument_list_id": 292,
                    "value": "11",
                    "name": "right"
                },
                {
                    "id": 9328,
                    "argument_list_id": 292,
                    "value": "12",
                    "name": "eat"
                },
                {
                    "id": 9329,
                    "argument_list_id": 292,
                    "value": "13",
                    "name": "hit"
                },
                {
                    "id": 9330,
                    "argument_list_id": 292,
                    "value": "14",
                    "name": "up"
                },
                {
                    "id": 9331,
                    "argument_list_id": 292,
                    "value": "15",
                    "name": "down"
                },
                {
                    "id": 9332,
                    "argument_list_id": 292,
                    "value": "16",
                    "name": "exit"
                }
            ],
            "variants": 24
        },
        "list_164": {
            "id": 164,
            "variant": "C2",
            "name": "WallDirection",
            "base_values_list_id": 49,
            "arguments": [
                {
                    "id": 3713,
                    "argument_list_id": 164,
                    "value": "0",
                    "name": "Left"
                },
                {
                    "id": 3714,
                    "argument_list_id": 164,
                    "value": "1",
                    "name": "Right"
                },
                {
                    "id": 3715,
                    "argument_list_id": 164,
                    "value": "2",
                    "name": "Up"
                },
                {
                    "id": 3716,
                    "argument_list_id": 164,
                    "value": "3",
                    "name": "Down"
                },
                {
                    "id": 3717,
                    "argument_list_id": 164,
                    "value": "4",
                    "name": "Unknown"
                }
            ],
            "variants": 2
        },
        "list_165": {
            "id": 165,
            "variant": "AL",
            "name": "WallDirectionConstants",
            "base_values_list_id": 50,
            "arguments": [
                {
                    "id": 3718,
                    "argument_list_id": 165,
                    "value": "LEFT",
                    "name": "Left"
                },
                {
                    "id": 3719,
                    "argument_list_id": 165,
                    "value": "RGHT",
                    "name": "Right"
                },
                {
                    "id": 3720,
                    "argument_list_id": 165,
                    "value": "_UP_",
                    "name": "Up"
                },
                {
                    "id": 3721,
                    "argument_list_id": 165,
                    "value": "DOWN",
                    "name": "Down"
                }
            ],
            "variants": 60
        },
        "list_201": {
            "id": 201,
            "variant": "AL",
            "name": "WolfFlags",
            "extension_type": "BitFlags",
            "base_values_list_id": 81,
            "arguments": [
                {
                    "id": 4306,
                    "argument_list_id": 201,
                    "value": "1",
                    "name": "Display rendering",
                    "description": "Turning it off speeds the game up."
                },
                {
                    "id": 4307,
                    "argument_list_id": 201,
                    "value": "2",
                    "name": "Fastest ticks",
                    "description": "The game usually runs at a maximum of 20 frames per second. If this is set, it instead runs as fast as it can."
                },
                {
                    "id": 4308,
                    "argument_list_id": 201,
                    "value": "4",
                    "name": "Refresh display at end of tick",
                    "description": "If set, then the display is updated at the end of the tick, and the flag is cleared."
                },
                {
                    "id": 4309,
                    "argument_list_id": 201,
                    "value": "8",
                    "name": "Autokill",
                    "description": "If set, agents which generate run errors are automatically killed, as the command line option."
                }
            ],
            "variants": 60
        },
        "list_232": {
            "id": 232,
            "variant": "C2",
            "name": "Xists",
            "extension_type": "bool",
            "base_values_list_id": 107,
            "arguments": [
                {
                    "id": 4602,
                    "argument_list_id": 232,
                    "value": "0",
                    "name": "Does Not Exist"
                },
                {
                    "id": 4601,
                    "argument_list_id": 232,
                    "value": "1",
                    "name": "Exists"
                }
            ],
            "variants": 2
        },
        "list_210": {
            "id": 210,
            "variant": "AL",
            "name": "XorY",
            "base_values_list_id": 89,
            "arguments": [
                {
                    "id": 4322,
                    "argument_list_id": 210,
                    "value": "1",
                    "name": "X"
                },
                {
                    "id": 4323,
                    "argument_list_id": 210,
                    "value": "2",
                    "name": "Y"
                }
            ],
            "variants": 60
        },
        "list_160": {
            "id": 160,
            "variant": "AL",
            "name": "Zombied",
            "extension_type": "bool",
            "base_values_list_id": 46,
            "arguments": [
                {
                    "id": 3705,
                    "argument_list_id": 160,
                    "value": "0",
                    "name": "False"
                },
                {
                    "id": 3700,
                    "argument_list_id": 160,
                    "value": "1",
                    "name": "Zombied"
                }
            ],
            "variants": 60
        }
    }
}